export const AIRPORTS: Record<string, { lat: number; lon: number }> = {
	UTK: { lat: 11.222219, lon: 169.851429 },
	OCA: { lat: 25.325399, lon: -80.274803 },
	CSE: { lat: 38.851918, lon: -106.928341 },
	CUS: { lat: 31.823898, lon: -107.629924 },
	JCY: { lat: 30.251801, lon: -98.622498 },
	WLR: { lat: 55.601299, lon: -131.636993 },
	NUP: { lat: 60.905591, lon: -162.440454 },
	PTC: { lat: 55.803, lon: -133.597 },
	ICY: { lat: 59.966269, lon: -141.660118 },
	PPV: { lat: 56.3288, lon: -133.610001 },
	KKK: { lat: 64.416626, lon: -156.820393 },
	MHS: { lat: 41.263199, lon: -122.272003 },
	NIR: { lat: 28.362444, lon: -97.661917 },
	GCT: { lat: 36.257984, lon: -113.231063 },
	ELW: { lat: 60.893818, lon: -146.704038 },
	LVD: { lat: 61.3591, lon: -155.440002 },
	HGZ: { lat: 66.176133, lon: -155.684816 },
	OTN: { lat: 38.851782, lon: -87.49987 },
	TLF: { lat: 63.393902, lon: -153.268997 },
	BZT: { lat: 28.982201, lon: -95.579697 },
	HBH: { lat: 57.412201, lon: -133.43848 },
	FAK: { lat: 57.5322, lon: -135.212997 },
	BYW: { lat: 48.579162, lon: -122.823844 },
	DRF: { lat: 60.588902, lon: -152.162003 },
	BDF: { lat: 41.2309, lon: -89.6157 },
	TEH: { lat: 63.124618, lon: -142.518005 },
	VRS: { lat: 38.427799, lon: -92.875198 },
	GDH: { lat: 59.747002, lon: -158.875 },
	ATT: { lat: 60.866699, lon: -162.272996 },
	LIV: { lat: 65.467, lon: -148.6534 },
	PDB: { lat: 59.796925, lon: -154.129994 },
	KOZ: { lat: 57.942094, lon: -152.464314 },
	TNK: { lat: 60.569638, lon: -165.246649 },
	WHD: { lat: 55.903324, lon: -130.009975 },
	MNT: { lat: 65.147991, lon: -149.368658 },
	TKI: { lat: 55.937099, lon: -133.326996 },
	WKK: { lat: 59.2826, lon: -158.617996 },
	WFB: { lat: 55.349899, lon: -131.677002 },
	RFK: { lat: 32.953543, lon: -90.845144 },
	NNK: { lat: 58.735633, lon: -157.02216 },
	BKF: { lat: 58.554798, lon: -155.776993 },
	BCS: { lat: 29.866078, lon: -90.021608 },
	MMN: { lat: 42.460298, lon: -71.519031 },
	SPQ: { lat: 33.749199, lon: -118.275002 },
	TSS: { lat: 40.742372, lon: -73.972074 },
	NYS: { lat: 40.735061, lon: -73.972814 },
	BWL: { lat: 36.795898, lon: -97.317001 },
	WYB: { lat: 55.916302, lon: -131.800995 },
	CWS: { lat: 48.490046, lon: -122.831612 },
	TEK: { lat: 60.871449, lon: -146.690297 },
	DUF: { lat: 36.252744, lon: -75.785256 },
	SSW: { lat: 48.673379, lon: -123.175439 },
	FOB: { lat: 39.472445, lon: -123.795319 },
	PUL: { lat: 47.734001, lon: -122.647003 },
	CCD: { lat: 34.060799, lon: -118.417999 },
	WMK: { lat: 55.739601, lon: -132.255005 },
	AXB: { lat: 44.312002, lon: -75.90034 },
	REE: { lat: 33.590302, lon: -102.037003 },
	WDN: { lat: 48.71141, lon: -123.018208 },
	WWP: { lat: 56.116299, lon: -133.121994 },
	CHU: { lat: 61.579102, lon: -159.216003 },
	UGS: { lat: 57.523476, lon: -157.396344 },
	JID: { lat: 34.020472, lon: -117.927396 },
	PSQ: { lat: 39.859001, lon: -75.299599 },
	KLL: { lat: 59.12606, lon: -156.860906 },
	SGW: { lat: 56.886299, lon: -134.158005 },
	WTL: { lat: 60.351243, lon: -162.654476 },
	TWA: { lat: 59.074713, lon: -160.274992 },
	KCQ: { lat: 56.255001, lon: -158.774994 },
	AAD: { lat: 6.095802, lon: 46.6375 },
	ABP: { lat: -6.06462, lon: 141.095173 },
	ACM: { lat: -2.143713, lon: -71.75935 },
	ADV: { lat: 11.4023, lon: 26.1186 },
	AEE: { lat: 10.053611, lon: 32.959444 },
	AEQ: { lat: 43.908407, lon: 120.15099 },
	AFK: { lat: 7.284, lon: 81.644 },
	AFT: { lat: -9.191389, lon: 160.948611 },
	RNA: { lat: -9.860544, lon: 161.979547 },
	ATD: { lat: -8.87333, lon: 161.011002 },
	VEV: { lat: -7.91278, lon: 156.705994 },
	BPF: { lat: -8.562028, lon: 158.119306 },
	GEF: { lat: -7.57583, lon: 156.597 },
	AGG: { lat: -4.057077, lon: 144.073841 },
	AKS: { lat: -8.70257, lon: 160.682007 },
	BNY: { lat: -11.302222, lon: 159.798333 },
	CHY: { lat: -6.711944, lon: 156.396111 },
	BAS: { lat: -6.990745, lon: 155.886656 },
	FRE: { lat: -8.1075, lon: 159.576996 },
	HIR: { lat: -9.428, lon: 160.054993 },
	MBU: { lat: -9.7475, lon: 159.839005 },
	AVU: { lat: -9.868333, lon: 160.410556 },
	IRA: { lat: -10.4497, lon: 161.897995 },
	SCZ: { lat: -10.7203, lon: 165.794998 },
	MUA: { lat: -8.32797, lon: 157.263 },
	GZO: { lat: -8.09778, lon: 156.863998 },
	MNY: { lat: -7.41694, lon: 155.565002 },
	PRS: { lat: -9.64167, lon: 161.425003 },
	RNL: { lat: -11.55, lon: 160.062778 },
	EGM: { lat: -8.57889, lon: 157.876007 },
	NNB: { lat: -10.847994, lon: 162.454108 },
	RUS: { lat: -9.86167, lon: 160.824997 },
	VAO: { lat: -7.58556, lon: 158.731003 },
	XYA: { lat: -9.092816, lon: 159.21841 },
	AGK: { lat: -6.396389, lon: 143.853611 },
	KGE: { lat: -7.3305, lon: 157.585 },
	KUE: { lat: -8.0262, lon: 156.94783 },
	KWS: { lat: -8.360508, lon: 160.775127 },
	LLM: { lat: -10.296828, lon: 166.327322 },
	NAZ: { lat: -10.6758, lon: 162.2049 },
	MHM: { lat: -8.325008, lon: 160.80051 },
	GTA: { lat: -8.738358, lon: 158.202836 },
	RIN: { lat: -8.12639, lon: 157.143005 },
	RBV: { lat: -8.16806, lon: 157.643005 },
	TLG: { lat: -9.108, lon: 160.149167 },
	AHY: { lat: -20.015833, lon: 45.535 },
	AIC: { lat: 7.279422, lon: 168.8257 },
	CEX: { lat: 65.051804, lon: -146.046997 },
	SOL: { lat: 64.5605, lon: -164.4457 },
	HED: { lat: 55.802346, lon: -160.901346 },
	TWE: { lat: 65.679298, lon: -164.798996 },
	KTH: { lat: 59.9632, lon: -158.477005 },
	NKI: { lat: 55.849602, lon: -133.227994 },
	CDL: { lat: 65.9077, lon: -161.925995 },
	AOS: { lat: 57.4715, lon: -153.815002 },
	BSW: { lat: 60.4231, lon: -146.145996 },
	AKM: { lat: 10.890278, lon: 19.817222 },
	ALZ: { lat: 56.897294, lon: -154.249692 },
	YUK: { lat: 39.202272, lon: 46.455204 },
	AME: { lat: -15.610278, lon: 37.681389 },
	AMY: { lat: -17.686667, lon: 45.623889 },
	INU: { lat: -0.547458, lon: 166.919006 },
	ANZ: { lat: -25.0325, lon: 132.2748 },
	CTV: { lat: -9.431359, lon: 20.311557 },
	ANL: { lat: -11.4723, lon: 16.710899 },
	CNZ: { lat: -13.7106, lon: 19.861099 },
	DRC: { lat: -17.981924, lon: 20.768061 },
	NDF: { lat: -9.280378, lon: 14.982432 },
	AOB: { lat: -4.904167, lon: 144.635833 },
	AOD: { lat: 11.4773, lon: 19.2874 },
	APP: { lat: -8.979167, lon: 148.103611 },
	AQY: { lat: 60.968774, lon: -149.119792 },
	QRF: { lat: -35.145811, lon: -60.480294 },
	CVI: { lat: -46.37428, lon: -67.59409 },
	CNT: { lat: -27.2164, lon: -61.2103 },
	VGS: { lat: -34.995728, lon: -62.999725 },
	LMD: { lat: -40.817699, lon: -68.074699 },
	VCF: { lat: -40.700001, lon: -66.150002 },
	CPG: { lat: -40.7781, lon: -62.9803 },
	ARP: { lat: -9.883333, lon: 149.483333 },
	ASZ: { lat: -6.009722, lon: 150.368611 },
	WFR: { lat: -71.517, lon: 8.8 },
	LYT: { lat: -24.1129, lon: 152.7156 },
	GYZ: { lat: -28.034548, lon: 123.81506 },
	AGW: { lat: -12.1456, lon: 142.149369 },
	AYD: { lat: -19.2908, lon: 136.078995 },
	BYX: { lat: -13.1981, lon: 136.227005 },
	COB: { lat: -15.5483, lon: 130.962006 },
	CRJ: { lat: -31.8944, lon: 132.296005 },
	CRY: { lat: -15.5019, lon: 128.533997 },
	CSD: { lat: -17.948, lon: 135.916 },
	DYM: { lat: -23.7617, lon: 141.145004 },
	HIS: { lat: -20.059999, lon: 148.880997 },
	HLV: { lat: -15.6858, lon: 145.214996 },
	KBD: { lat: -17.3978, lon: 124.355003 },
	KGR: { lat: -25.8428, lon: 133.292007 },
	PEP: { lat: -14.1442, lon: 130.091003 },
	RDA: { lat: -18.9533, lon: 135.201004 },
	SSK: { lat: -19.166401, lon: 128.173996 },
	SWB: { lat: -21.5103, lon: 119.362 },
	TWP: { lat: -17.3633, lon: 143.75 },
	ZVG: { lat: -17.7869, lon: 127.669998 },
	AWR: { lat: -4.122278, lon: 144.853292 },
	AXF: { lat: 38.748317, lon: 105.58416 },
	AXO: { lat: -8.244832, lon: 124.219108 },
	AMF: { lat: -4.101111, lon: 141.67 },
	UAE: { lat: -6.229978, lon: 144.664181 },
	AFR: { lat: -9.13867, lon: 148.390701 },
	AUP: { lat: -9.927715, lon: 149.389951 },
	ATP: { lat: -3.143611, lon: 142.346806 },
	AIH: { lat: -7.342778, lon: 141.2675 },
	AMU: { lat: -3.586, lon: 141.214333 },
	ADC: { lat: -7.137222, lon: 145.744722 },
	AIE: { lat: -5.1457, lon: 144.7307 },
	KPM: { lat: -5.381667, lon: 143.924722 },
	AUJ: { lat: -4.215667, lon: 142.823167 },
	AWB: { lat: -8.013414, lon: 142.752099 },
	AEK: { lat: -7.350805, lon: 146.193994 },
	AYU: { lat: -6.338056, lon: 145.904167 },
	VMU: { lat: -7.496955, lon: 144.821756 },
	BCP: { lat: -5.863611, lon: 146.4925 },
	BNM: { lat: -9.107778, lon: 147.666722 },
	BMZ: { lat: -7.8485, lon: 143.2433 },
	BDZ: { lat: -6.347222, lon: 146.942222 },
	BSP: { lat: -8.858056, lon: 141.259444 },
	BWP: { lat: -3.021667, lon: 141.165278 },
	BUA: { lat: -5.422299, lon: 154.672698 },
	BAA: { lat: -5.33056, lon: 151.007996 },
	OPU: { lat: -8.05, lon: 142.932999 },
	BMH: { lat: -6.373167, lon: 144.637 },
	BPD: { lat: -7.743611, lon: 147.020556 },
	BPK: { lat: -5.526389, lon: 141.744583 },
	BRP: { lat: -7.6693, lon: 146.7594 },
	BUL: { lat: -7.216287, lon: 146.649542 },
	XBN: { lat: -9.6425, lon: 149.303889 },
	CVB: { lat: -4.80662, lon: 144.714996 },
	CGC: { lat: -5.455231, lon: 148.422289 },
	CMU: { lat: -6.02429, lon: 144.970993 },
	SQT: { lat: -10.562778, lon: 150.690694 },
	DBP: { lat: -6.308611, lon: 141.905556 },
	DER: { lat: -6.144722, lon: 147.107222 },
	BNT: { lat: -5.742222, lon: 145.2275 },
	MDM: { lat: -4.6204, lon: 143.4516 },
	KPF: { lat: -8.5336, lon: 142.5049 },
	DNU: { lat: -6.1546, lon: 146.6772 },
	DOI: { lat: -10.7009, lon: 150.7218 },
	DOO: { lat: -9.461855, lon: 147.920907 },
	DAU: { lat: -9.08676, lon: 143.207993 },
	KRU: { lat: -8.271612, lon: 147.071899 },
	EMS: { lat: -9.447, lon: 148.7628 },
	XYR: { lat: -3.883986, lon: 141.792234 },
	EMI: { lat: -1.65395, lon: 149.975767 },
	EFG: { lat: -9.153806, lon: 147.659806 },
	MHY: { lat: -8.714111, lon: 141.644444 },
	EPT: { lat: -5.0412, lon: 141.6779 },
	EGA: { lat: -6.9179, lon: 146.1053 },
	EMO: { lat: -9.1234, lon: 148.0415 },
	ERU: { lat: -8.2538, lon: 146.9747 },
	MFZ: { lat: -6.1364, lon: 149.1183 },
	BOT: { lat: -7.237257, lon: 141.106322 },
	ERE: { lat: -6.606463, lon: 143.900213 },
	SWE: { lat: -6.284181, lon: 147.582371 },
	FNE: { lat: -8.549278, lon: 147.085833 },
	FRQ: { lat: -5.208, lon: 141.6988 },
	FIN: { lat: -6.62175, lon: 147.85405 },
	FAQ: { lat: -4.610468, lon: 141.960138 },
	FUM: { lat: -6.3933, lon: 142.4408 },
	GKA: { lat: -6.08169, lon: 145.391998 },
	GEW: { lat: -9.2263, lon: 148.4949 },
	GUG: { lat: -8.1286, lon: 146.8722 },
	GRL: { lat: -7.980713, lon: 147.213461 },
	GAR: { lat: -7.875625, lon: 147.141266 },
	GAZ: { lat: -9.225918, lon: 152.944352 },
	GOE: { lat: -5.527717, lon: 151.573333 },
	GUR: { lat: -10.3115, lon: 150.334 },
	GAP: { lat: -6.053196, lon: 145.959047 },
	PNP: { lat: -8.80454, lon: 148.309006 },
	GBC: { lat: -6.1028, lon: 141.7393 },
	GMI: { lat: -6.27111, lon: 150.330994 },
	AKG: { lat: -3.560504, lon: 142.217307 },
	GVI: { lat: -3.902243, lon: 141.170517 },
	GOC: { lat: -9.0021, lon: 148.2364 },
	HBD: { lat: -6.32, lon: 142.4893 },
	HNI: { lat: -7.4223, lon: 146.4276 },
	HYF: { lat: -3.69838, lon: 143.057902 },
	HNN: { lat: -6.2457, lon: 142.1771 },
	HKN: { lat: -5.463846, lon: 150.407327 },
	HIT: { lat: -6.9406, lon: 143.059 },
	HWA: { lat: -7.392994, lon: 146.003487 },
	IIS: { lat: -4.49972, lon: 154.225998 },
	IDN: { lat: -6.22663, lon: 147.244 },
	IMN: { lat: -6.7524, lon: 146.1072 },
	KGM: { lat: -5.671, lon: 141.03 },
	IMD: { lat: -3.328, lon: 141.1573 },
	KIE: { lat: -6.305417, lon: 155.728139 },
	IAL: { lat: -6.2782, lon: 143.9944 },
	WSA: { lat: -8.2836, lon: 142.8697 },
	WIU: { lat: -4.689522, lon: 149.440112 },
	MPX: { lat: -4.903056, lon: 141.620833 },
	KGH: { lat: -8.5289, lon: 147.4603 },
	JOP: { lat: -4.747083, lon: 145.007083 },
	LSA: { lat: -8.50582, lon: 151.080994 },
	KBM: { lat: -6.155472, lon: 147.191472 },
	KDR: { lat: -6.19217, lon: 149.54783 },
	KMF: { lat: -7.64925, lon: 145.956944 },
	KPA: { lat: -5.3883, lon: 142.4977 },
	KAQ: { lat: -8.150694, lon: 146.834 },
	UNG: { lat: -6.12571, lon: 141.281998 },
	KNE: { lat: -5.2903, lon: 144.7072 },
	KRI: { lat: -7.42438, lon: 144.250076 },
	KMA: { lat: -7.96361, lon: 145.770996 },
	KKD: { lat: -8.884679, lon: 147.730957 },
	KGW: { lat: -9.135917, lon: 147.669444 },
	KRX: { lat: -4.557, lon: 145.9404 },
	KZF: { lat: -7.50025, lon: 146.033833 },
	KUQ: { lat: -7.135083, lon: 143.276111 },
	KVG: { lat: -2.5794, lon: 150.807999 },
	KWO: { lat: -7.977007, lon: 142.823578 },
	LNV: { lat: -3.04361, lon: 152.628998 },
	LAB: { lat: -5.7204, lon: 148.0566 },
	KEG: { lat: -5.832778, lon: 145.097222 },
	KII: { lat: -9.006528, lon: 142.698056 },
	LGN: { lat: -5.531944, lon: 149.734167 },
	LNM: { lat: -7.223139, lon: 146.227083 },
	LWI: { lat: -6.3344, lon: 146.6458 },
	LPN: { lat: -6.3917, lon: 146.3434 },
	LNG: { lat: -8.2799, lon: 146.2765 },
	LNC: { lat: -6.384611, lon: 147.368639 },
	LMI: { lat: -3.47684, lon: 142.041292 },
	LSJ: { lat: -5.3604, lon: 147.0177 },
	AYM: { lat: 24.467, lon: 54.6103 },
	MRM: { lat: -9.1908, lon: 147.6219 },
	OBM: { lat: -7.74, lon: 147.59 },
	MYX: { lat: -7.211667, lon: 146.019361 },
	MAG: { lat: -5.20708, lon: 145.789001 },
	HGU: { lat: -5.828212, lon: 144.299412 },
	MXK: { lat: -6.471667, lon: 147.441139 },
	MPG: { lat: -6.532222, lon: 147.651167 },
	GUV: { lat: -6.280859, lon: 142.420775 },
	MDU: { lat: -6.14774, lon: 143.656998 },
	MAS: { lat: -2.06189, lon: 147.423996 },
	MLQ: { lat: -8.071389, lon: 146.155472 },
	MQO: { lat: -8.709167, lon: 142.649722 },
	MXH: { lat: -6.36333, lon: 143.238007 },
	MIS: { lat: -10.6892, lon: 152.837997 },
	MKN: { lat: -4.023431, lon: 153.657278 },
	MWG: { lat: -6.9736, lon: 145.8849 },
	MPU: { lat: -2.811389, lon: 151.991111 },
	NKN: { lat: -5.837, lon: 146.4533 },
	KEX: { lat: -7.538889, lon: 145.905 },
	NDN: { lat: -9.143556, lon: 147.68425 },
	AUI: { lat: -1.460556, lon: 143.064722 },
	GBF: { lat: -6.567778, lon: 144.703058 },
	MFO: { lat: -5.577778, lon: 151.792333 },
	NUG: { lat: -3.4075, lon: 154.7383 },
	NDI: { lat: -9.47375, lon: 148.329417 },
	KSB: { lat: -6.3819, lon: 146.9859 },
	KDP: { lat: -5.840611, lon: 143.507222 },
	NMN: { lat: -6.32183, lon: 145.070667 },
	BXZ: { lat: -5.7243, lon: 147.8667 },
	UKU: { lat: -3.676651, lon: 142.484334 },
	ATN: { lat: -3.6695, lon: 152.438 },
	NBA: { lat: -6.2412, lon: 145.2424 },
	LAE: { lat: -6.569803, lon: 146.725977 },
	OBX: { lat: -7.590622, lon: 141.324263 },
	KGB: { lat: -6.2239, lon: 147.2152 },
	OKV: { lat: -5.556667, lon: 141.032778 },
	OGE: { lat: -6.46675, lon: 147.364167 },
	OKP: { lat: -5.2261, lon: 142.2259 },
	HOC: { lat: -7.3984, lon: 145.8827 },
	KQL: { lat: -5.731167, lon: 144.846 },
	OSE: { lat: -7.827778, lon: 147.080639 },
	KOM: { lat: -6.0682, lon: 142.8598 },
	KSP: { lat: -8.450716, lon: 147.209195 },
	KCJ: { lat: -7.2714, lon: 143.5952 },
	OLQ: { lat: -5.389722, lon: 141.515278 },
	KDE: { lat: -5.6952, lon: 142.7441 },
	OPB: { lat: -4.794727, lon: 151.696195 },
	PLE: { lat: -5.372407, lon: 142.975774 },
	PGB: { lat: -7.0226, lon: 141.5605 },
	PDI: { lat: -6.445139, lon: 147.515833 },
	APR: { lat: -4.676667, lon: 142.540139 },
	PGN: { lat: -6.386, lon: 144.1084 },
	PMP: { lat: -6.499167, lon: 143.510278 },
	MPF: { lat: -7.979, lon: 143.1694 },
	PMN: { lat: -9.7469, lon: 149.4766 },
	WLU: { lat: -6.475161, lon: 143.987222 },
	POM: { lat: -9.44338, lon: 147.220001 },
	KRJ: { lat: -4.596667, lon: 143.5225 },
	TLP: { lat: -4.7748, lon: 141.0133 },
	SPH: { lat: -8.3038, lon: 147.1659 },
	ONB: { lat: -8.674361, lon: 147.262417 },
	SXA: { lat: -6.0908, lon: 147.5955 },
	KIQ: { lat: -8.065111, lon: 147.332028 },
	RBP: { lat: -9.971111, lon: 149.832222 },
	RMN: { lat: -5.897222, lon: 141.271667 },
	KMR: { lat: -6.4921, lon: 144.823 },
	RKU: { lat: -8.817, lon: 146.524383 },
	MWI: { lat: -5.13, lon: 143.4829 },
	KOR: { lat: -7.834667, lon: 146.5335 },
	MRH: { lat: -4.3615, lon: 141.785 },
	SBE: { lat: -6.104444, lon: 142.278333 },
	SDI: { lat: -5.627139, lon: 146.462778 },
	NIS: { lat: -2.662222, lon: 151.997778 },
	SFU: { lat: -9.593056, lon: 148.636111 },
	SIL: { lat: -9.073556, lon: 148.38925 },
	SBV: { lat: -5.5765, lon: 155.0489 },
	SIM: { lat: -5.278611, lon: 144.544722 },
	SGK: { lat: -5.125833, lon: 144.323611 },
	SXH: { lat: -9.964528, lon: 151.161861 },
	SBC: { lat: -5.315, lon: 141.752 },
	SMH: { lat: -6.075278, lon: 146.811111 },
	SPV: { lat: -3.8821, lon: 143.6734 },
	TDS: { lat: -7.6217, lon: 142.868 },
	SKC: { lat: -8.0466, lon: 141.7222 },
	SXW: { lat: -5.9701, lon: 148.8543 },
	SWG: { lat: -6.139556, lon: 147.279167 },
	MBV: { lat: -6.345, lon: 147.591 },
	TIZ: { lat: -5.845, lon: 142.947998 },
	TBG: { lat: -5.280471, lon: 141.227576 },
	TFM: { lat: -5.12608, lon: 141.641922 },
	TDB: { lat: -9.1586, lon: 148.0686 },
	TGL: { lat: -11.331111, lon: 153.202917 },
	TFB: { lat: -5.117249, lon: 141.418076 },
	TPI: { lat: -8.356667, lon: 146.989167 },
	RAB: { lat: -4.34046, lon: 152.380005 },
	TKW: { lat: -5.243667, lon: 142.165194 },
	KDQ: { lat: -3.600556, lon: 141.051667 },
	TEP: { lat: -5.9553, lon: 146.5595 },
	TBQ: { lat: -6.466667, lon: 145.532222 },
	TSW: { lat: -7.0695, lon: 146.1272 },
	TRJ: { lat: -5.614, lon: 141.0421 },
	TFI: { lat: -9.075954, lon: 149.319839 },
	TBE: { lat: -4.196633, lon: 143.519222 },
	TWY: { lat: -7.4463, lon: 146.1067 },
	TEO: { lat: -8.169722, lon: 146.194444 },
	TKB: { lat: -7.6808, lon: 146.5503 },
	UMC: { lat: -7.0214, lon: 145.966 },
	URU: { lat: -9.5162, lon: 148.5591 },
	UBI: { lat: -6.729167, lon: 155.683333 },
	AUV: { lat: -5.731111, lon: 148.445278 },
	GLP: { lat: -5.2808, lon: 141.5411 },
	UPR: { lat: -8.5411, lon: 142.6503 },
	KUX: { lat: -5.372361, lon: 141.623889 },
	UVO: { lat: -6.0178, lon: 150.9557 },
	TLW: { lat: -5.2726, lon: 150.0089 },
	TCJ: { lat: -4.0165, lon: 143.1329 },
	VAI: { lat: -2.6926, lon: 141.3028 },
	TON: { lat: -6.6552, lon: 155.4326 },
	WUV: { lat: -1.736111, lon: 142.836667 },
	WAO: { lat: -6.989444, lon: 145.075111 },
	WTT: { lat: -6.1325, lon: 146.467778 },
	WBM: { lat: -5.635293, lon: 143.892231 },
	WAJ: { lat: -6.9523, lon: 142.6557 },
	AGL: { lat: -9.3375, lon: 149.155556 },
	WNU: { lat: -4.8961, lon: 145.3213 },
	WBC: { lat: -9.3376, lon: 150.5093 },
	WWK: { lat: -3.58383, lon: 143.669006 },
	WOA: { lat: -6.796861, lon: 145.891944 },
	WKN: { lat: -5.8603, lon: 155.2223 },
	WSU: { lat: -5.961709, lon: 147.198225 },
	WTP: { lat: -8.545833, lon: 147.2525 },
	WUG: { lat: -7.345556, lon: 146.718611 },
	YVD: { lat: -7.548, lon: 146.188 },
	SMJ: { lat: -7.75, lon: 146.9273 },
	TLO: { lat: -4.98083, lon: 152.009995 },
	WPM: { lat: -8.78822, lon: 142.882004 },
	WEP: { lat: -8.6184, lon: 141.1381 },
	AYY: { lat: 6.86, lon: 81.823889 },
	KYX: { lat: -6.09, lon: 147.0117 },
	YEQ: { lat: -5.109722, lon: 143.917667 },
	TCK: { lat: -4.0949, lon: 143.3838 },
	LNF: { lat: -4.855941, lon: 141.220165 },
	RAX: { lat: -9.632917, lon: 148.048056 },
	KPE: { lat: -4.628056, lon: 141.094167 },
	KSX: { lat: -6.6015, lon: 146.1813 },
	ZEN: { lat: -6.952222, lon: 146.61625 },
	SWR: { lat: -4.529889, lon: 153.054444 },
	WUM: { lat: -6.0491, lon: 149.337 },
	SIZ: { lat: -2.999444, lon: 142.0445 },
	OSG: { lat: -2.915556, lon: 141.297306 },
	ZXT: { lat: 40.494884, lon: 49.977065 },
	HAE: { lat: 36.191601, lon: -113.092003 },
	AZB: { lat: -10.299167, lon: 149.338333 },
	BAJ: { lat: -4.883333, lon: 149.133333 },
	BCW: { lat: -21.8533, lon: 35.438301 },
	BCZ: { lat: -13.780833, lon: 136.201667 },
	JAM: { lat: 42.454899, lon: 26.3522 },
	JEG: { lat: 68.721802, lon: -52.784698 },
	AOQ: { lat: 72.88703, lon: -55.596287 },
	AGM: { lat: 65.612296, lon: -37.618335 },
	LLU: { lat: 60.46445, lon: -45.56917 },
	QUV: { lat: 60.148357, lon: -44.286916 },
	JRK: { lat: 61.176828, lon: -48.419698 },
	QUW: { lat: 60.597376, lon: -45.382445 },
	QGQ: { lat: 67.940663, lon: -53.62187 },
	UAK: { lat: 61.1605, lon: -45.425999 },
	JCH: { lat: 68.822816, lon: -51.173447 },
	CNP: { lat: 70.743103, lon: -22.650499 },
	QFG: { lat: 60.61972, lon: -45.914062 },
	QFN: { lat: 60.004694, lon: -44.656935 },
	JGR: { lat: 61.22896, lon: -48.09698 },
	GOH: { lat: 64.191066, lon: -51.67914 },
	JGO: { lat: 69.251182, lon: -53.514876 },
	IKE: { lat: 70.498145, lon: -51.303084 },
	QFI: { lat: 68.147226, lon: -53.173528 },
	QRY: { lat: 68.140881, lon: -53.441459 },
	XIQ: { lat: 69.080915, lon: -51.114315 },
	IUI: { lat: 73.199895, lon: -56.010817 },
	IOQ: { lat: 65.547792, lon: -38.976552 },
	QJI: { lat: 68.634253, lon: -51.832262 },
	JJU: { lat: 60.715684, lon: -46.029919 },
	JAV: { lat: 69.243202, lon: -51.057098 },
	QPW: { lat: 68.312657, lon: -53.460208 },
	KUS: { lat: 65.573601, lon: -37.1236 },
	KUZ: { lat: 65.863935, lon: -36.997919 },
	KHQ: { lat: 74.57805, lon: -57.226828 },
	KGQ: { lat: 72.381092, lon: -55.536586 },
	QJE: { lat: 68.857926, lon: -53.123295 },
	IOT: { lat: 71.241944, lon: -53.562877 },
	JSU: { lat: 65.412498, lon: -52.9394 },
	JNN: { lat: 60.141884, lon: -45.232977 },
	JUU: { lat: 71.538769, lon: -53.205038 },
	JNS: { lat: 60.917283, lon: -46.059923 },
	NIQ: { lat: 70.789385, lon: -53.662945 },
	NSQ: { lat: 74.109853, lon: -57.065037 },
	JFR: { lat: 62.014736, lon: -49.670937 },
	PQT: { lat: 69.995861, lon: -51.300917 },
	NAQ: { lat: 77.488602, lon: -69.388702 },
	QJH: { lat: 60.780959, lon: -47.156249 },
	OBY: { lat: 70.488229, lon: -21.97168 },
	SFJ: { lat: 67.010446, lon: -50.715294 },
	SGG: { lat: 65.90592, lon: -36.378254 },
	SRK: { lat: 77.786517, lon: -70.638657 },
	QOQ: { lat: 60.537778, lon: -46.024722 },
	JHS: { lat: 66.951302, lon: -53.729301 },
	SAE: { lat: 70.811172, lon: -51.63129 },
	SVR: { lat: 76.018613, lon: -65.117683 },
	TQA: { lat: 73.373055, lon: -56.06028 },
	THU: { lat: 76.531197, lon: -68.703201 },
	TQI: { lat: 65.892027, lon: -37.783409 },
	XEQ: { lat: 60.194305, lon: -44.813447 },
	JUV: { lat: 72.790199, lon: -56.1306 },
	UMD: { lat: 70.680428, lon: -52.11163 },
	JQA: { lat: 70.7342, lon: -52.696201 },
	JUK: { lat: 71.049438, lon: -51.890016 },
	BHL: { lat: 28.9786, lon: -113.560997 },
	BHT: { lat: -23.363333, lon: 141.562778 },
	AEY: { lat: 65.656573, lon: -18.072018 },
	BIU: { lat: 65.641296, lon: -23.5462 },
	BGJ: { lat: 65.516769, lon: -13.81578 },
	BJD: { lat: 66.021896, lon: -14.8244 },
	BLO: { lat: 65.644997, lon: -20.2875 },
	BXV: { lat: 64.790037, lon: -14.043927 },
	DJU: { lat: 64.642372, lon: -14.277297 },
	EGS: { lat: 65.283302, lon: -14.4014 },
	FAS: { lat: 64.931456, lon: -14.047957 },
	FAG: { lat: 63.874699, lon: -16.6411 },
	GUU: { lat: 64.991402, lon: -23.224701 },
	GJR: { lat: 65.9953, lon: -21.3269 },
	GRY: { lat: 66.5458, lon: -18.0173 },
	HVK: { lat: 65.704697, lon: -21.6964 },
	HFN: { lat: 64.295601, lon: -15.2272 },
	FLI: { lat: 66.01418, lon: -23.441691 },
	HZK: { lat: 65.952301, lon: -17.426001 },
	HLO: { lat: 66.050003, lon: -23.6961 },
	IFJ: { lat: 66.058098, lon: -23.1353 },
	KEF: { lat: 63.985001, lon: -22.6056 },
	OPA: { lat: 66.310799, lon: -16.4667 },
	SAK: { lat: 65.731697, lon: -19.5728 },
	NOR: { lat: 65.131897, lon: -13.7464 },
	OFJ: { lat: 66.083298, lon: -18.6667 },
	PFJ: { lat: 65.555801, lon: -23.965 },
	RHA: { lat: 65.452629, lon: -22.206116 },
	OLI: { lat: 64.9114, lon: -23.823099 },
	RFN: { lat: 66.406403, lon: -15.9183 },
	RKV: { lat: 64.128732, lon: -21.93759 },
	MVA: { lat: 65.6558, lon: -16.9181 },
	SIJ: { lat: 66.137847, lon: -18.908157 },
	SYK: { lat: 65.058851, lon: -22.764616 },
	TEY: { lat: 65.8703, lon: -23.559999 },
	THO: { lat: 66.218498, lon: -15.3356 },
	VEY: { lat: 63.424301, lon: -20.2789 },
	VPN: { lat: 65.720596, lon: -14.8506 },
	BJE: { lat: 11.199444, lon: 28.523056 },
	BJQ: { lat: 19.873056, lon: 56.067778 },
	BJT: { lat: 6.431, lon: 79.996 },
	PRN: { lat: 42.5728, lon: 21.035801 },
	BMQ: { lat: -3.983363, lon: 39.730982 },
	BNF: { lat: 57.088799, lon: -134.833146 },
	BNV: { lat: -6.426631, lon: 146.826697 },
	BVL: { lat: -13.654426, lon: -63.704718 },
	BOV: { lat: -3.3834, lon: 153.2812 },
	BQV: { lat: 58.4552, lon: -135.884995 },
	CJZ: { lat: -6.8827, lon: -38.61583 },
	VDC: { lat: -14.907885, lon: -40.914804 },
	CMP: { lat: -9.319906, lon: -50.328536 },
	AAI: { lat: -13.025154, lon: -46.884107 },
	ITN: { lat: -14.8105, lon: -39.290401 },
	LEP: { lat: -21.468226, lon: -42.727076 },
	CPU: { lat: -1.820006, lon: -44.864065 },
	CTQ: { lat: -33.502038, lon: -53.344911 },
	APY: { lat: -9.08533, lon: -45.955603 },
	JRN: { lat: -10.305833, lon: -58.489445 },
	STZ: { lat: -10.464722, lon: -50.518612 },
	MTG: { lat: -14.995499, lon: -59.945662 },
	ALT: { lat: -1.917, lon: -54.7231 },
	NSB: { lat: 25.767, lon: -79.25 },
	BSV: { lat: -15.6725, lon: 47.061667 },
	BTZ: { lat: 5.79, lon: 101.15 },
	HUK: { lat: -23.9897, lon: 21.758101 },
	BWJ: { lat: -6.396944, lon: 146.881667 },
	BXL: { lat: -16.943, lon: 177.368 },
	TXC: { lat: 54.439999, lon: 30.2967 },
	BYA: { lat: 64.077678, lon: -141.122088 },
	BYL: { lat: 7.369167, lon: -9.993722 },
	BYV: { lat: 6.929444, lon: 79.854167 },
	BCV: { lat: 17.269603, lon: -88.776496 },
	BGK: { lat: 16.519369, lon: -88.407913 },
	CUK: { lat: 17.735015, lon: -88.032862 },
	CYC: { lat: 17.683792, lon: -88.044985 },
	CZH: { lat: 18.3822, lon: -88.411903 },
	DGA: { lat: 16.98251, lon: -88.230988 },
	INB: { lat: 16.53456, lon: -88.441615 },
	MDB: { lat: 17.004299, lon: -88.304199 },
	ORZ: { lat: 18.046767, lon: -88.583858 },
	PND: { lat: 16.1024, lon: -88.808296 },
	SJX: { lat: 18.3561, lon: -88.130798 },
	SPR: { lat: 17.9139, lon: -87.9711 },
	SQS: { lat: 17.185898, lon: -89.009936 },
	STU: { lat: 18.2721, lon: -88.456299 },
	SVK: { lat: 16.728338, lon: -88.369174 },
	TZA: { lat: 17.517239, lon: -88.195775 },
	BZB: { lat: -21.5411, lon: 35.4729 },
	BZM: { lat: -17.6925, lon: 45.088833 },
	PFM: { lat: 55.390002, lon: -111.1198 },
	YSV: { lat: 58.474312, lon: -62.653999 },
	YRR: { lat: 50.409447, lon: -125.131617 },
	YMV: { lat: 71.324167, lon: -79.356944 },
	YHC: { lat: 51.669733, lon: -128.08181 },
	YMF: { lat: 48.89225, lon: -123.39215 },
	PYS: { lat: 39.71029, lon: -121.616528 },
	YBW: { lat: 48.75, lon: -123.233002 },
	YTP: { lat: 49.155, lon: -125.91 },
	CBA: { lat: 49.8636, lon: -119.568045 },
	ZNA: { lat: 49.169813, lon: -123.933845 },
	YZZ: { lat: 49.055599, lon: -117.609001 },
	YMB: { lat: 50.122504, lon: -120.745368 },
	YHH: { lat: 50.049999, lon: -125.25 },
	YWS: { lat: 50.1436, lon: -122.948997 },
	YBF: { lat: 48.835967, lon: -125.137453 },
	YIG: { lat: 50.3923, lon: -125.1372 },
	CJH: { lat: 51.625797, lon: -124.144478 },
	YPT: { lat: 49.623785, lon: -124.024884 },
	ZOF: { lat: 52.366699, lon: -127.717003 },
	YCA: { lat: 49.679237, lon: -124.98064 },
	CFQ: { lat: 49.0369, lon: -116.498001 },
	YAA: { lat: 52.451501, lon: -125.303776 },
	DGF: { lat: 50.16546, lon: -120.171273 },
	JHL: { lat: 57.2239, lon: -111.418999 },
	ZTS: { lat: 49.92, lon: -126.655 },
	DUQ: { lat: 48.754534, lon: -123.709702 },
	YHS: { lat: 49.460602, lon: -123.719002 },
	YKK: { lat: 53.799999, lon: -130.432999 },
	ZQS: { lat: 53.25282, lon: -132.074214 },
	WPL: { lat: 49.887335, lon: -124.53372 },
	XQU: { lat: 49.337456, lon: -124.393086 },
	YMP: { lat: 50.57348, lon: -127.027702 },
	YRN: { lat: 51.683985, lon: -127.264044 },
	YTG: { lat: 50.885359, lon: -126.831069 },
	YMU: { lat: 50.07137, lon: -124.98362 },
	YAV: { lat: 48.852241, lon: -123.301982 },
	YSX: { lat: 52.150002, lon: -128.08299 },
	YGG: { lat: 48.8545, lon: -123.4969 },
	YTB: { lat: 53.416698, lon: -129.25 },
	YZA: { lat: 50.775258, lon: -121.321314 },
	ZEL: { lat: 52.185001, lon: -128.156994 },
	CBC: { lat: -18.917778, lon: 125.537778 },
	YPB: { lat: 49.321899, lon: -124.931 },
	YBO: { lat: 56.966702, lon: -130.25 },
	TNS: { lat: 61.956902, lon: -128.203003 },
	TUX: { lat: 55.025002, lon: -120.934998 },
	YWM: { lat: 52.567377, lon: -55.784883 },
	YSO: { lat: 54.9105, lon: -59.78507 },
	YBI: { lat: 53.469836, lon: -55.787501 },
	YHG: { lat: 52.765774, lon: -56.11237 },
	YFX: { lat: 52.372799, lon: -55.673901 },
	YHA: { lat: 52.528099, lon: -56.286098 },
	YRG: { lat: 54.179699, lon: -58.4575 },
	KGN: { lat: -6.468027, lon: 16.805012 },
	DVK: { lat: 64.511398, lon: -110.289001 },
	JOJ: { lat: 68.125275, lon: -106.585281 },
	ZFW: { lat: 56.081402, lon: -118.434998 },
	YJP: { lat: 53.319199, lon: -117.752998 },
	YLE: { lat: 63.131699, lon: -117.246002 },
	YDC: { lat: 53.2658, lon: -114.959999 },
	NML: { lat: 57.055599, lon: -111.573997 },
	CFM: { lat: 55.695301, lon: -111.278999 },
	KWD: { lat: 7.964938, lon: 23.526018 },
	GSL: { lat: 62.598099, lon: -111.542999 },
	XMP: { lat: 63.181099, lon: -130.201996 },
	DAS: { lat: 66.703053, lon: -119.716816 },
	YFI: { lat: 57.275833, lon: -110.976666 },
	YOE: { lat: 55.7094, lon: -117.094002 },
	TIL: { lat: 51.057499, lon: -113.624001 },
	OKG: { lat: -1.44833, lon: 15.0733 },
	CGA: { lat: 55.478802, lon: -133.147995 },
	CGG: { lat: 16.1941, lon: 122.0651 },
	GHK: { lat: 63.435198, lon: -109.144812 },
	CHP: { lat: 65.485497, lon: -144.610992 },
	CIV: { lat: 55.217, lon: -132.21 },
	LRQ: { lat: 56.2486, lon: -101.304001 },
	YDJ: { lat: 58.662498, lon: -103.538002 },
	YDU: { lat: 60.291901, lon: -102.501999 },
	YFL: { lat: 62.7, lon: -109.167 },
	XCL: { lat: 58.391102, lon: -109.515999 },
	YKE: { lat: 54.915298, lon: -94.798103 },
	SUR: { lat: 52.708599, lon: -88.541901 },
	CKD: { lat: 61.870315, lon: -158.137636 },
	YTT: { lat: 52.8367, lon: -104.067001 },
	YAX: { lat: 53.849201, lon: -89.579399 },
	WNN: { lat: 52.893902, lon: -89.2892 },
	YBS: { lat: 52.606701, lon: -90.3769 },
	YNO: { lat: 52.490002, lon: -92.9711 },
	CKR: { lat: 48.5978, lon: -122.9979 },
	CKU: { lat: 60.5439, lon: -145.727005 },
	YDW: { lat: 60.315719, lon: -103.131324 },
	CKX: { lat: 64.066495, lon: -141.951342 },
	CMT: { lat: -2.2468, lon: -49.56 },
	CMZ: { lat: -17.8331, lon: 35.3341 },
	ZKL: { lat: 29.376484, lon: 104.625789 },
	BZX: { lat: 31.73842, lon: 106.644872 },
	DFA: { lat: 33.708533, lon: 110.249284 },
	HSC: { lat: 24.9786, lon: 113.420998 },
	JGS: { lat: 26.856899, lon: 114.737 },
	JNH: { lat: 30.705535, lon: 120.679779 },
	DWS: { lat: 48.38745, lon: 124.43127 },
	LCT: { lat: 37.91305, lon: 114.59166 },
	WHN: { lat: 30.25521, lon: 114.062805 },
	NAY: { lat: 39.48595, lon: 116.37236 },
	PFA: { lat: 45.59886, lon: 126.65808 },
	PNJ: { lat: 37.80473, lon: 120.80954 },
	CBZ: { lat: 37.61055, lon: 117.885699 },
	DDR: { lat: 28.604567, lon: 86.798 },
	HQL: { lat: 37.661333, lon: 75.288877 },
	HEW: { lat: 29.122619, lon: 120.24289 },
	JDE: { lat: 29.360905, lon: 119.180829 },
	HLJ: { lat: 46.12779, lon: 125.77354 },
	TYC: { lat: 37.50312, lon: 112.424126 },
	WRH: { lat: 46.01761, lon: 85.657436 },
	JRJ: { lat: 25.960236, lon: 116.077016 },
	APJ: { lat: 30.397898, lon: 81.13317 },
	ZFL: { lat: 43.088477, lon: 81.223013 },
	YEH: { lat: 38.588095, lon: 106.539788 },
	LCS: { lat: 24.26652, lon: 97.9048 },
	LFH: { lat: 26.64518, lon: 99.54419 },
	ZGN: { lat: 22.519296, lon: 113.361307 },
	BZJ: { lat: 33.560777, lon: 115.911859 },
	BKV: { lat: 41.656944, lon: 110.3125 },
	HJB: { lat: 42.976395, lon: 83.995543 },
	OTQ: { lat: 38.1712, lon: 107.3905 },
	JBK: { lat: 44.166086, lon: 89.55014 },
	LIJ: { lat: 28.3727, lon: 119.839 },
	YHJ: { lat: 28.700972, lon: 116.107694 },
	OTO: { lat: 39.03139, lon: 107.98889 },
	BFY: { lat: 33.165808, lon: 117.057295 },
	XBE: { lat: 53.965599, lon: -91.027199 },
	YNP: { lat: 55.913898, lon: -61.184399 },
	YWR: { lat: 48.6269, lon: -85.223297 },
	YPD: { lat: 45.2575, lon: -79.829697 },
	XBR: { lat: 44.6394, lon: -75.750298 },
	KIF: { lat: 53.012501, lon: -89.855301 },
	LCR: { lat: -1.456361, lon: -72.801086 },
	YEB: { lat: 46.421233, lon: -84.096478 },
	CPI: { lat: -5.448333, lon: 152.081944 },
	YSI: { lat: 45.173302, lon: -80.137497 },
	KEW: { lat: 52.9911, lon: -92.836403 },
	ACO: { lat: 9.693365, lon: -85.091216 },
	KFM: { lat: 55.355598, lon: -110.637001 },
	YSA: { lat: 43.928235, lon: -59.948986 },
	YLS: { lat: 49.0303, lon: -77.017197 },
	YNX: { lat: 63.593601, lon: -110.905998 },
	SSQ: { lat: 48.917198, lon: -79.178596 },
	YKU: { lat: 53.805599, lon: -78.916901 },
	ZTB: { lat: 50.6744, lon: -59.383598 },
	ZKG: { lat: 50.195801, lon: -61.2658 },
	YWQ: { lat: 49.9434, lon: -71.138 },
	CTP: { lat: -1.225365, lon: -46.019057 },
	YAU: { lat: 61.662201, lon: -73.321404 },
	ZGS: { lat: 50.259553, lon: -60.674357 },
	YFG: { lat: 54.553902, lon: -71.173302 },
	ZLT: { lat: 50.830799, lon: -58.975601 },
	CUJ: { lat: 11.8553, lon: 119.9378 },
	CVL: { lat: -9.67, lon: 150.019722 },
	CXC: { lat: 61.582901, lon: -144.427002 },
	YAB: { lat: 73.006101, lon: -85.04616 },
	YAC: { lat: 51.7272, lon: -91.824402 },
	YAR: { lat: 53.571701, lon: -76.196404 },
	YAG: { lat: 48.655749, lon: -93.44349 },
	YAH: { lat: 53.7547, lon: -73.675301 },
	YAL: { lat: 50.582199, lon: -126.916 },
	YAM: { lat: 46.483216, lon: -84.508467 },
	XKS: { lat: 53.5247, lon: -88.642799 },
	YKG: { lat: 60.027199, lon: -69.999199 },
	YAT: { lat: 52.927502, lon: -82.4319 },
	YAY: { lat: 51.391909, lon: -56.08321 },
	YAZ: { lat: 49.079833, lon: -125.775583 },
	YBA: { lat: 51.208222, lon: -115.540624 },
	YBB: { lat: 68.535711, lon: -89.805508 },
	YBC: { lat: 49.1325, lon: -68.204399 },
	QBC: { lat: 52.387501, lon: -126.596001 },
	YBE: { lat: 59.561401, lon: -108.481003 },
	YBY: { lat: 54.304199, lon: -110.744003 },
	YBG: { lat: 48.331908, lon: -70.992909 },
	YBK: { lat: 64.298897, lon: -96.077797 },
	YBL: { lat: 49.950802, lon: -125.271004 },
	XTL: { lat: 58.706308, lon: -98.511057 },
	YBR: { lat: 49.91, lon: -99.951897 },
	YBT: { lat: 57.8894, lon: -101.679001 },
	YBV: { lat: 52.358898, lon: -97.018303 },
	YBX: { lat: 51.4436, lon: -57.185299 },
	YRF: { lat: 53.682501, lon: -57.042303 },
	YCB: { lat: 69.108101, lon: -105.138 },
	YCC: { lat: 45.092637, lon: -74.567724 },
	YCD: { lat: 49.05497, lon: -123.869863 },
	YCE: { lat: 43.285599, lon: -81.508301 },
	YCG: { lat: 49.296398, lon: -117.632004 },
	YCH: { lat: 47.007801, lon: -65.449203 },
	XCM: { lat: 42.3064, lon: -82.081902 },
	YCL: { lat: 47.990799, lon: -66.330299 },
	YCN: { lat: 49.105598, lon: -81.013603 },
	YCO: { lat: 67.816408, lon: -115.14307 },
	YCQ: { lat: 55.687199, lon: -121.626999 },
	YCR: { lat: 54.609758, lon: -97.762442 },
	YCS: { lat: 63.346901, lon: -90.731102 },
	YCT: { lat: 52.075001, lon: -111.445 },
	YCW: { lat: 49.153157, lon: -121.939309 },
	YCY: { lat: 70.486099, lon: -68.516701 },
	YCZ: { lat: 50.331052, lon: -115.873739 },
	YDA: { lat: 64.043098, lon: -139.128006 },
	YDB: { lat: 61.371101, lon: -139.041 },
	YDF: { lat: 49.2108, lon: -57.391399 },
	YDL: { lat: 58.422199, lon: -130.031998 },
	XRR: { lat: 61.9706, lon: -132.423004 },
	YDN: { lat: 51.1008, lon: -100.052002 },
	YDO: { lat: 48.7785, lon: -72.375 },
	YDP: { lat: 56.550778, lon: -61.682224 },
	YDQ: { lat: 55.741245, lon: -120.183263 },
	YEG: { lat: 53.3097, lon: -113.580002 },
	YEK: { lat: 61.0942, lon: -94.070801 },
	YEL: { lat: 46.351398, lon: -82.561401 },
	YEM: { lat: 45.842435, lon: -81.857595 },
	YEN: { lat: 49.2103, lon: -102.966003 },
	YER: { lat: 56.018902, lon: -87.676102 },
	YET: { lat: 53.578899, lon: -116.464996 },
	YEU: { lat: 79.994698, lon: -85.814201 },
	YEV: { lat: 68.304199, lon: -133.483002 },
	YEY: { lat: 48.563903, lon: -78.249702 },
	YFA: { lat: 52.203451, lon: -81.695194 },
	YFB: { lat: 63.756402, lon: -68.555801 },
	YFC: { lat: 45.8689, lon: -66.537201 },
	YFE: { lat: 48.746101, lon: -69.097198 },
	YFH: { lat: 51.561901, lon: -87.907799 },
	YTM: { lat: 46.409401, lon: -74.779999 },
	YFO: { lat: 54.678101, lon: -101.681999 },
	YFR: { lat: 61.180801, lon: -113.690002 },
	YFS: { lat: 61.760201, lon: -121.237 },
	YMN: { lat: 55.077335, lon: -59.187942 },
	YGB: { lat: 49.694341, lon: -124.518099 },
	YGH: { lat: 66.240658, lon: -128.647757 },
	YGK: { lat: 44.2253, lon: -76.596901 },
	YGL: { lat: 53.625301, lon: -77.704201 },
	YGM: { lat: 50.628101, lon: -97.043297 },
	YGO: { lat: 54.55768, lon: -94.490061 },
	YGP: { lat: 48.774915, lon: -64.481893 },
	YGQ: { lat: 49.778301, lon: -86.9394 },
	YGR: { lat: 47.425242, lon: -61.778612 },
	YGT: { lat: 69.3647, lon: -81.816101 },
	YGV: { lat: 50.281898, lon: -63.611401 },
	YGW: { lat: 55.281898, lon: -77.765297 },
	YGX: { lat: 56.35712, lon: -94.711504 },
	YGZ: { lat: 76.425823, lon: -82.908583 },
	YQC: { lat: 61.046398, lon: -69.617798 },
	YHB: { lat: 52.8167, lon: -102.310997 },
	CXH: { lat: 49.291265, lon: -123.11717 },
	YHD: { lat: 49.831699, lon: -92.744202 },
	YHE: { lat: 49.368865, lon: -121.49495 },
	YHF: { lat: 49.714199, lon: -83.686096 },
	YNS: { lat: 51.691101, lon: -76.135597 },
	YHI: { lat: 70.762802, lon: -117.806 },
	YHK: { lat: 68.635597, lon: -95.849701 },
	YHM: { lat: 43.173599, lon: -79.934998 },
	YHN: { lat: 49.1931, lon: -84.758904 },
	YHO: { lat: 55.448757, lon: -60.228124 },
	YHP: { lat: 52.1133, lon: -94.2556 },
	YHR: { lat: 50.468322, lon: -59.637823 },
	YHT: { lat: 60.7892, lon: -137.546005 },
	YHU: { lat: 45.517502, lon: -73.416901 },
	YHY: { lat: 60.839699, lon: -115.782997 },
	YHZ: { lat: 44.880798, lon: -63.508598 },
	YIB: { lat: 48.773899, lon: -91.638603 },
	YDG: { lat: 44.545845, lon: -65.785425 },
	YIF: { lat: 51.2117, lon: -58.658298 },
	YIK: { lat: 62.417301, lon: -77.925301 },
	YIO: { lat: 72.689494, lon: -77.968941 },
	YIV: { lat: 53.857201, lon: -94.653603 },
	YJA: { lat: 52.996418, lon: -118.060233 },
	YJF: { lat: 60.235802, lon: -123.469002 },
	YJN: { lat: 45.294399, lon: -73.281097 },
	YJT: { lat: 48.544201, lon: -58.549999 },
	YKA: { lat: 50.703038, lon: -120.448641 },
	YKC: { lat: 58.236099, lon: -103.678001 },
	LAK: { lat: 68.223297, lon: -135.00599 },
	YKF: { lat: 43.4608, lon: -80.378601 },
	YWB: { lat: 61.5886, lon: -71.929398 },
	YKJ: { lat: 57.2561, lon: -105.617996 },
	YKL: { lat: 54.805302, lon: -66.805298 },
	YKD: { lat: 44.201401, lon: -81.606697 },
	AKV: { lat: 60.8186, lon: -78.148598 },
	YOG: { lat: 51.6586, lon: -85.901703 },
	YKQ: { lat: 51.473301, lon: -78.758301 },
	YKX: { lat: 48.2103, lon: -79.9814 },
	YKY: { lat: 51.517502, lon: -109.181 },
	YPJ: { lat: 59.2967, lon: -69.599701 },
	YLB: { lat: 54.770302, lon: -112.031998 },
	YLC: { lat: 62.848253, lon: -69.877853 },
	YLD: { lat: 47.82, lon: -83.346703 },
	YLH: { lat: 52.195599, lon: -87.934196 },
	YLJ: { lat: 54.125301, lon: -108.523003 },
	YSG: { lat: 62.417823, lon: -110.682793 },
	YLL: { lat: 53.3092, lon: -110.072998 },
	YLQ: { lat: 47.409698, lon: -72.788902 },
	YLR: { lat: 56.513302, lon: -99.985298 },
	YLK: { lat: 44.485056, lon: -79.554663 },
	YLT: { lat: 82.517799, lon: -62.280602 },
	XGR: { lat: 58.711399, lon: -65.992798 },
	YLW: { lat: 49.9561, lon: -119.377998 },
	CYM: { lat: 57.5149, lon: -134.945999 },
	YMA: { lat: 63.616402, lon: -135.867996 },
	YME: { lat: 48.856899, lon: -67.4533 },
	YMG: { lat: 49.0839, lon: -85.860603 },
	YMH: { lat: 52.302837, lon: -55.847433 },
	YMJ: { lat: 50.330299, lon: -105.558998 },
	YML: { lat: 47.5975, lon: -70.2239 },
	YMM: { lat: 56.653301, lon: -111.222 },
	YMO: { lat: 51.2911, lon: -80.607803 },
	YMT: { lat: 49.7719, lon: -74.528099 },
	YUD: { lat: 56.536098, lon: -76.518303 },
	YMW: { lat: 46.2728, lon: -75.990601 },
	YMX: { lat: 45.679501, lon: -74.038696 },
	YNA: { lat: 50.190114, lon: -61.78898 },
	YNC: { lat: 53.010601, lon: -78.8311 },
	YND: { lat: 45.521702, lon: -75.563599 },
	YNE: { lat: 53.958302, lon: -97.8442 },
	YNH: { lat: 56.035142, lon: -121.978326 },
	YLY: { lat: 49.1008, lon: -122.630997 },
	YNL: { lat: 58.276699, lon: -104.082001 },
	YNM: { lat: 49.7617, lon: -77.802803 },
	HZP: { lat: 57.381699, lon: -111.700996 },
	YOA: { lat: 64.698898, lon: -110.614998 },
	YOC: { lat: 67.570602, lon: -139.839005 },
	YOD: { lat: 54.404999, lon: -110.278999 },
	YOH: { lat: 54.9333, lon: -95.2789 },
	YOJ: { lat: 58.621399, lon: -117.165001 },
	YOO: { lat: 43.922798, lon: -78.894997 },
	YOP: { lat: 58.491402, lon: -119.407997 },
	YOS: { lat: 44.590302, lon: -80.837502 },
	YOW: { lat: 45.322498, lon: -75.669197 },
	YPA: { lat: 53.214199, lon: -105.672997 },
	YPC: { lat: 69.360838, lon: -124.07547 },
	YPS: { lat: 45.6567, lon: -61.368099 },
	YPE: { lat: 56.226898, lon: -117.446999 },
	YPG: { lat: 49.903099, lon: -98.273817 },
	YPH: { lat: 58.471901, lon: -78.076897 },
	YPL: { lat: 51.4464, lon: -90.214203 },
	YPM: { lat: 51.819698, lon: -93.973297 },
	YPN: { lat: 49.836399, lon: -64.288597 },
	YPO: { lat: 54.987932, lon: -85.442648 },
	YPQ: { lat: 44.23, lon: -78.363297 },
	YPR: { lat: 54.286098, lon: -130.445007 },
	YPW: { lat: 49.834202, lon: -124.5 },
	YPX: { lat: 60.050598, lon: -77.286903 },
	YPY: { lat: 58.7672, lon: -111.116997 },
	YPZ: { lat: 54.3764, lon: -125.950996 },
	YQA: { lat: 44.975376, lon: -79.306546 },
	YQB: { lat: 46.7911, lon: -71.393303 },
	YQD: { lat: 53.971401, lon: -101.091003 },
	YQF: { lat: 52.182201, lon: -113.893997 },
	YQG: { lat: 42.2756, lon: -82.955597 },
	YQH: { lat: 60.116839, lon: -128.821993 },
	YQI: { lat: 43.8269, lon: -66.088097 },
	YQK: { lat: 49.7883, lon: -94.363098 },
	YQL: { lat: 49.630299, lon: -112.800003 },
	YQM: { lat: 46.112202, lon: -64.678596 },
	YQN: { lat: 50.1828, lon: -86.696404 },
	YQQ: { lat: 49.7108, lon: -124.887001 },
	YQR: { lat: 50.4319, lon: -104.666 },
	YQS: { lat: 42.77, lon: -81.110802 },
	YQT: { lat: 48.371899, lon: -89.323898 },
	YQU: { lat: 55.179699, lon: -118.885002 },
	YQV: { lat: 51.264702, lon: -102.461998 },
	YQW: { lat: 52.769409, lon: -108.243742 },
	YQX: { lat: 48.936258, lon: -54.567719 },
	YQY: { lat: 46.1614, lon: -60.047798 },
	YQZ: { lat: 53.0261, lon: -122.510002 },
	YRA: { lat: 64.116096, lon: -117.309998 },
	YRB: { lat: 74.716904, lon: -94.969398 },
	YRI: { lat: 47.7644, lon: -69.584702 },
	YRJ: { lat: 48.519665, lon: -72.265735 },
	YRL: { lat: 51.066898, lon: -93.793098 },
	YRM: { lat: 52.429699, lon: -114.903999 },
	YRO: { lat: 45.4603, lon: -75.646103 },
	YRQ: { lat: 46.352798, lon: -72.679398 },
	YRS: { lat: 54.167198, lon: -93.557198 },
	YRT: { lat: 62.811401, lon: -92.115799 },
	YRV: { lat: 50.962245, lon: -118.184258 },
	YSB: { lat: 46.625, lon: -80.798897 },
	YSC: { lat: 45.438599, lon: -71.691399 },
	YSD: { lat: 50.276359, lon: -111.180189 },
	YSE: { lat: 49.7817, lon: -123.162003 },
	YSF: { lat: 59.250301, lon: -105.841003 },
	YSH: { lat: 44.945801, lon: -75.940598 },
	YSJ: { lat: 45.316101, lon: -65.890297 },
	YSK: { lat: 56.536891, lon: -79.250221 },
	YSL: { lat: 47.157097, lon: -67.836242 },
	YSM: { lat: 60.020302, lon: -111.961998 },
	YCM: { lat: 43.191598, lon: -79.171686 },
	YSP: { lat: 48.755299, lon: -86.344398 },
	YST: { lat: 53.845261, lon: -94.851966 },
	YSU: { lat: 46.440601, lon: -63.833599 },
	YSY: { lat: 71.993896, lon: -125.242996 },
	YTA: { lat: 45.864399, lon: -77.251701 },
	YTE: { lat: 64.230003, lon: -76.526703 },
	YTF: { lat: 48.5089, lon: -71.641899 },
	YTH: { lat: 55.801102, lon: -97.864197 },
	YTL: { lat: 53.817799, lon: -89.896896 },
	YTQ: { lat: 58.667801, lon: -69.955803 },
	YTR: { lat: 44.1189, lon: -77.528099 },
	YTS: { lat: 48.569698, lon: -81.376701 },
	YTZ: { lat: 43.627499, lon: -79.396202 },
	YUB: { lat: 69.433296, lon: -133.026001 },
	YUL: { lat: 45.467837, lon: -73.742294 },
	YUT: { lat: 66.521024, lon: -86.225166 },
	YUX: { lat: 68.7761, lon: -81.2425 },
	YUY: { lat: 48.2061, lon: -78.835602 },
	YVB: { lat: 48.071098, lon: -65.460297 },
	YVC: { lat: 55.151402, lon: -105.262001 },
	YVG: { lat: 53.357714, lon: -110.827388 },
	YVE: { lat: 50.246163, lon: -119.330963 },
	YCK: { lat: 67.02015, lon: -126.128364 },
	YVM: { lat: 67.54656, lon: -64.03141 },
	YVO: { lat: 48.053299, lon: -77.782799 },
	YVP: { lat: 58.0961, lon: -68.426903 },
	YVQ: { lat: 65.281601, lon: -126.797997 },
	YVR: { lat: 49.193901, lon: -123.183998 },
	YVT: { lat: 55.8419, lon: -108.417999 },
	YVV: { lat: 44.7458, lon: -81.107201 },
	YVZ: { lat: 52.655613, lon: -94.061208 },
	YWA: { lat: 45.952202, lon: -77.319199 },
	YFJ: { lat: 64.190804, lon: -114.077002 },
	YWG: { lat: 49.91, lon: -97.239899 },
	YWH: { lat: 48.423782, lon: -123.37198 },
	YWJ: { lat: 65.211098, lon: -123.435997 },
	YWK: { lat: 52.921902, lon: -66.864403 },
	YWL: { lat: 52.183102, lon: -122.054001 },
	YWP: { lat: 52.959393, lon: -87.374868 },
	YWY: { lat: 63.2094, lon: -123.436996 },
	YXC: { lat: 49.610802, lon: -115.781998 },
	YXE: { lat: 52.170799, lon: -106.699997 },
	YXH: { lat: 50.018902, lon: -110.721001 },
	YXJ: { lat: 56.238098, lon: -120.739998 },
	YXK: { lat: 48.477644, lon: -68.496323 },
	YXL: { lat: 50.113899, lon: -91.905296 },
	YXN: { lat: 62.240002, lon: -92.598099 },
	YXP: { lat: 66.144878, lon: -65.713606 },
	YXQ: { lat: 62.410301, lon: -140.867004 },
	YXR: { lat: 47.697401, lon: -79.847345 },
	YXS: { lat: 53.884311, lon: -122.666554 },
	YXT: { lat: 54.468498, lon: -128.576009 },
	YXU: { lat: 43.035599, lon: -81.1539 },
	YXX: { lat: 49.025299, lon: -122.361 },
	YXY: { lat: 60.709599, lon: -135.067001 },
	YXZ: { lat: 47.966702, lon: -84.786697 },
	YYB: { lat: 46.363602, lon: -79.422798 },
	YYC: { lat: 51.118822, lon: -114.009933 },
	YYD: { lat: 54.824699, lon: -127.182999 },
	YYE: { lat: 58.836399, lon: -122.597 },
	YYF: { lat: 49.4631, lon: -119.601997 },
	YYG: { lat: 46.290001, lon: -63.121101 },
	YYH: { lat: 69.5467, lon: -93.576698 },
	YYJ: { lat: 48.647201, lon: -123.427792 },
	YYL: { lat: 56.863899, lon: -101.075996 },
	YYM: { lat: 49.636398, lon: -114.094002 },
	YYN: { lat: 50.291901, lon: -107.691002 },
	YYQ: { lat: 58.739201, lon: -94.065002 },
	YYR: { lat: 53.319199, lon: -60.4258 },
	YYT: { lat: 47.618599, lon: -52.7519 },
	YYU: { lat: 49.411587, lon: -82.469645 },
	YYW: { lat: 50.290298, lon: -88.909698 },
	YYY: { lat: 48.608601, lon: -68.208099 },
	YYZ: { lat: 43.6772, lon: -79.6306 },
	YZE: { lat: 45.8853, lon: -82.567802 },
	YZF: { lat: 62.462799, lon: -114.440002 },
	YZG: { lat: 62.179401, lon: -75.667198 },
	YZH: { lat: 55.292945, lon: -114.777276 },
	YZP: { lat: 53.254299, lon: -131.813995 },
	YZR: { lat: 42.999401, lon: -82.308899 },
	YZS: { lat: 64.193298, lon: -83.359398 },
	YZT: { lat: 50.680599, lon: -127.366997 },
	YZU: { lat: 54.143902, lon: -115.787003 },
	YZV: { lat: 50.223301, lon: -66.265602 },
	YZW: { lat: 60.172798, lon: -132.742996 },
	YZX: { lat: 44.984402, lon: -64.916901 },
	ZAC: { lat: 56.089401, lon: -96.089203 },
	YSN: { lat: 50.682802, lon: -119.228996 },
	YDT: { lat: 49.0742, lon: -123.012001 },
	ILF: { lat: 56.051622, lon: -95.61882 },
	ZBF: { lat: 47.6297, lon: -65.738899 },
	ZBM: { lat: 45.290798, lon: -72.741402 },
	KES: { lat: 56.037498, lon: -96.509697 },
	ZEM: { lat: 52.226398, lon: -78.522499 },
	ZFA: { lat: 62.2075, lon: -133.376007 },
	ZFD: { lat: 59.3344, lon: -107.181999 },
	XPK: { lat: 55.749199, lon: -101.265999 },
	ZFM: { lat: 67.406993, lon: -134.860182 },
	ZFN: { lat: 64.909496, lon: -125.570297 },
	ZGF: { lat: 49.015598, lon: -118.431 },
	ZGI: { lat: 54.839699, lon: -94.078598 },
	ZGR: { lat: 52.045417, lon: -95.46617 },
	ZHP: { lat: 55.3936, lon: -116.474998 },
	CZJ: { lat: 9.44686, lon: -78.575678 },
	ZJG: { lat: 54.518902, lon: -98.046097 },
	ZJN: { lat: 52.120602, lon: -101.236 },
	ZKE: { lat: 52.282501, lon: -81.677803 },
	YTD: { lat: 55.318901, lon: -97.707802 },
	MSA: { lat: 53.441399, lon: -91.762802 },
	ZMH: { lat: 51.736099, lon: -121.333 },
	PIW: { lat: 55.588902, lon: -97.1642 },
	ZMT: { lat: 54.0275, lon: -132.125 },
	CZN: { lat: 62.071201, lon: -142.048004 },
	XPP: { lat: 52.996526, lon: -97.274194 },
	CZO: { lat: 62.563499, lon: -144.669006 },
	ZPB: { lat: 53.890885, lon: -92.195935 },
	WPC: { lat: 49.520429, lon: -113.997002 },
	ZPO: { lat: 55.528099, lon: -106.582001 },
	ZRJ: { lat: 52.9436, lon: -91.312798 },
	ZSJ: { lat: 53.064201, lon: -93.344398 },
	XSI: { lat: 56.792801, lon: -98.907204 },
	ZST: { lat: 55.93541, lon: -129.982435 },
	ZSW: { lat: 54.333302, lon: -130.283005 },
	YDV: { lat: 51.784568, lon: -96.692305 },
	ZTM: { lat: 55.86356, lon: -92.081137 },
	ZUC: { lat: 49.428204, lon: -91.720418 },
	ZUM: { lat: 53.561901, lon: -64.1064 },
	XLB: { lat: 58.614279, lon: -101.468954 },
	ZWL: { lat: 58.106899, lon: -103.171997 },
	IUA: { lat: 42.908902, lon: -77.325226 },
	DJN: { lat: 64.049861, lon: -145.722656 },
	MQV: { lat: 35.90518, lon: 0.144539 },
	BUJ: { lat: 35.3325, lon: 4.20639 },
	BJA: { lat: 36.711952, lon: 5.069804 },
	ALG: { lat: 36.693886, lon: 3.214531 },
	DJG: { lat: 24.292801, lon: 9.45244 },
	VVZ: { lat: 26.723499, lon: 8.62265 },
	QSF: { lat: 36.178101, lon: 5.32449 },
	TMR: { lat: 22.811501, lon: 5.45108 },
	GJL: { lat: 36.795101, lon: 5.87361 },
	MZW: { lat: 33.5359, lon: -0.242353 },
	AAE: { lat: 36.826781, lon: 7.81334 },
	CZL: { lat: 36.276001, lon: 6.62039 },
	QMH: { lat: 35.8797, lon: 7.2708 },
	TEE: { lat: 35.431599, lon: 8.12072 },
	BLJ: { lat: 35.752102, lon: 6.30859 },
	DAF: { lat: -4.7403, lon: 145.9515 },
	HRM: { lat: 32.930401, lon: 3.31154 },
	DAH: { lat: 13.866884, lon: 46.133473 },
	DAO: { lat: -8.431944, lon: 147.843056 },
	TID: { lat: 35.341099, lon: 1.46315 },
	TIN: { lat: 27.700399, lon: -8.1671 },
	CFK: { lat: 36.217166, lon: 1.342237 },
	TAF: { lat: 35.5424, lon: -0.532278 },
	TLM: { lat: 35.013426, lon: -1.457191 },
	ORN: { lat: 35.623901, lon: -0.621183 },
	CBH: { lat: 31.6457, lon: -2.26986 },
	BFW: { lat: 35.171799, lon: -0.593275 },
	MUW: { lat: 35.207699, lon: 0.147142 },
	EBH: { lat: 33.721667, lon: 1.0925 },
	INF: { lat: 19.560518, lon: 5.749326 },
	BMW: { lat: 21.3778, lon: 0.92698 },
	AZR: { lat: 27.837601, lon: -0.186414 },
	BSK: { lat: 34.793301, lon: 5.73823 },
	ELG: { lat: 30.580732, lon: 2.861595 },
	GHA: { lat: 32.384102, lon: 3.79411 },
	HME: { lat: 31.673, lon: 6.14044 },
	INZ: { lat: 27.250999, lon: 2.51202 },
	TGR: { lat: 33.067799, lon: 6.08867 },
	LOO: { lat: 33.7644, lon: 2.92834 },
	ELU: { lat: 33.511398, lon: 6.77679 },
	TMX: { lat: 29.237101, lon: 0.276033 },
	OGX: { lat: 31.9172, lon: 5.41278 },
	IAM: { lat: 28.0515, lon: 9.64291 },
	COO: { lat: 6.35723, lon: 2.38435 },
	DJA: { lat: 9.692083, lon: 1.637778 },
	KDC: { lat: 11.14479, lon: 2.940381 },
	NAE: { lat: 10.376965, lon: 1.360507 },
	PKO: { lat: 9.35769, lon: 2.60968 },
	SVF: { lat: 8.01817, lon: 2.46458 },
	DBK: { lat: 8.273, lon: 79.756 },
	DBU: { lat: 7.8604, lon: 80.6304 },
	DCK: { lat: 66.943298, lon: -156.904999 },
	DDM: { lat: -8.177361, lon: 147.809444 },
	DEQ: { lat: 30.504264, lon: 120.107388 },
	DEX: { lat: -4.8557, lon: 139.482006 },
	XKY: { lat: 13.067, lon: -1.1 },
	OUG: { lat: 13.655287, lon: -2.322067 },
	XDJ: { lat: 14.125, lon: -1.624722 },
	XLU: { lat: 11.1, lon: -2.1 },
	PUP: { lat: 11.179139, lon: -1.148472 },
	XBO: { lat: 12.65, lon: -0.567 },
	XBG: { lat: 12.983, lon: -0.167 },
	DIP: { lat: 12.060324, lon: 1.784631 },
	DOR: { lat: 14.021638, lon: -0.068207 },
	FNG: { lat: 12.033, lon: 0.35 },
	XGG: { lat: 14.454174, lon: -0.218644 },
	XKA: { lat: 12.464046, lon: 1.492939 },
	TMQ: { lat: 14.790874, lon: 0.039492 },
	XPA: { lat: 11.25, lon: 0.7 },
	ARL: { lat: 11.597, lon: 1.483 },
	XSE: { lat: 13.45, lon: 0.517 },
	TEG: { lat: 11.801149, lon: -0.371377 },
	XZA: { lat: 11.167, lon: -0.617 },
	OUA: { lat: 12.3532, lon: -1.51242 },
	BNR: { lat: 10.688861, lon: -4.727726 },
	DGU: { lat: 12.459, lon: -3.49 },
	XGA: { lat: 10.384059, lon: -3.163454 },
	XNU: { lat: 12.75, lon: -3.867 },
	BOY: { lat: 11.1601, lon: -4.33097 },
	TUQ: { lat: 13.059091, lon: -3.077291 },
	XDE: { lat: 10.95, lon: -3.25 },
	XAR: { lat: 14.217, lon: -0.883 },
	ACC: { lat: 5.60519, lon: -0.166786 },
	TML: { lat: 9.55719, lon: -0.863214 },
	WZA: { lat: 10.0827, lon: -2.50769 },
	DGM: { lat: 7.1079, lon: 79.8721 },
	KMS: { lat: 6.71456, lon: -1.59082 },
	NYI: { lat: 7.36183, lon: -2.32876 },
	TKD: { lat: 4.89606, lon: -1.77476 },
	DHB: { lat: 48.616667, lon: -123.002778 },
	DHG: { lat: 44.558748, lon: 135.490005 },
	DHL: { lat: 13.73846, lon: 44.72719 },
	ABO: { lat: 5.461944, lon: -3.234722 },
	ABJ: { lat: 5.26139, lon: -3.92629 },
	OGO: { lat: 6.71556, lon: -3.47028 },
	BXI: { lat: 9.540571, lon: -6.469831 },
	BYK: { lat: 7.7388, lon: -5.07367 },
	BQO: { lat: 9.255556, lon: -3.033333 },
	BDK: { lat: 8.01722, lon: -2.76194 },
	DIM: { lat: 6.65167, lon: -4.64056 },
	DJO: { lat: 6.79281, lon: -6.47319 },
	GGN: { lat: 6.102855, lon: -5.986809 },
	GGO: { lat: 6.534711, lon: -7.526847 },
	BBV: { lat: 4.643413, lon: -6.923962 },
	HGO: { lat: 9.38718, lon: -5.55666 },
	MJC: { lat: 7.27207, lon: -7.58736 },
	KEO: { lat: 9.539457, lon: -7.56134 },
	OFI: { lat: 9.6, lon: -4.05 },
	SEO: { lat: 7.96, lon: -6.644167 },
	SPY: { lat: 4.74672, lon: -6.66082 },
	ZSS: { lat: 4.928888, lon: -6.133156 },
	TXU: { lat: 4.437809, lon: -7.362728 },
	TOZ: { lat: 8.2934, lon: -7.674 },
	DIW: { lat: 5.990192, lon: 80.733129 },
	ASK: { lat: 6.90317, lon: -5.36558 },
	DLR: { lat: 45.877949, lon: 133.735822 },
	DIO: { lat: 65.758367, lon: -168.953676 },
	DKA: { lat: 13.0078, lon: 7.66045 },
	ABV: { lat: 9.00679, lon: 7.26317 },
	QUO: { lat: 4.8725, lon: 8.093 },
	AKR: { lat: 7.24674, lon: 5.30101 },
	ABB: { lat: 6.204167, lon: 6.665278 },
	BCU: { lat: 10.482833, lon: 9.744 },
	BNI: { lat: 6.31698, lon: 5.5995 },
	CBQ: { lat: 4.97602, lon: 8.3472 },
	ENU: { lat: 6.47427, lon: 7.56196 },
	GMO: { lat: 10.298889, lon: 10.9 },
	IBA: { lat: 7.36246, lon: 3.97833 },
	ILR: { lat: 8.44021, lon: 4.49392 },
	QOW: { lat: 5.42706, lon: 7.20603 },
	JOS: { lat: 9.63983, lon: 8.86905 },
	KAD: { lat: 10.696, lon: 7.32011 },
	KAN: { lat: 12.0476, lon: 8.52462 },
	MIU: { lat: 11.8553, lon: 13.0809 },
	MDI: { lat: 7.70388, lon: 8.61394 },
	LOS: { lat: 6.57737, lon: 3.32116 },
	MXJ: { lat: 9.65217, lon: 6.46226 },
	PHC: { lat: 5.01549, lon: 6.94959 },
	SKO: { lat: 12.9163, lon: 5.20719 },
	QRW: { lat: 5.59821, lon: 5.8187 },
	YOL: { lat: 9.25755, lon: 12.4304 },
	ZAR: { lat: 11.1302, lon: 7.68581 },
	DPT: { lat: 69.392503, lon: 139.890012 },
	MFQ: { lat: 13.5025, lon: 7.12675 },
	NIM: { lat: 13.4815, lon: 2.18361 },
	THZ: { lat: 14.8757, lon: 5.26536 },
	AJY: { lat: 16.966, lon: 8.00011 },
	RLT: { lat: 18.7904, lon: 7.36595 },
	ZND: { lat: 13.779, lon: 8.98376 },
	DSG: { lat: 16.445833, lon: 122.206806 },
	TBJ: { lat: 36.98, lon: 8.87694 },
	MIR: { lat: 35.758099, lon: 10.7547 },
	NBE: { lat: 36.075833, lon: 10.438611 },
	TUN: { lat: 36.851002, lon: 10.2272 },
	GAF: { lat: 34.422001, lon: 8.8225 },
	GAE: { lat: 33.733691, lon: 9.91941 },
	DJE: { lat: 33.875, lon: 10.7755 },
	EBM: { lat: 31.7043, lon: 9.25462 },
	SFA: { lat: 34.717999, lon: 10.691 },
	TOE: { lat: 33.939701, lon: 8.11056 },
	DVD: { lat: -22.06608, lon: 43.259573 },
	DWO: { lat: 6.906585, lon: 79.909 },
	LRL: { lat: 9.76733, lon: 1.09125 },
	LFW: { lat: 6.16561, lon: 1.25451 },
	EAL: { lat: 9.319306, lon: 166.847778 },
	ANR: { lat: 51.190667, lon: 4.463153 },
	BRU: { lat: 50.901402, lon: 4.48444 },
	CRL: { lat: 50.460982, lon: 4.457158 },
	GNE: { lat: 51.020551, lon: 3.730341 },
	KJK: { lat: 50.818878, lon: 3.209551 },
	LGG: { lat: 50.638574, lon: 5.443897 },
	EBO: { lat: 4.5982, lon: 168.752 },
	OST: { lat: 51.1998, lon: 2.874673 },
	OBL: { lat: 51.269092, lon: 4.762428 },
	MZD: { lat: -2.73333, lon: -78.316704 },
	EDA: { lat: 55.949653, lon: -133.661012 },
	AOC: { lat: 50.981945, lon: 12.506389 },
	HDF: { lat: 53.8787, lon: 14.1523 },
	IES: { lat: 51.29361, lon: 13.356111 },
	REB: { lat: 53.306389, lon: 12.752222 },
	CSO: { lat: 51.8564, lon: 11.4203 },
	BBH: { lat: 54.338253, lon: 12.710515 },
	FNB: { lat: 53.6022, lon: 13.306 },
	GTI: { lat: 54.38347, lon: 13.325542 },
	KOQ: { lat: 51.723745, lon: 11.948826 },
	PEF: { lat: 54.15778, lon: 13.774444 },
	BER: { lat: 52.362247, lon: 13.500672 },
	DRS: { lat: 51.134123, lon: 13.767831 },
	ERF: { lat: 50.979801, lon: 10.9581 },
	FRA: { lat: 50.030241, lon: 8.561096 },
	FMO: { lat: 52.134602, lon: 7.68483 },
	HAM: { lat: 53.630402, lon: 9.98823 },
	CGN: { lat: 50.865898, lon: 7.14274 },
	DUS: { lat: 51.289501, lon: 6.76678 },
	MUC: { lat: 48.353802, lon: 11.7861 },
	NUE: { lat: 49.498699, lon: 11.078056 },
	LEJ: { lat: 51.420657, lon: 12.232705 },
	SCN: { lat: 49.2146, lon: 7.10951 },
	STR: { lat: 48.689899, lon: 9.22196 },
	HAJ: { lat: 52.461102, lon: 9.68508 },
	BRE: { lat: 53.046786, lon: 8.78932 },
	HHN: { lat: 49.9487, lon: 7.26389 },
	MHG: { lat: 49.473057, lon: 8.514167 },
	EIB: { lat: 50.991604, lon: 10.47973 },
	ZOE: { lat: 49.486509, lon: 8.389243 },
	SGE: { lat: 50.707699, lon: 8.08297 },
	IZE: { lat: 53.992009, lon: 9.576409 },
	XFW: { lat: 53.535278, lon: 9.835556 },
	KEL: { lat: 54.37957, lon: 10.145266 },
	LBC: { lat: 53.805401, lon: 10.7192 },
	EUM: { lat: 54.079445, lon: 9.941389 },
	FMM: { lat: 47.9888, lon: 10.2395 },
	AAH: { lat: 50.823055, lon: 6.186389 },
	ESS: { lat: 51.402302, lon: 6.93733 },
	BFE: { lat: 51.964722, lon: 8.544444 },
	MGL: { lat: 51.230278, lon: 6.504444 },
	PAD: { lat: 51.614101, lon: 8.61632 },
	NRN: { lat: 51.602402, lon: 6.14217 },
	DTM: { lat: 51.518299, lon: 7.61224 },
	AGB: { lat: 48.425278, lon: 10.931667 },
	OBF: { lat: 48.081402, lon: 11.2831 },
	RBM: { lat: 48.900833, lon: 12.516667 },
	FDH: { lat: 47.671299, lon: 9.51149 },
	BYU: { lat: 49.985001, lon: 11.64 },
	URD: { lat: 49.794167, lon: 11.133611 },
	GHF: { lat: 49.648056, lon: 9.966389 },
	HOQ: { lat: 50.288544, lon: 11.852876 },
	BBJ: { lat: 49.945278, lon: 6.565 },
	ZQW: { lat: 49.2094, lon: 7.40056 },
	FKB: { lat: 48.7794, lon: 8.0805 },
	LHA: { lat: 48.369301, lon: 7.82772 },
	BWE: { lat: 52.319199, lon: 10.5561 },
	KSF: { lat: 51.420699, lon: 9.392152 },
	EME: { lat: 53.391109, lon: 7.2275 },
	AGE: { lat: 53.782544, lon: 7.919584 },
	WVN: { lat: 53.50222, lon: 8.052222 },
	JUI: { lat: 53.681421, lon: 7.056398 },
	LGO: { lat: 53.742379, lon: 7.496345 },
	BMK: { lat: 53.59639, lon: 6.709167 },
	NOD: { lat: 53.633057, lon: 7.190278 },
	VAC: { lat: 52.908333, lon: 8.040556 },
	NRD: { lat: 53.706944, lon: 7.23 },
	BMR: { lat: 53.72485, lon: 7.373257 },
	HEI: { lat: 54.153332, lon: 8.901667 },
	FLF: { lat: 54.773335, lon: 9.378889 },
	HGL: { lat: 54.18528, lon: 7.915833 },
	QHU: { lat: 54.509998, lon: 9.138333 },
	PSH: { lat: 54.308887, lon: 8.686944 },
	GWT: { lat: 54.9132, lon: 8.34047 },
	OHR: { lat: 54.684444, lon: 8.528333 },
	CHE: { lat: 59.448015, lon: 24.753313 },
	KDL: { lat: 58.990799, lon: 22.8307 },
	URE: { lat: 58.2299, lon: 22.509501 },
	EPU: { lat: 58.418999, lon: 24.472799 },
	EES: { lat: 23.980437, lon: 35.460277 },
	TLL: { lat: 59.413246, lon: 24.83264 },
	TAY: { lat: 58.307438, lon: 26.686473 },
	ENF: { lat: 68.362602, lon: 23.424299 },
	KEV: { lat: 61.856039, lon: 24.786686 },
	HEN: { lat: 60.147778, lon: 24.924444 },
	HEL: { lat: 60.318363, lon: 24.963341 },
	HYV: { lat: 60.6544, lon: 24.8811 },
	KTQ: { lat: 62.1661, lon: 30.073601 },
	IVL: { lat: 68.6073, lon: 27.4053 },
	JOE: { lat: 62.658815, lon: 29.619398 },
	JYV: { lat: 62.399502, lon: 25.678301 },
	KAU: { lat: 63.127102, lon: 23.051399 },
	KEM: { lat: 65.778702, lon: 24.5821 },
	KAJ: { lat: 64.2855, lon: 27.6924 },
	KHJ: { lat: 62.463212, lon: 22.390817 },
	KOK: { lat: 63.721199, lon: 23.143101 },
	KAO: { lat: 65.987602, lon: 29.239401 },
	KTT: { lat: 67.700996, lon: 24.8468 },
	KUO: { lat: 63.007099, lon: 27.7978 },
	LPP: { lat: 61.044601, lon: 28.144743 },
	MHQ: { lat: 60.1222, lon: 19.898199 },
	MIK: { lat: 61.6866, lon: 27.201799 },
	OUL: { lat: 64.930099, lon: 25.354601 },
	POR: { lat: 61.4617, lon: 21.799999 },
	RVN: { lat: 66.564796, lon: 25.8304 },
	SVL: { lat: 61.9431, lon: 28.945101 },
	SJY: { lat: 62.692101, lon: 22.8323 },
	SOT: { lat: 67.394997, lon: 26.619101 },
	TMP: { lat: 61.414101, lon: 23.604401 },
	TKU: { lat: 60.514099, lon: 22.2628 },
	UTI: { lat: 60.8964, lon: 26.9384 },
	VAA: { lat: 63.050701, lon: 21.762199 },
	VRK: { lat: 62.171101, lon: 27.868601 },
	YLI: { lat: 64.054722, lon: 24.725278 },
	TFR: { lat: 30.0503, lon: 31.841369 },
	AUE: { lat: 28.899694, lon: 33.202057 },
	BFS: { lat: 54.657501, lon: -6.21583 },
	ENK: { lat: 54.398274, lon: -7.651179 },
	BHD: { lat: 54.618099, lon: -5.8725 },
	LDY: { lat: 55.042801, lon: -7.16111 },
	BHX: { lat: 52.453899, lon: -1.74803 },
	CVT: { lat: 52.369701, lon: -1.47972 },
	GLO: { lat: 51.894199, lon: -2.16722 },
	ORM: { lat: 52.305302, lon: -0.793056 },
	GBA: { lat: 51.668528, lon: -2.056599 },
	MAN: { lat: 53.349375, lon: -2.279521 },
	UPV: { lat: 51.28657, lon: -1.782239 },
	YEO: { lat: 51.009399, lon: -2.63882 },
	CAL: { lat: 55.437199, lon: -5.68639 },
	EOI: { lat: 59.190601, lon: -2.77222 },
	FIE: { lat: 59.534721, lon: -1.628509 },
	WHS: { lat: 60.376835, lon: -0.927229 },
	SKL: { lat: 57.253399, lon: -5.8279 },
	COL: { lat: 56.601898, lon: -6.61778 },
	NRL: { lat: 59.3675, lon: -2.43444 },
	OBN: { lat: 56.463501, lon: -5.39967 },
	PPW: { lat: 59.3517, lon: -2.90028 },
	SOY: { lat: 59.1553, lon: -2.64139 },
	NDY: { lat: 59.250301, lon: -2.57667 },
	LWK: { lat: 60.1922, lon: -1.24361 },
	WRY: { lat: 59.3503, lon: -2.95 },
	CSA: { lat: 56.057499, lon: -6.24306 },
	HAW: { lat: 51.833099, lon: -4.96111 },
	CWL: { lat: 51.396702, lon: -3.34333 },
	SWS: { lat: 51.601366, lon: -4.071006 },
	BRS: { lat: 51.382702, lon: -2.71909 },
	LPL: { lat: 53.333599, lon: -2.84972 },
	LTN: { lat: 51.874699, lon: -0.368333 },
	LEQ: { lat: 50.102798, lon: -5.67056 },
	ISC: { lat: 49.913375, lon: -6.291894 },
	BOH: { lat: 50.780483, lon: -1.839576 },
	SOU: { lat: 50.950298, lon: -1.3568 },
	BBP: { lat: 50.678101, lon: -1.10944 },
	NQY: { lat: 50.440601, lon: -4.99541 },
	QUG: { lat: 50.859832, lon: -0.760073 },
	ACI: { lat: 49.706104, lon: -2.21472 },
	GCI: { lat: 49.435001, lon: -2.60197 },
	JER: { lat: 49.207901, lon: -2.19551 },
	ESH: { lat: 50.835602, lon: -0.297222 },
	BQH: { lat: 51.330799, lon: 0.0325 },
	LGW: { lat: 51.148771, lon: -0.192089 },
	LCY: { lat: 51.505299, lon: 0.055278 },
	FAB: { lat: 51.275799, lon: -0.776333 },
	BBS: { lat: 51.323898, lon: -0.8475 },
	LHR: { lat: 51.4706, lon: -0.461941 },
	SEN: { lat: 51.570562, lon: 0.693627 },
	LYX: { lat: 50.956246, lon: 0.939074 },
	CAX: { lat: 54.9375, lon: -2.80917 },
	BLK: { lat: 53.771702, lon: -3.02861 },
	HUY: { lat: 53.576152, lon: -0.34954 },
	BWF: { lat: 54.128611, lon: -3.2675 },
	LBA: { lat: 53.865898, lon: -1.66057 },
	WRT: { lat: 53.745098, lon: -2.88306 },
	CEG: { lat: 53.178101, lon: -2.97778 },
	IOM: { lat: 54.083302, lon: -4.62389 },
	NCL: { lat: 55.037958, lon: -1.689577 },
	MME: { lat: 54.509201, lon: -1.42941 },
	EMA: { lat: 52.8311, lon: -1.32806 },
	VLY: { lat: 53.2481, lon: -4.53534 },
	KOI: { lat: 58.957802, lon: -2.905 },
	LSI: { lat: 59.878899, lon: -1.29556 },
	WIC: { lat: 58.4589, lon: -3.09306 },
	ABZ: { lat: 57.2019, lon: -2.19778 },
	INV: { lat: 57.5425, lon: -4.0475 },
	GLA: { lat: 55.871899, lon: -4.43306 },
	EDI: { lat: 55.950145, lon: -3.372288 },
	ILY: { lat: 55.682708, lon: -6.257525 },
	PIK: { lat: 55.502003, lon: -4.587019 },
	BEB: { lat: 57.481098, lon: -7.36278 },
	DND: { lat: 56.452499, lon: -3.02583 },
	SYY: { lat: 58.215599, lon: -6.33111 },
	BRR: { lat: 57.0228, lon: -7.44306 },
	PSL: { lat: 56.439201, lon: -3.37222 },
	TRE: { lat: 56.499199, lon: -6.86917 },
	ADX: { lat: 56.37398, lon: -2.868862 },
	LMO: { lat: 57.7052, lon: -3.33917 },
	CBG: { lat: 52.205002, lon: 0.175 },
	NWI: { lat: 52.6758, lon: 1.28278 },
	STN: { lat: 51.884998, lon: 0.235 },
	HYC: { lat: 51.61177, lon: -0.808316 },
	EXT: { lat: 50.734261, lon: -3.413984 },
	OXF: { lat: 51.836899, lon: -1.32 },
	RCS: { lat: 51.351898, lon: 0.503333 },
	BEX: { lat: 51.614366, lon: -1.095991 },
	LKZ: { lat: 52.40954, lon: 0.561161 },
	MHZ: { lat: 52.3619, lon: 0.486406 },
	FFD: { lat: 51.683568, lon: -1.789172 },
	BZZ: { lat: 51.75, lon: -1.58362 },
	ODH: { lat: 51.2341, lon: -0.942825 },
	NHT: { lat: 51.553001, lon: -0.418167 },
	QCY: { lat: 53.092999, lon: -0.166014 },
	BEQ: { lat: 52.342602, lon: 0.772939 },
	WTN: { lat: 53.166199, lon: -0.523811 },
	KNF: { lat: 52.648395, lon: 0.550692 },
	MPN: { lat: -51.8228, lon: -58.447201 },
	AMS: { lat: 52.308601, lon: 4.76389 },
	MST: { lat: 50.911701, lon: 5.77014 },
	EIN: { lat: 51.4501, lon: 5.37453 },
	GRQ: { lat: 53.119701, lon: 6.57944 },
	GLZ: { lat: 51.567402, lon: 4.93183 },
	DHR: { lat: 52.923401, lon: 4.78062 },
	LEY: { lat: 52.453188, lon: 5.514622 },
	LWR: { lat: 53.2286, lon: 5.76056 },
	RTM: { lat: 51.956902, lon: 4.43722 },
	ENS: { lat: 52.275833, lon: 6.889167 },
	UDE: { lat: 51.657222, lon: 5.707778 },
	WOE: { lat: 51.4491, lon: 4.34203 },
	BYT: { lat: 51.6772, lon: -9.487123 },
	BLY: { lat: 54.222801, lon: -10.0308 },
	NNR: { lat: 53.230301, lon: -9.46778 },
	ORK: { lat: 51.841301, lon: -8.49111 },
	CFN: { lat: 55.044201, lon: -8.341 },
	DUB: { lat: 53.428713, lon: -6.262121 },
	IOR: { lat: 53.106701, lon: -9.65361 },
	INQ: { lat: 53.064701, lon: -9.5109 },
	KKY: { lat: 52.650799, lon: -7.29611 },
	NOC: { lat: 53.910301, lon: -8.81849 },
	KIR: { lat: 52.180901, lon: -9.52378 },
	IIA: { lat: 53.092999, lon: -9.56806 },
	SNN: { lat: 52.702, lon: -8.92482 },
	SXL: { lat: 54.280201, lon: -8.59921 },
	WAT: { lat: 52.187199, lon: -7.08696 },
	EJN: { lat: 42.0155, lon: 101.0005 },
	EJT: { lat: 6.0404, lon: 171.9846 },
	AAR: { lat: 56.303331, lon: 10.618286 },
	BLL: { lat: 55.740335, lon: 9.157019 },
	CPH: { lat: 55.617901, lon: 12.656 },
	EBJ: { lat: 55.525902, lon: 8.5534 },
	KRP: { lat: 56.297139, lon: 9.104311 },
	BYR: { lat: 57.277199, lon: 11.0001 },
	MRW: { lat: 54.699447, lon: 11.438163 },
	ODE: { lat: 55.475307, lon: 10.327206 },
	RKE: { lat: 55.585602, lon: 12.1314 },
	RNN: { lat: 55.063301, lon: 14.7596 },
	SGD: { lat: 54.964401, lon: 9.79173 },
	CNL: { lat: 57.503502, lon: 10.2294 },
	SKS: { lat: 55.221048, lon: 9.26702 },
	SQW: { lat: 56.550201, lon: 9.17298 },
	TED: { lat: 57.068802, lon: 8.70522 },
	FAE: { lat: 62.063256, lon: -7.275782 },
	STA: { lat: 55.990101, lon: 8.35391 },
	AAL: { lat: 57.094763, lon: 9.84993 },
	LUX: { lat: 49.623333, lon: 6.204444 },
	EMR: { lat: 17.752077, lon: -89.924916 },
	AES: { lat: 62.5625, lon: 6.1197 },
	ANX: { lat: 69.292503, lon: 16.144199 },
	ALF: { lat: 69.976097, lon: 23.3717 },
	FDE: { lat: 61.391102, lon: 5.75694 },
	BNN: { lat: 65.461098, lon: 12.2175 },
	BOO: { lat: 67.269203, lon: 14.3653 },
	BGO: { lat: 60.2934, lon: 5.21814 },
	BJF: { lat: 70.60025, lon: 29.692612 },
	BVG: { lat: 70.871517, lon: 29.034097 },
	KRS: { lat: 58.204201, lon: 8.08537 },
	BDU: { lat: 69.055801, lon: 18.5404 },
	EVE: { lat: 68.491302, lon: 16.678101 },
	FRO: { lat: 61.583599, lon: 5.02472 },
	OSL: { lat: 60.193901, lon: 11.1004 },
	HMR: { lat: 60.8181, lon: 11.068 },
	HAU: { lat: 59.345299, lon: 5.20836 },
	HFT: { lat: 70.679703, lon: 23.6686 },
	HAA: { lat: 70.486702, lon: 22.1397 },
	HVG: { lat: 71.009697, lon: 25.983601 },
	KSU: { lat: 63.111801, lon: 7.82452 },
	GLL: { lat: 60.791066, lon: 9.048672 },
	KKN: { lat: 69.7258, lon: 29.8913 },
	LKN: { lat: 68.152496, lon: 13.6094 },
	MEH: { lat: 71.029701, lon: 27.8267 },
	MOL: { lat: 62.744701, lon: 7.2625 },
	MJF: { lat: 65.783997, lon: 13.2149 },
	LKL: { lat: 70.068802, lon: 24.973499 },
	OSY: { lat: 64.472198, lon: 11.5786 },
	NTB: { lat: 59.565071, lon: 9.213152 },
	OLA: { lat: 63.698898, lon: 9.604 },
	HOV: { lat: 62.18, lon: 6.0741 },
	MQN: { lat: 66.363899, lon: 14.3014 },
	RVK: { lat: 64.838303, lon: 11.1461 },
	RRS: { lat: 62.5784, lon: 11.3423 },
	RET: { lat: 67.526482, lon: 12.101575 },
	LYR: { lat: 78.246101, lon: 15.4656 },
	SDN: { lat: 61.830002, lon: 6.10583 },
	SOG: { lat: 61.156101, lon: 7.13778 },
	SVJ: { lat: 68.243301, lon: 14.6692 },
	SKN: { lat: 68.578827, lon: 15.033417 },
	SRP: { lat: 59.791901, lon: 5.34085 },
	SOJ: { lat: 69.786797, lon: 20.9594 },
	VAW: { lat: 70.3554, lon: 31.044901 },
	SSJ: { lat: 65.956802, lon: 12.4689 },
	TOS: { lat: 69.683296, lon: 18.9189 },
	TRF: { lat: 59.186699, lon: 10.2586 },
	TRD: { lat: 63.457802, lon: 10.924 },
	VDS: { lat: 70.0653, lon: 29.8447 },
	VRY: { lat: 67.654555, lon: 12.727257 },
	SVG: { lat: 58.876701, lon: 5.63778 },
	BZG: { lat: 53.096802, lon: 17.977699 },
	GDN: { lat: 54.377602, lon: 18.4662 },
	KRK: { lat: 50.077702, lon: 19.7848 },
	KTW: { lat: 50.476015, lon: 19.080705 },
	LUZ: { lat: 51.240157, lon: 22.713461 },
	LCJ: { lat: 51.721901, lon: 19.3981 },
	WMI: { lat: 52.451099, lon: 20.6518 },
	POZ: { lat: 52.421598, lon: 16.823359 },
	RDO: { lat: 51.38937, lon: 21.214742 },
	RZE: { lat: 50.109791, lon: 22.024155 },
	SZZ: { lat: 53.584702, lon: 14.9022 },
	SZY: { lat: 53.481899, lon: 20.9377 },
	WAW: { lat: 52.165699, lon: 20.9671 },
	WRO: { lat: 51.103719, lon: 16.882096 },
	IEG: { lat: 52.1385, lon: 15.7986 },
	ERT: { lat: 48.983056, lon: 104.150556 },
	RNB: { lat: 56.266701, lon: 15.265 },
	GOT: { lat: 57.6628, lon: 12.2798 },
	JKG: { lat: 57.757599, lon: 14.0687 },
	LDK: { lat: 58.4655, lon: 13.1744 },
	GSE: { lat: 57.7747, lon: 11.8704 },
	KVB: { lat: 58.456402, lon: 13.9727 },
	THN: { lat: 58.3181, lon: 12.345 },
	KSK: { lat: 59.345901, lon: 14.4959 },
	MXX: { lat: 60.957901, lon: 14.5114 },
	NYO: { lat: 58.788601, lon: 16.912201 },
	SCR: { lat: 61.158393, lon: 12.842503 },
	KID: { lat: 55.9217, lon: 14.0855 },
	OSK: { lat: 57.350498, lon: 16.497999 },
	KLR: { lat: 56.685501, lon: 16.2876 },
	MMX: { lat: 55.535564, lon: 13.376327 },
	HAD: { lat: 56.691101, lon: 12.8202 },
	VXO: { lat: 56.9291, lon: 14.728 },
	EVG: { lat: 62.047798, lon: 14.4229 },
	GEV: { lat: 67.132401, lon: 20.8146 },
	KRF: { lat: 63.048599, lon: 17.7689 },
	LYC: { lat: 64.548302, lon: 18.7162 },
	SDL: { lat: 62.528099, lon: 17.443899 },
	OER: { lat: 63.408298, lon: 18.99 },
	KRN: { lat: 67.821999, lon: 20.3368 },
	SFT: { lat: 64.624802, lon: 21.0769 },
	UME: { lat: 63.791801, lon: 20.282801 },
	VHM: { lat: 64.579102, lon: 16.833599 },
	AJR: { lat: 65.590302, lon: 19.2819 },
	SOO: { lat: 61.261501, lon: 17.0991 },
	OSD: { lat: 63.194135, lon: 14.500322 },
	ORB: { lat: 59.223701, lon: 15.038 },
	HFS: { lat: 60.0201, lon: 13.5789 },
	KSD: { lat: 59.444698, lon: 13.3374 },
	VST: { lat: 59.589401, lon: 16.6336 },
	LLA: { lat: 65.5438, lon: 22.122 },
	ARN: { lat: 59.64849, lon: 17.928829 },
	BMA: { lat: 59.354401, lon: 17.9417 },
	BLE: { lat: 60.422001, lon: 15.5152 },
	HLF: { lat: 57.525799, lon: 15.8233 },
	GVX: { lat: 60.5933, lon: 16.951401 },
	LPI: { lat: 58.4062, lon: 15.6805 },
	NRK: { lat: 58.5863, lon: 16.250601 },
	TYF: { lat: 60.1576, lon: 12.9913 },
	EKT: { lat: 59.351101, lon: 16.708401 },
	VBY: { lat: 57.6628, lon: 18.346201 },
	VVK: { lat: 57.779999, lon: 16.5236 },
	AGH: { lat: 56.296101, lon: 12.8471 },
	SQO: { lat: 64.960899, lon: 17.6966 },
	IDB: { lat: 61.869701, lon: 12.6894 },
	PJA: { lat: 67.244569, lon: 23.074894 },
	HMV: { lat: 65.806099, lon: 15.0828 },
	GLC: { lat: 6.98444, lon: 46.421398 },
	SHC: { lat: 14.075699, lon: 38.273592 },
	SPM: { lat: 49.976507, lon: 6.698413 },
	RMS: { lat: 49.436901, lon: 7.60028 },
	FRZ: { lat: 51.1146, lon: 9.286 },
	ILH: { lat: 49.4739, lon: 10.3881 },
	KZG: { lat: 49.744293, lon: 10.207313 },
	FCN: { lat: 53.767689, lon: 8.659201 },
	GKE: { lat: 50.9608, lon: 6.04242 },
	RLG: { lat: 53.918201, lon: 12.2783 },
	WBG: { lat: 54.459301, lon: 9.51633 },
	WIE: { lat: 50.049801, lon: 8.3254 },
	IGS: { lat: 48.715698, lon: 11.534 },
	LPX: { lat: 56.517502, lon: 21.096901 },
	RIX: { lat: 56.920752, lon: 23.970711 },
	VNT: { lat: 57.3578, lon: 21.544201 },
	EXI: { lat: 58.420502, lon: -135.449005 },
	KUN: { lat: 54.963902, lon: 24.084801 },
	PLQ: { lat: 55.973202, lon: 21.093901 },
	PNV: { lat: 55.729401, lon: 24.4608 },
	SQQ: { lat: 55.893902, lon: 23.395 },
	VNO: { lat: 54.634102, lon: 25.285801 },
	RGR: { lat: 32.452599, lon: -98.6828 },
	ALJ: { lat: -28.575001, lon: 16.5333 },
	AGZ: { lat: -29.281799, lon: 18.8139 },
	ADY: { lat: -22.679001, lon: 29.0555 },
	BIY: { lat: -32.897099, lon: 27.2791 },
	BFN: { lat: -29.092699, lon: 26.302401 },
	UTE: { lat: -28.273369, lon: 26.135835 },
	ASS: { lat: -24.740527, lon: 31.517973 },
	CDO: { lat: -32.1567, lon: 25.645599 },
	CPT: { lat: -33.964802, lon: 18.6017 },
	DUK: { lat: -28.368401, lon: 32.2481 },
	PZL: { lat: -27.8494, lon: 32.3097 },
	ELS: { lat: -33.035599, lon: 27.825899 },
	EMG: { lat: -28.719999, lon: 31.889999 },
	ELL: { lat: -23.7267, lon: 27.688299 },
	FCB: { lat: -28.823099, lon: 27.908899 },
	GCJ: { lat: -25.9863, lon: 28.1401 },
	GRJ: { lat: -34.0056, lon: 22.378902 },
	GIY: { lat: -23.2833, lon: 30.65 },
	QRA: { lat: -26.2425, lon: 28.151199 },
	HLW: { lat: -28.016605, lon: 32.275171 },
	HRS: { lat: -28.2351, lon: 29.106199 },
	HDS: { lat: -24.368601, lon: 31.0487 },
	KXE: { lat: -26.871099, lon: 26.718 },
	KIM: { lat: -28.802799, lon: 24.7652 },
	MQP: { lat: -25.3832, lon: 31.1056 },
	KOF: { lat: -25.4403, lon: 31.93 },
	KMH: { lat: -27.456699, lon: 23.4114 },
	KLZ: { lat: -29.6884, lon: 17.094 },
	HLA: { lat: -25.938499, lon: 27.9261 },
	LMR: { lat: -28.3601, lon: 23.4391 },
	LDZ: { lat: -24.7478, lon: 31.4743 },
	DUR: { lat: -29.614444, lon: 31.119722 },
	LCD: { lat: -23.061899, lon: 29.8647 },
	SDB: { lat: -32.968899, lon: 18.160299 },
	LAY: { lat: -28.581699, lon: 29.749701 },
	AAM: { lat: -24.816866, lon: 31.544085 },
	MGH: { lat: -30.857401, lon: 30.343 },
	MEZ: { lat: -22.355672, lon: 29.9862 },
	MBD: { lat: -25.798401, lon: 25.548 },
	LLE: { lat: -25.473581, lon: 31.565947 },
	MZY: { lat: -34.158746, lon: 22.055676 },
	MZQ: { lat: -27.626101, lon: 32.0443 },
	NCS: { lat: -27.770599, lon: 29.9769 },
	NGL: { lat: -24.389, lon: 31.326 },
	NLP: { lat: -25.5, lon: 30.913799 },
	OVG: { lat: -34.563474, lon: 20.252438 },
	OUH: { lat: -33.606998, lon: 22.188999 },
	JNB: { lat: -26.1392, lon: 28.246 },
	AFD: { lat: -33.555057, lon: 26.881656 },
	PLZ: { lat: -33.984901, lon: 25.6173 },
	PBZ: { lat: -34.08816, lon: 23.328723 },
	PHW: { lat: -23.937201, lon: 31.155399 },
	JOH: { lat: -31.60612, lon: 29.52175 },
	PRK: { lat: -29.683599, lon: 22.770599 },
	PZB: { lat: -29.649, lon: 30.398701 },
	NTY: { lat: -25.333799, lon: 27.173401 },
	PTG: { lat: -23.845269, lon: 29.458615 },
	PCF: { lat: -26.671, lon: 27.0819 },
	UTW: { lat: -31.9202, lon: 26.8822 },
	RCB: { lat: -28.740999, lon: 32.092098 },
	RVO: { lat: -27.547199, lon: 24.172501 },
	ROD: { lat: -33.812199, lon: 19.9028 },
	SBU: { lat: -29.689301, lon: 17.9396 },
	ZEC: { lat: -26.524099, lon: 29.170099 },
	GSS: { lat: -24.947375, lon: 31.448848 },
	SIS: { lat: -27.6486, lon: 22.9993 },
	SZK: { lat: -24.960899, lon: 31.588699 },
	THY: { lat: -23.0769, lon: 30.3836 },
	TCU: { lat: -29.317801, lon: 26.8228 },
	LTA: { lat: -23.8244, lon: 30.3293 },
	ULD: { lat: -28.320601, lon: 31.4165 },
	UTN: { lat: -28.399099, lon: 21.260201 },
	ULX: { lat: -24.7854, lon: 31.3549 },
	UTT: { lat: -31.546363, lon: 28.673355 },
	VRU: { lat: -26.982401, lon: 24.7288 },
	VIR: { lat: -29.770599, lon: 31.058399 },
	VRE: { lat: -31.641001, lon: 18.5448 },
	VYD: { lat: -27.7869, lon: 30.7964 },
	PRY: { lat: -25.6539, lon: 28.224199 },
	WKF: { lat: -25.83, lon: 28.2225 },
	WEL: { lat: -27.996825, lon: 26.663334 },
	FRW: { lat: -21.15914, lon: 27.468545 },
	GNZ: { lat: -21.692499, lon: 21.6581 },
	JWA: { lat: -24.602301, lon: 24.691 },
	BBK: { lat: -17.832899, lon: 25.162399 },
	KHW: { lat: -19.149477, lon: 23.787937 },
	LOQ: { lat: -25.1981, lon: 25.7139 },
	MUB: { lat: -19.970491, lon: 23.431409 },
	ORP: { lat: -21.265901, lon: 25.319667 },
	GBE: { lat: -24.555201, lon: 25.9182 },
	SXN: { lat: -20.5534, lon: 26.115801 },
	PKW: { lat: -22.0583, lon: 27.8288 },
	SVT: { lat: -18.518475, lon: 24.077687 },
	SWX: { lat: -18.373899, lon: 21.8326 },
	TLD: { lat: -22.191897, lon: 29.131229 },
	TBY: { lat: -26.034524, lon: 22.401252 },
	BZV: { lat: -4.2517, lon: 15.253 },
	DJM: { lat: -2.516883, lon: 14.754403 },
	KNJ: { lat: -3.749781, lon: 14.490264 },
	LCO: { lat: -2.45, lon: 14.533 },
	MUY: { lat: -4.014874, lon: 13.966112 },
	SIB: { lat: -3.683, lon: 13.35 },
	NKY: { lat: -4.223077, lon: 13.286347 },
	ANJ: { lat: -2.85, lon: 13.817 },
	MSX: { lat: -2.95, lon: 12.7 },
	BOE: { lat: -1.03104, lon: 15.336009 },
	OLL: { lat: -1.226666, lon: 15.91 },
	EWO: { lat: -0.883, lon: 14.8 },
	GMM: { lat: -1.829403, lon: 15.885237 },
	ION: { lat: 1.589968, lon: 18.046624 },
	KEE: { lat: -0.071271, lon: 14.506621 },
	MKJ: { lat: -0.020842, lon: 15.577746 },
	FTX: { lat: -0.524566, lon: 15.93782 },
	SOE: { lat: 1.998326, lon: 14.174217 },
	BTB: { lat: 3.057593, lon: 18.514433 },
	OUE: { lat: 1.61599, lon: 16.037901 },
	KMK: { lat: -3.483, lon: 12.617 },
	DIS: { lat: -4.20635, lon: 12.6599 },
	PNR: { lat: -4.81603, lon: 11.8866 },
	MTS: { lat: -26.528999, lon: 31.307501 },
	SHO: { lat: -26.358611, lon: 31.716944 },
	CRF: { lat: 4.937, lon: 15.894 },
	BGF: { lat: 4.39848, lon: 18.518801 },
	BGU: { lat: 4.785, lon: 22.781 },
	IRO: { lat: 10.2364, lon: 22.7169 },
	BBY: { lat: 5.847012, lon: 20.64992 },
	NDL: { lat: 8.427206, lon: 20.635157 },
	BOP: { lat: 5.958, lon: 15.637 },
	BIV: { lat: 6.52778, lon: 21.989401 },
	BSN: { lat: 6.492, lon: 17.429001 },
	BBT: { lat: 4.22158, lon: 15.7864 },
	ODA: { lat: 8.01056, lon: 22.3986 },
	AIG: { lat: 6.52, lon: 23.26 },
	IMO: { lat: 5.002226, lon: 25.101857 },
	MKI: { lat: 5.33301, lon: 25.9319 },
	BTG: { lat: 7.31411, lon: 18.3088 },
	GDI: { lat: 9.581117, lon: 21.728172 },
	BMF: { lat: 5.694, lon: 22.801001 },
	ODJ: { lat: 8.9, lon: 22.783001 },
	RFA: { lat: 4.98861, lon: 23.927799 },
	BCF: { lat: 6.517, lon: 18.267 },
	BOZ: { lat: 6.34417, lon: 16.321899 },
	NBN: { lat: -1.408615, lon: 5.624163 },
	BSG: { lat: 1.90547, lon: 9.80568 },
	GEM: { lat: 1.685334, lon: 11.024394 },
	SSG: { lat: 3.75527, lon: 8.70872 },
	ASI: { lat: -7.9696, lon: -14.3937 },
	HLE: { lat: -15.957725, lon: -5.645943 },
	MRU: { lat: -20.430201, lon: 57.683601 },
	RRG: { lat: -19.7577, lon: 63.361 },
	KVU: { lat: -18.215569, lon: 177.729767 },
	NKW: { lat: -7.31327, lon: 72.411102 },
	KBI: { lat: 2.87389, lon: 9.97778 },
	TKC: { lat: 4.08919, lon: 9.36053 },
	DLA: { lat: 4.00608, lon: 9.71948 },
	MMF: { lat: 5.70417, lon: 9.30639 },
	BLC: { lat: 5.895278, lon: 10.033889 },
	KLE: { lat: 10.0925, lon: 14.4456 },
	OUR: { lat: 4.475, lon: 14.3625 },
	GXX: { lat: 10.3561, lon: 15.2372 },
	MVR: { lat: 10.4514, lon: 14.2574 },
	FOM: { lat: 5.63692, lon: 10.7508 },
	NGE: { lat: 7.35701, lon: 13.5592 },
	BTA: { lat: 4.54861, lon: 13.7261 },
	GOU: { lat: 9.33589, lon: 13.3701 },
	DSC: { lat: 5.45, lon: 10.067 },
	BFX: { lat: 5.53692, lon: 10.3546 },
	BPC: { lat: 6.03924, lon: 10.1226 },
	EBW: { lat: 2.876, lon: 11.185 },
	YAO: { lat: 3.83604, lon: 11.5235 },
	NSI: { lat: 3.72256, lon: 11.5533 },
	MMQ: { lat: -8.85917, lon: 31.336399 },
	CIP: { lat: -13.5583, lon: 32.5872 },
	CGX: { lat: -15.053957, lon: 25.985673 },
	JEK: { lat: -15.6334, lon: 29.6036 },
	CGJ: { lat: -12.5728, lon: 27.8939 },
	KLB: { lat: -14.998818, lon: 22.648372 },
	KMZ: { lat: -14.8, lon: 24.783001 },
	KAA: { lat: -10.210169, lon: 31.123045 },
	ZKB: { lat: -8.525, lon: 30.663 },
	LVI: { lat: -17.8218, lon: 25.822701 },
	LXU: { lat: -14.375891, lon: 23.248648 },
	LUN: { lat: -15.330833, lon: 28.452722 },
	MNS: { lat: -11.137, lon: 28.872601 },
	MFU: { lat: -13.2589, lon: 31.9366 },
	MNR: { lat: -15.2545, lon: 23.1623 },
	ZGM: { lat: -15.9658, lon: 25.9333 },
	RYL: { lat: -15.724789, lon: 29.303541 },
	NLA: { lat: -12.961667, lon: 28.516667 },
	SXG: { lat: -16.113, lon: 23.2982 },
	KIW: { lat: -12.9005, lon: 28.1499 },
	SJQ: { lat: -17.47632, lon: 24.306089 },
	SLI: { lat: -12.1737, lon: 26.365101 },
	FLT: { lat: 62.452599, lon: -157.988998 },
	BBZ: { lat: -13.535996, lon: 23.10559 },
	ULI: { lat: 10.0198, lon: 139.789993 },
	HAH: { lat: -11.5337, lon: 43.2719 },
	NWA: { lat: -12.2981, lon: 43.766399 },
	AJN: { lat: -12.131047, lon: 44.430044 },
	DZA: { lat: -12.809319, lon: 45.281815 },
	RUN: { lat: -20.890087, lon: 55.518894 },
	ZSE: { lat: -21.319362, lon: 55.422506 },
	OHB: { lat: -18.9175, lon: 48.218194 },
	WML: { lat: -20.35539, lon: 45.543373 },
	ATJ: { lat: -19.839221, lon: 47.063713 },
	WAQ: { lat: -18.701273, lon: 44.614921 },
	VVB: { lat: -19.833, lon: 48.799999 },
	TNR: { lat: -18.7969, lon: 47.478802 },
	JVA: { lat: -18.80501, lon: 45.273467 },
	BMD: { lat: -19.686701, lon: 44.541901 },
	ZVA: { lat: -19.562799, lon: 45.450802 },
	MXT: { lat: -18.049999, lon: 44.033001 },
	ILK: { lat: -19.583, lon: 48.803001 },
	TVA: { lat: -17.850083, lon: 44.920467 },
	SMS: { lat: -17.093901, lon: 49.8158 },
	TMM: { lat: -18.109501, lon: 49.392502 },
	WTA: { lat: -17.476101, lon: 43.972801 },
	MOQ: { lat: -20.2847, lon: 44.3176 },
	WTS: { lat: -18.759677, lon: 46.054065 },
	VAT: { lat: -19.383333, lon: 48.95 },
	WAM: { lat: -17.795378, lon: 48.442583 },
	DIE: { lat: -12.3494, lon: 49.291698 },
	WBE: { lat: -14.544277, lon: 48.691413 },
	WMR: { lat: -16.1639, lon: 49.7738 },
	ZWA: { lat: -14.6517, lon: 49.620602 },
	AMB: { lat: -13.1884, lon: 48.987999 },
	WBD: { lat: -15.2, lon: 48.483002 },
	WPB: { lat: -15.584286, lon: 47.623587 },
	ANM: { lat: -14.9994, lon: 50.320202 },
	HVA: { lat: -14.629514, lon: 47.763555 },
	MJN: { lat: -15.666842, lon: 46.351233 },
	NOS: { lat: -13.3121, lon: 48.3148 },
	DWB: { lat: -16.10169, lon: 45.358837 },
	WMP: { lat: -16.071916, lon: 47.642953 },
	BPY: { lat: -16.74453, lon: 44.482484 },
	WMN: { lat: -15.437742, lon: 49.689081 },
	SVB: { lat: -14.2786, lon: 50.174702 },
	TTS: { lat: -16.751064, lon: 47.619016 },
	VOH: { lat: -13.3758, lon: 50.0028 },
	WAI: { lat: -14.8988, lon: 47.9939 },
	WMA: { lat: -15.845992, lon: 48.834718 },
	IVA: { lat: -13.484816, lon: 48.632702 },
	WBO: { lat: -21.606984, lon: 45.13602 },
	WMD: { lat: -21.046305, lon: 44.940412 },
	FTU: { lat: -25.038099, lon: 46.9561 },
	WFI: { lat: -21.441601, lon: 47.111698 },
	RVA: { lat: -22.8053, lon: 47.820599 },
	IHO: { lat: -22.40472, lon: 46.164937 },
	MJA: { lat: -21.426105, lon: 44.316509 },
	WVK: { lat: -22.119699, lon: 48.021702 },
	OVA: { lat: -24.235695, lon: 45.304527 },
	MNJ: { lat: -21.201799, lon: 48.358299 },
	TDV: { lat: -21.700001, lon: 43.733002 },
	MXM: { lat: -21.753837, lon: 43.374753 },
	TLE: { lat: -23.3834, lon: 43.7285 },
	VND: { lat: -23.350767, lon: 47.581701 },
	BKU: { lat: -23.733, lon: 44.389 },
	AMP: { lat: -24.699699, lon: 44.7342 },
	WAK: { lat: -22.296442, lon: 44.531536 },
	AZZ: { lat: -7.86222, lon: 13.1161 },
	SSY: { lat: -6.2699, lon: 14.247 },
	BUG: { lat: -12.609, lon: 13.4037 },
	NBJ: { lat: -9.050734, lon: 13.499078 },
	GGC: { lat: -14.105106, lon: 21.45083 },
	CAB: { lat: -5.59699, lon: 12.1884 },
	CFF: { lat: -8.78361, lon: 17.9897 },
	PGI: { lat: -7.35889, lon: 20.804701 },
	KNP: { lat: -9.76937, lon: 15.455319 },
	CBT: { lat: -12.4792, lon: 13.4869 },
	CTI: { lat: -15.1603, lon: 19.156099 },
	CXM: { lat: -8.37361, lon: 18.923599 },
	CAV: { lat: -11.8931, lon: 22.916239 },
	FND: { lat: 6.162443, lon: 73.28752 },
	DUE: { lat: -7.40089, lon: 20.818501 },
	VPE: { lat: -17.043501, lon: 15.6838 },
	NOV: { lat: -12.8089, lon: 15.7605 },
	SVP: { lat: -12.4046, lon: 16.947399 },
	LLT: { lat: -12.3712, lon: 13.5366 },
	LBZ: { lat: -8.442339, lon: 20.732701 },
	LAD: { lat: -8.85837, lon: 13.2312 },
	LZM: { lat: -9.11596, lon: 18.049299 },
	MEG: { lat: -9.52509, lon: 16.312401 },
	SPP: { lat: -14.6576, lon: 17.719801 },
	MSZ: { lat: -15.2612, lon: 12.1468 },
	GXG: { lat: -7.75451, lon: 15.2877 },
	PBN: { lat: -10.722, lon: 13.7655 },
	VHC: { lat: -9.68907, lon: 20.4319 },
	SZA: { lat: -6.14109, lon: 12.3718 },
	NDD: { lat: -11.1679, lon: 13.8475 },
	UAL: { lat: -10.7158, lon: 22.2311 },
	SDD: { lat: -14.9247, lon: 13.575 },
	LUO: { lat: -11.7681, lon: 19.897699 },
	UGO: { lat: -7.60307, lon: 15.0278 },
	CEO: { lat: -11.4264, lon: 15.1014 },
	XGN: { lat: -16.7554, lon: 14.9653 },
	ARZ: { lat: -7.259277, lon: 12.862355 },
	NZA: { lat: -7.71694, lon: 21.3582 },
	AKE: { lat: -1.13967, lon: 13.9036 },
	BGB: { lat: -0.1075, lon: 11.9438 },
	KDN: { lat: -2.4, lon: 11.367 },
	FOU: { lat: -1.278325, lon: 10.612497 },
	MBC: { lat: -1.893056, lon: 11.9125 },
	MGX: { lat: -2.455187, lon: 10.9358 },
	KDJ: { lat: -0.183, lon: 10.75 },
	KOU: { lat: -1.18461, lon: 12.4413 },
	MJL: { lat: -1.84514, lon: 11.0567 },
	OYE: { lat: 1.54311, lon: 11.5814 },
	OKN: { lat: -0.665214, lon: 13.6731 },
	LBQ: { lat: -0.704389, lon: 10.2457 },
	MVX: { lat: 2.152413, lon: 12.108044 },
	AWE: { lat: -0.545, lon: 9.444 },
	BMM: { lat: 2.07564, lon: 11.4932 },
	MFF: { lat: -1.526558, lon: 13.251332 },
	MKB: { lat: 0.976706, lon: 13.968462 },
	POG: { lat: -0.711739, lon: 8.75438 },
	OMB: { lat: -1.57473, lon: 9.26269 },
	IGE: { lat: -1.930801, lon: 9.319577 },
	MKU: { lat: 0.579211, lon: 12.8909 },
	LBV: { lat: 0.4586, lon: 9.41228 },
	MZC: { lat: 0.783, lon: 11.55 },
	MVB: { lat: -1.65616, lon: 13.438 },
	LTL: { lat: -0.826667, lon: 12.7486 },
	TCH: { lat: -2.88848, lon: 10.955429 },
	MYB: { lat: -3.458372, lon: 10.676539 },
	FOY: { lat: 8.3513, lon: -10.2269 },
	PCP: { lat: 1.66294, lon: 7.41174 },
	TMS: { lat: 0.378175, lon: 6.71215 },
	ANO: { lat: -16.18187, lon: 39.945217 },
	BEW: { lat: -19.7964, lon: 34.9076 },
	FXO: { lat: -14.815, lon: 36.529999 },
	VPY: { lat: -19.1513, lon: 33.429001 },
	IHC: { lat: -25.997145, lon: 32.929352 },
	IBO: { lat: -12.350174, lon: 40.602297 },
	INH: { lat: -23.8764, lon: 35.408501 },
	VXC: { lat: -13.274, lon: 35.2663 },
	LFB: { lat: -15.0331, lon: 40.6717 },
	MPM: { lat: -25.920799, lon: 32.572601 },
	MUD: { lat: -11.6729, lon: 39.563099 },
	MZB: { lat: -11.3618, lon: 40.3549 },
	MNC: { lat: -14.4882, lon: 40.7122 },
	APL: { lat: -15.1056, lon: 39.281799 },
	POL: { lat: -12.993302, lon: 40.524867 },
	PDD: { lat: -26.826913, lon: 32.838444 },
	UEL: { lat: -17.855499, lon: 36.869099 },
	TET: { lat: -16.104799, lon: 33.640202 },
	VNX: { lat: -22.0184, lon: 35.313301 },
	VJB: { lat: -24.892909, lon: 33.753024 },
	DES: { lat: -5.6967, lon: 53.6558 },
	SEZ: { lat: -4.67434, lon: 55.521801 },
	FSL: { lat: -18.1321, lon: 125.7873 },
	PRI: { lat: -4.319256, lon: 55.691561 },
	BDI: { lat: -3.723683, lon: 55.206106 },
	DEI: { lat: -3.802067, lon: 55.667439 },
	FRK: { lat: -4.582785, lon: 55.944928 },
	SRH: { lat: 9.14444, lon: 18.374399 },
	OGR: { lat: 10.288345, lon: 15.379561 },
	AEH: { lat: 13.847, lon: 20.844299 },
	MQQ: { lat: 8.628503, lon: 16.074241 },
	LTC: { lat: 9.3979, lon: 16.3125 },
	ATV: { lat: 13.239778, lon: 18.315893 },
	NDJ: { lat: 12.1337, lon: 15.034 },
	BKR: { lat: 12.385511, lon: 17.070989 },
	OTC: { lat: 13.443574, lon: 14.739254 },
	MVO: { lat: 12.17048, lon: 18.675642 },
	AMC: { lat: 11.034, lon: 20.274 },
	PLF: { lat: 9.37806, lon: 14.925 },
	OUT: { lat: 10.483, lon: 16.716999 },
	AMO: { lat: 14.1456, lon: 15.3144 },
	FYT: { lat: 17.917101, lon: 19.111099 },
	FUB: { lat: -6.1518, lon: 150.6264 },
	BZH: { lat: -16.816485, lon: 28.344786 },
	BUQ: { lat: -20.021254, lon: 28.626296 },
	CHJ: { lat: -20.206699, lon: 32.6283 },
	BFO: { lat: -21.008101, lon: 31.5786 },
	VFA: { lat: -18.0959, lon: 25.839001 },
	HRE: { lat: -17.931801, lon: 31.0928 },
	KAB: { lat: -16.5198, lon: 28.885 },
	MJW: { lat: -21.231, lon: 32.3336 },
	UTA: { lat: -18.997499, lon: 32.627201 },
	MVZ: { lat: -20.0553, lon: 30.8591 },
	GWE: { lat: -19.436718, lon: 29.861945 },
	HWN: { lat: -18.6299, lon: 27.021 },
	WKI: { lat: -18.362967, lon: 26.519791 },
	CEH: { lat: -10.55, lon: 33.799999 },
	BLZ: { lat: -15.6791, lon: 34.973999 },
	CMK: { lat: -14.306483, lon: 35.131477 },
	DWA: { lat: -12.517527, lon: 34.131877 },
	KGJ: { lat: -9.953571, lon: 33.893264 },
	KBQ: { lat: -13.0146, lon: 33.468601 },
	LLW: { lat: -13.7894, lon: 33.780998 },
	LIX: { lat: -12.079787, lon: 34.736253 },
	MYZ: { lat: -14.0836, lon: 34.919701 },
	LMB: { lat: -13.755893, lon: 34.584188 },
	ZZU: { lat: -11.4447, lon: 34.011799 },
	LEF: { lat: -29.8908, lon: 28.6556 },
	LRB: { lat: -28.8556, lon: 28.052799 },
	LES: { lat: -29.755583, lon: 28.357054 },
	MSG: { lat: -29.840562, lon: 28.77668 },
	MFC: { lat: -29.8011, lon: 27.243601 },
	MKH: { lat: -29.281799, lon: 29.0728 },
	MSU: { lat: -29.462299, lon: 27.5525 },
	NKU: { lat: -30.0217, lon: 28.196899 },
	PEL: { lat: -29.088056, lon: 28.497222 },
	UTG: { lat: -30.407499, lon: 27.6933 },
	UNE: { lat: -30.1117, lon: 28.6719 },
	SHK: { lat: -29.731088, lon: 28.767945 },
	SKQ: { lat: -30.0389, lon: 28.3703 },
	SOK: { lat: -29.8386, lon: 28.059999 },
	SHZ: { lat: -29.267599, lon: 28.552299 },
	THB: { lat: -29.5228, lon: 28.615801 },
	TKO: { lat: -29.233, lon: 28.882999 },
	AIW: { lat: -27.995, lon: 17.5966 },
	ADI: { lat: -22.461875, lon: 14.979322 },
	GOG: { lat: -22.5044, lon: 18.973101 },
	GFY: { lat: -19.6022, lon: 18.1227 },
	HAL: { lat: -19.0285, lon: 16.4585 },
	KAS: { lat: -28.0297, lon: 18.7385 },
	MPA: { lat: -17.634258, lon: 24.176688 },
	KMP: { lat: -26.539801, lon: 18.111401 },
	LHU: { lat: -18.116495, lon: 23.39346 },
	LUD: { lat: -26.687401, lon: 15.2429 },
	MJO: { lat: -21.0233, lon: 16.452801 },
	MQG: { lat: -22.0106, lon: 17.37 },
	OKU: { lat: -18.812799, lon: 17.059401 },
	NNI: { lat: -18.8064, lon: 16.9272 },
	OGV: { lat: -19.328533, lon: 15.915003 },
	OND: { lat: -17.878201, lon: 15.9526 },
	OMG: { lat: -18.0303, lon: 22.189699 },
	OMD: { lat: -28.5847, lon: 16.446699 },
	OKF: { lat: -19.1492, lon: 15.9119 },
	OPW: { lat: -18.061424, lon: 13.85047 },
	OHI: { lat: -17.797, lon: 15.6993 },
	OTJ: { lat: -20.4347, lon: 16.660801 },
	NDU: { lat: -17.956499, lon: 19.7194 },
	RHN: { lat: -27.8764, lon: 16.6478 },
	SWP: { lat: -22.6619, lon: 14.5681 },
	SZM: { lat: -24.5128, lon: 15.7467 },
	TCY: { lat: -19.9713, lon: 13.0249 },
	TSB: { lat: -19.2619, lon: 17.7325 },
	WVB: { lat: -22.979332, lon: 14.647102 },
	ERS: { lat: -22.6122, lon: 17.0804 },
	WDH: { lat: -22.4799, lon: 17.4709 },
	FIH: { lat: -4.38575, lon: 15.4446 },
	NLO: { lat: -4.32666, lon: 15.3275 },
	MNB: { lat: -5.930637, lon: 12.351334 },
	BOA: { lat: -5.854, lon: 13.064 },
	LZI: { lat: -4.943881, lon: 14.123337 },
	MAT: { lat: -5.79961, lon: 13.4404 },
	NKL: { lat: -5.421, lon: 14.8169 },
	INO: { lat: -1.94722, lon: 18.285801 },
	NIO: { lat: -2.717453, lon: 17.685735 },
	FDU: { lat: -3.31132, lon: 17.381701 },
	KRZ: { lat: -1.499806, lon: 18.928456 },
	KKW: { lat: -5.03577, lon: 18.785601 },
	IDF: { lat: -4.970605, lon: 19.57867 },
	MSM: { lat: -4.783, lon: 17.85 },
	MDK: { lat: 0.0226, lon: 18.2887 },
	BSU: { lat: 1.224789, lon: 19.788097 },
	LIE: { lat: 3.626584, lon: 18.638477 },
	BDT: { lat: 4.252745, lon: 20.975271 },
	GMA: { lat: 3.23537, lon: 19.771299 },
	KLI: { lat: 4.156991, lon: 21.66667 },
	BMB: { lat: 2.183261, lon: 22.479572 },
	LIQ: { lat: 2.17066, lon: 21.496901 },
	BNB: { lat: -0.286652, lon: 20.883551 },
	IKL: { lat: -1.048109, lon: 23.372501 },
	FKI: { lat: 0.481639, lon: 25.337999 },
	YAN: { lat: 0.783, lon: 24.466999 },
	IRP: { lat: 2.82761, lon: 27.588301 },
	BUX: { lat: 1.565743, lon: 30.220685 },
	BZU: { lat: 2.818058, lon: 24.793997 },
	BKY: { lat: -2.30898, lon: 28.8088 },
	RUE: { lat: 0.117142, lon: 29.312992 },
	GOM: { lat: -1.66617, lon: 29.237929 },
	BNC: { lat: 0.575, lon: 29.4739 },
	KND: { lat: -2.91918, lon: 25.9154 },
	KLY: { lat: -2.578, lon: 26.733999 },
	PUN: { lat: -1.390698, lon: 26.348146 },
	FBM: { lat: -11.5913, lon: 27.530899 },
	PWO: { lat: -8.400768, lon: 28.926285 },
	KEC: { lat: -10.355228, lon: 28.617243 },
	KWZ: { lat: -10.7659, lon: 25.505699 },
	MNO: { lat: -7.28889, lon: 27.3944 },
	BDV: { lat: -7.08488, lon: 29.737072 },
	FMI: { lat: -5.87556, lon: 29.25 },
	KBO: { lat: -6.083, lon: 26.917 },
	KOO: { lat: -5.393898, lon: 26.989932 },
	KMN: { lat: -8.728878, lon: 24.991407 },
	KAP: { lat: -8.371157, lon: 22.647457 },
	KNM: { lat: -7.599343, lon: 24.158592 },
	KGA: { lat: -5.90005, lon: 22.4692 },
	LZA: { lat: -7.189971, lon: 22.39254 },
	TSH: { lat: -6.43833, lon: 20.794701 },
	LJA: { lat: -3.462745, lon: 23.615162 },
	LBO: { lat: -4.96167, lon: 23.3783 },
	MEW: { lat: -4.855027, lon: 21.541786 },
	BAN: { lat: -4.315802, lon: 20.414891 },
	PFR: { lat: -4.329919, lon: 20.590124 },
	MJM: { lat: -6.12124, lon: 23.569 },
	KBN: { lat: -6.120761, lon: 24.546204 },
	NKA: { lat: 0.3843, lon: 9.75364 },
	GIM: { lat: -0.02894, lon: 11.418021 },
	GAX: { lat: -2.785278, lon: 10.047222 },
	BKO: { lat: 12.5335, lon: -7.94994 },
	GUD: { lat: 16.358426, lon: -3.604536 },
	GAQ: { lat: 16.2484, lon: -0.005456 },
	KNZ: { lat: 12.833, lon: -11.25 },
	KTX: { lat: 12.383, lon: -5.467 },
	KYS: { lat: 14.482473, lon: -11.39971 },
	MZI: { lat: 14.5128, lon: -4.07956 },
	NRM: { lat: 15.22913, lon: -7.261965 },
	NIX: { lat: 15.2381, lon: -9.57611 },
	KSS: { lat: 11.328611, lon: -5.684722 },
	TOM: { lat: 16.730499, lon: -3.00758 },
	EYL: { lat: 15.123682, lon: -10.571177 },
	PZE: { lat: 50.130376, lon: -5.513946 },
	FLH: { lat: 58.825802, lon: -3.14278 },
	FOA: { lat: 60.121725, lon: -2.053202 },
	GBM: { lat: 3.32294, lon: 42.21309 },
	BJL: { lat: 13.338, lon: -16.652201 },
	FUE: { lat: 28.4527, lon: -13.8638 },
	GMZ: { lat: 28.0296, lon: -17.2146 },
	VDE: { lat: 27.8148, lon: -17.8871 },
	SPC: { lat: 28.626499, lon: -17.7556 },
	LPA: { lat: 27.9319, lon: -15.3866 },
	ACE: { lat: 28.945499, lon: -13.6052 },
	TFS: { lat: 28.0445, lon: -16.5725 },
	GCV: { lat: -29.9494, lon: -50.98505 },
	TFN: { lat: 28.4827, lon: -16.341499 },
	JCU: { lat: 35.892657, lon: -5.306321 },
	MLN: { lat: 35.2798, lon: -2.95626 },
	OYC: { lat: 3.172847, lon: -52.336142 },
	KBS: { lat: 7.9444, lon: -11.761 },
	GBK: { lat: 7.812535, lon: -12.377815 },
	HGS: { lat: 8.394348, lon: -13.128891 },
	KBA: { lat: 9.638323, lon: -11.51556 },
	KEN: { lat: 7.896364, lon: -11.174126 },
	FNA: { lat: 8.61644, lon: -13.1955 },
	WYE: { lat: 8.61047, lon: -11.0454 },
	BQE: { lat: 11.297356, lon: -15.838079 },
	OXB: { lat: 11.8948, lon: -15.6537 },
	GHE: { lat: 8.0644, lon: -78.3673 },
	QCU: { lat: 68.744273, lon: -52.340369 },
	UCN: { lat: 5.905503, lon: -10.058262 },
	CPA: { lat: 4.37902, lon: -7.69695 },
	SNI: { lat: 5.032124, lon: -9.064236 },
	MLW: { lat: 6.28906, lon: -10.7587 },
	NIA: { lat: 7.494459, lon: -8.584514 },
	ROB: { lat: 6.23379, lon: -10.3623 },
	SAZ: { lat: 4.681845, lon: -8.434668 },
	THC: { lat: 6.04565, lon: -8.138723 },
	VOI: { lat: 8.32347, lon: -9.769249 },
	AGA: { lat: 30.322478, lon: -9.412003 },
	TTA: { lat: 28.4482, lon: -11.1613 },
	OZG: { lat: 30.263858, lon: -5.853341 },
	UAR: { lat: 32.514306, lon: -1.983056 },
	FEZ: { lat: 33.927299, lon: -4.97796 },
	ERH: { lat: 31.9475, lon: -4.39833 },
	MEK: { lat: 33.879101, lon: -5.51512 },
	OUD: { lat: 34.789558, lon: -1.926041 },
	SMW: { lat: 26.731987, lon: -11.683655 },
	GMD: { lat: 33.655399, lon: -7.22145 },
	BEM: { lat: 32.401895, lon: -6.315905 },
	RBA: { lat: 34.051498, lon: -6.75152 },
	VIL: { lat: 23.7183, lon: -15.932 },
	ESU: { lat: 31.397499, lon: -9.68167 },
	EUN: { lat: 27.142467, lon: -13.224947 },
	CMN: { lat: 33.3675, lon: -7.58997 },
	NDR: { lat: 34.9888, lon: -3.02821 },
	RAK: { lat: 31.606899, lon: -8.0363 },
	NNA: { lat: 34.298901, lon: -6.59588 },
	OZZ: { lat: 30.9391, lon: -6.90943 },
	AHU: { lat: 35.177101, lon: -3.83952 },
	TTU: { lat: 35.594299, lon: -5.32002 },
	TNG: { lat: 35.731741, lon: -5.921459 },
	GNU: { lat: 59.117561, lon: -161.575241 },
	DSS: { lat: 14.670878, lon: -17.072829 },
	KDA: { lat: 12.898604, lon: -14.968322 },
	ZIG: { lat: 12.5556, lon: -16.281799 },
	CSK: { lat: 12.39533, lon: -16.748 },
	KLC: { lat: 14.1469, lon: -16.0513 },
	DKR: { lat: 14.7397, lon: -17.4902 },
	MAX: { lat: 15.5936, lon: -13.3228 },
	POD: { lat: 16.678155, lon: -14.964957 },
	RDT: { lat: 16.437816, lon: -15.656376 },
	XLS: { lat: 16.049814, lon: -16.461039 },
	BXE: { lat: 14.8473, lon: -12.4683 },
	KGG: { lat: 12.5723, lon: -12.2203 },
	SMY: { lat: 13.0468, lon: -13.2954 },
	TUD: { lat: 13.7368, lon: -13.6531 },
	AEO: { lat: 16.7113, lon: -9.63788 },
	OTL: { lat: 17.52832, lon: -14.71412 },
	THI: { lat: 18.433942, lon: -9.486411 },
	TIY: { lat: 18.570101, lon: -11.4235 },
	BGH: { lat: 16.633314, lon: -14.200001 },
	KFA: { lat: 16.59, lon: -11.4062 },
	TMD: { lat: 16.233671, lon: -8.163464 },
	EMN: { lat: 16.622, lon: -7.3166 },
	AJJ: { lat: 19.727998, lon: -14.377214 },
	KED: { lat: 16.1595, lon: -13.5076 },
	MOM: { lat: 17.75, lon: -12.5 },
	NKC: { lat: 18.31, lon: -15.969722 },
	SEY: { lat: 15.1797, lon: -12.2073 },
	THT: { lat: 17.23157, lon: -10.77923 },
	ATR: { lat: 20.5068, lon: -13.0432 },
	FGD: { lat: 22.673551, lon: -12.729262 },
	NDB: { lat: 20.9331, lon: -17.030001 },
	OUZ: { lat: 22.757345, lon: -12.482228 },
	GRC: { lat: 4.571, lon: -8.2076 },
	CIQ: { lat: 14.83092, lon: -89.520938 },
	DON: { lat: 17.6124, lon: -89.6884 },
	ENJ: { lat: 14.106931, lon: -90.817496 },
	PCG: { lat: 17.263901, lon: -90.256302 },
	UAX: { lat: 17.393888, lon: -89.632744 },
	CKY: { lat: 9.57689, lon: -13.612 },
	GUE: { lat: -3.583167, lon: 141.5895 },
	FIG: { lat: 10.3506, lon: -13.5692 },
	FAA: { lat: 10.0355, lon: -10.7698 },
	KSI: { lat: 9.16056, lon: -10.1244 },
	LEK: { lat: 11.337512, lon: -12.290869 },
	MCA: { lat: 8.481456, lon: -9.526048 },
	NZE: { lat: 7.810413, lon: -8.702073 },
	BKJ: { lat: 10.9658, lon: -14.2811 },
	SBI: { lat: 12.575315, lon: -13.363349 },
	GII: { lat: 11.399833, lon: -9.18841 },
	SID: { lat: 16.7414, lon: -22.9494 },
	NTO: { lat: 17.202801, lon: -25.090599 },
	BVC: { lat: 16.136499, lon: -22.888901 },
	MMO: { lat: 15.1559, lon: -23.213699 },
	MTI: { lat: 15.045, lon: -24.339199 },
	RAI: { lat: 14.941126, lon: -23.484728 },
	SFL: { lat: 14.885, lon: -24.48 },
	SNE: { lat: 16.588852, lon: -24.284132 },
	VXE: { lat: 16.8332, lon: -25.0553 },
	KNN: { lat: 10.448438, lon: -9.228757 },
	BCG: { lat: 7.640212, lon: -58.961786 },
	BTO: { lat: 4.217511, lon: -55.447054 },
	DOE: { lat: 4.005713, lon: -55.481644 },
	ADD: { lat: 8.97789, lon: 38.799301 },
	AMH: { lat: 6.03939, lon: 37.5905 },
	AXU: { lat: 14.1468, lon: 38.7728 },
	BCO: { lat: 5.783333, lon: 36.55 },
	BJR: { lat: 11.6081, lon: 37.321602 },
	BEI: { lat: 9.38639, lon: 34.5219 },
	DSE: { lat: 11.10975, lon: 39.725911 },
	DEM: { lat: 8.554, lon: 34.858002 },
	DBM: { lat: 10.321501, lon: 37.741887 },
	DIR: { lat: 9.6247, lon: 41.854198 },
	DBT: { lat: 11.884808, lon: 38.009241 },
	FNH: { lat: 9.584387, lon: 37.377855 },
	GOB: { lat: 7.119033, lon: 40.045166 },
	GNN: { lat: 7.15, lon: 40.716999 },
	GMB: { lat: 8.12876, lon: 34.563099 },
	GDQ: { lat: 12.5199, lon: 37.433998 },
	GDE: { lat: 5.93513, lon: 43.578602 },
	GOR: { lat: 8.1614, lon: 35.5529 },
	QHR: { lat: 8.7163, lon: 39.0059 },
	HUE: { lat: 13.83012, lon: 36.88237 },
	JIJ: { lat: 9.3325, lon: 42.9121 },
	JIM: { lat: 7.66609, lon: 36.816601 },
	ABK: { lat: 6.732577, lon: 44.241339 },
	LFO: { lat: 5.657, lon: 44.349998 },
	AWA: { lat: 7.099869, lon: 38.396187 },
	LLI: { lat: 11.975225, lon: 38.980198 },
	MKS: { lat: 10.7254, lon: 38.7415 },
	MQX: { lat: 13.4674, lon: 39.533501 },
	ETE: { lat: 12.933, lon: 36.167 },
	NDM: { lat: 9.767, lon: 35.099998 },
	MUJ: { lat: 5.8646, lon: 35.7485 },
	MTF: { lat: 6.9571, lon: 35.5547 },
	EGL: { lat: 5.2897, lon: 39.7023 },
	NEJ: { lat: 9.55, lon: 35.466995 },
	NEK: { lat: 9.034333, lon: 36.613154 },
	PWI: { lat: 11.3126, lon: 36.4164 },
	SXU: { lat: 6.80281, lon: 37.68622 },
	SKR: { lat: 5.6923, lon: 38.9764 },
	HIL: { lat: 6.077545, lon: 44.763736 },
	SZE: { lat: 11.7875, lon: 40.9915 },
	ASO: { lat: 10.0185, lon: 34.5863 },
	TIE: { lat: 7.2024, lon: 35.415 },
	WRA: { lat: 6.9724, lon: 45.3334 },
	HAZ: { lat: -4.4033, lon: 145.2056 },
	BJM: { lat: -3.32402, lon: 29.318501 },
	GID: { lat: -3.417209, lon: 29.911308 },
	KRE: { lat: -2.544772, lon: 30.094575 },
	HBT: { lat: 6.124043, lon: 81.103 },
	ALU: { lat: 11.9582, lon: 50.748 },
	BIB: { lat: 3.10192, lon: 43.627137 },
	CXN: { lat: 11.495627, lon: 49.909816 },
	BSY: { lat: 2.330195, lon: 42.311802 },
	HCM: { lat: 8.104, lon: 49.82 },
	BSA: { lat: 11.275235, lon: 49.139231 },
	GSR: { lat: 9.545975, lon: 49.119148 },
	HGA: { lat: 9.513207, lon: 44.082389 },
	BBO: { lat: 10.385035, lon: 44.936723 },
	LGX: { lat: 3.8124, lon: 42.5459 },
	KMU: { lat: -0.377353, lon: 42.459202 },
	MGQ: { lat: 2.01444, lon: 45.304699 },
	BLW: { lat: 4.766976, lon: 45.2388 },
	CMO: { lat: 5.358003, lon: 48.515281 },
	GLK: { lat: 6.78083, lon: 47.4547 },
	CMS: { lat: 10.313889, lon: 50.205556 },
	ERA: { lat: 10.642051, lon: 47.387981 },
	BUO: { lat: 9.5275, lon: 45.5549 },
	GGR: { lat: 8.457942, lon: 48.567407 },
	JIB: { lat: 11.5473, lon: 43.1595 },
	AII: { lat: 11.146889, lon: 42.72 },
	MHI: { lat: 11.72975, lon: 43.209559 },
	OBC: { lat: 11.967, lon: 43.266998 },
	TDJ: { lat: 11.787037, lon: 42.917376 },
	EMY: { lat: 28.090509, lon: 30.738738 },
	RDL: { lat: 30.410714, lon: 33.15535 },
	SQK: { lat: 31.47201, lon: 25.879272 },
	DBB: { lat: 30.924324, lon: 28.46161 },
	AAC: { lat: 31.078565, lon: 33.836791 },
	ATZ: { lat: 27.050818, lon: 31.016309 },
	HBE: { lat: 30.93249, lon: 29.696437 },
	ABS: { lat: 22.367657, lon: 31.609962 },
	CAI: { lat: 30.111534, lon: 31.396694 },
	CCE: { lat: 30.074293, lon: 31.84296 },
	DAK: { lat: 25.41116, lon: 29.003273 },
	HRG: { lat: 27.176776, lon: 33.796692 },
	EGH: { lat: 31.078138, lon: 34.153131 },
	UVL: { lat: 25.471483, lon: 30.588491 },
	LXR: { lat: 25.671037, lon: 32.706451 },
	RMF: { lat: 25.555548, lon: 34.59245 },
	MUH: { lat: 31.325464, lon: 27.221716 },
	HEO: { lat: -9.13658, lon: 147.598434 },
	GSQ: { lat: 22.584256, lon: 28.721609 },
	PSD: { lat: 31.279285, lon: 32.240582 },
	SKV: { lat: 28.684601, lon: 34.062681 },
	HMB: { lat: 26.342515, lon: 31.743017 },
	SSH: { lat: 27.977272, lon: 34.394717 },
	ASW: { lat: 23.968137, lon: 32.824445 },
	SEW: { lat: 29.346234, lon: 25.505624 },
	SPX: { lat: 30.108179, lon: 30.895728 },
	TCP: { lat: 29.594496, lon: 34.775752 },
	ELT: { lat: 28.208964, lon: 33.645483 },
	HEY: { lat: 31.346001, lon: -85.654297 },
	HGT: { lat: 35.9935, lon: -121.237 },
	ASM: { lat: 15.2919, lon: 38.910702 },
	MSW: { lat: 15.67, lon: 39.370098 },
	ASA: { lat: 13.0718, lon: 42.645 },
	TES: { lat: 15.104322, lon: 36.681711 },
	HPV: { lat: 22.209313, lon: -159.44515 },
	WKL: { lat: 19.920546, lon: -155.860628 },
	JUB: { lat: 4.87201, lon: 31.601101 },
	ASV: { lat: -2.64505, lon: 37.253101 },
	HKB: { lat: 63.9958, lon: -144.6926 },
	EDL: { lat: 0.404458, lon: 35.238899 },
	EYS: { lat: 3.23635, lon: 35.97664 },
	KLK: { lat: 3.49161, lon: 35.836777 },
	GAS: { lat: -0.463508, lon: 39.6483 },
	HOA: { lat: -1.522, lon: 40.004002 },
	NBO: { lat: -1.31924, lon: 36.927799 },
	KEU: { lat: -1.586345, lon: 35.257455 },
	GGM: { lat: 0.271342, lon: 34.7873 },
	KIS: { lat: -0.086139, lon: 34.728901 },
	ILU: { lat: -2.91061, lon: 38.065201 },
	KEY: { lat: -0.3899, lon: 35.242093 },
	KTL: { lat: 0.971989, lon: 34.958599 },
	LKG: { lat: 4.20412, lon: 34.348202 },
	LOK: { lat: 3.12197, lon: 35.6087 },
	LAU: { lat: -2.252431, lon: 40.912892 },
	LOY: { lat: 2.75, lon: 36.716999 },
	NDE: { lat: 3.934045, lon: 41.844437 },
	RBT: { lat: 2.344254, lon: 37.999996 },
	JJM: { lat: 0.165083, lon: 38.195141 },
	MYD: { lat: -3.22931, lon: 40.1017 },
	MBA: { lat: -4.03483, lon: 39.5942 },
	MRE: { lat: -1.406111, lon: 35.008057 },
	OYL: { lat: 3.46972, lon: 39.101398 },
	NYE: { lat: -0.364414, lon: 36.978485 },
	NUU: { lat: -0.298067, lon: 36.159302 },
	NYK: { lat: -0.062399, lon: 37.041008 },
	WIL: { lat: -1.32172, lon: 36.8148 },
	UAS: { lat: 0.534069, lon: 37.531991 },
	UKA: { lat: -4.29333, lon: 39.571098 },
	WJR: { lat: 1.73324, lon: 40.091599 },
	SRX: { lat: 31.063499, lon: 16.594999 },
	GHT: { lat: 25.145599, lon: 10.1426 },
	AKF: { lat: 24.178699, lon: 23.313999 },
	BEN: { lat: 32.096802, lon: 20.269501 },
	MJI: { lat: 32.89177, lon: 13.287878 },
	LAQ: { lat: 32.7887, lon: 21.9643 },
	SEB: { lat: 26.992452, lon: 14.466162 },
	LMQ: { lat: 30.378099, lon: 19.576401 },
	MRA: { lat: 32.325001, lon: 15.061 },
	NFR: { lat: 29.2132, lon: 21.5924 },
	HUQ: { lat: 29.1101, lon: 15.9656 },
	LTD: { lat: 30.151699, lon: 9.71531 },
	TOB: { lat: 31.861, lon: 23.907 },
	QUB: { lat: 26.567499, lon: 12.8231 },
	ZIS: { lat: 31.774878, lon: 12.25006 },
	WAX: { lat: 32.952301, lon: 12.0155 },
	EDQ: { lat: 14.235833, lon: -88.437225 },
	HOO: { lat: 11.9787, lon: 107.5638 },
	HRC: { lat: 48.3974, lon: 70.1915 },
	GYI: { lat: -1.6772, lon: 29.2589 },
	BTQ: { lat: -2.59583, lon: 29.7367 },
	KGL: { lat: -1.96863, lon: 30.1395 },
	RHG: { lat: -1.496873, lon: 29.631343 },
	KME: { lat: -2.46224, lon: 28.9079 },
	ATB: { lat: 17.710344, lon: 34.057018 },
	EDB: { lat: 18.0146, lon: 30.9595 },
	DOG: { lat: 19.1539, lon: 30.430099 },
	RSS: { lat: 11.7859, lon: 34.3367 },
	ELF: { lat: 13.6149, lon: 25.3246 },
	DNX: { lat: 12.533, lon: 35.067001 },
	EGN: { lat: 13.481882, lon: 22.467119 },
	HEG: { lat: 9.994933, lon: 29.397718 },
	HSJ: { lat: 34.842153, lon: 113.273983 },
	KSL: { lat: 15.3875, lon: 36.3288 },
	GBU: { lat: 14.925, lon: 35.877998 },
	KDX: { lat: 11.138, lon: 29.701099 },
	RBX: { lat: 6.831074, lon: 29.669073 },
	MWE: { lat: 18.443333, lon: 31.843333 },
	NUD: { lat: 12.735513, lon: 28.410841 },
	UYL: { lat: 12.0535, lon: 24.9562 },
	NHF: { lat: 15.3556, lon: 35.727798 },
	EBD: { lat: 13.1532, lon: 30.2327 },
	PZU: { lat: 19.433599, lon: 37.2341 },
	KRT: { lat: 15.5895, lon: 32.5532 },
	MAK: { lat: 9.55897, lon: 31.652201 },
	WHF: { lat: 21.802698, lon: 31.521578 },
	WUU: { lat: 7.72583, lon: 27.975 },
	ZLX: { lat: 12.9437, lon: 23.5631 },
	ARK: { lat: -3.36779, lon: 36.633301 },
	BKZ: { lat: -1.332, lon: 31.8212 },
	DAR: { lat: -6.87811, lon: 39.202599 },
	DOD: { lat: -6.17044, lon: 35.752602 },
	GTC: { lat: -2.74233, lon: 31.70683 },
	GTZ: { lat: -2.160833, lon: 34.225556 },
	MBI: { lat: -8.919942, lon: 33.273981 },
	IRI: { lat: -7.66863, lon: 35.752102 },
	TKQ: { lat: -4.8862, lon: 29.6709 },
	KIY: { lat: -8.91123, lon: 39.508619 },
	JRO: { lat: -3.42941, lon: 37.074501 },
	LDI: { lat: -9.851005, lon: 39.75911 },
	LKY: { lat: -3.37631, lon: 35.818298 },
	MFA: { lat: -7.917478, lon: 39.668502 },
	MWN: { lat: -3.521332, lon: 33.615542 },
	XMI: { lat: -10.733, lon: 38.766998 },
	NPY: { lat: -6.355374, lon: 31.084116 },
	QSI: { lat: -3.36333, lon: 37.3269 },
	MYW: { lat: -10.336204, lon: 40.181997 },
	MUZ: { lat: -1.503, lon: 33.8021 },
	MWZ: { lat: -2.44449, lon: 32.932701 },
	NCH: { lat: -10.3575, lon: 38.779202 },
	JOM: { lat: -9.35, lon: 34.799999 },
	PMA: { lat: -5.25726, lon: 39.811401 },
	SEU: { lat: -2.45806, lon: 34.822498 },
	SGX: { lat: -10.683, lon: 35.583 },
	SUT: { lat: -7.948889, lon: 31.610278 },
	SHY: { lat: -3.6093, lon: 33.5035 },
	TBO: { lat: -5.07639, lon: 32.833302 },
	TGT: { lat: -5.09236, lon: 39.071201 },
	ZNZ: { lat: -6.22202, lon: 39.224899 },
	RUA: { lat: 3.049152, lon: 30.911714 },
	EBB: { lat: 0.042386, lon: 32.443501 },
	ULU: { lat: 2.80556, lon: 32.271801 },
	JIN: { lat: 0.453094, lon: 33.19356 },
	KJJ: { lat: 0.1968, lon: 32.55297 },
	KSE: { lat: 0.183, lon: 30.1 },
	MBQ: { lat: -0.555278, lon: 30.5994 },
	KCU: { lat: 1.75806, lon: 31.7367 },
	PAF: { lat: 2.326563, lon: 31.497698 },
	SRT: { lat: 1.72769, lon: 33.622799 },
	TRY: { lat: 0.683, lon: 34.167 },
	HWI: { lat: 58.127399, lon: -134.755997 },
	HYL: { lat: 55.481529, lon: -132.646008 },
	HZU: { lat: 30.677339, lon: 104.529397 },
	IBI: { lat: -5.5536, lon: 149.19 },
	IBL: { lat: -21.708, lon: 35.452801 },
	ICO: { lat: 11.4595, lon: 123.2506 },
	PPJ: { lat: -5.644444, lon: 106.5625 },
	GXM: { lat: -1.128903, lon: 113.873075 },
	ENG: { lat: -5.305621, lon: 102.189546 },
	GYO: { lat: 3.94548, lon: 97.35968 },
	DHX: { lat: -7.750278, lon: 111.947222 },
	SKJ: { lat: 0.789936, lon: 108.960395 },
	RUF: { lat: -3.628919, lon: 140.953689 },
	BJG: { lat: 0.686111, lon: 124.273611 },
	AAS: { lat: -3.882495, lon: 139.310932 },
	AGD: { lat: -1.3858, lon: 133.8737 },
	AKQ: { lat: -4.611588, lon: 105.231968 },
	ELR: { lat: -3.785922, lon: 139.384497 },
	EWE: { lat: -5.496185, lon: 138.078361 },
	GAV: { lat: -0.400556, lon: 129.895004 },
	IUL: { lat: -3.7051, lon: 138.2002 },
	KOD: { lat: -0.26667, lon: 116.583336 },
	KRC: { lat: -2.094042, lon: 101.47025 },
	LLN: { lat: -3.728968, lon: 138.710117 },
	MSI: { lat: -5.58333, lon: 114.432999 },
	NAF: { lat: 2.72305, lon: 117.125999 },
	OBD: { lat: -3.9106, lon: 136.2306 },
	RKI: { lat: -2.094167, lon: 99.699167 },
	TMY: { lat: -3.9256, lon: 138.4555 },
	UGU: { lat: -3.739503, lon: 137.031183 },
	IMA: { lat: -9.5107, lon: 150.5246 },
	IMG: { lat: -18.41, lon: 35.0045 },
	PYG: { lat: 27.2313, lon: 88.587196 },
	AYJ: { lat: 26.751283, lon: 82.155295 },
	SDW: { lat: 16.002552, lon: 73.529846 },
	NMI: { lat: 18.984597, lon: 73.065253 },
	RQY: { lat: 13.858024, lon: 75.618868 },
	HGI: { lat: 26.96683, lon: 93.638792 },
	UKE: { lat: 20.097778, lon: 83.183333 },
	AHA: { lat: 22.98753, lon: 83.19612 },
	JGB: { lat: 19.074301, lon: 82.036797 },
	RJI: { lat: 33.377899, lon: 74.315201 },
	INE: { lat: -18.59, lon: 36.4489 },
	IOK: { lat: -8.401, lon: 146.277 },
	IOP: { lat: -8.3614, lon: 147.84 },
	IRU: { lat: 9.299746, lon: 80.448627 },
	ITK: { lat: -9.201527, lon: 148.264261 },
	IVI: { lat: 8.4693, lon: -79.0016 },
	JIO: { lat: -8.140402, lon: 127.908758 },
	JLA: { lat: 60.484235, lon: -149.722909 },
	JMB: { lat: -14.698193, lon: 16.070148 },
	JPN: { lat: 38.874908, lon: -77.056682 },
	JRA: { lat: 40.755107, lon: -74.006896 },
	JRB: { lat: 40.700711, lon: -74.008573 },
	JUH: { lat: 30.7403, lon: 117.6856 },
	AMK: { lat: 37.203201, lon: -107.869003 },
	BDX: { lat: 45.470462, lon: -105.457145 },
	EUE: { lat: 39.604198, lon: -116.004997 },
	KPT: { lat: 41.976002, lon: -114.657997 },
	RLA: { lat: 37.935699, lon: -91.813499 },
	FID: { lat: 41.252099, lon: -72.032218 },
	HUD: { lat: 42.734831, lon: -94.245315 },
	TWD: { lat: 48.053799, lon: -122.810997 },
	MVM: { lat: 36.716444, lon: -110.228444 },
	HCC: { lat: 42.291302, lon: -73.710297 },
	AHD: { lat: 34.146999, lon: -97.122704 },
	GCW: { lat: 35.985787, lon: -113.817072 },
	CKE: { lat: 38.990601, lon: -122.901001 },
	ROF: { lat: 41.7304, lon: -122.545998 },
	CNE: { lat: 38.429739, lon: -105.108562 },
	RSX: { lat: 44.991699, lon: -73.363073 },
	COP: { lat: 42.629552, lon: -74.890445 },
	CIL: { lat: 64.897903, lon: -163.703003 },
	NWH: { lat: 43.3881, lon: -72.189301 },
	IRB: { lat: 30.905701, lon: -101.891998 },
	ODM: { lat: 39.580819, lon: -79.33573 },
	GNF: { lat: 39.943902, lon: -120.945 },
	CHZ: { lat: 42.57944, lon: -121.879063 },
	LTW: { lat: 38.315399, lon: -76.550102 },
	USC: { lat: 34.687046, lon: -81.64105 },
	AHF: { lat: 40.341576, lon: -99.907839 },
	PCT: { lat: 40.3992, lon: -74.658897 },
	CTO: { lat: 40.9151, lon: -72.791901 },
	NRI: { lat: 36.577599, lon: -94.8619 },
	GTP: { lat: 42.510101, lon: -123.388 },
	NLE: { lat: 41.835899, lon: -86.225197 },
	GCD: { lat: 47.922001, lon: -119.083 },
	VLE: { lat: 35.6506, lon: -112.148003 },
	FPY: { lat: 30.0693, lon: -83.580597 },
	NTJ: { lat: 39.329102, lon: -111.614998 },
	SBO: { lat: 39.029099, lon: -111.837997 },
	JVI: { lat: 40.524399, lon: -74.598396 },
	UCE: { lat: 30.466299, lon: -92.423798 },
	GOL: { lat: 42.413399, lon: -124.424004 },
	KKT: { lat: 40.758733, lon: -87.429457 },
	PRW: { lat: 45.538313, lon: -90.275978 },
	EGP: { lat: 28.859766, lon: -100.516682 },
	BLD: { lat: 35.947161, lon: -114.858799 },
	MFH: { lat: 36.833105, lon: -114.055928 },
	ECA: { lat: 44.312801, lon: -83.422302 },
	FMU: { lat: 43.9828, lon: -124.111 },
	OTS: { lat: 48.498513, lon: -122.662513 },
	ROL: { lat: 40.278301, lon: -110.051003 },
	CTK: { lat: 43.308842, lon: -96.571225 },
	WPO: { lat: 38.831412, lon: -107.645763 },
	ATE: { lat: 34.1926, lon: -95.649902 },
	ASQ: { lat: 39.467708, lon: -117.197576 },
	AAF: { lat: 29.727501, lon: -85.027496 },
	ABE: { lat: 40.651773, lon: -75.442797 },
	ABI: { lat: 32.411301, lon: -99.6819 },
	ABQ: { lat: 35.039976, lon: -106.608925 },
	ABR: { lat: 45.4491, lon: -98.421799 },
	ABY: { lat: 31.532946, lon: -84.196215 },
	ACB: { lat: 44.988602, lon: -85.198402 },
	ACK: { lat: 41.253101, lon: -70.060204 },
	ACT: { lat: 31.6113, lon: -97.230499 },
	ACV: { lat: 40.978101, lon: -124.109 },
	ACY: { lat: 39.4576, lon: -74.577202 },
	ADG: { lat: 41.866205, lon: -84.077983 },
	ADT: { lat: 34.805214, lon: -96.671988 },
	ADM: { lat: 34.30301, lon: -97.019634 },
	ADS: { lat: 32.968601, lon: -96.836403 },
	ADW: { lat: 38.810799, lon: -76.866997 },
	KAE: { lat: 56.973, lon: -133.945999 },
	AEL: { lat: 43.681499, lon: -93.367203 },
	AEX: { lat: 31.3274, lon: -92.549797 },
	KAF: { lat: -6.2655, lon: 155.3052 },
	AFF: { lat: 38.972497, lon: -104.821125 },
	WSG: { lat: 40.136501, lon: -80.290199 },
	AFN: { lat: 42.805099, lon: -72.002998 },
	AFO: { lat: 42.711201, lon: -110.942001 },
	AFW: { lat: 32.99044, lon: -97.31947 },
	AGC: { lat: 40.354401, lon: -79.930199 },
	AGO: { lat: 33.228001, lon: -93.217002 },
	AGS: { lat: 33.3699, lon: -81.9645 },
	AHC: { lat: 40.266201, lon: -120.153 },
	AHH: { lat: 45.281101, lon: -92.375397 },
	AHN: { lat: 33.948842, lon: -83.325634 },
	AIA: { lat: 42.052543, lon: -102.803965 },
	AID: { lat: 40.108601, lon: -85.612999 },
	AIK: { lat: 33.649399, lon: -81.684998 },
	AIO: { lat: 41.407299, lon: -95.046898 },
	AIV: { lat: 33.106499, lon: -88.1978 },
	AIZ: { lat: 38.096001, lon: -92.5495 },
	KAK: { lat: -6.2452, lon: 143.5516 },
	AKO: { lat: 40.175598, lon: -103.222 },
	AKC: { lat: 41.037355, lon: -81.46784 },
	ALB: { lat: 42.748299, lon: -73.801697 },
	ALI: { lat: 27.7409, lon: -98.026901 },
	ALM: { lat: 32.837818, lon: -105.993149 },
	ALN: { lat: 38.890301, lon: -90.045998 },
	ALO: { lat: 42.557098, lon: -92.400299 },
	ALS: { lat: 37.434898, lon: -105.866997 },
	ALW: { lat: 46.094898, lon: -118.288002 },
	ALX: { lat: 32.9147, lon: -85.962997 },
	AMA: { lat: 35.219398, lon: -101.706001 },
	AMN: { lat: 43.322102, lon: -84.688004 },
	AMW: { lat: 41.992001, lon: -93.621803 },
	ANB: { lat: 33.5882, lon: -85.8581 },
	AND: { lat: 34.494598, lon: -82.709396 },
	SLT: { lat: 38.5383, lon: -106.049004 },
	ANP: { lat: 38.942902, lon: -76.568398 },
	ANQ: { lat: 41.639702, lon: -85.083504 },
	ANW: { lat: 42.579201, lon: -99.992995 },
	ANY: { lat: 37.158501, lon: -98.079597 },
	AOH: { lat: 40.706902, lon: -84.026703 },
	AOO: { lat: 40.296398, lon: -78.32 },
	APA: { lat: 39.570099, lon: -104.848999 },
	APC: { lat: 38.2132, lon: -122.280998 },
	APF: { lat: 26.152599, lon: -81.775299 },
	APG: { lat: 39.466202, lon: -76.1688 },
	APH: { lat: 38.068631, lon: -77.319318 },
	APN: { lat: 45.078098, lon: -83.560303 },
	APT: { lat: 35.060699, lon: -85.585297 },
	APV: { lat: 34.575298, lon: -117.185997 },
	ARA: { lat: 30.0378, lon: -91.883904 },
	ARB: { lat: 42.223, lon: -83.745598 },
	ARG: { lat: 36.124667, lon: -90.925111 },
	WHT: { lat: 29.254299, lon: -96.154404 },
	AUZ: { lat: 41.7719, lon: -88.4757 },
	ART: { lat: 43.991901, lon: -76.021698 },
	ARV: { lat: 45.927898, lon: -89.730904 },
	BFT: { lat: 32.412201, lon: -80.634399 },
	ASE: { lat: 39.223202, lon: -106.869003 },
	SPZ: { lat: 36.176399, lon: -94.119301 },
	ASH: { lat: 42.7817, lon: -71.514801 },
	ASL: { lat: 32.5205, lon: -94.3078 },
	ASN: { lat: 33.569901, lon: -86.050903 },
	AST: { lat: 46.158001, lon: -123.878998 },
	ASX: { lat: 46.5485, lon: -90.918999 },
	ASY: { lat: 46.023899, lon: -99.3526 },
	ATL: { lat: 33.6367, lon: -84.428101 },
	ATS: { lat: 32.852501, lon: -104.468002 },
	ATW: { lat: 44.258099, lon: -88.519096 },
	ATY: { lat: 44.914001, lon: -97.154701 },
	AUG: { lat: 44.320599, lon: -69.797302 },
	AUM: { lat: 43.665001, lon: -92.933403 },
	AUN: { lat: 38.9548, lon: -121.082001 },
	AUO: { lat: 32.615101, lon: -85.433998 },
	AUS: { lat: 30.197535, lon: -97.662015 },
	AUW: { lat: 44.926201, lon: -89.626602 },
	AVL: { lat: 35.436199, lon: -82.541801 },
	AVO: { lat: 27.5912, lon: -81.527802 },
	AVP: { lat: 41.338501, lon: -75.723396 },
	AVW: { lat: 32.409065, lon: -111.216199 },
	AVX: { lat: 33.4049, lon: -118.416 },
	AWM: { lat: 35.135101, lon: -90.234398 },
	AXG: { lat: 43.078104, lon: -94.271836 },
	AXN: { lat: 45.866299, lon: -95.394699 },
	AXS: { lat: 34.697952, lon: -99.3385 },
	AXV: { lat: 40.493401, lon: -84.298897 },
	AXX: { lat: 36.422001, lon: -105.290001 },
	AYS: { lat: 31.2491, lon: -82.3955 },
	TUH: { lat: 35.392601, lon: -86.0858 },
	AZO: { lat: 42.234901, lon: -85.552101 },
	BAB: { lat: 39.136101, lon: -121.436996 },
	BAD: { lat: 32.501801, lon: -93.662697 },
	BAF: { lat: 42.157799, lon: -72.715599 },
	CLU: { lat: 39.262386, lon: -85.895576 },
	BAM: { lat: 40.598999, lon: -116.874001 },
	BBB: { lat: 45.331902, lon: -95.650597 },
	BBD: { lat: 31.178931, lon: -99.324732 },
	BKG: { lat: 36.532082, lon: -93.200544 },
	BTN: { lat: 34.6217, lon: -79.734398 },
	BBW: { lat: 41.436501, lon: -99.642197 },
	BCB: { lat: 37.2076, lon: -80.407799 },
	BCE: { lat: 37.706402, lon: -112.144997 },
	BCT: { lat: 26.3785, lon: -80.107697 },
	BDE: { lat: 48.728401, lon: -94.612198 },
	BDG: { lat: 37.583302, lon: -109.483002 },
	ILL: { lat: 45.117552, lon: -95.132259 },
	BDL: { lat: 41.93851, lon: -72.688066 },
	BDR: { lat: 41.163502, lon: -73.126198 },
	WBU: { lat: 40.039101, lon: -105.226025 },
	KBE: { lat: 55.9291, lon: -131.572006 },
	BEC: { lat: 37.6945, lon: -97.214996 },
	BED: { lat: 42.470001, lon: -71.289001 },
	BEH: { lat: 42.128601, lon: -86.428497 },
	BFD: { lat: 41.803101, lon: -78.640099 },
	BFF: { lat: 41.874001, lon: -103.596001 },
	BFI: { lat: 47.529999, lon: -122.302002 },
	BFL: { lat: 35.433601, lon: -119.056999 },
	BFM: { lat: 30.626801, lon: -88.0681 },
	BFR: { lat: 38.84, lon: -86.445396 },
	BGD: { lat: 35.700901, lon: -101.393997 },
	BGE: { lat: 30.9715, lon: -84.637398 },
	BGM: { lat: 42.208698, lon: -75.979797 },
	BGR: { lat: 44.8074, lon: -68.828102 },
	KBH: { lat: -3.847, lon: 32.6865 },
	BHB: { lat: 44.450001, lon: -68.361504 },
	BHM: { lat: 33.562901, lon: -86.753502 },
	BID: { lat: 41.168446, lon: -71.578631 },
	BIE: { lat: 40.3013, lon: -96.754097 },
	BIF: { lat: 31.849501, lon: -106.379997 },
	BIH: { lat: 37.3731, lon: -118.363998 },
	BIL: { lat: 45.807701, lon: -108.542999 },
	BIS: { lat: 46.772701, lon: -100.746002 },
	BIX: { lat: 30.4104, lon: -88.9244 },
	BJC: { lat: 39.908798, lon: -105.116997 },
	BJI: { lat: 47.509399, lon: -94.933701 },
	BJJ: { lat: 40.874802, lon: -81.888298 },
	BKD: { lat: 32.719002, lon: -98.890999 },
	BKE: { lat: 44.837299, lon: -117.808998 },
	BFK: { lat: 39.701698, lon: -104.751999 },
	BKL: { lat: 41.517502, lon: -81.683296 },
	BKT: { lat: 37.0742, lon: -77.957497 },
	BKW: { lat: 37.7873, lon: -81.124199 },
	BKX: { lat: 44.304798, lon: -96.816902 },
	BLF: { lat: 37.295799, lon: -81.207703 },
	BLH: { lat: 33.619202, lon: -114.717003 },
	BLI: { lat: 48.792801, lon: -122.538002 },
	BLM: { lat: 40.186901, lon: -74.124901 },
	BLU: { lat: 39.275002, lon: -120.709999 },
	BLV: { lat: 38.5452, lon: -89.835197 },
	BMC: { lat: 41.552399, lon: -112.061996 },
	BMG: { lat: 39.146, lon: -86.616699 },
	BMI: { lat: 40.4771, lon: -88.915901 },
	BML: { lat: 44.575401, lon: -71.175903 },
	BMT: { lat: 30.070635, lon: -94.215746 },
	BNA: { lat: 36.1245, lon: -86.6782 },
	BNG: { lat: 33.922548, lon: -116.850672 },
	BNL: { lat: 33.257801, lon: -81.388298 },
	BNO: { lat: 43.590463, lon: -118.955154 },
	BNW: { lat: 42.049599, lon: -93.847603 },
	BOI: { lat: 43.5644, lon: -116.223 },
	BOK: { lat: 42.0746, lon: -124.290001 },
	BOS: { lat: 42.36197, lon: -71.0079 },
	BOW: { lat: 27.943399, lon: -81.783401 },
	HCA: { lat: 32.212601, lon: -101.522003 },
	BPI: { lat: 42.585098, lon: -110.111 },
	WMH: { lat: 36.3689, lon: -92.470497 },
	BPT: { lat: 29.9508, lon: -94.020699 },
	BQK: { lat: 31.258801, lon: -81.466499 },
	BRD: { lat: 46.402861, lon: -94.129727 },
	BRL: { lat: 40.783199, lon: -91.125504 },
	BRO: { lat: 25.906799, lon: -97.425903 },
	BRY: { lat: 37.814301, lon: -85.499603 },
	KBT: { lat: 8.90056, lon: 170.843994 },
	BTF: { lat: 40.8694, lon: -111.927002 },
	BTL: { lat: 42.307301, lon: -85.251503 },
	BTM: { lat: 45.9548, lon: -112.497002 },
	TTO: { lat: 45.815201, lon: -97.743103 },
	BTP: { lat: 40.776901, lon: -79.949699 },
	BTR: { lat: 30.533199, lon: -91.149597 },
	BTV: { lat: 44.471901, lon: -73.153297 },
	BTY: { lat: 36.861099, lon: -116.787003 },
	BUB: { lat: 41.776699, lon: -99.149696 },
	BUF: { lat: 42.940498, lon: -78.732201 },
	BUM: { lat: 38.289799, lon: -94.340103 },
	BUR: { lat: 34.197703, lon: -118.356378 },
	BFP: { lat: 40.772499, lon: -80.391403 },
	BVO: { lat: 36.762501, lon: -96.0112 },
	MVW: { lat: 48.470901, lon: -122.420998 },
	BVX: { lat: 35.7262, lon: -91.647301 },
	BVY: { lat: 42.584202, lon: -70.916496 },
	BWC: { lat: 32.992901, lon: -115.516998 },
	BWD: { lat: 31.7936, lon: -98.956497 },
	BWG: { lat: 36.9645, lon: -86.419701 },
	BWI: { lat: 39.1754, lon: -76.668297 },
	WAH: { lat: 46.244099, lon: -96.607399 },
	BWM: { lat: 46.165519, lon: -103.30075 },
	BXA: { lat: 30.8137, lon: -89.864998 },
	BXK: { lat: 33.422397, lon: -112.686317 },
	NHZ: { lat: 43.8922, lon: -69.938599 },
	BYG: { lat: 44.3811, lon: -106.722 },
	BYH: { lat: 35.964298, lon: -89.944 },
	BYI: { lat: 42.542599, lon: -113.772003 },
	BYS: { lat: 35.280499, lon: -116.629997 },
	BBC: { lat: 28.973301, lon: -95.863503 },
	BZN: { lat: 45.7775, lon: -111.153 },
	XES: { lat: 42.614899, lon: -88.389603 },
	PLY: { lat: 41.365101, lon: -86.300499 },
	CLG: { lat: 36.163101, lon: -120.293999 },
	CAD: { lat: 44.275749, lon: -85.421534 },
	CAE: { lat: 33.938801, lon: -81.119499 },
	CIG: { lat: 40.495201, lon: -107.522003 },
	CAK: { lat: 40.9161, lon: -81.4422 },
	CAO: { lat: 36.446201, lon: -103.167 },
	CAR: { lat: 46.871498, lon: -68.017899 },
	CBE: { lat: 39.615398, lon: -78.760902 },
	CBF: { lat: 41.259201, lon: -95.760597 },
	CBK: { lat: 39.427502, lon: -101.046997 },
	CBM: { lat: 33.643799, lon: -88.443802 },
	KCC: { lat: 56.012586, lon: -132.835093 },
	CCB: { lat: 34.111599, lon: -117.688004 },
	CCR: { lat: 37.9897, lon: -122.056999 },
	CCY: { lat: 43.072601, lon: -92.610802 },
	LLX: { lat: 44.569099, lon: -72.017998 },
	CDC: { lat: 37.701, lon: -113.098999 },
	CDH: { lat: 33.622799, lon: -92.763397 },
	CDK: { lat: 29.134095, lon: -83.050783 },
	CDN: { lat: 34.2836, lon: -80.564903 },
	CDR: { lat: 42.837601, lon: -103.095001 },
	CDS: { lat: 34.4338, lon: -100.288002 },
	CDW: { lat: 40.875198, lon: -74.281403 },
	CEA: { lat: 37.648602, lon: -97.250603 },
	CEC: { lat: 41.778929, lon: -124.236403 },
	CEF: { lat: 42.194, lon: -72.534798 },
	CEU: { lat: 34.671902, lon: -82.886498 },
	CEV: { lat: 39.698502, lon: -85.1297 },
	CEW: { lat: 30.778799, lon: -86.522102 },
	CEY: { lat: 36.6646, lon: -88.372803 },
	CEZ: { lat: 37.303001, lon: -108.627998 },
	CFD: { lat: 30.7157, lon: -96.331398 },
	TZC: { lat: 43.458801, lon: -83.445503 },
	CFT: { lat: 32.957039, lon: -109.211397 },
	CFV: { lat: 37.094002, lon: -95.571899 },
	CGE: { lat: 38.539299, lon: -76.030403 },
	CGF: { lat: 41.565102, lon: -81.486397 },
	CGI: { lat: 37.2253, lon: -89.570801 },
	CGS: { lat: 38.980598, lon: -76.922302 },
	CGZ: { lat: 32.954899, lon: -111.766998 },
	CHA: { lat: 35.035301, lon: -85.203796 },
	CHK: { lat: 35.097401, lon: -97.967697 },
	CHO: { lat: 38.138599, lon: -78.452904 },
	CHS: { lat: 32.898602, lon: -80.040497 },
	CIC: { lat: 39.795595, lon: -121.857716 },
	CID: { lat: 41.884701, lon: -91.7108 },
	CIN: { lat: 42.0462, lon: -94.789001 },
	CIR: { lat: 37.064499, lon: -89.219597 },
	CIU: { lat: 46.247707, lon: -84.471379 },
	CKA: { lat: 36.734348, lon: -98.123531 },
	CKB: { lat: 39.2966, lon: -80.228104 },
	GRM: { lat: 47.838299, lon: -90.382896 },
	CKM: { lat: 34.299702, lon: -90.512299 },
	CKN: { lat: 47.841702, lon: -96.621597 },
	CKV: { lat: 36.621899, lon: -87.415001 },
	KCL: { lat: 56.310776, lon: -158.534818 },
	CLE: { lat: 41.411701, lon: -81.8498 },
	CLI: { lat: 44.6138, lon: -88.7313 },
	CLK: { lat: 35.5383, lon: -98.932701 },
	CLL: { lat: 30.5886, lon: -96.3638 },
	CLM: { lat: 48.120201, lon: -123.5 },
	CLR: { lat: 33.1315, lon: -115.521004 },
	CLS: { lat: 46.676998, lon: -122.983002 },
	CLT: { lat: 35.214001, lon: -80.9431 },
	CLW: { lat: 27.9767, lon: -82.758698 },
	CMH: { lat: 39.998001, lon: -82.891899 },
	CMI: { lat: 40.039819, lon: -88.276249 },
	CMX: { lat: 47.1684, lon: -88.489098 },
	CMY: { lat: 43.958009, lon: -90.737886 },
	KCN: { lat: 53.402899, lon: -167.520272 },
	CNH: { lat: 43.370399, lon: -72.368698 },
	CNK: { lat: 39.549301, lon: -97.652298 },
	CNM: { lat: 32.337502, lon: -104.263 },
	CNO: { lat: 33.974701, lon: -117.637001 },
	CNU: { lat: 37.668173, lon: -95.486727 },
	CNW: { lat: 31.641129, lon: -97.073335 },
	CNY: { lat: 38.755001, lon: -109.754997 },
	COD: { lat: 44.520199, lon: -109.024002 },
	COE: { lat: 47.7743, lon: -116.82 },
	COF: { lat: 28.2349, lon: -80.6101 },
	COI: { lat: 28.3416, lon: -80.685501 },
	COM: { lat: 31.841101, lon: -99.403603 },
	CON: { lat: 43.202702, lon: -71.502296 },
	COS: { lat: 38.805801, lon: -104.700996 },
	COT: { lat: 28.456699, lon: -99.220299 },
	COU: { lat: 38.8181, lon: -92.219597 },
	CPM: { lat: 33.889999, lon: -118.244003 },
	CPR: { lat: 42.908001, lon: -106.463997 },
	CPS: { lat: 38.570702, lon: -90.156197 },
	HCW: { lat: 34.712898, lon: -79.957001 },
	KCR: { lat: 63.567699, lon: -155.988998 },
	CRE: { lat: 33.811699, lon: -78.7239 },
	CRG: { lat: 30.3363, lon: -81.514397 },
	CRP: { lat: 27.770399, lon: -97.501198 },
	CLD: { lat: 33.1283, lon: -117.279999 },
	CRS: { lat: 32.028099, lon: -96.400597 },
	CRT: { lat: 33.178299, lon: -91.880203 },
	CRW: { lat: 38.3731, lon: -81.593201 },
	CRX: { lat: 34.915001, lon: -88.6035 },
	CSG: { lat: 32.5163, lon: -84.938904 },
	CSM: { lat: 35.339802, lon: -99.2005 },
	CSQ: { lat: 41.0214, lon: -94.363297 },
	CSV: { lat: 35.95131, lon: -85.08499 },
	CTB: { lat: 48.608657, lon: -112.378183 },
	CTY: { lat: 29.6355, lon: -83.104797 },
	CTZ: { lat: 34.975601, lon: -78.364601 },
	CUB: { lat: 33.970501, lon: -80.995201 },
	CUH: { lat: 35.950496, lon: -96.772371 },
	CVG: { lat: 39.048801, lon: -84.667801 },
	HLI: { lat: 36.893299, lon: -121.410004 },
	CKK: { lat: 36.2649, lon: -91.562599 },
	CVN: { lat: 34.426594, lon: -103.078794 },
	CVO: { lat: 44.4972, lon: -123.290001 },
	CVS: { lat: 34.382801, lon: -103.321999 },
	CWA: { lat: 44.777448, lon: -89.670238 },
	KIP: { lat: 33.8578, lon: -98.490402 },
	CWF: { lat: 30.2106, lon: -93.143204 },
	CWI: { lat: 41.8311, lon: -90.329102 },
	CXL: { lat: 32.669498, lon: -115.513 },
	CXO: { lat: 30.351801, lon: -95.414497 },
	CSN: { lat: 39.1922, lon: -119.734001 },
	HAR: { lat: 40.217098, lon: -76.851501 },
	CYS: { lat: 41.155701, lon: -104.811997 },
	CZK: { lat: 45.676599, lon: -121.878879 },
	CZT: { lat: 28.5222, lon: -99.823601 },
	VEX: { lat: 48.380501, lon: -102.898003 },
	DAA: { lat: 38.715, lon: -77.181 },
	DAB: { lat: 29.179899, lon: -81.058098 },
	DAG: { lat: 34.853699, lon: -116.787003 },
	DAL: { lat: 32.847099, lon: -96.851799 },
	DAN: { lat: 36.572899, lon: -79.336098 },
	DAY: { lat: 39.902401, lon: -84.219398 },
	DBN: { lat: 32.5644, lon: -82.985298 },
	DBQ: { lat: 42.402, lon: -90.709503 },
	DCA: { lat: 38.8521, lon: -77.037697 },
	DCU: { lat: 34.652699, lon: -86.945396 },
	DDC: { lat: 37.763401, lon: -99.965599 },
	DEC: { lat: 39.834599, lon: -88.8657 },
	DEH: { lat: 43.275501, lon: -91.739403 },
	DEN: { lat: 39.861698, lon: -104.672997 },
	DET: { lat: 42.409199, lon: -83.009903 },
	DFI: { lat: 41.337502, lon: -84.428802 },
	DFW: { lat: 32.896801, lon: -97.038002 },
	DGL: { lat: 31.3426, lon: -109.505997 },
	DGW: { lat: 42.797199, lon: -105.386002 },
	DHN: { lat: 31.321301, lon: -85.4496 },
	DHT: { lat: 36.022598, lon: -102.546997 },
	DIK: { lat: 46.797533, lon: -102.801905 },
	DKK: { lat: 42.49247, lon: -79.273102 },
	DLL: { lat: 34.4491, lon: -79.368599 },
	DLF: { lat: 29.359501, lon: -100.778002 },
	DLH: { lat: 46.842098, lon: -92.193604 },
	DLN: { lat: 45.255402, lon: -112.553001 },
	DLS: { lat: 45.620979, lon: -121.170777 },
	DMA: { lat: 32.1665, lon: -110.883003 },
	DMN: { lat: 32.262299, lon: -107.721001 },
	DMO: { lat: 38.707401, lon: -93.175903 },
	DNL: { lat: 33.466499, lon: -82.039398 },
	DNN: { lat: 34.7229, lon: -84.870201 },
	DNS: { lat: 41.986401, lon: -95.380699 },
	DNV: { lat: 40.199124, lon: -87.59663 },
	DOV: { lat: 39.129501, lon: -75.466003 },
	DPA: { lat: 41.907799, lon: -88.248596 },
	DPG: { lat: 40.197396, lon: -112.935094 },
	DRA: { lat: 36.6194, lon: -116.032997 },
	DRI: { lat: 30.831699, lon: -93.339897 },
	DRE: { lat: 46.0093, lon: -83.743896 },
	DRO: { lat: 37.151501, lon: -107.753998 },
	DRT: { lat: 29.374201, lon: -100.927002 },
	KDS: { lat: -24.3388, lon: 139.2785 },
	DSM: { lat: 41.534, lon: -93.663101 },
	DSV: { lat: 42.570545, lon: -77.713273 },
	DTA: { lat: 39.3806, lon: -112.508003 },
	DTL: { lat: 46.824301, lon: -95.883322 },
	DTN: { lat: 32.540199, lon: -93.745003 },
	DSI: { lat: 30.400101, lon: -86.471497 },
	DTW: { lat: 42.21377, lon: -83.353786 },
	DUA: { lat: 33.939675, lon: -96.395072 },
	DUC: { lat: 34.470901, lon: -97.9599 },
	DUG: { lat: 31.469, lon: -109.603996 },
	DUJ: { lat: 41.178299, lon: -78.898697 },
	DVL: { lat: 48.115454, lon: -98.908796 },
	DVN: { lat: 41.610432, lon: -90.589693 },
	NOT: { lat: 38.1436, lon: -122.556 },
	NSL: { lat: 43.986801, lon: -95.7826 },
	DVT: { lat: 33.688301, lon: -112.083 },
	KDW: { lat: 7.2415, lon: 80.7834 },
	DWH: { lat: 30.0618, lon: -95.552803 },
	DXR: { lat: 41.371656, lon: -73.482227 },
	DYL: { lat: 40.333, lon: -75.122299 },
	DYS: { lat: 32.420799, lon: -99.854599 },
	KDZ: { lat: 7.3251, lon: 80.6422 },
	LBN: { lat: 0.603167, lon: 36.013 },
	VPG: { lat: -3.806667, lon: 39.797389 },
	KTJ: { lat: -1.263497, lon: 35.027533 },
	OSJ: { lat: -1.378382, lon: 35.378453 },
	OLG: { lat: -1.324213, lon: 35.246106 },
	HKR: { lat: -1.14542, lon: 35.124922 },
	ANA: { lat: -1.27156, lon: 34.955513 },
	MDR: { lat: -1.298636, lon: 35.063885 },
	OLX: { lat: -1.408586, lon: 35.110689 },
	KRV: { lat: 0.319638, lon: 35.66256 },
	KIU: { lat: -1.743829, lon: 41.484344 },
	LBK: { lat: 0.348333, lon: 40.881699 },
	LKU: { lat: 3.416256, lon: 35.885468 },
	MIF: { lat: 31.5825, lon: -102.908997 },
	CCG: { lat: 31.4151, lon: -102.362999 },
	ESO: { lat: 36.026133, lon: -106.045443 },
	WTR: { lat: 33.810175, lon: -109.986555 },
	ALE: { lat: 30.384199, lon: -103.683998 },
	BGT: { lat: 34.592796, lon: -113.171993 },
	EAN: { lat: 42.0555, lon: -104.929001 },
	EAR: { lat: 40.727001, lon: -99.006798 },
	EAT: { lat: 47.398899, lon: -120.207001 },
	EAU: { lat: 44.865799, lon: -91.484299 },
	KEB: { lat: 59.3521, lon: -151.925003 },
	EBS: { lat: 42.436848, lon: -93.869905 },
	ECG: { lat: 36.260601, lon: -76.174599 },
	ECP: { lat: 30.357106, lon: -85.795414 },
	ECS: { lat: 43.88379, lon: -104.314156 },
	EDE: { lat: 36.027699, lon: -76.567101 },
	ETS: { lat: 31.2997, lon: -85.899902 },
	EDW: { lat: 34.910781, lon: -117.886391 },
	EED: { lat: 34.7663, lon: -114.623001 },
	EEN: { lat: 42.898399, lon: -72.270798 },
	EFD: { lat: 29.6073, lon: -95.158798 },
	EFK: { lat: 44.888802, lon: -72.229202 },
	EFW: { lat: 42.009866, lon: -94.341717 },
	EGE: { lat: 39.642601, lon: -106.917999 },
	EGI: { lat: 30.6504, lon: -86.522903 },
	EGV: { lat: 45.932301, lon: -89.268303 },
	KEK: { lat: 59.3568, lon: -157.470993 },
	EKA: { lat: 40.803398, lon: -124.112999 },
	EKI: { lat: 41.719398, lon: -86.003197 },
	EKN: { lat: 38.889759, lon: -79.857651 },
	EKO: { lat: 40.824902, lon: -115.792 },
	EKX: { lat: 37.686001, lon: -85.925003 },
	ELA: { lat: 29.600599, lon: -96.321899 },
	ELD: { lat: 33.221001, lon: -92.813301 },
	ELK: { lat: 35.430801, lon: -99.394302 },
	ELM: { lat: 42.159901, lon: -76.891602 },
	ELN: { lat: 47.033001, lon: -120.530998 },
	LYU: { lat: 47.824501, lon: -91.830704 },
	ELP: { lat: 31.807199, lon: -106.377998 },
	ELY: { lat: 39.299702, lon: -114.842003 },
	ELZ: { lat: 42.109501, lon: -77.989998 },
	EMM: { lat: 41.8241, lon: -110.556999 },
	EMP: { lat: 38.3321, lon: -96.1912 },
	EMT: { lat: 34.086102, lon: -118.035004 },
	END: { lat: 36.339199, lon: -97.916496 },
	ENL: { lat: 38.515099, lon: -89.091103 },
	ENV: { lat: 40.7187, lon: -114.030998 },
	ENW: { lat: 42.595699, lon: -87.927803 },
	EOK: { lat: 40.4599, lon: -91.428497 },
	EOS: { lat: 36.810799, lon: -94.391701 },
	EPH: { lat: 47.307598, lon: -119.515999 },
	EDK: { lat: 37.774101, lon: -96.817596 },
	ERI: { lat: 42.083127, lon: -80.173867 },
	ERR: { lat: 44.7925, lon: -71.1642 },
	ERV: { lat: 29.9767, lon: -99.085701 },
	ESC: { lat: 45.723199, lon: -87.088623 },
	ESF: { lat: 31.394266, lon: -92.294082 },
	ESN: { lat: 38.804199, lon: -76.069 },
	EST: { lat: 43.407398, lon: -94.746399 },
	ESW: { lat: 47.2542, lon: -121.185997 },
	ETB: { lat: 43.422278, lon: -88.128966 },
	ETN: { lat: 32.413502, lon: -98.809799 },
	EUF: { lat: 31.9513, lon: -85.128899 },
	EUG: { lat: 44.124599, lon: -123.211998 },
	EVM: { lat: 47.42458, lon: -92.499204 },
	EVV: { lat: 38.036999, lon: -87.532402 },
	EVW: { lat: 41.274799, lon: -111.035004 },
	EWB: { lat: 41.676102, lon: -70.956902 },
	EWK: { lat: 38.058201, lon: -97.274498 },
	EWN: { lat: 35.073002, lon: -77.0429 },
	EWR: { lat: 40.692501, lon: -74.168701 },
	EYW: { lat: 24.556101, lon: -81.759598 },
	KEZ: { lat: 6.95, lon: 79.93 },
	WIB: { lat: 34.2257, lon: -99.283798 },
	RBK: { lat: 33.5742, lon: -117.127998 },
	FAF: { lat: 37.1325, lon: -76.608803 },
	FAM: { lat: 37.761101, lon: -90.428597 },
	FAR: { lat: 46.9207, lon: -96.815804 },
	FAT: { lat: 36.776199, lon: -119.718002 },
	FAY: { lat: 34.991199, lon: -78.880302 },
	FBG: { lat: 35.131802, lon: -78.936699 },
	FBL: { lat: 44.32844, lon: -93.312534 },
	FBR: { lat: 41.391899, lon: -110.406998 },
	FBY: { lat: 40.182999, lon: -97.169296 },
	FCH: { lat: 36.732399, lon: -119.82 },
	FCM: { lat: 44.827202, lon: -93.4571 },
	FCS: { lat: 38.678398, lon: -104.757004 },
	FCY: { lat: 34.942001, lon: -90.775002 },
	FDK: { lat: 39.417599, lon: -77.374298 },
	FDR: { lat: 34.352001, lon: -98.983902 },
	FDY: { lat: 41.0135, lon: -83.668701 },
	FEP: { lat: 42.246201, lon: -89.582001 },
	FET: { lat: 41.45024, lon: -96.522884 },
	FFA: { lat: 36.0182, lon: -75.671303 },
	FFL: { lat: 41.053024, lon: -91.980114 },
	FFM: { lat: 46.284401, lon: -96.1567 },
	FFO: { lat: 39.826099, lon: -84.048302 },
	FFT: { lat: 38.181698, lon: -84.906764 },
	MSC: { lat: 33.4608, lon: -111.727997 },
	FRD: { lat: 48.523654, lon: -123.024645 },
	FHU: { lat: 31.587383, lon: -110.348225 },
	FKL: { lat: 41.377899, lon: -79.860397 },
	FKN: { lat: 36.698101, lon: -76.903801 },
	FLD: { lat: 43.771198, lon: -88.488403 },
	FLG: { lat: 35.1385, lon: -111.670998 },
	FLL: { lat: 26.072599, lon: -80.152702 },
	FLO: { lat: 34.185398, lon: -79.7239 },
	FLP: { lat: 36.290901, lon: -92.590302 },
	FLV: { lat: 39.368301, lon: -94.914703 },
	FLX: { lat: 39.4991, lon: -118.749001 },
	FME: { lat: 39.0854, lon: -76.759399 },
	FMH: { lat: 41.657899, lon: -70.52163 },
	FMN: { lat: 36.741199, lon: -108.230003 },
	FMY: { lat: 26.586599, lon: -81.863297 },
	FNL: { lat: 40.44969, lon: -105.011272 },
	FNT: { lat: 42.965401, lon: -83.743599 },
	FOD: { lat: 42.552624, lon: -94.191237 },
	FOE: { lat: 38.950901, lon: -95.663597 },
	FOK: { lat: 40.8437, lon: -72.631798 },
	FIL: { lat: 38.958302, lon: -112.362999 },
	FPR: { lat: 27.4951, lon: -80.368301 },
	FRG: { lat: 40.728802, lon: -73.413399 },
	FRH: { lat: 38.506199, lon: -86.636902 },
	FRI: { lat: 39.053021, lon: -96.764202 },
	FRM: { lat: 43.643902, lon: -94.415604 },
	FRR: { lat: 38.9175, lon: -78.253502 },
	FSD: { lat: 43.585463, lon: -96.741152 },
	FSI: { lat: 34.649799, lon: -98.402199 },
	FSK: { lat: 37.798401, lon: -94.769402 },
	FSM: { lat: 35.336601, lon: -94.367401 },
	FST: { lat: 30.915701, lon: -102.916 },
	FSU: { lat: 34.483398, lon: -104.217003 },
	FMS: { lat: 40.659113, lon: -91.327763 },
	FTK: { lat: 37.907101, lon: -85.972099 },
	FTW: { lat: 32.819801, lon: -97.362396 },
	FTY: { lat: 33.779099, lon: -84.5214 },
	FUL: { lat: 33.872002, lon: -117.980003 },
	WFK: { lat: 47.2855, lon: -68.312798 },
	FWA: { lat: 40.9785, lon: -85.195099 },
	FXE: { lat: 26.1973, lon: -80.1707 },
	FXY: { lat: 43.234699, lon: -93.6241 },
	FYM: { lat: 35.0597, lon: -86.564003 },
	FYV: { lat: 36.0051, lon: -94.170097 },
	GAB: { lat: 38.923173, lon: -117.9572 },
	GAD: { lat: 33.972599, lon: -86.088996 },
	GAG: { lat: 36.295502, lon: -99.776398 },
	GAI: { lat: 39.168301, lon: -77.166 },
	GBD: { lat: 38.344299, lon: -98.8592 },
	GBG: { lat: 40.938, lon: -90.431099 },
	GBR: { lat: 42.1842, lon: -73.403198 },
	GCC: { lat: 44.3489, lon: -105.539001 },
	JDA: { lat: 44.404202, lon: -118.962997 },
	GCK: { lat: 37.927502, lon: -100.723999 },
	GCN: { lat: 35.9524, lon: -112.147003 },
	GCY: { lat: 36.195648, lon: -82.811482 },
	GDM: { lat: 42.549999, lon: -72.016098 },
	GDV: { lat: 47.137658, lon: -104.80691 },
	GDW: { lat: 43.9706, lon: -84.474998 },
	GED: { lat: 38.689201, lon: -75.358902 },
	GEG: { lat: 47.6199, lon: -117.533997 },
	GEY: { lat: 44.5168, lon: -108.083 },
	GFA: { lat: 47.5047, lon: -111.186996 },
	GFD: { lat: 39.790715, lon: -85.735019 },
	GFK: { lat: 47.949299, lon: -97.176102 },
	GFL: { lat: 43.341202, lon: -73.610298 },
	GGE: { lat: 33.311699, lon: -79.319603 },
	GGG: { lat: 32.383999, lon: -94.711502 },
	GGW: { lat: 48.212502, lon: -106.614998 },
	GHM: { lat: 35.837399, lon: -87.445396 },
	IDH: { lat: 45.9426, lon: -116.123001 },
	GIF: { lat: 28.062901, lon: -81.753304 },
	GJT: { lat: 39.126663, lon: -108.529387 },
	MEJ: { lat: 41.626499, lon: -80.214699 },
	GKT: { lat: 35.8578, lon: -83.528702 },
	GLD: { lat: 39.370701, lon: -101.699753 },
	GLE: { lat: 33.651402, lon: -97.196999 },
	GLH: { lat: 33.482899, lon: -90.985603 },
	GLR: { lat: 45.0135, lon: -84.703598 },
	GLS: { lat: 29.265301, lon: -94.860397 },
	GLW: { lat: 37.031799, lon: -85.953697 },
	GMU: { lat: 34.847903, lon: -82.350217 },
	GNG: { lat: 42.917198, lon: -114.764999 },
	GNT: { lat: 35.167301, lon: -107.902 },
	GNV: { lat: 29.6901, lon: -82.271797 },
	GOK: { lat: 35.8498, lon: -97.415604 },
	GON: { lat: 41.330101, lon: -72.045097 },
	FCA: { lat: 48.310501, lon: -114.255997 },
	GPT: { lat: 30.407301, lon: -89.070099 },
	GPZ: { lat: 47.211102, lon: -93.509804 },
	GQQ: { lat: 40.753399, lon: -82.723801 },
	GRB: { lat: 44.483459, lon: -88.130805 },
	GRD: { lat: 34.248699, lon: -82.159103 },
	GRE: { lat: 38.836844, lon: -89.376525 },
	GRF: { lat: 47.079201, lon: -122.581001 },
	GRI: { lat: 40.967499, lon: -98.309601 },
	GRK: { lat: 31.0672, lon: -97.828903 },
	GRN: { lat: 42.806, lon: -102.175003 },
	GRR: { lat: 42.880798, lon: -85.522797 },
	GSB: { lat: 35.339401, lon: -77.960602 },
	GSH: { lat: 41.526402, lon: -85.7929 },
	GSO: { lat: 36.097801, lon: -79.937302 },
	GSP: { lat: 34.895699, lon: -82.218903 },
	GTF: { lat: 47.481998, lon: -111.371002 },
	GTG: { lat: 45.7981, lon: -92.664398 },
	GTR: { lat: 33.450298, lon: -88.5914 },
	GUC: { lat: 38.534672, lon: -106.934566 },
	GUP: { lat: 35.511653, lon: -108.788166 },
	GUS: { lat: 40.648102, lon: -86.1521 },
	GUY: { lat: 36.685101, lon: -101.508003 },
	GVE: { lat: 38.155998, lon: -78.165802 },
	GVL: { lat: 34.272598, lon: -83.8302 },
	GVT: { lat: 33.067799, lon: -96.0653 },
	GWO: { lat: 33.495025, lon: -90.088204 },
	GWS: { lat: 39.508301, lon: -107.310997 },
	KGX: { lat: 62.895187, lon: -160.066289 },
	GXY: { lat: 40.437401, lon: -104.633003 },
	GDC: { lat: 34.758301, lon: -82.376404 },
	PNX: { lat: 33.7141, lon: -96.673698 },
	GYR: { lat: 33.422501, lon: -112.375999 },
	GYY: { lat: 41.616299, lon: -87.412804 },
	KGZ: { lat: 61.455101, lon: -142.380997 },
	DSY: { lat: 10.914244, lon: 103.226652 },
	KTI: { lat: 11.359987, lon: 104.921272 },
	HAB: { lat: 34.117599, lon: -87.998199 },
	HAF: { lat: 37.513401, lon: -122.500999 },
	HAI: { lat: 41.959801, lon: -85.593399 },
	HAO: { lat: 39.3638, lon: -84.522003 },
	HBG: { lat: 31.264799, lon: -89.2528 },
	HBR: { lat: 34.991317, lon: -99.051313 },
	HDE: { lat: 40.452099, lon: -99.336502 },
	HDN: { lat: 40.481201, lon: -107.218002 },
	HEE: { lat: 34.576571, lon: -90.67616 },
	MNZ: { lat: 38.721401, lon: -77.515404 },
	HEZ: { lat: 31.614817, lon: -91.297331 },
	HFD: { lat: 41.736698, lon: -72.649399 },
	HFF: { lat: 35.036087, lon: -79.498615 },
	HGR: { lat: 39.708771, lon: -77.728014 },
	HHR: { lat: 33.922798, lon: -118.334999 },
	HUJ: { lat: 34.034801, lon: -95.541901 },
	HIB: { lat: 47.384831, lon: -92.836905 },
	HIE: { lat: 44.36752, lon: -71.545765 },
	HIF: { lat: 41.12403, lon: -111.973086 },
	HII: { lat: 34.571098, lon: -114.358002 },
	HIO: { lat: 45.540401, lon: -122.949997 },
	HKA: { lat: 35.940399, lon: -89.830803 },
	HKS: { lat: 32.334499, lon: -90.222198 },
	HKY: { lat: 35.7411, lon: -81.389503 },
	HLB: { lat: 39.342861, lon: -85.258441 },
	HLC: { lat: 39.378799, lon: -99.831497 },
	HLG: { lat: 40.174999, lon: -80.646301 },
	HLN: { lat: 46.6068, lon: -111.983002 },
	HLR: { lat: 31.1387, lon: -97.7145 },
	HMN: { lat: 32.852501, lon: -106.107002 },
	HMT: { lat: 33.734001, lon: -117.023003 },
	HNB: { lat: 38.249001, lon: -86.953697 },
	HSH: { lat: 35.972801, lon: -115.134003 },
	HOB: { lat: 32.6875, lon: -103.217003 },
	HON: { lat: 44.385201, lon: -98.2285 },
	HOP: { lat: 36.674154, lon: -87.48974 },
	HOT: { lat: 34.4788, lon: -93.096262 },
	HOU: { lat: 29.645399, lon: -95.2789 },
	HPN: { lat: 41.067001, lon: -73.707603 },
	HPT: { lat: 42.723701, lon: -93.226303 },
	HPY: { lat: 29.7861, lon: -94.952698 },
	HQM: { lat: 46.971199, lon: -123.936996 },
	HES: { lat: 45.828223, lon: -119.259024 },
	HRL: { lat: 26.2285, lon: -97.654404 },
	HRO: { lat: 36.261501, lon: -93.154701 },
	HSB: { lat: 37.811298, lon: -88.550301 },
	HNC: { lat: 35.2328, lon: -75.617798 },
	THP: { lat: 43.713602, lon: -108.389687 },
	HSI: { lat: 40.605301, lon: -98.427902 },
	HSP: { lat: 37.951401, lon: -79.8339 },
	HST: { lat: 25.4886, lon: -80.383598 },
	HSV: { lat: 34.637199, lon: -86.775101 },
	HTH: { lat: 38.544399, lon: -118.634002 },
	HTL: { lat: 44.359798, lon: -84.671095 },
	HTO: { lat: 40.959954, lon: -72.25105 },
	HTS: { lat: 38.366699, lon: -82.557999 },
	HTW: { lat: 38.419082, lon: -82.494922 },
	HUA: { lat: 34.678699, lon: -86.684799 },
	HUF: { lat: 39.4515, lon: -87.307602 },
	HUL: { lat: 46.1231, lon: -67.792099 },
	HUM: { lat: 29.5665, lon: -90.6604 },
	HUT: { lat: 38.065498, lon: -97.860603 },
	HVE: { lat: 38.417999, lon: -110.704002 },
	HVN: { lat: 41.263699, lon: -72.886803 },
	HVR: { lat: 48.541387, lon: -109.762859 },
	HVS: { lat: 34.403099, lon: -80.119202 },
	HWD: { lat: 37.659199, lon: -122.122002 },
	HWO: { lat: 26.0012, lon: -80.2407 },
	WSH: { lat: 40.821899, lon: -72.8694 },
	HHH: { lat: 32.2244, lon: -80.697502 },
	HYA: { lat: 41.6693, lon: -70.280403 },
	HYR: { lat: 46.0252, lon: -91.444298 },
	HYS: { lat: 38.844521, lon: -99.273148 },
	HZL: { lat: 40.986801, lon: -75.994904 },
	JFN: { lat: 41.778, lon: -80.695503 },
	IAB: { lat: 37.621899, lon: -97.268204 },
	IAD: { lat: 38.9445, lon: -77.455803 },
	IAG: { lat: 43.1073, lon: -78.946198 },
	IAH: { lat: 29.9844, lon: -95.3414 },
	KIB: { lat: 55.897499, lon: -159.488998 },
	ICL: { lat: 40.721802, lon: -95.026398 },
	ICT: { lat: 37.649899, lon: -97.433098 },
	IDA: { lat: 43.514599, lon: -112.070999 },
	IDG: { lat: 42.3326, lon: -95.444901 },
	IDI: { lat: 40.631119, lon: -79.101884 },
	IDP: { lat: 37.158401, lon: -95.778397 },
	XPR: { lat: 43.020902, lon: -102.506089 },
	IFA: { lat: 42.470798, lon: -93.269997 },
	IFP: { lat: 35.157398, lon: -114.559998 },
	IGM: { lat: 35.259499, lon: -113.938004 },
	IJX: { lat: 39.774601, lon: -90.238297 },
	IKK: { lat: 41.0714, lon: -87.846298 },
	KIL: { lat: -9.2886, lon: 28.3269 },
	ILE: { lat: 31.0858, lon: -97.686501 },
	ILG: { lat: 39.678699, lon: -75.606499 },
	ILM: { lat: 34.270599, lon: -77.902603 },
	ILN: { lat: 39.427898, lon: -83.792099 },
	IML: { lat: 40.5093, lon: -101.621002 },
	IMM: { lat: 26.427933, lon: -81.403531 },
	MDN: { lat: 38.7589, lon: -85.4655 },
	IMT: { lat: 45.81911, lon: -88.114557 },
	IND: { lat: 39.7173, lon: -86.294403 },
	INK: { lat: 31.7796, lon: -103.200996 },
	INL: { lat: 48.5662, lon: -93.403099 },
	INS: { lat: 36.5872, lon: -115.672997 },
	INT: { lat: 36.133701, lon: -80.222 },
	INW: { lat: 35.0219, lon: -110.723 },
	IOW: { lat: 41.639198, lon: -91.546501 },
	IPL: { lat: 32.83539, lon: -115.574026 },
	IPT: { lat: 41.242126, lon: -76.92245 },
	IRK: { lat: 40.093498, lon: -92.544899 },
	IRS: { lat: 41.813301, lon: -85.439003 },
	ISM: { lat: 28.289801, lon: -81.437103 },
	ISO: { lat: 35.331402, lon: -77.608803 },
	ISP: { lat: 40.7952, lon: -73.100197 },
	ISQ: { lat: 45.974602, lon: -86.171799 },
	ISW: { lat: 44.360298, lon: -89.838997 },
	ITH: { lat: 42.491001, lon: -76.458397 },
	AZA: { lat: 33.3078, lon: -111.654999 },
	IWD: { lat: 46.525298, lon: -90.131578 },
	ISS: { lat: 43.961399, lon: -69.712601 },
	IWS: { lat: 29.818199, lon: -95.6726 },
	JCI: { lat: 38.830898, lon: -94.890297 },
	IYK: { lat: 35.658798, lon: -117.830002 },
	SQA: { lat: 34.6068, lon: -120.075996 },
	FRY: { lat: 43.9911, lon: -70.947899 },
	JAC: { lat: 43.6073, lon: -110.737999 },
	JAN: { lat: 32.311199, lon: -90.075897 },
	JAS: { lat: 30.8857, lon: -94.034897 },
	JAX: { lat: 30.492469, lon: -81.687813 },
	JBR: { lat: 35.831699, lon: -90.6464 },
	JCT: { lat: 30.511299, lon: -99.763496 },
	JDN: { lat: 47.3288, lon: -106.953003 },
	JEF: { lat: 38.591202, lon: -92.156097 },
	JFK: { lat: 40.639447, lon: -73.779317 },
	JHW: { lat: 42.15425, lon: -79.254008 },
	GUF: { lat: 30.290501, lon: -87.671799 },
	JLN: { lat: 37.151798, lon: -94.498299 },
	JMS: { lat: 46.929699, lon: -98.6782 },
	JOT: { lat: 41.517799, lon: -88.175499 },
	USA: { lat: 35.387798, lon: -80.709099 },
	JKV: { lat: 31.869301, lon: -95.2174 },
	JST: { lat: 40.316101, lon: -78.8339 },
	JVL: { lat: 42.6203, lon: -89.041603 },
	KJX: { lat: 3.735749, lon: 96.790109 },
	JXN: { lat: 42.260509, lon: -84.463019 },
	OSB: { lat: 38.1105, lon: -92.680496 },
	KKB: { lat: 58.190899, lon: -152.369995 },
	KIC: { lat: 36.228001, lon: -121.122002 },
	KKL: { lat: 57.367001, lon: -154.028 },
	KLS: { lat: 46.118, lon: -122.898003 },
	KNB: { lat: 37.011101, lon: -112.530998 },
	KKU: { lat: 58.811199, lon: -158.559006 },
	DTH: { lat: 36.463799, lon: -116.880997 },
	BXS: { lat: 33.258999, lon: -116.320999 },
	RBF: { lat: 34.263802, lon: -116.856003 },
	MYH: { lat: 36.8125, lon: -111.647003 },
	TRH: { lat: 35.8125, lon: -117.327003 },
	LAA: { lat: 38.066407, lon: -102.691373 },
	LAF: { lat: 40.412875, lon: -86.939363 },
	LAL: { lat: 27.987656, lon: -82.018776 },
	LAM: { lat: 35.879799, lon: -106.268997 },
	LAN: { lat: 42.778702, lon: -84.587402 },
	LAR: { lat: 41.312099, lon: -105.675003 },
	LAS: { lat: 36.083361, lon: -115.151817 },
	LAW: { lat: 34.567699, lon: -98.416603 },
	LAX: { lat: 33.942501, lon: -118.407997 },
	LBB: { lat: 33.663601, lon: -101.822998 },
	LBE: { lat: 40.275902, lon: -79.4048 },
	LBF: { lat: 41.126202, lon: -100.683998 },
	LBL: { lat: 37.044201, lon: -100.959999 },
	LBT: { lat: 34.610773, lon: -79.05943 },
	LJN: { lat: 29.108601, lon: -95.462097 },
	LCH: { lat: 30.126101, lon: -93.223297 },
	LCI: { lat: 43.572701, lon: -71.4189 },
	LCK: { lat: 39.813801, lon: -82.927803 },
	LCQ: { lat: 30.181999, lon: -82.576897 },
	LDJ: { lat: 40.617401, lon: -74.244598 },
	LDM: { lat: 43.962502, lon: -86.407898 },
	LEB: { lat: 43.626099, lon: -72.304199 },
	LEE: { lat: 28.823099, lon: -81.808701 },
	LEM: { lat: 45.918701, lon: -102.106003 },
	LEW: { lat: 44.0485, lon: -70.283501 },
	LEX: { lat: 38.036499, lon: -84.605904 },
	LFI: { lat: 37.082901, lon: -76.360497 },
	LFK: { lat: 31.233999, lon: -94.75 },
	LFT: { lat: 30.205299, lon: -91.987602 },
	LGA: { lat: 40.777199, lon: -73.872597 },
	LGB: { lat: 33.816523, lon: -118.149891 },
	LGC: { lat: 33.008873, lon: -85.074331 },
	LGD: { lat: 45.290199, lon: -118.007004 },
	LGF: { lat: 32.860001, lon: -114.397003 },
	LGU: { lat: 41.791199, lon: -111.851997 },
	LHV: { lat: 41.135601, lon: -77.422302 },
	LIY: { lat: 31.891237, lon: -81.561003 },
	LFN: { lat: 36.0233, lon: -78.330299 },
	LIC: { lat: 39.274799, lon: -103.666 },
	LIT: { lat: 34.729582, lon: -92.223728 },
	LKP: { lat: 44.2645, lon: -73.961899 },
	LOW: { lat: 38.0098, lon: -77.9701 },
	LKV: { lat: 42.161098, lon: -120.399002 },
	CHL: { lat: 44.522999, lon: -114.218002 },
	LMS: { lat: 33.146198, lon: -89.0625 },
	LMT: { lat: 42.156101, lon: -121.733002 },
	LNA: { lat: 26.593, lon: -80.085098 },
	LND: { lat: 42.815201, lon: -108.730003 },
	LNK: { lat: 40.851002, lon: -96.759201 },
	LNN: { lat: 41.683998, lon: -81.389702 },
	LNP: { lat: 36.987499, lon: -82.529999 },
	LNR: { lat: 43.2099, lon: -90.181332 },
	LNS: { lat: 40.1217, lon: -76.296097 },
	LOL: { lat: 40.066399, lon: -118.565002 },
	BBX: { lat: 40.137501, lon: -75.265099 },
	LOT: { lat: 41.6073, lon: -88.096199 },
	LOU: { lat: 38.228001, lon: -85.663696 },
	LOZ: { lat: 37.082199, lon: -84.0849 },
	LPC: { lat: 34.6656, lon: -120.468002 },
	LQK: { lat: 34.810001, lon: -82.702904 },
	LRD: { lat: 27.5438, lon: -99.461601 },
	LRF: { lat: 34.916901, lon: -92.149696 },
	LRJ: { lat: 42.778, lon: -96.193703 },
	LRU: { lat: 32.289398, lon: -106.921997 },
	LSB: { lat: 32.3335, lon: -108.692001 },
	LSE: { lat: 43.879002, lon: -91.256699 },
	LSF: { lat: 32.332546, lon: -84.988003 },
	LSK: { lat: 42.753799, lon: -104.404999 },
	LSN: { lat: 37.062901, lon: -120.869003 },
	LSV: { lat: 36.236198, lon: -115.033997 },
	LTS: { lat: 34.667099, lon: -99.266701 },
	LUF: { lat: 33.535, lon: -112.383003 },
	LUK: { lat: 39.102357, lon: -84.418945 },
	LUL: { lat: 31.6726, lon: -89.172203 },
	LVK: { lat: 37.693401, lon: -121.82 },
	LVL: { lat: 36.774229, lon: -77.793846 },
	LVM: { lat: 45.699402, lon: -110.447998 },
	LVS: { lat: 35.654202, lon: -105.141998 },
	LWB: { lat: 37.857914, lon: -80.400438 },
	LWC: { lat: 39.0112, lon: -95.216599 },
	LWL: { lat: 41.1171, lon: -114.921997 },
	LWM: { lat: 42.717201, lon: -71.123398 },
	LWS: { lat: 46.3745, lon: -117.014999 },
	LWT: { lat: 47.048429, lon: -109.466143 },
	LWV: { lat: 38.764301, lon: -87.605499 },
	LXN: { lat: 40.791, lon: -99.777298 },
	LXV: { lat: 39.220299, lon: -106.317001 },
	LYH: { lat: 37.326698, lon: -79.200401 },
	LYO: { lat: 38.339481, lon: -98.228702 },
	LZU: { lat: 33.9781, lon: -83.962402 },
	PCU: { lat: 30.785999, lon: -89.504501 },
	MLK: { lat: 48.366901, lon: -107.918999 },
	MAC: { lat: 32.822102, lon: -83.561996 },
	MAE: { lat: 36.988602, lon: -120.112 },
	MAF: { lat: 31.942499, lon: -102.202003 },
	MAW: { lat: 36.600601, lon: -89.992203 },
	KMB: { lat: -5.4875, lon: 144.606944 },
	MBG: { lat: 45.546501, lon: -100.407997 },
	MBL: { lat: 44.272707, lon: -86.246495 },
	DXE: { lat: 32.438702, lon: -90.103104 },
	MBS: { lat: 43.531913, lon: -84.082275 },
	MBY: { lat: 39.464393, lon: -92.428365 },
	MCB: { lat: 31.178499, lon: -90.471901 },
	MCC: { lat: 38.667599, lon: -121.401001 },
	MCD: { lat: 45.864899, lon: -84.637299 },
	MCE: { lat: 37.284698, lon: -120.514 },
	MCF: { lat: 27.8493, lon: -82.521202 },
	MCI: { lat: 39.2976, lon: -94.713898 },
	MCK: { lat: 40.207787, lon: -100.592794 },
	MCN: { lat: 32.692799, lon: -83.6492 },
	MCO: { lat: 28.429399, lon: -81.308998 },
	MCW: { lat: 43.159801, lon: -93.329716 },
	MDA: { lat: 29.431299, lon: -98.3778 },
	MDD: { lat: 32.036499, lon: -102.100998 },
	MDH: { lat: 37.778099, lon: -89.251999 },
	XMD: { lat: 44.015999, lon: -97.085899 },
	MDT: { lat: 40.193501, lon: -76.763397 },
	MDW: { lat: 41.785999, lon: -87.752403 },
	MDF: { lat: 45.101002, lon: -90.303299 },
	MXE: { lat: 34.791901, lon: -79.365799 },
	MEI: { lat: 32.3326, lon: -88.7519 },
	MEM: { lat: 35.0424, lon: -89.9767 },
	MER: { lat: 37.380501, lon: -120.568001 },
	MEV: { lat: 39.000301, lon: -119.751 },
	UMZ: { lat: 34.545399, lon: -94.202698 },
	MFD: { lat: 40.8214, lon: -82.516602 },
	MFE: { lat: 26.176141, lon: -98.237965 },
	MFI: { lat: 44.636902, lon: -90.189301 },
	MFR: { lat: 42.374199, lon: -122.873001 },
	MFV: { lat: 37.6469, lon: -75.761101 },
	MGC: { lat: 41.7033, lon: -86.821198 },
	MGE: { lat: 33.915401, lon: -84.516296 },
	MGJ: { lat: 41.509998, lon: -74.264603 },
	MGM: { lat: 32.300598, lon: -86.393997 },
	MGR: { lat: 31.0849, lon: -83.803299 },
	MGW: { lat: 39.643305, lon: -79.917598 },
	MGY: { lat: 39.589001, lon: -84.224899 },
	MHE: { lat: 43.774799, lon: -98.038597 },
	MHK: { lat: 39.140999, lon: -96.670799 },
	MHL: { lat: 39.095798, lon: -93.202904 },
	MHR: { lat: 38.554744, lon: -121.297989 },
	MHT: { lat: 42.932598, lon: -71.435699 },
	MHV: { lat: 35.059399, lon: -118.152 },
	MIA: { lat: 25.7932, lon: -80.290604 },
	MIB: { lat: 48.4156, lon: -101.358002 },
	MIC: { lat: 45.062, lon: -93.353897 },
	MIE: { lat: 40.242298, lon: -85.395897 },
	MIO: { lat: 36.909199, lon: -94.887497 },
	MIT: { lat: 35.507401, lon: -119.192002 },
	MIV: { lat: 39.367802, lon: -75.072197 },
	MIW: { lat: 42.112701, lon: -92.917801 },
	MJQ: { lat: 43.650002, lon: -94.986504 },
	MJX: { lat: 39.927502, lon: -74.292397 },
	MKC: { lat: 39.123199, lon: -94.592796 },
	MKE: { lat: 42.947201, lon: -87.896599 },
	MKG: { lat: 43.169498, lon: -86.238197 },
	MKL: { lat: 35.599899, lon: -88.915604 },
	MKO: { lat: 35.656502, lon: -95.366699 },
	MKT: { lat: 44.224781, lon: -93.919128 },
	MRK: { lat: 25.995001, lon: -81.672501 },
	MLB: { lat: 28.1028, lon: -80.645302 },
	MLC: { lat: 34.882401, lon: -95.783501 },
	MLD: { lat: 42.166599, lon: -112.296997 },
	MIQ: { lat: 41.195877, lon: -96.112107 },
	MLF: { lat: 38.426601, lon: -113.012001 },
	MLI: { lat: 41.448502, lon: -90.5075 },
	MLJ: { lat: 33.154202, lon: -83.240701 },
	MLS: { lat: 46.427268, lon: -105.885372 },
	MLT: { lat: 45.6478, lon: -68.6856 },
	MLU: { lat: 32.510899, lon: -92.037697 },
	KMM: { lat: -7.97789, lon: 138.851776 },
	MMH: { lat: 37.625381, lon: -118.84306 },
	MMI: { lat: 35.397301, lon: -84.562599 },
	MML: { lat: 44.4505, lon: -95.821899 },
	MMS: { lat: 34.231499, lon: -90.289597 },
	MMT: { lat: 33.920799, lon: -80.8013 },
	MMU: { lat: 40.799062, lon: -74.414949 },
	MNM: { lat: 45.126701, lon: -87.638397 },
	MNN: { lat: 40.616199, lon: -83.063499 },
	MOB: { lat: 30.6912, lon: -88.242798 },
	MOD: { lat: 37.625801, lon: -120.954002 },
	MOP: { lat: 43.6217, lon: -84.737503 },
	MOR: { lat: 36.179401, lon: -83.375504 },
	MOT: { lat: 48.259399, lon: -101.279999 },
	MOX: { lat: 45.566002, lon: -95.967201 },
	RMY: { lat: 37.510899, lon: -120.040001 },
	MPJ: { lat: 35.138901, lon: -92.909202 },
	MPO: { lat: 41.136025, lon: -75.379572 },
	MPR: { lat: 38.352402, lon: -97.691299 },
	MPV: { lat: 44.203499, lon: -72.562302 },
	MPZ: { lat: 40.946602, lon: -91.511101 },
	MQB: { lat: 40.5201, lon: -90.652397 },
	MEO: { lat: 35.91879, lon: -75.695662 },
	CTH: { lat: 39.979, lon: -75.865501 },
	MQW: { lat: 32.095798, lon: -82.879997 },
	MQY: { lat: 36.008999, lon: -86.520103 },
	MRB: { lat: 39.401901, lon: -77.984596 },
	MRC: { lat: 35.5541, lon: -87.178902 },
	MRF: { lat: 30.369593, lon: -104.015893 },
	MRN: { lat: 35.820202, lon: -81.611397 },
	MRY: { lat: 36.587002, lon: -121.843002 },
	MSL: { lat: 34.745123, lon: -87.612981 },
	MSN: { lat: 43.1399, lon: -89.337502 },
	MSO: { lat: 46.916302, lon: -114.091003 },
	MSP: { lat: 44.880081, lon: -93.221741 },
	MSS: { lat: 44.936157, lon: -74.844304 },
	MSV: { lat: 41.701596, lon: -74.794997 },
	MSY: { lat: 29.993401, lon: -90.258003 },
	MTC: { lat: 42.613463, lon: -82.836919 },
	MTH: { lat: 24.726101, lon: -81.051399 },
	MTJ: { lat: 38.5098, lon: -107.893997 },
	MTN: { lat: 39.325699, lon: -76.413803 },
	MTO: { lat: 39.477901, lon: -88.279198 },
	MTP: { lat: 41.0765, lon: -71.920797 },
	MTW: { lat: 44.127116, lon: -87.681983 },
	MUI: { lat: 40.435214, lon: -76.568661 },
	MUL: { lat: 31.141569, lon: -83.703718 },
	MUO: { lat: 43.043598, lon: -115.872002 },
	MUT: { lat: 41.367803, lon: -91.148201 },
	MVC: { lat: 31.458, lon: -87.350996 },
	MVE: { lat: 44.969101, lon: -95.710297 },
	MVL: { lat: 44.534599, lon: -72.613998 },
	MVN: { lat: 38.322774, lon: -88.859257 },
	MVY: { lat: 41.393101, lon: -70.614304 },
	MWA: { lat: 37.751208, lon: -89.016568 },
	MWC: { lat: 43.110401, lon: -88.034401 },
	MWH: { lat: 47.207699, lon: -119.32 },
	MWL: { lat: 32.781601, lon: -98.060204 },
	MWM: { lat: 43.913399, lon: -95.109398 },
	MWO: { lat: 39.530998, lon: -84.395302 },
	MXA: { lat: 35.894402, lon: -90.154602 },
	MXF: { lat: 32.3829, lon: -86.365799 },
	MXO: { lat: 42.220402, lon: -91.1633 },
	KMY: { lat: 57.0256, lon: -154.145996 },
	MYF: { lat: 32.8157, lon: -117.139999 },
	MYL: { lat: 44.888837, lon: -116.101112 },
	MYR: { lat: 33.679699, lon: -78.928299 },
	MYV: { lat: 39.097801, lon: -121.57 },
	MZJ: { lat: 32.510601, lon: -111.328003 },
	MZZ: { lat: 40.489899, lon: -85.679703 },
	CTX: { lat: 42.592602, lon: -76.214897 },
	SXY: { lat: 42.302601, lon: -75.416 },
	ONH: { lat: 42.5247, lon: -75.0644 },
	NBG: { lat: 29.8253, lon: -90.035004 },
	NHX: { lat: 30.389099, lon: -87.6353 },
	DGN: { lat: 38.3325, lon: -77.037201 },
	NEL: { lat: 40.033298, lon: -74.353302 },
	NEN: { lat: 30.353901, lon: -81.871902 },
	NEW: { lat: 30.0424, lon: -90.028297 },
	NFL: { lat: 39.416599, lon: -118.700996 },
	FWH: { lat: 32.769199, lon: -97.441498 },
	NGP: { lat: 27.6926, lon: -97.2911 },
	NGU: { lat: 36.937599, lon: -76.289299 },
	NGW: { lat: 27.704426, lon: -97.440578 },
	NHK: { lat: 38.285999, lon: -76.411797 },
	NIP: { lat: 30.2358, lon: -81.680603 },
	NJK: { lat: 32.829201, lon: -115.671996 },
	NKX: { lat: 32.868401, lon: -117.142998 },
	NLC: { lat: 36.333, lon: -119.952004 },
	NPA: { lat: 30.352699, lon: -87.318604 },
	NQA: { lat: 35.356701, lon: -89.8703 },
	NQI: { lat: 27.5072, lon: -97.8097 },
	NQX: { lat: 24.5758, lon: -81.688904 },
	NRB: { lat: 30.3911, lon: -81.424698 },
	NRS: { lat: 32.5667, lon: -117.116997 },
	NSE: { lat: 30.724199, lon: -87.021896 },
	NTD: { lat: 34.1203, lon: -119.121002 },
	NTU: { lat: 36.820702, lon: -76.033501 },
	NUQ: { lat: 37.4161, lon: -122.049004 },
	NUW: { lat: 48.351799, lon: -122.655998 },
	NVD: { lat: 37.8521, lon: -94.304901 },
	NYG: { lat: 38.501701, lon: -77.305298 },
	YUM: { lat: 32.650938, lon: -114.609375 },
	NZY: { lat: 32.6992, lon: -117.214996 },
	NVN: { lat: 39.818501, lon: -120.352997 },
	COA: { lat: 38.030399, lon: -120.415001 },
	ODC: { lat: 37.756302, lon: -120.800003 },
	EYR: { lat: 39.004101, lon: -119.157997 },
	OAJ: { lat: 34.829201, lon: -77.612099 },
	OAK: { lat: 37.720085, lon: -122.221184 },
	OAR: { lat: 36.6819, lon: -121.762001 },
	OBE: { lat: 27.2628, lon: -80.8498 },
	OCF: { lat: 29.1726, lon: -82.224197 },
	OCH: { lat: 31.577999, lon: -94.709503 },
	OCW: { lat: 35.570499, lon: -77.049797 },
	ODT: { lat: 31.920601, lon: -102.387001 },
	OEA: { lat: 38.68521, lon: -87.543138 },
	OEO: { lat: 45.310001, lon: -92.691902 },
	OFF: { lat: 41.119307, lon: -95.90851 },
	OFK: { lat: 41.9855, lon: -97.435097 },
	OGA: { lat: 41.119499, lon: -101.769997 },
	OGB: { lat: 33.456799, lon: -80.859497 },
	OGD: { lat: 41.1959, lon: -112.012001 },
	OGS: { lat: 44.6819, lon: -75.4655 },
	OIC: { lat: 42.566601, lon: -75.524101 },
	OJC: { lat: 38.847599, lon: -94.737602 },
	OCN: { lat: 33.217947, lon: -117.351683 },
	OKC: { lat: 35.393388, lon: -97.598248 },
	ODW: { lat: 48.251499, lon: -122.674004 },
	OKK: { lat: 40.528198, lon: -86.058998 },
	OKM: { lat: 35.668098, lon: -95.9487 },
	OKS: { lat: 41.401001, lon: -102.355003 },
	WGO: { lat: 39.143501, lon: -78.144402 },
	OLD: { lat: 44.952801, lon: -68.674301 },
	OLE: { lat: 42.241199, lon: -78.371399 },
	OLF: { lat: 48.094501, lon: -105.574997 },
	OLM: { lat: 46.969399, lon: -122.903 },
	OLS: { lat: 31.4177, lon: -110.848 },
	OLU: { lat: 41.448145, lon: -97.340174 },
	OLV: { lat: 34.978699, lon: -89.786903 },
	OLY: { lat: 38.721802, lon: -88.176399 },
	OMA: { lat: 41.3032, lon: -95.894096 },
	OMK: { lat: 48.464401, lon: -119.517998 },
	ONA: { lat: 44.077202, lon: -91.708298 },
	ONL: { lat: 42.468916, lon: -98.686989 },
	ONM: { lat: 34.022499, lon: -106.903 },
	ONO: { lat: 44.0198, lon: -117.013289 },
	ONP: { lat: 44.580399, lon: -124.057999 },
	ONT: { lat: 34.056, lon: -117.600998 },
	ONY: { lat: 33.350899, lon: -98.819199 },
	OOA: { lat: 41.2262, lon: -92.493896 },
	OPF: { lat: 25.907, lon: -80.278397 },
	OPL: { lat: 30.558399, lon: -92.099403 },
	NCO: { lat: 41.597099, lon: -71.412102 },
	ORD: { lat: 41.9786, lon: -87.9048 },
	ORF: { lat: 36.895341, lon: -76.201 },
	ORH: { lat: 42.2673, lon: -71.875702 },
	ORL: { lat: 28.5455, lon: -81.332901 },
	ESD: { lat: 48.708199, lon: -122.910004 },
	MPS: { lat: 33.095501, lon: -94.961502 },
	OSC: { lat: 44.451599, lon: -83.394096 },
	OSH: { lat: 43.984402, lon: -88.556999 },
	OSU: { lat: 40.0798, lon: -83.072998 },
	OSX: { lat: 33.090302, lon: -89.542 },
	OTG: { lat: 43.65477, lon: -95.577364 },
	OTH: { lat: 43.417099, lon: -124.246002 },
	OTM: { lat: 41.106368, lon: -92.449837 },
	OUN: { lat: 35.2456, lon: -97.472099 },
	OVE: { lat: 39.487801, lon: -121.622002 },
	OWA: { lat: 44.123402, lon: -93.260597 },
	OWB: { lat: 37.740101, lon: -87.166801 },
	OWD: { lat: 42.190498, lon: -71.172897 },
	OWK: { lat: 44.7155, lon: -69.866501 },
	OCE: { lat: 38.310398, lon: -75.124001 },
	OXC: { lat: 41.4786, lon: -73.135201 },
	OXD: { lat: 39.5023, lon: -84.784401 },
	OXR: { lat: 34.200802, lon: -119.207001 },
	KOY: { lat: 57.161499, lon: -154.229996 },
	STQ: { lat: 41.412498, lon: -78.502602 },
	OZA: { lat: 30.7353, lon: -101.203003 },
	OZR: { lat: 31.2757, lon: -85.713402 },
	BSQ: { lat: 31.364, lon: -109.883003 },
	PXL: { lat: 35.791698, lon: -110.422997 },
	GLB: { lat: 33.3531, lon: -110.667 },
	HBK: { lat: 34.940701, lon: -110.138 },
	CWX: { lat: 32.245399, lon: -109.894997 },
	CTW: { lat: 34.73, lon: -112.035004 },
	PAE: { lat: 47.9063, lon: -122.281998 },
	PAH: { lat: 37.060799, lon: -88.773804 },
	PAM: { lat: 30.069599, lon: -85.575401 },
	PJB: { lat: 34.256802, lon: -111.338997 },
	PAO: { lat: 37.461102, lon: -122.114998 },
	KPB: { lat: 56.351898, lon: -133.623001 },
	PBF: { lat: 34.174121, lon: -91.935643 },
	PBG: { lat: 44.650902, lon: -73.468102 },
	PBI: { lat: 26.683201, lon: -80.095596 },
	PVL: { lat: 37.560795, lon: -82.570051 },
	PCD: { lat: 43.019299, lon: -91.123703 },
	PDK: { lat: 33.87633, lon: -84.30213 },
	PDT: { lat: 45.695099, lon: -118.841003 },
	PDX: { lat: 45.588699, lon: -122.598 },
	PEQ: { lat: 31.382401, lon: -103.511002 },
	PFC: { lat: 45.199799, lon: -123.961998 },
	PGA: { lat: 36.924234, lon: -111.447716 },
	PGD: { lat: 26.9202, lon: -81.990501 },
	PGR: { lat: 36.062901, lon: -90.507797 },
	PGV: { lat: 35.635535, lon: -77.384262 },
	PHD: { lat: 40.470901, lon: -81.419701 },
	PHF: { lat: 37.131901, lon: -76.492996 },
	ADR: { lat: 33.451698, lon: -79.526199 },
	PHK: { lat: 26.785, lon: -80.693398 },
	PHL: { lat: 39.871899, lon: -75.241096 },
	PHN: { lat: 42.910999, lon: -82.5289 },
	PHP: { lat: 44.048527, lon: -101.600933 },
	PHT: { lat: 36.3382, lon: -88.382896 },
	PHX: { lat: 33.435302, lon: -112.005905 },
	PIA: { lat: 40.6642, lon: -89.693298 },
	PIB: { lat: 31.4671, lon: -89.337097 },
	PIE: { lat: 27.9102, lon: -82.687401 },
	PIH: { lat: 42.909801, lon: -112.596001 },
	PIM: { lat: 32.840698, lon: -84.882401 },
	PIR: { lat: 44.382702, lon: -100.286003 },
	PIT: { lat: 40.491501, lon: -80.232903 },
	PKB: { lat: 39.3451, lon: -81.439201 },
	PKD: { lat: 46.9006, lon: -95.073095 },
	PKF: { lat: 45.955002, lon: -90.4244 },
	KPL: { lat: -8.630184, lon: 142.823756 },
	PLK: { lat: 36.6259, lon: -93.228897 },
	PLN: { lat: 45.5709, lon: -84.7967 },
	PLR: { lat: 33.5588, lon: -86.2491 },
	PMB: { lat: 48.942501, lon: -97.240799 },
	PMD: { lat: 34.629398, lon: -118.084999 },
	PMH: { lat: 38.8405, lon: -82.847298 },
	PPM: { lat: 26.247101, lon: -80.111099 },
	PWY: { lat: 42.795502, lon: -109.806999 },
	PNC: { lat: 36.731998, lon: -97.0998 },
	PNE: { lat: 40.082406, lon: -75.010614 },
	PNN: { lat: 45.200699, lon: -67.5644 },
	PNS: { lat: 30.4734, lon: -87.1866 },
	POB: { lat: 35.170898, lon: -79.014503 },
	POC: { lat: 34.091599, lon: -117.781998 },
	POE: { lat: 31.0448, lon: -93.191704 },
	POF: { lat: 36.773899, lon: -90.324898 },
	POH: { lat: 42.742802, lon: -94.647301 },
	POU: { lat: 41.626598, lon: -73.884201 },
	POY: { lat: 44.867199, lon: -108.792999 },
	PPA: { lat: 35.612999, lon: -100.996002 },
	PPF: { lat: 37.329899, lon: -95.506203 },
	LPO: { lat: 41.572498, lon: -86.734497 },
	PQI: { lat: 46.688999, lon: -68.0448 },
	PGL: { lat: 30.462799, lon: -88.529198 },
	KPR: { lat: 58.490101, lon: -152.582001 },
	PRB: { lat: 35.672901, lon: -120.626999 },
	PRC: { lat: 34.654499, lon: -112.419998 },
	PRO: { lat: 41.827999, lon: -94.159897 },
	PRX: { lat: 33.6366, lon: -95.450798 },
	PSB: { lat: 40.884399, lon: -78.087303 },
	PSC: { lat: 46.264702, lon: -119.119003 },
	PSF: { lat: 42.4268, lon: -73.2929 },
	PSK: { lat: 37.137299, lon: -80.678497 },
	PSM: { lat: 43.0779, lon: -70.823303 },
	PSN: { lat: 31.779699, lon: -95.706299 },
	PGO: { lat: 37.286301, lon: -107.056 },
	PSP: { lat: 33.8297, lon: -116.507004 },
	PSX: { lat: 28.727501, lon: -96.250999 },
	PTB: { lat: 37.1838, lon: -77.507401 },
	PTK: { lat: 42.665501, lon: -83.420097 },
	PTN: { lat: 29.709499, lon: -91.338997 },
	PTS: { lat: 37.449501, lon: -94.731102 },
	PTT: { lat: 37.701599, lon: -98.746902 },
	PTV: { lat: 36.029598, lon: -119.063004 },
	PTW: { lat: 40.239601, lon: -75.556702 },
	PUB: { lat: 38.289101, lon: -104.497002 },
	PUC: { lat: 39.613899, lon: -110.751 },
	PUW: { lat: 46.741601, lon: -117.11163 },
	PVC: { lat: 42.071899, lon: -70.221397 },
	PVD: { lat: 41.725038, lon: -71.425668 },
	PVF: { lat: 38.724201, lon: -120.752998 },
	PVU: { lat: 40.2192, lon: -111.723 },
	PVW: { lat: 34.168098, lon: -101.717003 },
	PWA: { lat: 35.534199, lon: -97.647102 },
	PWD: { lat: 48.790298, lon: -104.533997 },
	PWK: { lat: 42.114222, lon: -87.901494 },
	PWM: { lat: 43.646198, lon: -70.309303 },
	PWT: { lat: 47.4902, lon: -122.764999 },
	KPY: { lat: 57.931257, lon: -153.040838 },
	PYM: { lat: 41.909, lon: -70.728798 },
	JCJ: { lat: 33.941188, lon: 126.324899 },
	RAC: { lat: 42.760601, lon: -87.815201 },
	RAL: { lat: 33.9519, lon: -117.445 },
	RAP: { lat: 44.0453, lon: -103.056999 },
	RBD: { lat: 32.680901, lon: -96.868202 },
	RBG: { lat: 43.2388, lon: -123.356003 },
	RBL: { lat: 40.1507, lon: -122.251999 },
	RBW: { lat: 32.921001, lon: -80.640602 },
	RCA: { lat: 44.145, lon: -103.103996 },
	RCK: { lat: 30.631599, lon: -96.9897 },
	RCR: { lat: 41.065601, lon: -86.181702 },
	RCT: { lat: 43.900002, lon: -85.516701 },
	RDD: { lat: 40.508999, lon: -122.292999 },
	RDG: { lat: 40.378502, lon: -75.965202 },
	RDM: { lat: 44.254101, lon: -121.150002 },
	RDR: { lat: 47.961102, lon: -97.401199 },
	RDU: { lat: 35.877602, lon: -78.787498 },
	REO: { lat: 42.577702, lon: -117.885002 },
	RFD: { lat: 42.1954, lon: -89.097198 },
	RFG: { lat: 28.2936, lon: -97.322998 },
	RHI: { lat: 45.631199, lon: -89.467499 },
	RHV: { lat: 37.332901, lon: -121.819 },
	RIC: { lat: 37.505199, lon: -77.319702 },
	RID: { lat: 39.757198, lon: -84.842796 },
	RIF: { lat: 38.734068, lon: -112.101603 },
	RIL: { lat: 39.526299, lon: -107.726997 },
	RIR: { lat: 33.9897, lon: -117.411003 },
	RIV: { lat: 33.880699, lon: -117.259003 },
	RIW: { lat: 43.064201, lon: -108.459999 },
	RKD: { lat: 44.060101, lon: -69.099197 },
	RKP: { lat: 28.0868, lon: -97.044601 },
	RKR: { lat: 35.021599, lon: -94.6213 },
	RKS: { lat: 41.5942, lon: -109.065001 },
	RKW: { lat: 35.922298, lon: -84.689697 },
	RLD: { lat: 46.305599, lon: -119.304001 },
	RME: { lat: 43.233799, lon: -75.406998 },
	RMG: { lat: 34.350601, lon: -85.157997 },
	RNC: { lat: 35.6987, lon: -85.843803 },
	RND: { lat: 29.529699, lon: -98.2789 },
	RNH: { lat: 45.1483, lon: -92.538101 },
	RNO: { lat: 39.4991, lon: -119.767998 },
	RNT: { lat: 47.493099, lon: -122.216003 },
	ROA: { lat: 37.3255, lon: -79.975403 },
	ROC: { lat: 43.1189, lon: -77.672401 },
	ROG: { lat: 36.372299, lon: -94.106903 },
	ROW: { lat: 33.301601, lon: -104.530998 },
	ROX: { lat: 48.855999, lon: -95.696999 },
	RIE: { lat: 45.423024, lon: -91.773127 },
	RPX: { lat: 46.475095, lon: -108.541497 },
	WBR: { lat: 43.722599, lon: -85.504097 },
	RQO: { lat: 35.472698, lon: -98.005798 },
	RRL: { lat: 45.198898, lon: -89.712898 },
	RRT: { lat: 48.941399, lon: -95.348396 },
	RSL: { lat: 38.872101, lon: -98.811798 },
	RSN: { lat: 32.514187, lon: -92.588517 },
	RST: { lat: 43.908298, lon: -92.5 },
	RSW: { lat: 26.5362, lon: -81.755203 },
	RTN: { lat: 36.741501, lon: -104.501999 },
	SRW: { lat: 35.645901, lon: -80.520302 },
	RUT: { lat: 43.5294, lon: -72.9496 },
	RED: { lat: 40.677399, lon: -77.626801 },
	RVS: { lat: 36.0396, lon: -95.984596 },
	RWF: { lat: 44.547199, lon: -95.082298 },
	RWI: { lat: 35.8563, lon: -77.891899 },
	RWL: { lat: 41.805599, lon: -107.199997 },
	RXE: { lat: 43.8339, lon: -111.805002 },
	RNZ: { lat: 40.947899, lon: -87.182602 },
	AHM: { lat: 42.190265, lon: -122.660648 },
	BDY: { lat: 43.086498, lon: -124.407997 },
	SUO: { lat: 43.876301, lon: -121.453003 },
	MDJ: { lat: 44.6702, lon: -121.154999 },
	PRZ: { lat: 44.286999, lon: -120.903999 },
	SAA: { lat: 41.444901, lon: -106.823997 },
	SAC: { lat: 38.512501, lon: -121.492996 },
	SAD: { lat: 32.854801, lon: -109.635002 },
	SAF: { lat: 35.6171, lon: -106.088997 },
	SAN: { lat: 32.733601, lon: -117.190002 },
	SAR: { lat: 38.148899, lon: -89.6987 },
	SAS: { lat: 33.241402, lon: -115.952003 },
	SAT: { lat: 29.533701, lon: -98.469803 },
	SAV: { lat: 32.127602, lon: -81.202103 },
	MQT: { lat: 46.3536, lon: -87.395401 },
	SBA: { lat: 34.426201, lon: -119.839996 },
	SBD: { lat: 34.095402, lon: -117.235001 },
	SBM: { lat: 43.7696, lon: -87.851402 },
	SBN: { lat: 41.708698, lon: -86.317299 },
	SBP: { lat: 35.236801, lon: -120.641998 },
	SBS: { lat: 40.5163, lon: -106.865997 },
	SBX: { lat: 48.540699, lon: -111.871002 },
	SBY: { lat: 38.3405, lon: -75.5103 },
	SCB: { lat: 41.610298, lon: -96.629898 },
	SCH: { lat: 42.852501, lon: -73.928902 },
	SCK: { lat: 37.893279, lon: -121.238079 },
	SDF: { lat: 38.1744, lon: -85.736 },
	SCF: { lat: 33.622898, lon: -111.911003 },
	SDM: { lat: 32.572639, lon: -116.980019 },
	SDY: { lat: 47.705141, lon: -104.194422 },
	SEA: { lat: 47.447943, lon: -122.310276 },
	SEE: { lat: 32.826199, lon: -116.972 },
	SEF: { lat: 27.4564, lon: -81.3424 },
	SEG: { lat: 40.820599, lon: -76.863899 },
	SEM: { lat: 32.343899, lon: -86.987801 },
	SEP: { lat: 32.215302, lon: -98.177696 },
	SER: { lat: 38.923599, lon: -85.907402 },
	SDX: { lat: 34.848598, lon: -111.788002 },
	SFB: { lat: 28.777599, lon: -81.237503 },
	SFF: { lat: 47.682899, lon: -117.321925 },
	SFM: { lat: 43.393902, lon: -70.708 },
	SFO: { lat: 37.619806, lon: -122.374821 },
	SFZ: { lat: 41.920799, lon: -71.491402 },
	SGF: { lat: 37.245701, lon: -93.388603 },
	SGH: { lat: 39.840302, lon: -83.840202 },
	UST: { lat: 29.9592, lon: -81.339798 },
	SGR: { lat: 29.622299, lon: -95.656502 },
	SGT: { lat: 34.599499, lon: -91.574997 },
	SGU: { lat: 37.036389, lon: -113.510306 },
	SHD: { lat: 38.263802, lon: -78.8964 },
	SHN: { lat: 47.233601, lon: -123.148003 },
	SHR: { lat: 44.769199, lon: -106.980003 },
	SHV: { lat: 32.446602, lon: -93.8256 },
	SIK: { lat: 36.898899, lon: -89.561798 },
	SIV: { lat: 39.1147, lon: -87.448303 },
	SIY: { lat: 41.781399, lon: -122.468002 },
	SJC: { lat: 37.362452, lon: -121.929188 },
	SJN: { lat: 34.5186, lon: -109.378998 },
	SJT: { lat: 31.3577, lon: -100.496002 },
	SKA: { lat: 47.615101, lon: -117.655998 },
	SKF: { lat: 29.384199, lon: -98.5811 },
	TSM: { lat: 36.452494, lon: -105.67749 },
	SLB: { lat: 42.597301, lon: -95.2407 },
	SLC: { lat: 40.78886, lon: -111.979866 },
	SLE: { lat: 44.9095, lon: -123.002998 },
	SLG: { lat: 36.191898, lon: -94.489998 },
	SLK: { lat: 44.38691, lon: -74.204629 },
	SLN: { lat: 38.791, lon: -97.652199 },
	SLO: { lat: 38.642899, lon: -88.964203 },
	SLR: { lat: 33.159801, lon: -95.621101 },
	SMD: { lat: 41.143398, lon: -85.152802 },
	SME: { lat: 37.053398, lon: -84.615898 },
	SMF: { lat: 38.6954, lon: -121.591003 },
	SMN: { lat: 45.122233, lon: -113.88196 },
	SMO: { lat: 34.0158, lon: -118.450996 },
	SUM: { lat: 33.994999, lon: -80.361298 },
	SMX: { lat: 34.898899, lon: -120.457001 },
	SNA: { lat: 33.675701, lon: -117.867996 },
	SNK: { lat: 32.690212, lon: -100.948918 },
	SNL: { lat: 35.357899, lon: -96.942802 },
	SNS: { lat: 36.6628, lon: -121.606003 },
	SNY: { lat: 41.101299, lon: -102.985001 },
	SOP: { lat: 35.237184, lon: -79.389381 },
	SOW: { lat: 34.264062, lon: -110.007091 },
	SPA: { lat: 34.915699, lon: -81.956497 },
	SPF: { lat: 44.480301, lon: -103.782997 },
	SPG: { lat: 27.7651, lon: -82.626999 },
	SPI: { lat: 39.844101, lon: -89.677902 },
	SPS: { lat: 33.9888, lon: -98.491898 },
	SPW: { lat: 43.165501, lon: -95.202797 },
	SQI: { lat: 41.742175, lon: -89.673629 },
	SQL: { lat: 37.51313, lon: -122.250838 },
	SRC: { lat: 35.210602, lon: -91.737503 },
	SRQ: { lat: 27.394631, lon: -82.554359 },
	RUI: { lat: 33.462799, lon: -105.535004 },
	SSC: { lat: 33.972698, lon: -80.470596 },
	SSF: { lat: 29.337, lon: -98.4711 },
	SSI: { lat: 31.1518, lon: -81.391296 },
	STC: { lat: 45.5466, lon: -94.059898 },
	STE: { lat: 44.5452, lon: -89.530296 },
	STJ: { lat: 39.7719, lon: -94.909698 },
	STK: { lat: 40.613497, lon: -103.263833 },
	STL: { lat: 38.748697, lon: -90.370003 },
	STP: { lat: 44.93479, lon: -93.060036 },
	STS: { lat: 38.508999, lon: -122.813004 },
	SUA: { lat: 27.1817, lon: -80.2211 },
	SUD: { lat: 35.7896, lon: -96.655701 },
	SUE: { lat: 44.8437, lon: -87.421501 },
	SUN: { lat: 43.504398, lon: -114.295998 },
	SUS: { lat: 38.662102, lon: -90.652 },
	SUU: { lat: 38.262699, lon: -121.927002 },
	SUW: { lat: 46.688612, lon: -92.095041 },
	SUX: { lat: 42.397605, lon: -96.382237 },
	SVC: { lat: 32.636701, lon: -108.154736 },
	SVE: { lat: 40.375702, lon: -120.572998 },
	SVH: { lat: 35.765301, lon: -80.953903 },
	SVN: { lat: 32.009998, lon: -81.145699 },
	SWF: { lat: 41.504101, lon: -74.104797 },
	SWO: { lat: 36.162132, lon: -97.085581 },
	SWW: { lat: 32.4674, lon: -100.467003 },
	SYI: { lat: 35.560101, lon: -86.442497 },
	SYN: { lat: 44.475579, lon: -93.016756 },
	SYR: { lat: 43.111198, lon: -76.1063 },
	SYV: { lat: 31.5585, lon: -83.895699 },
	SZL: { lat: 38.730301, lon: -93.547897 },
	SZN: { lat: 34.06007, lon: -119.915229 },
	SZP: { lat: 34.347198, lon: -119.060997 },
	TBC: { lat: 36.091146, lon: -111.38286 },
	TAD: { lat: 37.259399, lon: -104.341003 },
	KTB: { lat: 55.682762, lon: -132.532883 },
	TBN: { lat: 37.7416, lon: -92.140701 },
	TBR: { lat: 32.4827, lon: -81.7369 },
	KTC: { lat: 8.132858, lon: -5.06487 },
	TCC: { lat: 35.1828, lon: -103.602997 },
	TCL: { lat: 33.2206, lon: -87.611397 },
	TCM: { lat: 47.137699, lon: -122.475998 },
	TCS: { lat: 33.2369, lon: -107.272003 },
	TDO: { lat: 46.4772, lon: -122.806 },
	TDW: { lat: 35.169899, lon: -101.825996 },
	TDZ: { lat: 41.564899, lon: -83.4823 },
	TEB: { lat: 40.850101, lon: -74.060799 },
	TEX: { lat: 37.9538, lon: -107.907997 },
	THA: { lat: 35.3801, lon: -86.246399 },
	THM: { lat: 47.573502, lon: -115.280998 },
	THV: { lat: 39.917, lon: -76.873001 },
	TIK: { lat: 35.4147, lon: -97.386597 },
	TIW: { lat: 47.267407, lon: -122.577295 },
	TIX: { lat: 28.514799, lon: -80.799202 },
	KNT: { lat: 36.225899, lon: -90.036598 },
	TLH: { lat: 30.3965, lon: -84.350304 },
	TLR: { lat: 36.1563, lon: -119.325996 },
	TMA: { lat: 31.429001, lon: -83.488503 },
	TMB: { lat: 25.6479, lon: -80.4328 },
	OTK: { lat: 45.418201, lon: -123.814003 },
	TNP: { lat: 34.133901, lon: -115.947347 },
	TNT: { lat: 25.861799, lon: -80.897003 },
	TNU: { lat: 41.6744, lon: -93.021698 },
	XSD: { lat: 37.798801, lon: -116.780998 },
	TOA: { lat: 33.803398, lon: -118.339996 },
	TOC: { lat: 34.5938, lon: -83.295799 },
	TOI: { lat: 31.860399, lon: -86.012101 },
	TOL: { lat: 41.5868, lon: -83.8078 },
	TOP: { lat: 39.069899, lon: -95.622606 },
	TOR: { lat: 42.064499, lon: -104.153 },
	TPA: { lat: 27.9755, lon: -82.533203 },
	TPF: { lat: 27.9156, lon: -82.449303 },
	TPH: { lat: 38.0602, lon: -117.086998 },
	TPL: { lat: 31.1525, lon: -97.407799 },
	TRI: { lat: 36.475201, lon: -82.407401 },
	TKF: { lat: 39.318628, lon: -120.140562 },
	TRL: { lat: 32.709202, lon: -96.267403 },
	TRM: { lat: 33.626701, lon: -116.160004 },
	TRX: { lat: 40.0835, lon: -93.590599 },
	TSP: { lat: 35.134998, lon: -118.439003 },
	TTD: { lat: 45.5494, lon: -122.401001 },
	TTN: { lat: 40.276699, lon: -74.813499 },
	TUL: { lat: 36.198399, lon: -95.8881 },
	TUP: { lat: 34.268101, lon: -88.769897 },
	TUS: { lat: 32.115004, lon: -110.938053 },
	TVC: { lat: 44.741402, lon: -85.582199 },
	TVF: { lat: 48.065701, lon: -96.184998 },
	TVI: { lat: 30.9016, lon: -83.881302 },
	TVL: { lat: 38.893902, lon: -119.995003 },
	TWF: { lat: 42.4818, lon: -114.487999 },
	TXK: { lat: 33.453701, lon: -93.990997 },
	TYZ: { lat: 34.452801, lon: -110.114998 },
	TYR: { lat: 32.354099, lon: -95.402397 },
	TYS: { lat: 35.811001, lon: -83.994003 },
	BFG: { lat: 37.547827, lon: -110.712898 },
	NPH: { lat: 39.73681, lon: -111.870063 },
	RVR: { lat: 38.961399, lon: -110.226997 },
	PNU: { lat: 37.8452, lon: -112.391998 },
	ICS: { lat: 44.493801, lon: -116.015999 },
	UBS: { lat: 33.465401, lon: -88.380302 },
	UCY: { lat: 36.381802, lon: -88.985397 },
	UDD: { lat: 33.748492, lon: -116.275027 },
	UES: { lat: 43.041, lon: -88.237099 },
	UGN: { lat: 42.422199, lon: -87.867897 },
	UIL: { lat: 47.9366, lon: -124.563004 },
	UIN: { lat: 39.942699, lon: -91.194603 },
	IKB: { lat: 36.222801, lon: -81.098297 },
	UKI: { lat: 39.125999, lon: -123.200996 },
	UKT: { lat: 40.4352, lon: -75.381897 },
	ULM: { lat: 44.319599, lon: -94.502296 },
	ATO: { lat: 39.211839, lon: -82.22949 },
	UNU: { lat: 43.426601, lon: -88.703201 },
	SCE: { lat: 40.849374, lon: -77.84852 },
	UOS: { lat: 35.204754, lon: -85.899052 },
	UOX: { lat: 34.3843, lon: -89.536797 },
	KUP: { lat: -10.0736, lon: 148.218 },
	UTM: { lat: 34.68505, lon: -90.347757 },
	HTV: { lat: 30.746901, lon: -95.587196 },
	NPT: { lat: 41.532398, lon: -71.281502 },
	UVA: { lat: 29.2113, lon: -99.743599 },
	RKH: { lat: 34.987801, lon: -81.057198 },
	VAD: { lat: 30.9678, lon: -83.193001 },
	LLY: { lat: 39.942902, lon: -74.845703 },
	VBG: { lat: 34.737301, lon: -120.584 },
	VCT: { lat: 28.8526, lon: -96.918503 },
	VCV: { lat: 34.5975, lon: -117.383003 },
	VDI: { lat: 32.192699, lon: -82.371201 },
	KVE: { lat: -8.6285, lon: 151.327 },
	VEL: { lat: 40.436214, lon: -109.511661 },
	VGT: { lat: 36.210701, lon: -115.194 },
	VHN: { lat: 31.0578, lon: -104.783997 },
	VIH: { lat: 38.127399, lon: -91.769501 },
	VIS: { lat: 36.318699, lon: -119.392998 },
	VJI: { lat: 36.687099, lon: -82.033302 },
	VKS: { lat: 32.2393, lon: -90.928398 },
	VLA: { lat: 38.991501, lon: -89.166199 },
	VLD: { lat: 30.782499, lon: -83.276703 },
	VNC: { lat: 27.070541, lon: -82.440815 },
	VNY: { lat: 34.209801, lon: -118.489998 },
	VOK: { lat: 43.938999, lon: -90.253403 },
	VPS: { lat: 30.4832, lon: -86.525398 },
	VPZ: { lat: 41.453999, lon: -87.007103 },
	VQQ: { lat: 30.2187, lon: -81.876701 },
	VRB: { lat: 27.6556, lon: -80.417901 },
	VSF: { lat: 43.343601, lon: -72.517303 },
	VTN: { lat: 42.856211, lon: -100.549192 },
	VYS: { lat: 41.351898, lon: -89.153099 },
	GTY: { lat: 39.841222, lon: -77.274699 },
	SQV: { lat: 48.098099, lon: -123.186996 },
	PGC: { lat: 38.9949, lon: -79.145897 },
	WAL: { lat: 37.940813, lon: -75.462255 },
	WAY: { lat: 39.90112, lon: -80.130733 },
	WBW: { lat: 41.297199, lon: -75.851196 },
	WDG: { lat: 36.3792, lon: -97.7911 },
	WDR: { lat: 33.982899, lon: -83.667397 },
	WEA: { lat: 32.7463, lon: -97.682404 },
	KWF: { lat: 55.296299, lon: -133.242996 },
	WHP: { lat: 34.2593, lon: -118.413002 },
	WJF: { lat: 34.7411, lon: -118.219002 },
	WLD: { lat: 37.168598, lon: -97.037598 },
	WLW: { lat: 39.516399, lon: -122.218002 },
	WMC: { lat: 40.896599, lon: -117.806 },
	KWP: { lat: 57.7701, lon: -153.548996 },
	WRB: { lat: 32.640099, lon: -83.591904 },
	WRI: { lat: 40.015598, lon: -74.591698 },
	WRL: { lat: 43.965698, lon: -107.950996 },
	WST: { lat: 41.349602, lon: -71.803398 },
	WVI: { lat: 36.935699, lon: -121.790001 },
	WVL: { lat: 44.533199, lon: -69.675499 },
	WWD: { lat: 39.008499, lon: -74.908302 },
	WWR: { lat: 36.438, lon: -99.522667 },
	KWY: { lat: -1.96056, lon: 41.297501 },
	WYS: { lat: 44.6884, lon: -111.117996 },
	KYO: { lat: 28.2213, lon: -82.374496 },
	KXA: { lat: 55.537399, lon: -132.397995 },
	XNA: { lat: 36.281898, lon: -94.306801 },
	XWA: { lat: 48.258387, lon: -103.748797 },
	WBK: { lat: 44.244801, lon: -84.179802 },
	YIP: { lat: 42.2379, lon: -83.530403 },
	YKM: { lat: 46.568199, lon: -120.543999 },
	YKN: { lat: 42.916698, lon: -97.385902 },
	YNG: { lat: 41.2607, lon: -80.6791 },
	ATX: { lat: 51.852306, lon: 68.366892 },
	KZB: { lat: 57.553001, lon: -153.746052 },
	ZPH: { lat: 28.228201, lon: -82.155899 },
	ZZV: { lat: 39.944401, lon: -81.892097 },
	PGS: { lat: 35.527168, lon: -113.247636 },
	BOR: { lat: 20.323986, lon: 100.165392 },
	LAC: { lat: 7.37157, lon: 113.844002 },
	KFZ: { lat: 42.035802, lon: 20.415955 },
	TIA: { lat: 41.4147, lon: 19.7206 },
	BOJ: { lat: 42.569917, lon: 27.515173 },
	GOZ: { lat: 43.151402, lon: 25.7129 },
	LBH: { lat: -33.5871, lon: 151.3234 },
	LBM: { lat: -18.4139, lon: 36.1068 },
	PDV: { lat: 42.067799, lon: 24.8508 },
	ROU: { lat: 43.694801, lon: 26.0567 },
	SOF: { lat: 42.696357, lon: 23.417671 },
	VAR: { lat: 43.232101, lon: 27.8251 },
	ECN: { lat: 35.152337, lon: 33.506584 },
	GEC: { lat: 35.23591, lon: 33.720088 },
	LCA: { lat: 34.875099, lon: 33.624901 },
	LCP: { lat: -38.081902, lon: -70.643898 },
	PFO: { lat: 34.717999, lon: 32.485699 },
	AKT: { lat: 34.590401, lon: 32.9879 },
	DBV: { lat: 42.562247, lon: 18.265543 },
	LSZ: { lat: 44.566985, lon: 14.393883 },
	OSI: { lat: 45.462355, lon: 18.811278 },
	PUY: { lat: 44.893501, lon: 13.9222 },
	RJK: { lat: 45.2169, lon: 14.5703 },
	BWK: { lat: 43.284454, lon: 16.678362 },
	SPU: { lat: 43.538898, lon: 16.298 },
	LDW: { lat: -17.6128, lon: 126.743 },
	ZAG: { lat: 45.742901, lon: 16.0688 },
	ZAD: { lat: 44.094988, lon: 15.354879 },
	ABC: { lat: 38.948502, lon: -1.86352 },
	ALC: { lat: 38.2822, lon: -0.558156 },
	LEI: { lat: 36.843899, lon: -2.3701 },
	OVD: { lat: 43.563599, lon: -6.03462 },
	ODB: { lat: 37.841999, lon: -4.84888 },
	BIO: { lat: 43.301102, lon: -2.91061 },
	RGS: { lat: 42.357601, lon: -3.62076 },
	BCN: { lat: 41.2971, lon: 2.07846 },
	BJZ: { lat: 38.8913, lon: -6.82133 },
	CDT: { lat: 40.213889, lon: 0.073333 },
	LCG: { lat: 43.302101, lon: -8.37726 },
	ILD: { lat: 41.728185, lon: 0.535023 },
	GRO: { lat: 41.904639, lon: 2.761774 },
	GRX: { lat: 37.188702, lon: -3.77736 },
	HSK: { lat: 42.076099, lon: -0.316667 },
	IBZ: { lat: 38.872898, lon: 1.37312 },
	XRY: { lat: 36.744598, lon: -6.06011 },
	LEN: { lat: 42.589001, lon: -5.65556 },
	RJL: { lat: 42.460953, lon: -2.322235 },
	MAD: { lat: 40.471926, lon: -3.56264 },
	AGP: { lat: 36.6749, lon: -4.49911 },
	MAH: { lat: 39.862598, lon: 4.21865 },
	RMU: { lat: 37.803, lon: -1.125 },
	OZP: { lat: 37.1749, lon: -5.61594 },
	LEO: { lat: -1.5724, lon: 14.2878 },
	PMI: { lat: 39.551701, lon: 2.73881 },
	PNA: { lat: 42.77, lon: -1.64633 },
	CQM: { lat: 38.856479, lon: -3.969944 },
	REU: { lat: 41.1474, lon: 1.16717 },
	ROZ: { lat: 36.645199, lon: -6.34946 },
	SLM: { lat: 40.952099, lon: -5.50199 },
	EAS: { lat: 43.356499, lon: -1.79061 },
	SCQ: { lat: 42.896301, lon: -8.41514 },
	LEU: { lat: 42.3386, lon: 1.40917 },
	TEV: { lat: 40.410269, lon: -1.217366 },
	TOJ: { lat: 40.487875, lon: -3.456808 },
	VLC: { lat: 39.4893, lon: -0.481625 },
	VLL: { lat: 41.7061, lon: -4.85194 },
	VIT: { lat: 42.882801, lon: -2.72447 },
	VGO: { lat: 42.2318, lon: -8.62677 },
	SDR: { lat: 43.427101, lon: -3.82001 },
	ZAZ: { lat: 41.666199, lon: -1.04155 },
	SVQ: { lat: 37.417999, lon: -5.89311 },
	DPE: { lat: 49.884662, lon: 1.08101 },
	CQF: { lat: 50.962101, lon: 1.95476 },
	BYF: { lat: 49.970049, lon: 2.693939 },
	LTQ: { lat: 50.518284, lon: 1.621656 },
	AGF: { lat: 44.174171, lon: 0.59309 },
	BOD: { lat: 44.82865, lon: -0.715356 },
	EGC: { lat: 44.825298, lon: 0.518611 },
	CNG: { lat: 45.658298, lon: -0.3175 },
	LRH: { lat: 46.179199, lon: -1.19528 },
	PIS: { lat: 46.5877, lon: 0.306666 },
	MCU: { lat: 46.222599, lon: 2.36396 },
	LIG: { lat: 45.862801, lon: 1.17944 },
	NIT: { lat: 46.313477, lon: -0.394529 },
	TLS: { lat: 43.629101, lon: 1.36382 },
	PUF: { lat: 43.380001, lon: -0.418611 },
	LDE: { lat: 43.178699, lon: -0.006439 },
	ANG: { lat: 45.729198, lon: 0.221456 },
	PGX: { lat: 45.198101, lon: 0.815556 },
	BIQ: { lat: 43.468372, lon: -1.523223 },
	ZAO: { lat: 44.351398, lon: 1.47528 },
	LBI: { lat: 43.913898, lon: 2.11306 },
	DCM: { lat: 43.556301, lon: 2.28918 },
	RDZ: { lat: 44.407902, lon: 2.48267 },
	RYN: { lat: 45.628101, lon: -0.9725 },
	RCO: { lat: 45.887798, lon: -0.983056 },
	BIC: { lat: 47.325256, lon: -3.201255 },
	OUI: { lat: 48.4632, lon: -5.06358 },
	IDY: { lat: 46.717641, lon: -2.392544 },
	CMR: { lat: 48.109901, lon: 7.35901 },
	DLE: { lat: 47.038955, lon: 5.427589 },
	MVV: { lat: 45.823005, lon: 6.649406 },
	OBS: { lat: 44.544367, lon: 4.372194 },
	LPY: { lat: 45.0807, lon: 3.76289 },
	AHZ: { lat: 45.087399, lon: 6.083604 },
	ETZ: { lat: 48.982101, lon: 6.25132 },
	ANE: { lat: 47.560299, lon: -0.312222 },
	BIA: { lat: 42.5527, lon: 9.48373 },
	CLY: { lat: 42.530422, lon: 8.792984 },
	FSC: { lat: 41.500599, lon: 9.09778 },
	AJA: { lat: 41.923599, lon: 8.80292 },
	PRP: { lat: 41.660599, lon: 8.88975 },
	SOZ: { lat: 41.9244, lon: 9.406 },
	MFX: { lat: 45.407505, lon: 6.577597 },
	AUF: { lat: 47.850201, lon: 3.49711 },
	CMF: { lat: 45.6381, lon: 5.88023 },
	CFE: { lat: 45.786701, lon: 3.16917 },
	BOU: { lat: 47.060158, lon: 2.369633 },
	CVF: { lat: 45.397531, lon: 6.63498 },
	LYS: { lat: 45.725996, lon: 5.090139 },
	SYT: { lat: 46.414019, lon: 4.014177 },
	RNE: { lat: 46.053818, lon: 3.999023 },
	NCY: { lat: 45.928947, lon: 6.0987 },
	GNB: { lat: 45.3629, lon: 5.32937 },
	VAF: { lat: 44.9216, lon: 4.9699 },
	VHY: { lat: 46.16969, lon: 3.403637 },
	AUR: { lat: 44.891399, lon: 2.42194 },
	CHR: { lat: 46.860221, lon: 1.728326 },
	LYN: { lat: 45.727947, lon: 4.943991 },
	CEQ: { lat: 43.547998, lon: 6.955176 },
	EBU: { lat: 45.5406, lon: 4.29639 },
	CCF: { lat: 43.216, lon: 2.30632 },
	MRS: { lat: 43.438088, lon: 5.2125 },
	NCE: { lat: 43.658401, lon: 7.21587 },
	PGF: { lat: 42.740398, lon: 2.87067 },
	CTT: { lat: 43.252499, lon: 5.78519 },
	BAE: { lat: 44.387198, lon: 6.608831 },
	MPL: { lat: 43.576199, lon: 3.96301 },
	BZR: { lat: 43.323502, lon: 3.3539 },
	AVN: { lat: 43.907299, lon: 4.90183 },
	GAT: { lat: 44.455002, lon: 6.03778 },
	MEN: { lat: 44.502102, lon: 3.53282 },
	SCP: { lat: 44.701698, lon: 6.60028 },
	BVA: { lat: 49.454399, lon: 2.11278 },
	EVX: { lat: 49.028702, lon: 1.21986 },
	LEH: { lat: 49.534038, lon: 0.088406 },
	XCR: { lat: 48.77333, lon: 4.20611 },
	LSO: { lat: 46.476898, lon: -1.72278 },
	URO: { lat: 49.384887, lon: 1.179142 },
	TUF: { lat: 47.432201, lon: 0.727606 },
	CET: { lat: 47.0821, lon: -0.877064 },
	LVA: { lat: 48.032208, lon: -0.743999 },
	ORE: { lat: 47.897758, lon: 2.164478 },
	LBG: { lat: 48.969398, lon: 2.44139 },
	CSF: { lat: 49.253502, lon: 2.51914 },
	CDG: { lat: 49.012798, lon: 2.55 },
	TNF: { lat: 48.7519, lon: 2.10619 },
	ORY: { lat: 48.72333, lon: 2.37944 },
	POX: { lat: 49.096064, lon: 2.035543 },
	VIY: { lat: 48.774406, lon: 2.203102 },
	NVS: { lat: 47.002913, lon: 3.113114 },
	LIL: { lat: 50.563332, lon: 3.086886 },
	HZB: { lat: 50.618401, lon: 2.64224 },
	BES: { lat: 48.447899, lon: -4.41854 },
	CER: { lat: 49.650101, lon: -1.47028 },
	DNR: { lat: 48.5877, lon: -2.07996 },
	LBY: { lat: 47.289398, lon: -2.34639 },
	GFR: { lat: 48.883099, lon: -1.56417 },
	DOL: { lat: 49.365237, lon: 0.154481 },
	LRT: { lat: 47.760601, lon: -3.44 },
	EDM: { lat: 46.7019, lon: -1.37863 },
	LDV: { lat: 48.5303, lon: -4.15164 },
	CFR: { lat: 49.17678, lon: -0.454883 },
	LME: { lat: 47.948604, lon: 0.201702 },
	RNS: { lat: 48.0695, lon: -1.73479 },
	LAI: { lat: 48.754398, lon: -3.47166 },
	UIP: { lat: 47.973031, lon: -4.169655 },
	NTE: { lat: 47.153198, lon: -1.61073 },
	SBK: { lat: 48.538628, lon: -2.853518 },
	MXN: { lat: 48.603199, lon: -3.81578 },
	VNE: { lat: 47.723301, lon: -2.71856 },
	SNR: { lat: 47.31142, lon: -2.152634 },
	BSL: { lat: 47.60068, lon: 7.521117 },
	DIJ: { lat: 47.268902, lon: 5.09 },
	EPL: { lat: 48.325001, lon: 6.06998 },
	BVE: { lat: 45.039722, lon: 1.485556 },
	ENC: { lat: 48.692101, lon: 6.23046 },
	SXB: { lat: 48.5383, lon: 7.62823 },
	TLN: { lat: 43.097301, lon: 6.14603 },
	FNI: { lat: 43.757401, lon: 4.41635 },
	LTT: { lat: 43.205399, lon: 6.482 },
	MQC: { lat: 47.095501, lon: -56.380299 },
	FSP: { lat: 46.762901, lon: -56.1731 },
	PYR: { lat: 37.9207, lon: 21.292601 },
	AXD: { lat: 40.8559, lon: 25.956301 },
	ATH: { lat: 37.936401, lon: 23.9445 },
	VOL: { lat: 39.219601, lon: 22.7943 },
	LGE: { lat: -20.1089, lon: 127.619 },
	JKH: { lat: 38.343201, lon: 26.1406 },
	JIK: { lat: 37.682701, lon: 26.347099 },
	IOA: { lat: 39.6964, lon: 20.8225 },
	HER: { lat: 35.339699, lon: 25.1803 },
	KSO: { lat: 40.446301, lon: 21.2822 },
	KIT: { lat: 36.273978, lon: 23.016719 },
	EFL: { lat: 38.120098, lon: 20.5005 },
	KZS: { lat: 36.141701, lon: 29.576401 },
	KLX: { lat: 37.068298, lon: 22.025499 },
	KGS: { lat: 36.794523, lon: 27.09115 },
	AOK: { lat: 35.421398, lon: 27.146 },
	CFU: { lat: 39.602024, lon: 19.912038 },
	KSJ: { lat: 35.421398, lon: 26.91 },
	KVA: { lat: 40.9133, lon: 24.6192 },
	JKL: { lat: 36.963299, lon: 26.940599 },
	KZI: { lat: 40.286098, lon: 21.840799 },
	LRS: { lat: 37.184898, lon: 26.800301 },
	LXS: { lat: 39.917099, lon: 25.2363 },
	LRA: { lat: 39.650253, lon: 22.4655 },
	JMK: { lat: 37.435101, lon: 25.348101 },
	MLO: { lat: 36.696899, lon: 24.4769 },
	MJT: { lat: 39.057272, lon: 26.598887 },
	JNX: { lat: 37.0811, lon: 25.368099 },
	PAS: { lat: 37.020495, lon: 25.113195 },
	JTY: { lat: 36.579899, lon: 26.375799 },
	PVK: { lat: 38.925499, lon: 20.765301 },
	RHO: { lat: 36.405399, lon: 28.086201 },
	GPA: { lat: 38.1511, lon: 21.4256 },
	CHQ: { lat: 35.5317, lon: 24.1497 },
	JSI: { lat: 39.177101, lon: 23.5037 },
	SMI: { lat: 37.689999, lon: 26.911699 },
	JSY: { lat: 37.422798, lon: 24.950899 },
	SPJ: { lat: 36.9738, lon: 22.525708 },
	JTR: { lat: 36.3992, lon: 25.4793 },
	JSH: { lat: 35.216099, lon: 26.101299 },
	SKU: { lat: 38.967602, lon: 24.4872 },
	SKG: { lat: 40.51928, lon: 22.970009 },
	ZTH: { lat: 37.7509, lon: 20.8843 },
	BUD: { lat: 47.43018, lon: 19.262393 },
	DEB: { lat: 47.488899, lon: 21.615299 },
	PEV: { lat: 45.988891, lon: 18.242044 },
	SOB: { lat: 46.686391, lon: 17.159084 },
	CRV: { lat: 38.9972, lon: 17.0802 },
	BRI: { lat: 41.138901, lon: 16.760599 },
	FOG: { lat: 41.433596, lon: 15.534566 },
	TAR: { lat: 40.517502, lon: 17.4032 },
	LCC: { lat: 40.239201, lon: 18.133301 },
	PSR: { lat: 42.431702, lon: 14.1811 },
	BDS: { lat: 40.6576, lon: 17.947001 },
	SUF: { lat: 38.905197, lon: 16.243762 },
	CIY: { lat: 36.99583, lon: 14.60889 },
	CTA: { lat: 37.466801, lon: 15.0664 },
	LMP: { lat: 35.497898, lon: 12.6181 },
	PNL: { lat: 36.816502, lon: 11.9689 },
	PMO: { lat: 38.175999, lon: 13.091 },
	REG: { lat: 38.071201, lon: 15.6516 },
	TPS: { lat: 37.9114, lon: 12.488 },
	BLX: { lat: 46.166549, lon: 12.250389 },
	RAN: { lat: 44.364291, lon: 12.224996 },
	AHO: { lat: 40.632099, lon: 8.29077 },
	DCI: { lat: 39.354198, lon: 8.97248 },
	CAG: { lat: 39.251499, lon: 9.05428 },
	OLB: { lat: 40.898701, lon: 9.51763 },
	FNU: { lat: 39.895308, lon: 8.642661 },
	MXP: { lat: 45.6306, lon: 8.72811 },
	BGY: { lat: 45.670725, lon: 9.709223 },
	TRN: { lat: 45.200802, lon: 7.64963 },
	GOA: { lat: 44.412039, lon: 8.840732 },
	LIN: { lat: 45.445099, lon: 9.27674 },
	PMF: { lat: 44.826351, lon: 10.29705 },
	AOT: { lat: 45.738552, lon: 7.3683 },
	CUF: { lat: 44.547001, lon: 7.62322 },
	AVB: { lat: 46.031898, lon: 12.596503 },
	BZO: { lat: 46.460201, lon: 11.3264 },
	BLQ: { lat: 44.5354, lon: 11.2887 },
	TSF: { lat: 45.648399, lon: 12.1944 },
	FRL: { lat: 44.194801, lon: 12.0701 },
	VBS: { lat: 45.428902, lon: 10.3306 },
	TRS: { lat: 45.827499, lon: 13.4722 },
	RMI: { lat: 44.020302, lon: 12.6117 },
	VRN: { lat: 45.394955, lon: 10.887303 },
	AOI: { lat: 43.616299, lon: 13.3623 },
	VCE: { lat: 45.505299, lon: 12.3519 },
	CIA: { lat: 41.7994, lon: 12.5949 },
	FCO: { lat: 41.804532, lon: 12.251998 },
	QSR: { lat: 40.620399, lon: 14.9113 },
	EBA: { lat: 42.760871, lon: 10.239811 },
	NAP: { lat: 40.886002, lon: 14.2908 },
	PSA: { lat: 43.683899, lon: 10.3927 },
	FLR: { lat: 43.808558, lon: 11.202822 },
	GRS: { lat: 42.759701, lon: 11.0719 },
	PEG: { lat: 43.095901, lon: 12.5132 },
	LJU: { lat: 46.223701, lon: 14.4576 },
	MBX: { lat: 46.4799, lon: 15.6861 },
	POW: { lat: 45.47201, lon: 13.615951 },
	NUA: { lat: 6.95605, lon: 80.77927 },
	LKC: { lat: -2.313, lon: 14.606 },
	JCL: { lat: 48.9464, lon: 14.4275 },
	UHE: { lat: 49.0294, lon: 17.439699 },
	KLV: { lat: 50.202999, lon: 12.915 },
	HRA: { lat: 50.540199, lon: 15.0066 },
	OSR: { lat: 49.696301, lon: 18.111099 },
	OLO: { lat: 49.587712, lon: 17.209275 },
	PED: { lat: 50.013401, lon: 15.7386 },
	PRV: { lat: 49.4258, lon: 17.404699 },
	PRG: { lat: 50.100874, lon: 14.259911 },
	BRQ: { lat: 49.151299, lon: 16.694401 },
	VOD: { lat: 50.216599, lon: 14.3958 },
	ZBE: { lat: 49.928258, lon: 18.075557 },
	TLV: { lat: 32.011398, lon: 34.8867 },
	BEV: { lat: 31.287001, lon: 34.723 },
	ETM: { lat: 29.727009, lon: 35.014116 },
	EIY: { lat: 30.6217, lon: 35.2033 },
	LLH: { lat: 15.442801, lon: -87.898564 },
	HFA: { lat: 32.809399, lon: 35.043098 },
	RPN: { lat: 32.980999, lon: 35.571899 },
	KSW: { lat: 33.216275, lon: 35.59622 },
	LLL: { lat: -16.661, lon: 128.594 },
	MTZ: { lat: 31.328199, lon: 35.388599 },
	VTM: { lat: 31.2083, lon: 35.012299 },
	VDA: { lat: 29.9403, lon: 34.935799 },
	MIP: { lat: 30.7761, lon: 34.666698 },
	YOT: { lat: 29.901111, lon: 35.0675 },
	GZM: { lat: 36.027199, lon: 14.2728 },
	MLA: { lat: 35.857498, lon: 14.4775 },
	LMV: { lat: 5.457545, lon: 73.370261 },
	LMZ: { lat: -10.7506, lon: 40.4702 },
	MCM: { lat: 43.725798, lon: 7.419673 },
	ANT: { lat: 47.119621, lon: 10.240524 },
	HOH: { lat: 47.384477, lon: 9.699776 },
	LOM: { lat: 21.258983, lon: -101.943758 },
	LOR: { lat: 31.355801, lon: -85.751198 },
	GRZ: { lat: 46.9911, lon: 15.4396 },
	INN: { lat: 47.260201, lon: 11.344 },
	KLU: { lat: 46.642502, lon: 14.3377 },
	LNZ: { lat: 48.2332, lon: 14.1875 },
	SZG: { lat: 47.793301, lon: 13.0043 },
	VIE: { lat: 48.110298, lon: 16.5697 },
	SMA: { lat: 36.971401, lon: -25.170601 },
	BGC: { lat: 41.8578, lon: -6.70713 },
	BYJ: { lat: 38.078899, lon: -7.9324 },
	CVU: { lat: 39.671501, lon: -31.1136 },
	CAT: { lat: 38.724998, lon: -9.35523 },
	FLW: { lat: 39.455299, lon: -31.131399 },
	FAO: { lat: 37.0144, lon: -7.96591 },
	GRW: { lat: 39.092201, lon: -28.0298 },
	HOR: { lat: 38.519901, lon: -28.7159 },
	TER: { lat: 38.761799, lon: -27.090799 },
	FNC: { lat: 32.697899, lon: -16.7745 },
	PDL: { lat: 37.741199, lon: -25.697901 },
	PIX: { lat: 38.554298, lon: -28.441299 },
	PRM: { lat: 37.1493, lon: -8.58396 },
	OPO: { lat: 41.2481, lon: -8.68139 },
	PXO: { lat: 33.073399, lon: -16.35 },
	LIS: { lat: 38.7813, lon: -9.13592 },
	SJZ: { lat: 38.665501, lon: -28.1758 },
	VRL: { lat: 41.2743, lon: -7.72047 },
	VSE: { lat: 40.725498, lon: -7.88899 },
	BNX: { lat: 44.941399, lon: 17.297501 },
	OMO: { lat: 43.282902, lon: 17.8459 },
	SJJ: { lat: 43.8246, lon: 18.331499 },
	TZL: { lat: 44.458698, lon: 18.7248 },
	ARW: { lat: 46.176601, lon: 21.261999 },
	BCM: { lat: 46.5219, lon: 26.910299 },
	BAY: { lat: 47.658444, lon: 23.464445 },
	BBU: { lat: 44.503201, lon: 26.1021 },
	GHV: { lat: 45.70558, lon: 25.522871 },
	CND: { lat: 44.362202, lon: 28.4883 },
	CLJ: { lat: 46.787425, lon: 23.684292 },
	CSB: { lat: 45.420142, lon: 22.252507 },
	CRA: { lat: 44.3181, lon: 23.888599 },
	IAS: { lat: 47.180278, lon: 27.620833 },
	OMR: { lat: 47.025299, lon: 21.9025 },
	OTP: { lat: 44.572127, lon: 26.103396 },
	SBZ: { lat: 45.785841, lon: 24.086666 },
	SUJ: { lat: 47.7033, lon: 22.8857 },
	SCV: { lat: 47.6875, lon: 26.354099 },
	TCE: { lat: 45.0625, lon: 28.7143 },
	TGM: { lat: 46.467701, lon: 24.4125 },
	TSR: { lat: 45.809898, lon: 21.3379 },
	GVA: { lat: 46.238098, lon: 6.10895 },
	SIR: { lat: 46.219166, lon: 7.326944 },
	EML: { lat: 47.092444, lon: 8.305184 },
	VIP: { lat: 46.8432, lon: 6.91506 },
	LUG: { lat: 46.004299, lon: 8.91058 },
	BRN: { lat: 46.912868, lon: 7.498512 },
	BXO: { lat: 46.974444, lon: 8.396944 },
	ZRH: { lat: 47.458056, lon: 8.548056 },
	ACH: { lat: 47.485001, lon: 9.56077 },
	SMV: { lat: 46.5341, lon: 9.88411 },
	ESB: { lat: 40.128101, lon: 32.995098 },
	ANK: { lat: 39.949799, lon: 32.688599 },
	ADA: { lat: 36.982201, lon: 35.280399 },
	UAB: { lat: 37.002102, lon: 35.4259 },
	AFY: { lat: 38.726398, lon: 30.601101 },
	AYT: { lat: 36.898701, lon: 30.800501 },
	GZT: { lat: 36.947201, lon: 37.478699 },
	KFS: { lat: 41.314201, lon: 33.795799 },
	KYA: { lat: 37.979, lon: 32.561901 },
	MZH: { lat: 40.829399, lon: 35.521999 },
	VAS: { lat: 39.813801, lon: 36.9035 },
	ONQ: { lat: 41.506401, lon: 32.0886 },
	MLX: { lat: 38.435299, lon: 38.091 },
	ASR: { lat: 38.770401, lon: 35.495399 },
	TJK: { lat: 40.32472, lon: 36.39056 },
	DNZ: { lat: 37.785599, lon: 29.7013 },
	NAV: { lat: 38.7719, lon: 34.5345 },
	ISL: { lat: 40.971913, lon: 28.823714 },
	CII: { lat: 37.815389, lon: 27.887566 },
	BZI: { lat: 39.619301, lon: 27.926001 },
	BDM: { lat: 40.318001, lon: 27.977699 },
	CKZ: { lat: 40.137699, lon: 26.4268 },
	ESK: { lat: 39.7841, lon: 30.5821 },
	ADB: { lat: 38.2924, lon: 27.157 },
	IGL: { lat: 38.513, lon: 27.010099 },
	USQ: { lat: 38.681499, lon: 29.471701 },
	KCO: { lat: 40.735001, lon: 30.0833 },
	YEI: { lat: 40.255199, lon: 29.562599 },
	DLM: { lat: 36.7131, lon: 28.7925 },
	TEQ: { lat: 41.138199, lon: 27.9191 },
	BXN: { lat: 37.140099, lon: 27.669701 },
	AOE: { lat: 39.809898, lon: 30.5194 },
	KZR: { lat: 39.113079, lon: 30.128111 },
	EZS: { lat: 38.597974, lon: 39.28348 },
	OGU: { lat: 40.966872, lon: 38.085995 },
	DIY: { lat: 37.893902, lon: 40.201 },
	ERC: { lat: 39.710201, lon: 39.527 },
	ERZ: { lat: 39.956501, lon: 41.1702 },
	KSY: { lat: 40.562199, lon: 43.115002 },
	TZX: { lat: 40.995098, lon: 39.7897 },
	VAN: { lat: 38.468201, lon: 43.332298 },
	BAL: { lat: 37.929001, lon: 41.1166 },
	MSR: { lat: 38.747799, lon: 41.661201 },
	SXZ: { lat: 37.978901, lon: 41.840401 },
	NOP: { lat: 42.018313, lon: 35.071774 },
	KCM: { lat: 37.538826, lon: 36.953522 },
	AJI: { lat: 39.655642, lon: 43.025742 },
	ADF: { lat: 37.7314, lon: 38.468899 },
	MQM: { lat: 37.223301, lon: 40.631699 },
	GNY: { lat: 37.445663, lon: 38.895592 },
	IGD: { lat: 39.976627, lon: 43.876648 },
	BGG: { lat: 38.860131, lon: 40.594489 },
	NKT: { lat: 37.3647, lon: 42.0582 },
	YKO: { lat: 37.5497, lon: 44.2381 },
	HTY: { lat: 36.362778, lon: 36.282223 },
	COV: { lat: 36.890908, lon: 35.070522 },
	LTF: { lat: -2.8337, lon: 141.6257 },
	IZM: { lat: 37.950699, lon: 27.329 },
	ISE: { lat: 37.8554, lon: 30.368401 },
	EDO: { lat: 39.5546, lon: 27.0138 },
	BJV: { lat: 37.250599, lon: 27.664301 },
	GZP: { lat: 36.299217, lon: 32.300598 },
	SZF: { lat: 41.253988, lon: 36.567546 },
	SAW: { lat: 40.898602, lon: 29.3092 },
	GKD: { lat: 40.204498, lon: 25.883302 },
	IST: { lat: 41.261297, lon: 28.741951 },
	RZV: { lat: 41.179766, lon: 40.848802 },
	BZY: { lat: 47.837666, lon: 27.781108 },
	RMO: { lat: 46.9277, lon: 28.931 },
	LWA: { lat: 6.6739, lon: 124.0581 },
	OHD: { lat: 41.18, lon: 20.7423 },
	SKP: { lat: 41.958087, lon: 21.622581 },
	GIB: { lat: 36.151199, lon: -5.34966 },
	BCQ: { lat: 27.653, lon: 14.272 },
	DNF: { lat: 32.542, lon: 22.745001 },
	BEG: { lat: 44.818401, lon: 20.309099 },
	IVG: { lat: 42.839001, lon: 19.862 },
	BJY: { lat: 44.935299, lon: 20.2575 },
	KVO: { lat: 43.817519, lon: 20.586662 },
	INI: { lat: 43.337009, lon: 21.85451 },
	TGD: { lat: 42.359402, lon: 19.2519 },
	TIV: { lat: 42.404701, lon: 18.723301 },
	UZC: { lat: 43.898899, lon: 19.697701 },
	LZG: { lat: 31.50191, lon: 106.034417 },
	BTS: { lat: 48.1702, lon: 17.2127 },
	KSC: { lat: 48.663101, lon: 21.2411 },
	LUE: { lat: 48.339401, lon: 19.7358 },
	PZY: { lat: 48.625198, lon: 17.8284 },
	POV: { lat: 49.029701, lon: 21.315599 },
	SLD: { lat: 48.637798, lon: 19.1341 },
	TAT: { lat: 49.073601, lon: 20.2411 },
	ILZ: { lat: 49.233292, lon: 18.613386 },
	DRU: { lat: 46.621599, lon: -113.201751 },
	GLN: { lat: 29.026699, lon: -10.0503 },
	UWA: { lat: 42.282001, lon: -72.214798 },
	MAP: { lat: -10.290833, lon: 149.519167 },
	GDT: { lat: 21.4445, lon: -71.142303 },
	MDS: { lat: 21.82602, lon: -71.8025 },
	NCA: { lat: 21.916094, lon: -71.942954 },
	PIC: { lat: 21.874661, lon: -72.090573 },
	PLS: { lat: 21.773697, lon: -72.268321 },
	XSC: { lat: 21.515699, lon: -71.528503 },
	SLX: { lat: 21.333, lon: -71.199997 },
	BRX: { lat: 18.251499, lon: -71.120399 },
	CBJ: { lat: 17.929001, lon: -71.644798 },
	AZS: { lat: 19.269259, lon: -69.737405 },
	COZ: { lat: 18.907499, lon: -70.721901 },
	JBQ: { lat: 18.5725, lon: -69.985603 },
	LRM: { lat: 18.452222, lon: -68.911111 },
	PUJ: { lat: 18.5674, lon: -68.363403 },
	POP: { lat: 19.7579, lon: -70.57 },
	SDQ: { lat: 18.429701, lon: -69.6689 },
	STI: { lat: 19.406099, lon: -70.604698 },
	MDV: { lat: 1.0085, lon: 10.7552 },
	LIZ: { lat: 46.950401, lon: -67.885902 },
	MEF: { lat: 11.060192, lon: 17.944495 },
	NKO: { lat: -16.594919, lon: 44.453654 },
	RLR: { lat: -22.645343, lon: 45.323914 },
	DOA: { lat: -14.3681, lon: 49.510799 },
	CBV: { lat: 15.469, lon: -90.4067 },
	CMM: { lat: 17.461201, lon: -90.053703 },
	CTF: { lat: 14.6942, lon: -91.8825 },
	GUA: { lat: 14.5833, lon: -90.527496 },
	HUG: { lat: 15.316667, lon: -91.505556 },
	MGI: { lat: 28.323, lon: -96.464 },
	MGP: { lat: -4.147, lon: 153.0186 },
	PBR: { lat: 15.7309, lon: -88.583801 },
	PKJ: { lat: 15.9975, lon: -90.741699 },
	PON: { lat: 16.3258, lon: -89.4161 },
	AQB: { lat: 15.0122, lon: -91.150597 },
	AAZ: { lat: 14.8656, lon: -91.501999 },
	RUV: { lat: 15.992, lon: -90.445297 },
	LCF: { lat: 15.668363, lon: -88.961763 },
	RER: { lat: 14.521431, lon: -91.697001 },
	GSJ: { lat: 13.9362, lon: -90.8358 },
	FRS: { lat: 16.913799, lon: -89.866402 },
	UJE: { lat: 8.92806, lon: 165.761993 },
	AIM: { lat: 10.2168, lon: 169.983002 },
	AUL: { lat: 8.14528, lon: 171.173004 },
	BII: { lat: 11.5225, lon: 165.565002 },
	EBN: { lat: 9.33056, lon: 166.820007 },
	JAT: { lat: 7.749775, lon: 168.977838 },
	JEJ: { lat: 7.56535, lon: 168.962006 },
	LIK: { lat: 9.82316, lon: 169.307999 },
	LML: { lat: 8.92111, lon: 166.264999 },
	MAV: { lat: 8.70444, lon: 171.229996 },
	MJB: { lat: 10.283302, lon: 170.869 },
	MJE: { lat: 8.163362, lon: 168.173862 },
	NDK: { lat: 5.633005, lon: 168.125631 },
	RNP: { lat: 11.1572, lon: 166.886993 },
	TIC: { lat: 7.121768, lon: 171.911584 },
	UIT: { lat: 5.909213, lon: 169.637256 },
	WJA: { lat: 7.450833, lon: 168.55 },
	WTE: { lat: 9.458333, lon: 170.238611 },
	WTO: { lat: 10.1733, lon: 166.003006 },
	AHS: { lat: 15.4722, lon: -84.352203 },
	BHG: { lat: 15.7631, lon: -84.543602 },
	LUI: { lat: 15.033192, lon: -86.692334 },
	CYL: { lat: 15.445556, lon: -86.675278 },
	CDD: { lat: 15.316667, lon: -83.591667 },
	OAN: { lat: 15.505556, lon: -86.574722 },
	CAA: { lat: 14.875, lon: -85.776108 },
	GAC: { lat: 14.573492, lon: -88.595801 },
	IRN: { lat: 15.939167, lon: -85.137222 },
	JUT: { lat: 14.6526, lon: -86.220299 },
	LCE: { lat: 15.7425, lon: -86.852997 },
	LEZ: { lat: 14.291111, lon: -88.175003 },
	SAP: { lat: 15.4526, lon: -87.923599 },
	LMH: { lat: 15.856066, lon: -85.443978 },
	MHN: { lat: 42.042155, lon: -101.059113 },
	GJA: { lat: 16.4454, lon: -85.906601 },
	PCH: { lat: 15.955, lon: -84.941391 },
	PEU: { lat: 15.2622, lon: -83.781197 },
	RTB: { lat: 16.316799, lon: -86.523003 },
	RUY: { lat: 14.914885, lon: -89.007837 },
	XPL: { lat: 14.3824, lon: -87.621201 },
	TEA: { lat: 15.7759, lon: -87.4758 },
	TGU: { lat: 14.0609, lon: -87.217201 },
	TJI: { lat: 15.926599, lon: -85.938573 },
	TCF: { lat: 15.659722, lon: -85.994164 },
	SCD: { lat: 14.9072, lon: -87.263397 },
	UII: { lat: 16.1131, lon: -86.880302 },
	ORO: { lat: 15.1275, lon: -87.135 },
	MIZ: { lat: -14.0533, lon: 134.0942 },
	MJJ: { lat: -5.7181, lon: 145.2404 },
	MJS: { lat: -17.3087, lon: 37.5 },
	OCJ: { lat: 18.404079, lon: -76.969754 },
	KIN: { lat: 17.935699, lon: -76.787498 },
	MBJ: { lat: 18.5037, lon: -77.913399 },
	POT: { lat: 18.198799, lon: -76.5345 },
	NEG: { lat: 18.341712, lon: -78.334164 },
	KTP: { lat: 17.9886, lon: -76.823799 },
	MIJ: { lat: 6.084754, lon: 171.731419 },
	HEB: { lat: 17.633329, lon: 95.466698 },
	TZM: { lat: 21.155716, lon: -88.172918 },
	ACA: { lat: 16.757126, lon: -99.753113 },
	NTR: { lat: 25.865601, lon: -100.237 },
	AGU: { lat: 21.699589, lon: -102.318372 },
	HUX: { lat: 15.774909, lon: -96.260319 },
	CNA: { lat: 31.06615, lon: -110.097878 },
	CVJ: { lat: 18.833922, lon: -99.261818 },
	ACN: { lat: 29.333662, lon: -101.100555 },
	CME: { lat: 18.6537, lon: -91.799004 },
	NCG: { lat: 30.3974, lon: -107.875 },
	CUL: { lat: 24.76504, lon: -107.475228 },
	CTM: { lat: 18.504985, lon: -88.328018 },
	CEN: { lat: 27.392599, lon: -109.833 },
	CJT: { lat: 16.176701, lon: -92.050598 },
	CPE: { lat: 19.816799, lon: -90.500298 },
	CJS: { lat: 31.636101, lon: -106.429001 },
	CZA: { lat: 20.6413, lon: -88.446198 },
	CUU: { lat: 28.7029, lon: -105.964996 },
	CVM: { lat: 23.7033, lon: -98.956497 },
	CYW: { lat: 20.545998, lon: -100.886539 },
	CZM: { lat: 20.514922, lon: -86.928538 },
	CUA: { lat: 25.053801, lon: -111.614998 },
	MMC: { lat: 22.738957, lon: -99.018516 },
	DGO: { lat: 24.125468, lon: -104.527938 },
	TPQ: { lat: 21.419833, lon: -104.842472 },
	ESE: { lat: 31.795175, lon: -116.60265 },
	GDL: { lat: 20.523342, lon: -103.310108 },
	GYM: { lat: 27.969, lon: -110.925003 },
	GUB: { lat: 28.0261, lon: -114.024002 },
	TCN: { lat: 18.49722, lon: -97.42011 },
	HMO: { lat: 29.093527, lon: -111.049891 },
	CLQ: { lat: 19.277, lon: -103.577002 },
	ISJ: { lat: 21.245962, lon: -86.740365 },
	SLW: { lat: 25.544145, lon: -100.930195 },
	IZT: { lat: 16.445961, lon: -95.093708 },
	JAL: { lat: 19.475107, lon: -96.797008 },
	AZP: { lat: 19.574155, lon: -99.291183 },
	LZC: { lat: 18.001672, lon: -102.220316 },
	LMM: { lat: 25.685447, lon: -109.081055 },
	BJX: { lat: 20.992695, lon: -101.480284 },
	LAP: { lat: 24.072701, lon: -110.362 },
	LTO: { lat: 25.989201, lon: -111.348 },
	MAM: { lat: 25.769899, lon: -97.525299 },
	MID: { lat: 20.930485, lon: -89.645462 },
	MUG: { lat: 26.905347, lon: -111.970725 },
	MXL: { lat: 32.630629, lon: -115.242805 },
	MLM: { lat: 19.849899, lon: -101.025002 },
	MTT: { lat: 18.103399, lon: -94.580704 },
	LOV: { lat: 26.9557, lon: -101.470001 },
	MEX: { lat: 19.435137, lon: -99.071328 },
	MTY: { lat: 25.778521, lon: -100.106989 },
	MZT: { lat: 23.161474, lon: -106.264572 },
	NOG: { lat: 31.225756, lon: -110.976934 },
	NLD: { lat: 27.443899, lon: -99.570503 },
	OAX: { lat: 17.000814, lon: -96.72197 },
	PAZ: { lat: 20.602699, lon: -97.4608 },
	PBC: { lat: 19.158465, lon: -98.371582 },
	PPE: { lat: 31.351987, lon: -113.305177 },
	PDS: { lat: 28.627873, lon: -100.53524 },
	PCO: { lat: 23.575011, lon: -109.535826 },
	UPN: { lat: 19.3967, lon: -102.039001 },
	PQM: { lat: 17.533153, lon: -92.015484 },
	PVR: { lat: 20.679913, lon: -105.254391 },
	PXM: { lat: 15.876808, lon: -97.0891 },
	QRO: { lat: 20.6173, lon: -100.185997 },
	REX: { lat: 26.0089, lon: -98.2285 },
	SJD: { lat: 23.151919, lon: -109.720731 },
	SFH: { lat: 30.93006, lon: -114.808459 },
	NLU: { lat: 19.7357, lon: -99.0257 },
	SLP: { lat: 22.254299, lon: -100.931 },
	SCX: { lat: 16.212601, lon: -95.201599 },
	TRC: { lat: 25.5683, lon: -103.411003 },
	TGZ: { lat: 16.563601, lon: -93.022499 },
	TIJ: { lat: 32.541043, lon: -116.969976 },
	TQO: { lat: 20.172098, lon: -87.660272 },
	TAM: { lat: 22.2964, lon: -97.865898 },
	TSL: { lat: 22.0383, lon: -98.806502 },
	TLC: { lat: 19.3369, lon: -99.56583 },
	TAP: { lat: 14.794549, lon: -92.369871 },
	TUY: { lat: 20.227301, lon: -87.438203 },
	CUN: { lat: 21.039444, lon: -86.874304 },
	MMV: { lat: -1.39139, lon: 144.17131 },
	VSA: { lat: 17.997, lon: -92.817398 },
	VER: { lat: 19.145901, lon: -96.187302 },
	ZCL: { lat: 22.8971, lon: -102.686996 },
	ZIH: { lat: 17.601771, lon: -101.460629 },
	ZMM: { lat: 20.045, lon: -102.276001 },
	ZLO: { lat: 19.1448, lon: -104.558998 },
	BEF: { lat: 11.991, lon: -83.774101 },
	BZA: { lat: 14.031524, lon: -84.624311 },
	ECI: { lat: 11.427542, lon: -86.033361 },
	RNI: { lat: 12.174785, lon: -83.059445 },
	MGA: { lat: 12.1415, lon: -86.168198 },
	MNP: { lat: -1.550403, lon: 145.017504 },
	PUZ: { lat: 14.0472, lon: -83.386703 },
	RFS: { lat: 13.8897, lon: -84.408897 },
	NCR: { lat: 11.13556, lon: -84.768727 },
	SIU: { lat: 13.727222, lon: -84.777779 },
	WSP: { lat: 14.7392, lon: -83.969398 },
	MOH: { lat: -2.201143, lon: 121.662884 },
	MOS: { lat: 64.694116, lon: -162.060699 },
	BOC: { lat: 9.34085, lon: -82.250801 },
	CTD: { lat: 7.98784, lon: -80.409837 },
	CHX: { lat: 9.458962, lon: -82.515062 },
	DAV: { lat: 8.391, lon: -82.434998 },
	ONX: { lat: 9.35664, lon: -79.867401 },
	BLB: { lat: 8.91479, lon: -79.599602 },
	MPI: { lat: 9.1851, lon: -77.9841 },
	JQE: { lat: 7.51778, lon: -78.157204 },
	PAC: { lat: 8.97334, lon: -79.555603 },
	PUE: { lat: 8.668813, lon: -77.417399 },
	PDM: { lat: 7.534801, lon: -80.043347 },
	SYP: { lat: 8.0856, lon: -80.945297 },
	RIH: { lat: 8.37588, lon: -80.127899 },
	PTY: { lat: 9.07136, lon: -79.383499 },
	PVE: { lat: 9.559212, lon: -78.946631 },
	NBL: { lat: 9.273476, lon: -78.139848 },
	FON: { lat: 10.469311, lon: -84.579073 },
	BAI: { lat: 9.163949, lon: -83.330171 },
	BCL: { lat: 10.7687, lon: -83.585602 },
	TTQ: { lat: 10.569, lon: -83.5149 },
	OTR: { lat: 8.60156, lon: -82.968754 },
	JAP: { lat: 9.98141, lon: -84.772697 },
	PLD: { lat: 9.87051, lon: -85.4814 },
	DRK: { lat: 8.71889, lon: -83.641701 },
	FMG: { lat: 10.4186, lon: -85.7827 },
	GLF: { lat: 8.65401, lon: -83.182198 },
	GPL: { lat: 10.2172, lon: -83.796997 },
	PBP: { lat: 9.85611, lon: -85.370796 },
	LIR: { lat: 10.5933, lon: -85.544403 },
	LSL: { lat: 11.0353, lon: -84.7061 },
	LIO: { lat: 9.95796, lon: -83.022003 },
	CSC: { lat: 10.4307, lon: -85.174599 },
	NCT: { lat: 10.1394, lon: -85.445801 },
	NOB: { lat: 9.97649, lon: -85.653 },
	SJO: { lat: 9.99386, lon: -84.208801 },
	PJM: { lat: 8.53333, lon: -83.300003 },
	PMZ: { lat: 8.95103, lon: -83.468597 },
	SYQ: { lat: 9.95705, lon: -84.139801 },
	XQP: { lat: 9.44316, lon: -84.129799 },
	RFR: { lat: 10.3274, lon: -83.887604 },
	IPZ: { lat: 9.348676, lon: -83.712301 },
	TOO: { lat: 8.826971, lon: -82.958922 },
	MRT: { lat: -14.818133, lon: 133.700594 },
	TNO: { lat: 10.3135, lon: -85.815498 },
	TMU: { lat: 9.739307, lon: -85.016199 },
	UPL: { lat: 10.8922, lon: -85.016197 },
	MSB: { lat: 18.0696, lon: -63.087 },
	SAL: { lat: 13.4409, lon: -89.055702 },
	ILS: { lat: 13.6995, lon: -89.119904 },
	JCO: { lat: 36.01007, lon: 14.347306 },
	CYA: { lat: 18.271099, lon: -73.7883 },
	CAP: { lat: 19.726734, lon: -72.199576 },
	MTX: { lat: 64.806801, lon: -147.761993 },
	JAK: { lat: 18.2411, lon: -72.518501 },
	JEE: { lat: 18.663099, lon: -74.170303 },
	PAP: { lat: 18.580023, lon: -72.292596 },
	PAX: { lat: 19.934045, lon: -72.84801 },
	MTU: { lat: -13.1219, lon: 39.052799 },
	AHG: { lat: -10.3731, lon: 56.609798 },
	BCA: { lat: 20.365299, lon: -74.506203 },
	BWW: { lat: 22.6213, lon: -79.147202 },
	BYM: { lat: 20.3964, lon: -76.621399 },
	AVI: { lat: 22.0271, lon: -78.789597 },
	CCC: { lat: 22.461, lon: -78.3284 },
	CFG: { lat: 22.15, lon: -80.4142 },
	CYO: { lat: 21.616501, lon: -81.545998 },
	CMW: { lat: 21.4203, lon: -77.847504 },
	SCU: { lat: 19.969801, lon: -75.835403 },
	NBW: { lat: 19.9065, lon: -75.2071 },
	GAO: { lat: 20.0853, lon: -75.158302 },
	HAV: { lat: 22.989201, lon: -82.409103 },
	HOG: { lat: 20.785601, lon: -76.315102 },
	VRO: { lat: 23.124001, lon: -81.301598 },
	LCL: { lat: 22.3361, lon: -83.641899 },
	UMA: { lat: 20.242374, lon: -74.148268 },
	MJG: { lat: 22.230801, lon: -79.062202 },
	MOA: { lat: 20.6539, lon: -74.922203 },
	MZO: { lat: 20.288605, lon: -77.087545 },
	GER: { lat: 21.8347, lon: -82.783798 },
	UPB: { lat: 23.032801, lon: -82.579399 },
	SNU: { lat: 22.492201, lon: -79.943604 },
	SNJ: { lat: 22.100525, lon: -84.157376 },
	SZJ: { lat: 21.6425, lon: -82.955101 },
	USS: { lat: 21.9704, lon: -79.442703 },
	TND: { lat: 21.7883, lon: -79.9972 },
	VRA: { lat: 23.034401, lon: -81.435303 },
	VTU: { lat: 20.9876, lon: -76.935799 },
	FMT: { lat: 0.192647, lon: 73.196755 },
	MUM: { lat: 2.911389, lon: 73.583611 },
	CYB: { lat: 19.687, lon: -79.882797 },
	LYB: { lat: 19.660161, lon: -80.088826 },
	GCM: { lat: 19.292801, lon: -81.357697 },
	MWR: { lat: -24.1903, lon: 31.3864 },
	MWU: { lat: -1.45, lon: 149.7 },
	AJS: { lat: 26.7272, lon: -113.558998 },
	AZG: { lat: 19.093399, lon: -102.393997 },
	PCM: { lat: 20.622499, lon: -87.082199 },
	PCV: { lat: 27.069201, lon: -111.961998 },
	SGM: { lat: 27.296473, lon: -112.938809 },
	UAC: { lat: 32.445301, lon: -114.797997 },
	XAL: { lat: 27.039, lon: -108.949021 },
	MXC: { lat: 37.93243, lon: -109.341225 },
	GTK: { lat: 2.64118, lon: 102.89297 },
	LBP: { lat: 3.202138, lon: 115.401811 },
	SPT: { lat: 5.083333, lon: 115.550003 },
	MAY: { lat: 24.287701, lon: -77.684601 },
	ASD: { lat: 24.697901, lon: -77.795601 },
	TZN: { lat: 24.158701, lon: -77.589798 },
	MHH: { lat: 26.510711, lon: -77.084262 },
	SAQ: { lat: 25.053801, lon: -78.049004 },
	AXP: { lat: 22.441799, lon: -73.970901 },
	TCB: { lat: 26.7453, lon: -77.391296 },
	WKR: { lat: 27.259656, lon: -78.400455 },
	CCZ: { lat: 25.417101, lon: -77.880898 },
	GHC: { lat: 25.7383, lon: -77.840103 },
	BIM: { lat: 25.6999, lon: -79.264702 },
	ATC: { lat: 24.6294, lon: -75.673797 },
	TBI: { lat: 24.3153, lon: -75.452301 },
	CXY: { lat: 25.554425, lon: -79.275404 },
	CRI: { lat: 22.7456, lon: -74.182404 },
	PWN: { lat: 22.8297, lon: -74.3461 },
	GGT: { lat: 23.562599, lon: -75.877998 },
	ELH: { lat: 25.474899, lon: -76.683502 },
	GHB: { lat: 25.2847, lon: -76.331001 },
	NMC: { lat: 24.594299, lon: -76.820198 },
	RSD: { lat: 24.895079, lon: -76.176882 },
	TYM: { lat: 24.1691, lon: -76.439102 },
	FPO: { lat: 26.558701, lon: -78.695602 },
	WTD: { lat: 26.685301, lon: -78.974998 },
	IGA: { lat: 20.975, lon: -73.666901 },
	MYK: { lat: 61.335701, lon: -142.686996 },
	LGI: { lat: 23.179001, lon: -75.093597 },
	SML: { lat: 23.582317, lon: -75.268621 },
	MYG: { lat: 22.379499, lon: -73.013494 },
	NAS: { lat: 25.039, lon: -77.466202 },
	DCT: { lat: 22.181801, lon: -75.7295 },
	RCY: { lat: 23.68344, lon: -74.836302 },
	MYS: { lat: 3.5623, lon: 39.0433 },
	ZSA: { lat: 24.063299, lon: -74.524002 },
	NTC: { lat: -21.615, lon: 35.338001 },
	TGS: { lat: -24.520599, lon: 32.965302 },
	BZE: { lat: 17.539951, lon: -88.303556 },
	MZE: { lat: 17.27846, lon: -89.0238 },
	CYD: { lat: 17.104872, lon: -89.101129 },
	PLJ: { lat: 16.536957, lon: -88.361511 },
	IMI: { lat: 7.005553, lon: 171.656959 },
	BQI: { lat: -18.11848, lon: 21.623296 },
	AIT: { lat: -18.8309, lon: -159.764008 },
	AIU: { lat: -19.9678, lon: -158.119003 },
	MGS: { lat: -21.895987, lon: -157.906662 },
	MHX: { lat: -10.3767, lon: -161.001999 },
	MUK: { lat: -20.136101, lon: -157.345001 },
	MOI: { lat: -19.842501, lon: -157.703003 },
	PZK: { lat: -10.9145, lon: -165.8393 },
	PYE: { lat: -9.01437, lon: -158.03241 },
	RAR: { lat: -21.2027, lon: -159.806 },
	EPG: { lat: 40.8675, lon: -96.110001 },
	ICI: { lat: -17.743299, lon: -179.341995 },
	CST: { lat: -17.7358, lon: 177.129 },
	NAN: { lat: -17.7554, lon: 177.442993 },
	PTF: { lat: -17.778448, lon: 177.196996 },
	RBI: { lat: -16.5337, lon: 179.9757 },
	KDV: { lat: -19.0581, lon: 178.156998 },
	MNF: { lat: -17.672844, lon: 177.0985 },
	MFJ: { lat: -18.5667, lon: 179.951004 },
	SUV: { lat: -18.043301, lon: 178.559006 },
	LEV: { lat: -17.7111, lon: 178.759003 },
	PHR: { lat: -18.2553, lon: 178.0492 },
	NGI: { lat: -18.115601, lon: 179.339996 },
	LUC: { lat: -16.7481, lon: -179.667007 },
	LKB: { lat: -18.1992, lon: -178.817001 },
	LBS: { lat: -16.4667, lon: 179.339996 },
	TVU: { lat: -16.690599, lon: -179.876999 },
	KXF: { lat: -17.3458, lon: 179.421997 },
	RTA: { lat: -12.4825, lon: 177.070999 },
	SVU: { lat: -16.803394, lon: 179.340587 },
	KAY: { lat: -17.617001, lon: 179.016998 },
	ONU: { lat: -20.6589, lon: -178.7411 },
	YAS: { lat: -16.7589, lon: 177.544998 },
	EUA: { lat: -21.3783, lon: -174.957993 },
	TBU: { lat: -21.241199, lon: -175.149994 },
	HPA: { lat: -19.777, lon: -174.341003 },
	NFO: { lat: -15.570603, lon: -175.631283 },
	NTT: { lat: -15.977297, lon: -173.791089 },
	VAV: { lat: -18.5853, lon: -173.962006 },
	TTL: { lat: -16.966, lon: 177.368 },
	VBV: { lat: -17.268999, lon: -178.975998 },
	VTF: { lat: -18.512501, lon: 177.639008 },
	PHG: { lat: 4.846111, lon: 7.021389 },
	ABF: { lat: 1.79861, lon: 173.041 },
	BEZ: { lat: -1.35472, lon: 176.007004 },
	FUN: { lat: -8.525, lon: 179.195999 },
	KUC: { lat: 0.218611, lon: 173.442001 },
	MNK: { lat: 1.00361, lon: 173.031006 },
	MZK: { lat: 2.05861, lon: 173.270996 },
	MTK: { lat: 3.37444, lon: 172.992004 },
	NIG: { lat: -1.31444, lon: 176.410004 },
	OOT: { lat: -1.79611, lon: 175.526001 },
	TRW: { lat: 1.38164, lon: 173.147003 },
	AEA: { lat: 0.490759, lon: 173.830287 },
	TBF: { lat: -1.22447, lon: 174.776001 },
	TMN: { lat: -2.48583, lon: 175.970001 },
	NON: { lat: -0.639722, lon: 174.427994 },
	AIS: { lat: -2.616233, lon: 176.802209 },
	TSU: { lat: -1.47444, lon: 175.063995 },
	BBG: { lat: 3.08583, lon: 172.811005 },
	AAK: { lat: 0.185278, lon: 173.636993 },
	NIK: { lat: 13.052014, lon: -12.727162 },
	NIN: { lat: 60.020199, lon: -151.589005 },
	IUE: { lat: -19.079031, lon: -169.925598 },
	NJJ: { lat: 49.236372, lon: 125.337052 },
	NKD: { lat: -3.822249, lon: 137.839208 },
	NLH: { lat: 27.5403, lon: 100.7593 },
	FUT: { lat: -14.311565, lon: -178.066492 },
	WLS: { lat: -13.2383, lon: -176.199005 },
	HBB: { lat: 32.7668, lon: -103.209 },
	NND: { lat: -11.073, lon: 39.68 },
	NOM: { lat: -6.294, lon: 142.234167 },
	NOO: { lat: -9.254455, lon: 147.621352 },
	PHH: { lat: 28.1838, lon: 84.0147 },
	NPG: { lat: -6.1454, lon: 143.4531 },
	NRY: { lat: -16.0442, lon: 129.2638 },
	OFU: { lat: -14.1844, lon: -169.669998 },
	AAU: { lat: -13.505132, lon: -172.627888 },
	APW: { lat: -13.83, lon: -172.007996 },
	FGI: { lat: -13.849167, lon: -171.739866 },
	FTI: { lat: -14.216131, lon: -169.423771 },
	MXS: { lat: -13.7423, lon: -172.257996 },
	PPG: { lat: -14.331, lon: -170.710007 },
	PPT: { lat: -17.553699, lon: -149.606995 },
	RMT: { lat: -22.63725, lon: -152.8059 },
	RUR: { lat: -22.434099, lon: -151.360992 },
	TUB: { lat: -23.3654, lon: -149.524002 },
	RVV: { lat: -23.885201, lon: -147.662003 },
	AAA: { lat: -17.3526, lon: -145.509995 },
	FGU: { lat: -15.820044, lon: -140.888071 },
	TIH: { lat: -15.1196, lon: -148.231003 },
	APK: { lat: -15.5736, lon: -146.414993 },
	REA: { lat: -18.46652, lon: -136.43855 },
	FAV: { lat: -16.0541, lon: -145.656998 },
	HHZ: { lat: -17.548297, lon: -142.612037 },
	XMH: { lat: -14.4368, lon: -146.070007 },
	GMR: { lat: -23.079901, lon: -134.889999 },
	KKR: { lat: -15.6633, lon: -146.884995 },
	MKP: { lat: -16.5839, lon: -143.658005 },
	NAU: { lat: -14.177397, lon: -141.266112 },
	TKV: { lat: -17.355226, lon: -138.44734 },
	PKP: { lat: -14.80955, lon: -138.812621 },
	PUK: { lat: -18.295726, lon: -137.016291 },
	TKP: { lat: -14.7095, lon: -145.246002 },
	AXR: { lat: -15.2483, lon: -146.617004 },
	MVT: { lat: -14.8681, lon: -148.716995 },
	NUK: { lat: -19.284613, lon: -138.768367 },
	ZTA: { lat: -20.784262, lon: -138.56796 },
	AHE: { lat: -14.4281, lon: -146.257004 },
	KHZ: { lat: -15.780622, lon: -145.128443 },
	FAC: { lat: -16.68657, lon: -145.329394 },
	FHZ: { lat: -15.992259, lon: -140.164246 },
	RKA: { lat: -15.485673, lon: -145.464778 },
	TJN: { lat: -15.857434, lon: -142.266469 },
	NIU: { lat: -16.119296, lon: -146.368768 },
	RRR: { lat: -16.050485, lon: -142.476568 },
	TKX: { lat: -14.4558, lon: -145.024994 },
	KXU: { lat: -16.339681, lon: -144.407966 },
	NKP: { lat: -20.700054, lon: -143.045933 },
	NHV: { lat: -8.7956, lon: -140.229004 },
	AUQ: { lat: -9.76879, lon: -139.011002 },
	UAP: { lat: -9.35167, lon: -140.078003 },
	UAH: { lat: -8.936228, lon: -139.554062 },
	BOB: { lat: -16.444401, lon: -151.751007 },
	TTI: { lat: -17.015095, lon: -149.589372 },
	RGI: { lat: -14.9543, lon: -147.660995 },
	HUH: { lat: -16.687084, lon: -151.021593 },
	MOZ: { lat: -17.48979, lon: -149.761777 },
	HOI: { lat: -18.0748, lon: -140.945999 },
	MAU: { lat: -16.4265, lon: -152.244003 },
	RFP: { lat: -16.7229, lon: -151.466003 },
	TPX: { lat: -16.2423, lon: -151.8338 },
	UOA: { lat: -21.80978, lon: -138.813385 },
	VHZ: { lat: -18.780697, lon: -138.85568 },
	NUF: { lat: 6.86, lon: 80.584 },
	UCC: { lat: 36.934661, lon: -116.00596 },
	MTV: { lat: -13.666, lon: 167.712006 },
	SLH: { lat: -13.8517, lon: 167.537003 },
	TOH: { lat: -13.328, lon: 166.638 },
	EAE: { lat: -17.0903, lon: 168.343002 },
	CCV: { lat: -16.264999, lon: 167.923996 },
	LOD: { lat: -15.3067, lon: 167.966995 },
	SSR: { lat: -15.4708, lon: 168.151993 },
	PBJ: { lat: -16.431955, lon: 168.235511 },
	LPM: { lat: -16.461123, lon: 167.829253 },
	LNB: { lat: -16.5842, lon: 168.158997 },
	MWF: { lat: -14.997222, lon: 168.081111 },
	LNE: { lat: -15.8656, lon: 168.171997 },
	NUS: { lat: -16.0797, lon: 167.401001 },
	ZGU: { lat: -14.2181, lon: 167.587006 },
	RCL: { lat: -15.472, lon: 167.835007 },
	SON: { lat: -15.505, lon: 167.220001 },
	TGH: { lat: -16.8911, lon: 168.550995 },
	ULB: { lat: -16.3297, lon: 168.3011 },
	VLS: { lat: -16.796101, lon: 168.177002 },
	WLH: { lat: -15.412, lon: 167.690994 },
	SWJ: { lat: -16.4864, lon: 167.4472 },
	OLJ: { lat: -14.8817, lon: 166.557999 },
	AUY: { lat: -20.249142, lon: 169.770758 },
	AWD: { lat: -19.2346, lon: 169.6009 },
	DLY: { lat: -18.7694, lon: 169.001007 },
	FTA: { lat: -19.516399, lon: 170.231995 },
	IPA: { lat: -18.856389, lon: 169.283333 },
	VLI: { lat: -17.699301, lon: 168.320007 },
	TAH: { lat: -19.455099, lon: 169.223999 },
	NWT: { lat: -9.984167, lon: 149.729167 },
	TGJ: { lat: -21.096407, lon: 167.80379 },
	BMY: { lat: -19.720521, lon: 163.661077 },
	KNQ: { lat: -21.053551, lon: 164.838768 },
	ILP: { lat: -22.5889, lon: 167.455994 },
	KOC: { lat: -20.546323, lon: 164.255648 },
	LIF: { lat: -20.774563, lon: 167.239328 },
	GEA: { lat: -22.25812, lon: 166.472783 },
	PUV: { lat: -20.289155, lon: 164.09935 },
	PDC: { lat: -21.316456, lon: 164.999399 },
	MEE: { lat: -21.482438, lon: 168.038465 },
	TOU: { lat: -20.790127, lon: 165.259524 },
	UVE: { lat: -20.640932, lon: 166.573024 },
	NOU: { lat: -22.014601, lon: 166.212997 },
	FGL: { lat: -43.46111, lon: 170.01702 },
	AKL: { lat: -37.01199, lon: 174.786331 },
	TUO: { lat: -38.7397, lon: 176.084 },
	AMZ: { lat: -37.029701, lon: 174.973007 },
	ASG: { lat: -43.903301, lon: 171.796997 },
	CHC: { lat: -43.489029, lon: 172.532065 },
	CHT: { lat: -43.81189, lon: -176.46514 },
	CMV: { lat: -36.791698, lon: 175.509003 },
	DGR: { lat: -35.939304, lon: 173.892862 },
	DUD: { lat: -45.928101, lon: 170.197998 },
	WHO: { lat: -43.363098, lon: 170.134003 },
	GBZ: { lat: -36.241402, lon: 175.472 },
	GMN: { lat: -42.4617, lon: 171.190002 },
	GIS: { lat: -38.6633, lon: 177.977997 },
	GTN: { lat: -43.9067, lon: 170.128006 },
	HKK: { lat: -42.7136, lon: 170.985001 },
	HLZ: { lat: -37.866699, lon: 175.332001 },
	WIK: { lat: -36.808899, lon: 175.085999 },
	KBZ: { lat: -42.424999, lon: 173.604996 },
	KKE: { lat: -35.259148, lon: 173.913317 },
	KKO: { lat: -35.451099, lon: 173.817001 },
	KAT: { lat: -35.069837, lon: 173.287053 },
	ALR: { lat: -45.210495, lon: 169.371113 },
	MTA: { lat: -37.734402, lon: 175.742004 },
	MHB: { lat: -36.846526, lon: 174.787872 },
	MON: { lat: -43.764999, lon: 170.132996 },
	MFN: { lat: -44.673302, lon: 167.923004 },
	MZP: { lat: -41.123299, lon: 172.988998 },
	TEU: { lat: -45.5331, lon: 167.649994 },
	MRO: { lat: -40.974634, lon: 175.63454 },
	NPL: { lat: -39.008598, lon: 174.179001 },
	NPE: { lat: -39.465801, lon: 176.869995 },
	NSN: { lat: -41.298302, lon: 173.220993 },
	IVC: { lat: -46.412399, lon: 168.313004 },
	OHA: { lat: -40.206001, lon: 175.388 },
	OAM: { lat: -44.970001, lon: 171.082001 },
	PMR: { lat: -40.320599, lon: 175.617004 },
	PCN: { lat: -41.3461, lon: 173.955994 },
	PPQ: { lat: -40.904701, lon: 174.988998 },
	ZQN: { lat: -45.021099, lon: 168.738998 },
	RAG: { lat: -37.804699, lon: 174.860001 },
	SZS: { lat: -46.8997, lon: 168.100998 },
	ROT: { lat: -38.1092, lon: 176.317001 },
	TRG: { lat: -37.671902, lon: 176.195999 },
	TMZ: { lat: -37.1567, lon: 175.550003 },
	KTF: { lat: -40.813301, lon: 172.774994 },
	TKZ: { lat: -38.236698, lon: 175.891998 },
	THH: { lat: -38.181099, lon: 174.707993 },
	TIU: { lat: -44.302799, lon: 171.225006 },
	TWZ: { lat: -44.235001, lon: 170.117996 },
	BHE: { lat: -41.518299, lon: 173.869995 },
	WKA: { lat: -44.722954, lon: 169.248419 },
	WHK: { lat: -37.920601, lon: 176.914001 },
	WLG: { lat: -41.327202, lon: 174.804993 },
	WIR: { lat: -39.012118, lon: 177.404395 },
	WRE: { lat: -35.769253, lon: 174.363713 },
	WSZ: { lat: -41.737111, lon: 171.579033 },
	WTZ: { lat: -36.828731, lon: 175.682802 },
	WAG: { lat: -39.963467, lon: 175.02444 },
	NLN: { lat: 40.718639, lon: -123.927298 },
	BZF: { lat: 40.574902, lon: -122.407997 },
	BIN: { lat: 34.808916, lon: 67.816629 },
	BST: { lat: 31.5597, lon: 64.364998 },
	CCN: { lat: 34.526465, lon: 65.27102 },
	SBF: { lat: 33.320702, lon: 68.636497 },
	DWR: { lat: 31.091265, lon: 64.066053 },
	DAZ: { lat: 38.461798, lon: 70.881606 },
	FAH: { lat: 32.366667, lon: 62.165347 },
	FBD: { lat: 37.122148, lon: 70.5201 },
	GZI: { lat: 33.487853, lon: 68.525243 },
	GRG: { lat: 33.627366, lon: 69.237023 },
	KWH: { lat: 37.890021, lon: 70.20383 },
	HEA: { lat: 34.209999, lon: 62.228298 },
	OAI: { lat: 34.946098, lon: 69.264999 },
	JAA: { lat: 34.399799, lon: 70.498596 },
	KBL: { lat: 34.565899, lon: 69.212303 },
	KDH: { lat: 31.5058, lon: 65.847801 },
	KHT: { lat: 33.284605, lon: 69.80734 },
	MMZ: { lat: 35.930801, lon: 64.760902 },
	MZR: { lat: 36.706902, lon: 67.209702 },
	URN: { lat: 32.939933, lon: 69.150064 },
	LQN: { lat: 34.985472, lon: 63.117404 },
	URZ: { lat: 32.903, lon: 66.630898 },
	KUR: { lat: 36.029893, lon: 70.714159 },
	OAS: { lat: 33.12575, lon: 68.838517 },
	OAH: { lat: 33.3913, lon: 62.261002 },
	OAA: { lat: 33.922217, lon: 69.07794 },
	OLR: { lat: 33.3638, lon: 69.9561 },
	SGA: { lat: 37.497642, lon: 71.508484 },
	TII: { lat: 32.604198, lon: 65.865799 },
	TQN: { lat: 36.770699, lon: 69.531998 },
	UND: { lat: 36.6651, lon: 68.910797 },
	OAZ: { lat: 31.848735, lon: 64.223175 },
	ZAJ: { lat: 30.972222, lon: 61.865833 },
	BAH: { lat: 26.267295, lon: 50.63764 },
	OCS: { lat: 0.9125, lon: 9.3304 },
	AHB: { lat: 18.2404, lon: 42.656601 },
	HOF: { lat: 25.285299, lon: 49.485199 },
	ULH: { lat: 26.483333, lon: 38.116944 },
	ABT: { lat: 20.298506, lon: 41.636153 },
	BHH: { lat: 19.9844, lon: 42.620899 },
	DMM: { lat: 26.471201, lon: 49.797901 },
	DWD: { lat: 24.4499, lon: 44.121201 },
	DHA: { lat: 26.2654, lon: 50.152 },
	GIZ: { lat: 16.9011, lon: 42.5858 },
	ELQ: { lat: 26.302799, lon: 43.774399 },
	URY: { lat: 31.412413, lon: 37.278898 },
	HAS: { lat: 27.437901, lon: 41.686298 },
	QJB: { lat: 27.039, lon: 49.405102 },
	JED: { lat: 21.6796, lon: 39.156502 },
	KMC: { lat: 27.9009, lon: 45.528198 },
	KMX: { lat: 18.2973, lon: 42.803501 },
	MED: { lat: 24.5534, lon: 39.705101 },
	EAM: { lat: 17.611401, lon: 44.419201 },
	NUM: { lat: 27.927598, lon: 35.28874 },
	AQI: { lat: 28.335199, lon: 46.125099 },
	AKH: { lat: 24.0627, lon: 47.580502 },
	RAH: { lat: 29.6264, lon: 43.490601 },
	RUH: { lat: 24.9576, lon: 46.698799 },
	RAE: { lat: 30.906601, lon: 41.138199 },
	SHW: { lat: 17.4669, lon: 47.121399 },
	AJF: { lat: 29.785101, lon: 40.099998 },
	SLF: { lat: 20.464701, lon: 45.619598 },
	TUU: { lat: 28.3654, lon: 36.6189 },
	TIF: { lat: 21.483001, lon: 40.543442 },
	TUI: { lat: 31.692188, lon: 38.731544 },
	WAE: { lat: 20.504299, lon: 45.1996 },
	EJH: { lat: 26.198601, lon: 36.476398 },
	YNB: { lat: 24.144199, lon: 38.0634 },
	ZUL: { lat: 26.35, lon: 44.833 },
	OGM: { lat: 9.1383, lon: -77.93385 },
	IAQ: { lat: 29.840099, lon: 50.272701 },
	ABD: { lat: 30.367887, lon: 48.230075 },
	DEF: { lat: 32.434399, lon: 48.397598 },
	AKW: { lat: 30.7444, lon: 49.6772 },
	GCH: { lat: 30.333869, lon: 50.833796 },
	QMJ: { lat: 32.001719, lon: 49.268599 },
	OMI: { lat: 30.835199, lon: 49.534901 },
	MRX: { lat: 30.5562, lon: 49.151901 },
	AWZ: { lat: 31.3374, lon: 48.762001 },
	AEU: { lat: 25.8757, lon: 55.033001 },
	BUZ: { lat: 28.944799, lon: 50.834599 },
	KNR: { lat: 27.820499, lon: 52.3522 },
	KIH: { lat: 26.526199, lon: 53.980202 },
	BDH: { lat: 26.532283, lon: 54.82484 },
	PGU: { lat: 27.379601, lon: 52.737701 },
	KHK: { lat: 29.260503, lon: 50.322193 },
	SXI: { lat: 25.908899, lon: 54.539398 },
	LVP: { lat: 26.810742, lon: 53.354302 },
	KSH: { lat: 34.345901, lon: 47.1581 },
	IIL: { lat: 33.586601, lon: 46.4048 },
	KHD: { lat: 33.435398, lon: 48.282902 },
	SDG: { lat: 35.245899, lon: 47.009201 },
	IFH: { lat: 32.928902, lon: 51.5611 },
	KKS: { lat: 33.895302, lon: 51.577 },
	IFN: { lat: 32.750755, lon: 51.861483 },
	CQD: { lat: 32.297199, lon: 50.842201 },
	RAS: { lat: 37.323333, lon: 49.617778 },
	HDM: { lat: 34.869202, lon: 48.552502 },
	AJK: { lat: 34.1381, lon: 49.847301 },
	NUJ: { lat: 35.211601, lon: 48.6534 },
	IKA: { lat: 35.4161, lon: 51.152199 },
	THR: { lat: 35.689201, lon: 51.3134 },
	GZW: { lat: 36.240101, lon: 50.0471 },
	PYK: { lat: 35.7761, lon: 50.826698 },
	SNX: { lat: 35.591099, lon: 53.495098 },
	BND: { lat: 27.2183, lon: 56.3778 },
	JYR: { lat: 28.723519, lon: 57.675037 },
	KER: { lat: 30.271276, lon: 56.949692 },
	BXR: { lat: 29.0842, lon: 58.450001 },
	HDR: { lat: 27.1583, lon: 56.172501 },
	GSM: { lat: 26.754639, lon: 55.902353 },
	RJN: { lat: 30.298345, lon: 56.048979 },
	SYJ: { lat: 29.5509, lon: 55.672699 },
	XBJ: { lat: 32.896525, lon: 59.281258 },
	CKT: { lat: 36.501202, lon: 61.064899 },
	RUD: { lat: 36.425301, lon: 55.104198 },
	MHD: { lat: 36.235199, lon: 59.640999 },
	BJB: { lat: 37.493, lon: 57.308201 },
	AFZ: { lat: 36.168098, lon: 57.5952 },
	TCX: { lat: 33.667801, lon: 56.8927 },
	KLM: { lat: 37.383301, lon: 55.452 },
	GBT: { lat: 36.909401, lon: 54.401299 },
	BSM: { lat: 36.655102, lon: 52.349602 },
	NSH: { lat: 36.664286, lon: 51.46273 },
	RZR: { lat: 36.90701, lon: 50.687316 },
	SRY: { lat: 36.644408, lon: 53.188761 },
	FAZ: { lat: 28.8918, lon: 53.723301 },
	JAR: { lat: 28.5867, lon: 53.579102 },
	LRR: { lat: 27.6747, lon: 54.383301 },
	LFM: { lat: 27.3727, lon: 53.188801 },
	SYZ: { lat: 29.5392, lon: 52.589802 },
	YES: { lat: 30.702238, lon: 51.542988 },
	KHA: { lat: 36.729096, lon: 45.158084 },
	KHY: { lat: 38.427502, lon: 44.973598 },
	ADU: { lat: 38.325699, lon: 48.4244 },
	ACP: { lat: 37.348, lon: 46.127899 },
	PFQ: { lat: 39.6036, lon: 47.8815 },
	OMH: { lat: 37.668098, lon: 45.068699 },
	TBZ: { lat: 38.1339, lon: 46.235001 },
	IMQ: { lat: 39.191293, lon: 44.928505 },
	JWN: { lat: 36.773701, lon: 48.359402 },
	AZD: { lat: 31.9049, lon: 54.276501 },
	ACZ: { lat: 31.098301, lon: 61.5439 },
	ZBR: { lat: 25.44319, lon: 60.382167 },
	ZAH: { lat: 29.4757, lon: 60.9062 },
	IHR: { lat: 27.236099, lon: 60.720001 },
	JSK: { lat: 25.654757, lon: 57.801718 },
	AMM: { lat: 31.722601, lon: 35.993198 },
	ADJ: { lat: 31.9727, lon: 35.9916 },
	AQJ: { lat: 29.611601, lon: 35.018101 },
	OMF: { lat: 32.3564, lon: 36.259201 },
	XIJ: { lat: 28.934799, lon: 47.791901 },
	KWI: { lat: 29.226601, lon: 47.968899 },
	BEY: { lat: 33.8209, lon: 35.4884 },
	OLH: { lat: 57.218102, lon: -153.270004 },
	KYE: { lat: 34.589298, lon: 36.011299 },
	BYB: { lat: 25.614229, lon: 56.2444 },
	AOM: { lat: 22.491944, lon: 57.383889 },
	DQM: { lat: 19.501944, lon: 57.634167 },
	MNH: { lat: 23.640556, lon: 57.4875 },
	AUH: { lat: 24.443764, lon: 54.651718 },
	AZI: { lat: 24.428301, lon: 54.458099 },
	AAN: { lat: 24.2617, lon: 55.6092 },
	DHF: { lat: 24.248199, lon: 54.547699 },
	XSB: { lat: 24.283611, lon: 52.580278 },
	DXB: { lat: 25.2528, lon: 55.364399 },
	ZDY: { lat: 24.51, lon: 52.3352 },
	NHD: { lat: 25.0268, lon: 55.366199 },
	DWC: { lat: 24.896356, lon: 55.161389 },
	FJR: { lat: 25.1122, lon: 56.324001 },
	RKT: { lat: 25.613501, lon: 55.938801 },
	SHJ: { lat: 25.3286, lon: 55.5172 },
	OMY: { lat: 13.7597, lon: 104.97173 },
	RMB: { lat: 24.241626, lon: 55.783674 },
	FAU: { lat: 22.354759, lon: 56.484146 },
	RNM: { lat: 21.377199, lon: 57.056293 },
	JNJ: { lat: 19.4749, lon: 57.3083 },
	KHS: { lat: 26.171, lon: 56.240601 },
	LKW: { lat: 22.804866, lon: 55.372801 },
	MSH: { lat: 20.6754, lon: 58.890499 },
	MCT: { lat: 23.5933, lon: 58.284401 },
	OMM: { lat: 18.138999, lon: 55.179005 },
	SLL: { lat: 17.0387, lon: 54.091301 },
	OHS: { lat: 24.38604, lon: 56.62541 },
	TTH: { lat: 17.666, lon: 54.024601 },
	KCF: { lat: 27.203205, lon: 69.14884 },
	DDU: { lat: 26.740801, lon: 67.666603 },
	BHW: { lat: 32.056099, lon: 72.948402 },
	BNP: { lat: 32.9729, lon: 70.527901 },
	WGB: { lat: 29.946301, lon: 73.2491 },
	BHV: { lat: 29.348101, lon: 71.718002 },
	CJL: { lat: 35.886213, lon: 71.799922 },
	CHB: { lat: 35.426701, lon: 74.081703 },
	DBA: { lat: 28.8783, lon: 64.399803 },
	DEA: { lat: 29.961, lon: 70.485901 },
	DSK: { lat: 31.909401, lon: 70.896599 },
	LYP: { lat: 31.365, lon: 72.994797 },
	GWD: { lat: 25.296733, lon: 62.498822 },
	GIL: { lat: 35.9188, lon: 74.333603 },
	ISB: { lat: 33.549, lon: 72.82566 },
	JAG: { lat: 28.284201, lon: 68.449699 },
	KHI: { lat: 24.9065, lon: 67.160797 },
	HDD: { lat: 25.3181, lon: 68.366096 },
	KDD: { lat: 27.7906, lon: 66.647301 },
	OHT: { lat: 33.57, lon: 71.440002 },
	LHE: { lat: 31.521601, lon: 74.403603 },
	LRG: { lat: 30.355499, lon: 68.613503 },
	XJM: { lat: 33.050098, lon: 73.638397 },
	MFG: { lat: 34.339001, lon: 73.508598 },
	MWD: { lat: 32.563099, lon: 71.570702 },
	MJD: { lat: 27.335199, lon: 68.143097 },
	MPD: { lat: 25.6828, lon: 69.0728 },
	ATG: { lat: 33.869099, lon: 72.400902 },
	MUX: { lat: 30.203199, lon: 71.419098 },
	WNS: { lat: 26.2194, lon: 68.390099 },
	ORW: { lat: 25.276625, lon: 64.588343 },
	PAJ: { lat: 33.9021, lon: 70.071602 },
	PJG: { lat: 26.9545, lon: 64.1325 },
	PSI: { lat: 25.290501, lon: 63.3451 },
	PEW: { lat: 33.9939, lon: 71.514603 },
	UET: { lat: 30.2514, lon: 66.937798 },
	RYK: { lat: 28.3839, lon: 70.279602 },
	RAZ: { lat: 33.849701, lon: 73.798103 },
	SBQ: { lat: 29.571199, lon: 67.8479 },
	KDU: { lat: 35.335499, lon: 75.536003 },
	SKZ: { lat: 27.722, lon: 68.791702 },
	SYW: { lat: 26.473101, lon: 67.717201 },
	SGI: { lat: 32.048599, lon: 72.665001 },
	SDT: { lat: 34.813599, lon: 72.352798 },
	SKT: { lat: 32.535557, lon: 74.363892 },
	SUL: { lat: 28.6451, lon: 69.176903 },
	RZS: { lat: 26.9662, lon: 68.878098 },
	TLB: { lat: 33.986099, lon: 72.611397 },
	BDN: { lat: 24.841499, lon: 68.838402 },
	TFT: { lat: 28.964199, lon: 61.595402 },
	TUK: { lat: 25.986401, lon: 63.030201 },
	WAF: { lat: 32.304699, lon: 69.570396 },
	PZH: { lat: 31.3584, lon: 69.4636 },
	IQA: { lat: 33.785599, lon: 42.4412 },
	TQD: { lat: 33.3381, lon: 43.597099 },
	BMN: { lat: 37.098801, lon: 43.266602 },
	BGW: { lat: 33.262501, lon: 44.2346 },
	OSM: { lat: 36.305801, lon: 43.1474 },
	EBL: { lat: 36.237598, lon: 43.9632 },
	ORI: { lat: 57.884905, lon: -152.847719 },
	KIK: { lat: 35.469501, lon: 44.3489 },
	BSR: { lat: 30.549101, lon: 47.662102 },
	NJF: { lat: 31.989853, lon: 44.404317 },
	RQW: { lat: 35.7672, lon: 43.125099 },
	ISU: { lat: 35.561749, lon: 45.316738 },
	XNH: { lat: 30.935801, lon: 46.090099 },
	ALP: { lat: 36.180698, lon: 37.2244 },
	DAM: { lat: 33.411499, lon: 36.515598 },
	DEZ: { lat: 35.2854, lon: 40.175999 },
	KAC: { lat: 37.020599, lon: 41.191399 },
	LTK: { lat: 35.4011, lon: 35.9487 },
	PMS: { lat: 34.5574, lon: 38.316898 },
	DIA: { lat: 25.261101, lon: 51.565102 },
	XJD: { lat: 25.1173, lon: 51.314999 },
	DOH: { lat: 25.273056, lon: 51.608056 },
	OTT: { lat: -9.898611, lon: -58.581944 },
	OUM: { lat: 13.278244, lon: 19.710256 },
	OXO: { lat: -28.0598, lon: 141.5361 },
	ADE: { lat: 12.8295, lon: 45.028801 },
	EAB: { lat: 16.010983, lon: 43.176771 },
	AXK: { lat: 14.5513, lon: 46.826199 },
	BYD: { lat: 14.105974, lon: 45.441079 },
	BHN: { lat: 14.781714, lon: 45.719703 },
	BUK: { lat: 17.350352, lon: 44.625542 },
	AAY: { lat: 16.193341, lon: 52.174186 },
	KAM: { lat: 15.368755, lon: 42.612515 },
	MYN: { lat: 15.469228, lon: 45.327272 },
	UKR: { lat: 13.9368, lon: 45.657 },
	IHN: { lat: 15.417, lon: 51.682999 },
	RIY: { lat: 14.6626, lon: 49.375 },
	SYE: { lat: 16.967542, lon: 43.728103 },
	SAH: { lat: 15.4763, lon: 44.2197 },
	SCT: { lat: 12.6307, lon: 53.9058 },
	GXF: { lat: 15.9661, lon: 48.7883 },
	TAI: { lat: 13.686, lon: 44.139099 },
	ACU: { lat: 9.188481, lon: -77.994153 },
	AIL: { lat: 9.2226, lon: -78.0236 },
	CTE: { lat: 9.452863, lon: -78.978917 },
	MPP: { lat: 8.945487, lon: -77.733486 },
	PYC: { lat: 9.30692, lon: -78.235273 },
	NMG: { lat: 8.456507, lon: -78.934214 },
	TUW: { lat: 8.918601, lon: -77.709182 },
	PYV: { lat: 8.1528, lon: -77.687 },
	AML: { lat: 8.267667, lon: -82.864537 },
	BFQ: { lat: 7.58737, lon: -78.179939 },
	ELE: { lat: 8.107235, lon: -77.725545 },
	OTD: { lat: 8.62876, lon: -79.034698 },
	SAX: { lat: 8.026279, lon: -78.209555 },
	AKB: { lat: 52.220299, lon: -174.205994 },
	PML: { lat: 56.006001, lon: -160.561005 },
	PTD: { lat: 56.246799, lon: -134.647995 },
	PAQ: { lat: 61.594898, lon: -149.08901 },
	ATU: { lat: 52.829797, lon: 173.173796 },
	BTI: { lat: 70.134003, lon: -143.582001 },
	BET: { lat: 60.7798, lon: -161.837997 },
	BVU: { lat: 61.172199, lon: -151.044006 },
	BIG: { lat: 63.994499, lon: -145.722 },
	BKC: { lat: 65.981598, lon: -161.149002 },
	BMX: { lat: 59.362274, lon: -155.260148 },
	BRW: { lat: 71.285402, lon: -156.766008 },
	BTT: { lat: 66.913902, lon: -151.529007 },
	CDB: { lat: 55.207871, lon: -162.725029 },
	CEM: { lat: 65.573815, lon: -144.780707 },
	CIK: { lat: 66.644997, lon: -143.740005 },
	CYF: { lat: 60.136667, lon: -164.279167 },
	SCM: { lat: 61.84471, lon: -165.575209 },
	IRC: { lat: 65.827673, lon: -144.076195 },
	WSF: { lat: 54.583934, lon: -164.905727 },
	CDV: { lat: 60.491798, lon: -145.477997 },
	CXF: { lat: 67.252197, lon: -150.203995 },
	CYT: { lat: 60.080974, lon: -142.494541 },
	CZF: { lat: 61.7803, lon: -166.039002 },
	DRG: { lat: 66.068901, lon: -162.766914 },
	RDB: { lat: 68.032097, lon: -162.899002 },
	ADK: { lat: 51.883564, lon: -176.642783 },
	DLG: { lat: 59.044701, lon: -158.505005 },
	MLL: { lat: 61.8643, lon: -162.026001 },
	ADQ: { lat: 57.75, lon: -152.494003 },
	DUT: { lat: 53.89881, lon: -166.544996 },
	KKH: { lat: 59.9608, lon: -162.880997 },
	EDF: { lat: 61.251709, lon: -149.807097 },
	EEK: { lat: 60.213173, lon: -162.044048 },
	EAA: { lat: 64.778003, lon: -141.150455 },
	EHM: { lat: 58.6464, lon: -162.063004 },
	EIL: { lat: 64.665703, lon: -147.102005 },
	ELV: { lat: 58.195202, lon: -136.347 },
	EMK: { lat: 62.786098, lon: -164.490997 },
	ENA: { lat: 60.570946, lon: -151.245174 },
	WWT: { lat: 60.81037, lon: -164.499511 },
	FAI: { lat: 64.815102, lon: -147.856003 },
	FBK: { lat: 64.837502, lon: -147.613998 },
	ABL: { lat: 67.105529, lon: -157.855339 },
	FRN: { lat: 61.266399, lon: -149.653 },
	NIB: { lat: 63.017949, lon: -154.360399 },
	GAL: { lat: 64.736198, lon: -156.936997 },
	GBH: { lat: 68.479698, lon: -149.490005 },
	KWK: { lat: 59.876499, lon: -163.169005 },
	SHG: { lat: 66.8881, lon: -157.162003 },
	GKN: { lat: 62.155859, lon: -145.454662 },
	GLV: { lat: 64.550499, lon: -163.007004 },
	GAM: { lat: 63.767694, lon: -171.733303 },
	AGN: { lat: 57.497097, lon: -134.56722 },
	BGQ: { lat: 61.534658, lon: -149.812936 },
	GST: { lat: 58.425301, lon: -135.707001 },
	NME: { lat: 60.469129, lon: -164.70407 },
	SGY: { lat: 59.460343, lon: -135.316651 },
	GMT: { lat: 65.4021, lon: -161.281006 },
	HCR: { lat: 62.188301, lon: -159.774994 },
	HSL: { lat: 65.697899, lon: -156.350998 },
	HNS: { lat: 59.243921, lon: -135.523925 },
	HOM: { lat: 59.644456, lon: -151.479235 },
	HPB: { lat: 61.523899, lon: -166.147003 },
	HUS: { lat: 66.0411, lon: -154.263001 },
	SHX: { lat: 62.692144, lon: -159.569035 },
	HYG: { lat: 55.205227, lon: -132.830286 },
	IGG: { lat: 59.324001, lon: -155.901993 },
	EGX: { lat: 58.184386, lon: -157.374873 },
	IAN: { lat: 66.976128, lon: -160.439014 },
	ILI: { lat: 59.754398, lon: -154.910996 },
	UTO: { lat: 65.992798, lon: -153.703995 },
	MCL: { lat: 63.732465, lon: -148.911266 },
	WAA: { lat: 65.622593, lon: -168.095 },
	KCG: { lat: 56.311501, lon: -158.373001 },
	JNU: { lat: 58.355, lon: -134.576004 },
	KGK: { lat: 59.726601, lon: -157.259003 },
	KDK: { lat: 57.806151, lon: -152.373693 },
	KFP: { lat: 54.84751, lon: -163.407168 },
	AKK: { lat: 56.938702, lon: -154.182999 },
	KPN: { lat: 59.931796, lon: -164.028196 },
	KKA: { lat: 64.939499, lon: -161.154007 },
	LKK: { lat: 58.982101, lon: -155.121002 },
	AKN: { lat: 58.677845, lon: -156.651965 },
	IKO: { lat: 52.941552, lon: -168.849478 },
	AKP: { lat: 68.133598, lon: -151.742996 },
	KTN: { lat: 55.355598, lon: -131.714005 },
	UUK: { lat: 70.330803, lon: -149.598007 },
	KAL: { lat: 64.31864, lon: -158.74197 },
	KLW: { lat: 55.579201, lon: -133.076004 },
	KYK: { lat: 57.565919, lon: -154.453762 },
	KLN: { lat: 57.53516, lon: -153.976455 },
	KLG: { lat: 61.536301, lon: -160.341003 },
	PTA: { lat: 60.201681, lon: -154.325863 },
	LNI: { lat: 70.911118, lon: -153.237766 },
	WCR: { lat: 67.504501, lon: -148.483002 },
	LUR: { lat: 68.875099, lon: -166.110001 },
	KMO: { lat: 58.932056, lon: -158.901886 },
	MCG: { lat: 62.9529, lon: -155.606003 },
	MDO: { lat: 59.449902, lon: -146.307007 },
	LMA: { lat: 63.886002, lon: -152.302002 },
	SMK: { lat: 63.490101, lon: -162.110001 },
	MLY: { lat: 64.99188, lon: -150.644102 },
	MTM: { lat: 55.131001, lon: -131.578003 },
	MOU: { lat: 62.095402, lon: -163.682007 },
	MRI: { lat: 61.212792, lon: -149.843988 },
	MXY: { lat: 61.437099, lon: -142.904007 },
	MYU: { lat: 60.372338, lon: -166.269751 },
	WNA: { lat: 60.6903, lon: -161.979004 },
	ANC: { lat: 61.179004, lon: -149.992561 },
	ANI: { lat: 61.5816, lon: -159.542999 },
	ENN: { lat: 64.548772, lon: -149.074516 },
	NNL: { lat: 59.980202, lon: -154.839005 },
	FNR: { lat: 58.254398, lon: -134.897995 },
	ANN: { lat: 55.037663, lon: -131.572609 },
	NUL: { lat: 64.729301, lon: -158.074005 },
	ANV: { lat: 62.646702, lon: -160.190994 },
	KNW: { lat: 59.451838, lon: -157.373829 },
	OBU: { lat: 66.9123, lon: -156.897003 },
	PCA: { lat: 58.9065, lon: -157.714 },
	HNH: { lat: 58.0961, lon: -135.410111 },
	OME: { lat: 64.512199, lon: -165.445007 },
	OOK: { lat: 60.541401, lon: -165.087006 },
	ORT: { lat: 62.9613, lon: -141.929001 },
	OTZ: { lat: 66.884697, lon: -162.598999 },
	NLG: { lat: 56.0075, lon: -161.160004 },
	STG: { lat: 56.577345, lon: -169.663823 },
	KPC: { lat: 65.2537, lon: -166.858994 },
	KPV: { lat: 55.9065, lon: -159.16091 },
	PSG: { lat: 56.801701, lon: -132.945007 },
	PTH: { lat: 56.957893, lon: -158.630219 },
	PKA: { lat: 60.7029, lon: -161.778 },
	PTU: { lat: 59.017675, lon: -161.827927 },
	PIP: { lat: 57.580399, lon: -157.572006 },
	PHO: { lat: 68.348801, lon: -166.798996 },
	PPC: { lat: 66.814102, lon: -150.643997 },
	KWN: { lat: 59.7551, lon: -161.845 },
	NUI: { lat: 70.209999, lon: -151.005998 },
	ARC: { lat: 68.1147, lon: -145.578995 },
	RSH: { lat: 61.775071, lon: -161.319466 },
	RBY: { lat: 64.727203, lon: -155.470001 },
	SVA: { lat: 63.686401, lon: -170.492996 },
	SCC: { lat: 70.194702, lon: -148.464996 },
	SDP: { lat: 55.313908, lon: -160.522099 },
	SHH: { lat: 66.249604, lon: -166.089112 },
	SIT: { lat: 57.0471, lon: -135.362 },
	WLK: { lat: 66.600098, lon: -159.985992 },
	SLQ: { lat: 61.7005, lon: -157.166 },
	KSM: { lat: 62.060501, lon: -163.302002 },
	SNP: { lat: 57.166311, lon: -170.222555 },
	SOV: { lat: 59.442981, lon: -151.705227 },
	SMU: { lat: 61.812, lon: -147.507004 },
	UMM: { lat: 63.331501, lon: -149.126999 },
	SVW: { lat: 61.097401, lon: -155.574005 },
	SKW: { lat: 61.965302, lon: -151.190994 },
	SXQ: { lat: 60.474935, lon: -151.038471 },
	SYA: { lat: 52.712299, lon: 174.113998 },
	TAL: { lat: 65.1744, lon: -152.108994 },
	TNC: { lat: 65.563103, lon: -167.921997 },
	TLA: { lat: 65.240402, lon: -166.339005 },
	TOG: { lat: 59.052799, lon: -160.397003 },
	TKA: { lat: 62.320499, lon: -150.093994 },
	TLJ: { lat: 62.894402, lon: -155.977005 },
	ATK: { lat: 70.46704, lon: -157.436013 },
	AUK: { lat: 62.682653, lon: -164.722481 },
	UMT: { lat: 69.371101, lon: -152.136002 },
	UNK: { lat: 63.888401, lon: -160.798996 },
	WOW: { lat: 61.7542, lon: -150.052002 },
	KQA: { lat: 54.14459, lon: -165.604332 },
	VAK: { lat: 61.5409, lon: -165.6005 },
	KVC: { lat: 55.116299, lon: -162.266006 },
	VDZ: { lat: 61.132712, lon: -146.246567 },
	VEE: { lat: 67.008698, lon: -146.365997 },
	KVL: { lat: 67.734565, lon: -164.559917 },
	WBQ: { lat: 66.362198, lon: -147.406998 },
	SWD: { lat: 60.130478, lon: -149.418612 },
	WRG: { lat: 56.484299, lon: -132.369995 },
	AIN: { lat: 70.638, lon: -159.994995 },
	WMO: { lat: 64.689201, lon: -163.412994 },
	WTK: { lat: 67.561241, lon: -162.980461 },
	WWA: { lat: 61.571701, lon: -149.539993 },
	YAK: { lat: 59.508717, lon: -139.660435 },
	CIS: { lat: -2.76812, lon: -171.710007 },
	PCQ: { lat: 21.6475, lon: 101.9 },
	PDR: { lat: -5.3098, lon: -44.481 },
	PTL: { lat: -4.08687, lon: -81.02577 },
	BLP: { lat: -7.06056, lon: -76.582199 },
	PEB: { lat: -17.27276, lon: 38.18073 },
	PEC: { lat: 57.9552, lon: -136.235992 },
	AKI: { lat: 60.902646, lon: -161.23106 },
	AET: { lat: 66.551804, lon: -152.621994 },
	NCN: { lat: 60.077602, lon: -147.99468 },
	CLP: { lat: 58.833698, lon: -158.529007 },
	ELI: { lat: 64.6147, lon: -162.272003 },
	KUK: { lat: 60.872747, lon: -162.5247 },
	KNK: { lat: 59.433248, lon: -154.80217 },
	KOT: { lat: 63.030602, lon: -163.533005 },
	KTS: { lat: 65.331826, lon: -166.467848 },
	KYU: { lat: 64.876099, lon: -157.727005 },
	KWT: { lat: 60.790298, lon: -161.444 },
	ORV: { lat: 66.817902, lon: -161.018997 },
	SKK: { lat: 64.371101, lon: -161.223999 },
	TKJ: { lat: 63.329498, lon: -142.953995 },
	WSN: { lat: 58.702362, lon: -157.005444 },
	FYU: { lat: 66.571651, lon: -145.249987 },
	CPN: { lat: -10.179823, lon: 148.37903 },
	ESA: { lat: -9.874327, lon: 150.954208 },
	MZN: { lat: -5.902962, lon: 144.686586 },
	SMP: { lat: -4.35, lon: 151.55 },
	BRH: { lat: -5.741032, lon: 145.378518 },
	BIJ: { lat: -5.577463, lon: 146.33401 },
	TAJ: { lat: -3.198192, lon: 142.430964 },
	IHU: { lat: -7.89756, lon: 145.395996 },
	JAQ: { lat: -5.6525, lon: 151.507004 },
	KUY: { lat: -7.420347, lon: 143.121811 },
	LMY: { lat: -7.00992, lon: 141.494003 },
	ULE: { lat: -4.97472, lon: 151.296997 },
	PGE: { lat: -7.134444, lon: 146.156389 },
	PGM: { lat: 59.348355, lon: -151.830025 },
	ROP: { lat: 14.1743, lon: 145.242996 },
	SPN: { lat: 15.119, lon: 145.729004 },
	UAM: { lat: 13.584, lon: 144.929998 },
	GUM: { lat: 13.485, lon: 144.797282 },
	TIQ: { lat: 14.998101, lon: 145.61923 },
	TGB: { lat: 8.71491, lon: 117.35259 },
	BKH: { lat: 22.0228, lon: -159.785004 },
	HDH: { lat: 21.5795, lon: -158.197006 },
	HHI: { lat: 21.481637, lon: -158.037048 },
	HNM: { lat: 20.795601, lon: -156.014008 },
	JHM: { lat: 20.9629, lon: -156.673004 },
	JRF: { lat: 21.3074, lon: -158.070009 },
	KOA: { lat: 19.738783, lon: -156.045603 },
	LIH: { lat: 21.976, lon: -159.339005 },
	LUP: { lat: 21.211, lon: -156.973999 },
	MKK: { lat: 21.152901, lon: -157.095993 },
	MUE: { lat: 20.001301, lon: -155.667999 },
	NGF: { lat: 21.4505, lon: -157.768005 },
	HNL: { lat: 21.32062, lon: -157.924228 },
	LNY: { lat: 20.785675, lon: -156.951324 },
	OGG: { lat: 20.896263, lon: -156.431837 },
	PAK: { lat: 21.8969, lon: -159.602997 },
	BSF: { lat: 19.760099, lon: -155.554001 },
	ITO: { lat: 19.721399, lon: -155.048004 },
	UPP: { lat: 20.265301, lon: -155.860001 },
	JIW: { lat: 25.067801, lon: 61.805401 },
	BHC: { lat: 33.960999, lon: 73.452003 },
	CWP: { lat: 33.766701, lon: 72.366898 },
	GRT: { lat: 32.62826, lon: 74.067287 },
	REQ: { lat: 29.04692, lon: 62.196819 },
	ENT: { lat: 11.3407, lon: 162.328003 },
	MAJ: { lat: 7.06476, lon: 171.272003 },
	KWA: { lat: 8.72012, lon: 167.731995 },
	CXI: { lat: 1.986278, lon: -157.350011 },
	TNV: { lat: 3.89944, lon: -159.389008 },
	TNQ: { lat: 4.698359, lon: -160.394376 },
	MDY: { lat: 28.2017, lon: -177.380997 },
	PIZ: { lat: 69.732903, lon: -163.005005 },
	PPX: { lat: -9.99, lon: 149.477 },
	PQD: { lat: 7.923107, lon: 81.567736 },
	HUC: { lat: 18.138082, lon: -65.800728 },
	XSO: { lat: 7.710035, lon: 122.161989 },
	TKK: { lat: 7.46187, lon: 151.843002 },
	PNI: { lat: 6.9851, lon: 158.209 },
	ROR: { lat: 7.36731, lon: 134.544236 },
	KSA: { lat: 5.35698, lon: 162.957993 },
	YAP: { lat: 9.49891, lon: 138.082993 },
	PUA: { lat: -2.395, lon: 150.2361 },
	AWK: { lat: 19.282437, lon: 166.636637 },
	PWR: { lat: 56.381001, lon: -134.651001 },
	PBT: { lat: -20.9046, lon: -57.927101 },
	PCJ: { lat: -22.289298, lon: -57.860484 },
	PYL: { lat: 60.685299, lon: -147.919006 },
	KIO: { lat: 5.64386, lon: 169.124586 },
	QFX: { lat: 60.99229, lon: -45.431428 },
	QJP: { lat: 37.864555, lon: 127.176633 },
	RAA: { lat: -4.2096, lon: 152.4385 },
	RAW: { lat: -6.220556, lon: 155.571389 },
	KNH: { lat: 24.4279, lon: 118.359001 },
	CMJ: { lat: 23.213127, lon: 119.417539 },
	LZN: { lat: 26.159656, lon: 119.958376 },
	TTT: { lat: 22.754999, lon: 121.101997 },
	GNI: { lat: 22.673901, lon: 121.466003 },
	KHH: { lat: 22.577101, lon: 120.349998 },
	CYI: { lat: 23.462577, lon: 120.390544 },
	HCN: { lat: 22.0411, lon: 120.730003 },
	DSX: { lat: 20.7066, lon: 116.721001 },
	KYD: { lat: 22.027, lon: 121.535004 },
	RMQ: { lat: 24.2647, lon: 120.621002 },
	MFK: { lat: 26.224199, lon: 120.002998 },
	TNN: { lat: 22.950399, lon: 120.206001 },
	HSZ: { lat: 24.818001, lon: 120.939003 },
	MZG: { lat: 23.568701, lon: 119.627998 },
	PIF: { lat: 22.700199, lon: 120.482002 },
	TSA: { lat: 25.069401, lon: 121.552002 },
	TPE: { lat: 25.0777, lon: 121.233002 },
	WOT: { lat: 23.369108, lon: 119.503598 },
	HUN: { lat: 24.0231, lon: 121.617996 },
	RDV: { lat: 61.788101, lon: -157.350006 },
	RHT: { lat: 39.225, lon: 101.546 },
	NRT: { lat: 35.764702, lon: 140.386002 },
	MMJ: { lat: 36.166801, lon: 137.923004 },
	IBR: { lat: 36.181099, lon: 140.414993 },
	MUS: { lat: 24.2897, lon: 153.979004 },
	IWO: { lat: 24.784153, lon: 141.32261 },
	KIX: { lat: 34.427299, lon: 135.244003 },
	SHM: { lat: 33.662201, lon: 135.363998 },
	UKB: { lat: 34.632801, lon: 135.223999 },
	HIW: { lat: 34.371451, lon: 132.417666 },
	TJH: { lat: 35.512798, lon: 134.787003 },
	OBO: { lat: 42.733299, lon: 143.216995 },
	CTS: { lat: 42.7752, lon: 141.692001 },
	HKD: { lat: 41.77, lon: 140.822006 },
	KUH: { lat: 43.041, lon: 144.192993 },
	MMB: { lat: 43.8806, lon: 144.164001 },
	SHB: { lat: 43.577499, lon: 144.960007 },
	OKD: { lat: 43.117447, lon: 141.38134 },
	RBJ: { lat: 45.455002, lon: 141.039001 },
	WKJ: { lat: 45.404202, lon: 141.800995 },
	AXJ: { lat: 32.482498, lon: 130.158997 },
	IKI: { lat: 33.749001, lon: 129.785004 },
	UBJ: { lat: 33.93, lon: 131.279007 },
	TSJ: { lat: 34.284901, lon: 129.330994 },
	OMJ: { lat: 32.928046, lon: 129.934168 },
	MBE: { lat: 44.303902, lon: 143.404007 },
	AKJ: { lat: 43.670799, lon: 142.447006 },
	OIR: { lat: 42.071701, lon: 139.432999 },
	RIS: { lat: 45.242001, lon: 141.186005 },
	KUM: { lat: 30.385599, lon: 130.658997 },
	FUJ: { lat: 32.666302, lon: 128.832993 },
	FUK: { lat: 33.585899, lon: 130.451004 },
	TNE: { lat: 30.605101, lon: 130.990997 },
	KOJ: { lat: 31.8034, lon: 130.718994 },
	KMI: { lat: 31.877199, lon: 131.449005 },
	OIT: { lat: 33.479401, lon: 131.737 },
	KKJ: { lat: 33.845901, lon: 131.035004 },
	HSG: { lat: 33.1497, lon: 130.302002 },
	KMJ: { lat: 32.837299, lon: 130.854996 },
	NGS: { lat: 32.916901, lon: 129.914001 },
	NGO: { lat: 34.858398, lon: 136.804993 },
	ASJ: { lat: 28.430599, lon: 129.712997 },
	OKE: { lat: 27.431604, lon: 128.705564 },
	KKX: { lat: 28.321301, lon: 129.927994 },
	TKN: { lat: 27.836382, lon: 128.881356 },
	NKM: { lat: 35.255759, lon: 136.924095 },
	FKJ: { lat: 36.142799, lon: 136.223999 },
	QGU: { lat: 35.3941, lon: 136.869995 },
	KMQ: { lat: 36.3946, lon: 136.406998 },
	OKI: { lat: 36.178388, lon: 133.323566 },
	FSZ: { lat: 34.796043, lon: 138.187752 },
	TOY: { lat: 36.6483, lon: 137.188004 },
	NTQ: { lat: 37.293098, lon: 136.962006 },
	HIJ: { lat: 34.4361, lon: 132.919006 },
	OKJ: { lat: 34.756901, lon: 133.854996 },
	IZO: { lat: 35.413601, lon: 132.889999 },
	YGJ: { lat: 35.492199, lon: 133.235992 },
	IWK: { lat: 34.146333, lon: 132.247238 },
	KCZ: { lat: 33.546101, lon: 133.669006 },
	MYJ: { lat: 33.827202, lon: 132.699997 },
	ITM: { lat: 34.7855, lon: 135.438004 },
	TTJ: { lat: 35.530102, lon: 134.167007 },
	TKS: { lat: 34.132801, lon: 134.606995 },
	TAK: { lat: 34.214199, lon: 134.016006 },
	IWJ: { lat: 34.676399, lon: 131.789993 },
	AOJ: { lat: 40.734699, lon: 140.690994 },
	GAJ: { lat: 38.4119, lon: 140.371002 },
	SDS: { lat: 38.0602, lon: 138.414001 },
	FKS: { lat: 37.227402, lon: 140.431 },
	HHE: { lat: 40.551181, lon: 141.465428 },
	HNA: { lat: 39.4286, lon: 141.134995 },
	AXT: { lat: 39.615601, lon: 140.218994 },
	MSJ: { lat: 40.703201, lon: 141.367996 },
	KIJ: { lat: 37.955898, lon: 139.121002 },
	ONJ: { lat: 40.191898, lon: 140.371002 },
	SDJ: { lat: 38.139702, lon: 140.917007 },
	SYO: { lat: 38.812199, lon: 139.787003 },
	NJA: { lat: 35.454601, lon: 139.449997 },
	HAC: { lat: 33.115002, lon: 139.785995 },
	OIM: { lat: 34.782001, lon: 139.360001 },
	MYE: { lat: 34.073601, lon: 139.559998 },
	HND: { lat: 35.552299, lon: 139.779999 },
	OKO: { lat: 35.748501, lon: 139.348007 },
	MWX: { lat: 34.991406, lon: 126.382814 },
	KWJ: { lat: 35.123173, lon: 126.805444 },
	KUV: { lat: 35.903801, lon: 126.615997 },
	CHN: { lat: 35.878289, lon: 127.11894 },
	RSU: { lat: 34.8423, lon: 127.616997 },
	KAG: { lat: 37.753601, lon: 128.943915 },
	WJU: { lat: 37.437113, lon: 127.960051 },
	YNY: { lat: 38.061298, lon: 128.669006 },
	CJU: { lat: 33.512058, lon: 126.492548 },
	JDG: { lat: 33.399601, lon: 126.711998 },
	CHF: { lat: 35.140248, lon: 128.696229 },
	PUS: { lat: 35.179501, lon: 128.938004 },
	HIN: { lat: 35.088591, lon: 128.071747 },
	USN: { lat: 35.593498, lon: 129.352005 },
	ICN: { lat: 37.469101, lon: 126.450996 },
	SSN: { lat: 37.444744, lon: 127.112718 },
	OSN: { lat: 37.091457, lon: 127.029448 },
	GMP: { lat: 37.5583, lon: 126.791 },
	SWU: { lat: 37.239399, lon: 127.007004 },
	QDY: { lat: 36.593781, lon: 126.29662 },
	KPO: { lat: 35.987955, lon: 129.420383 },
	JWO: { lat: 37.03024, lon: 127.886353 },
	UJN: { lat: 36.777049, lon: 129.461861 },
	TAE: { lat: 35.896872, lon: 128.65531 },
	HMY: { lat: 36.703999, lon: 126.486 },
	CJJ: { lat: 36.717008, lon: 127.498741 },
	YEC: { lat: 36.630373, lon: 128.34971 },
	RKY: { lat: -13.6434, lon: 142.641 },
	RLP: { lat: -18.4253, lon: 144.4587 },
	RMP: { lat: 65.507896, lon: -150.141007 },
	OKA: { lat: 26.195801, lon: 127.646004 },
	DNA: { lat: 26.351667, lon: 127.769444 },
	ISG: { lat: 24.396389, lon: 124.245 },
	UEO: { lat: 26.363445, lon: 126.71384 },
	KJP: { lat: 26.168337, lon: 127.293423 },
	MMD: { lat: 25.8465, lon: 131.263 },
	MMY: { lat: 24.782801, lon: 125.294998 },
	AGJ: { lat: 26.592755, lon: 127.240335 },
	IEJ: { lat: 26.722537, lon: 127.786801 },
	HTR: { lat: 24.059751, lon: 123.80558 },
	KTD: { lat: 25.9447, lon: 131.326996 },
	SHI: { lat: 24.8267, lon: 125.144997 },
	TRA: { lat: 24.653793, lon: 124.675453 },
	RNJ: { lat: 27.043847, lon: 128.401648 },
	OGN: { lat: 24.467298, lon: 122.979827 },
	ENI: { lat: 11.202399, lon: 119.416087 },
	SFS: { lat: 14.7944, lon: 120.271004 },
	CRK: { lat: 15.186, lon: 120.559998 },
	BSI: { lat: 14.418624, lon: 122.03923 },
	LLC: { lat: 18.182388, lon: 121.745853 },
	LAO: { lat: 18.176121, lon: 120.531034 },
	DRP: { lat: 13.111915, lon: 123.676829 },
	MNL: { lat: 14.5086, lon: 121.019997 },
	CYU: { lat: 10.8581, lon: 121.069 },
	SGL: { lat: 14.4954, lon: 120.903999 },
	LBX: { lat: 13.8554, lon: 120.105003 },
	AAV: { lat: 6.367903, lon: 124.752431 },
	CBO: { lat: 7.164753, lon: 124.209938 },
	DVO: { lat: 7.12552, lon: 125.646004 },
	BXU: { lat: 8.9515, lon: 125.4788 },
	BPH: { lat: 8.195052, lon: 126.321015 },
	DPL: { lat: 8.601983, lon: 123.341875 },
	CGM: { lat: 9.253894, lon: 124.709115 },
	IGN: { lat: 8.13049, lon: 124.214996 },
	JOL: { lat: 6.05367, lon: 121.011002 },
	MLP: { lat: 7.616911, lon: 124.057961 },
	TWT: { lat: 5.048196, lon: 119.743338 },
	OZC: { lat: 8.17851, lon: 123.842003 },
	PAG: { lat: 7.825632, lon: 123.459635 },
	MXI: { lat: 6.949091, lon: 126.27368 },
	GES: { lat: 6.058, lon: 125.096001 },
	SUG: { lat: 9.755838, lon: 125.480947 },
	CDY: { lat: 7.014, lon: 118.496002 },
	IPE: { lat: 7.784898, lon: 122.6015 },
	TDG: { lat: 9.072002, lon: 126.17132 },
	CGY: { lat: 8.612203, lon: 124.456496 },
	ZAM: { lat: 6.92242, lon: 122.059998 },
	IAO: { lat: 9.8591, lon: 126.014 },
	RZP: { lat: 11.05065, lon: 119.519266 },
	TAG: { lat: 9.573045, lon: 123.770143 },
	SWL: { lat: 10.524298, lon: 119.272899 },
	BAG: { lat: 16.375034, lon: 120.619949 },
	DTE: { lat: 14.1292, lon: 122.980003 },
	SJI: { lat: 12.3615, lon: 121.046997 },
	MBO: { lat: 13.208048, lon: 120.605457 },
	WNP: { lat: 13.5849, lon: 123.269997 },
	BSO: { lat: 20.4513, lon: 121.980003 },
	BQA: { lat: 15.729309, lon: 121.500034 },
	SFE: { lat: 16.5956, lon: 120.303001 },
	TUG: { lat: 17.643368, lon: 121.73315 },
	VRC: { lat: 13.5764, lon: 124.206001 },
	MRQ: { lat: 13.361, lon: 121.825996 },
	CYZ: { lat: 16.929899, lon: 121.752998 },
	RPV: { lat: -14.9215, lon: 134.05 },
	TAC: { lat: 11.227761, lon: 125.027783 },
	BCD: { lat: 10.7764, lon: 123.014999 },
	CYP: { lat: 12.072574, lon: 124.54508 },
	DGT: { lat: 9.334183, lon: 123.30191 },
	MPH: { lat: 11.9245, lon: 121.954002 },
	CRM: { lat: 12.50161, lon: 124.635258 },
	ILO: { lat: 10.833017, lon: 122.493358 },
	MBT: { lat: 12.369682, lon: 123.630095 },
	KLO: { lat: 11.6794, lon: 122.375999 },
	CEB: { lat: 10.309261, lon: 123.97974 },
	OMC: { lat: 11.057715, lon: 124.565622 },
	PPS: { lat: 9.74212, lon: 118.759003 },
	RXS: { lat: 11.5977, lon: 122.751999 },
	EUQ: { lat: 10.766644, lon: 121.932506 },
	TBH: { lat: 12.311, lon: 122.084999 },
	USU: { lat: 12.121865, lon: 120.100801 },
	BPA: { lat: 11.674262, lon: 125.479259 },
	RRM: { lat: -18.319259, lon: 35.949501 },
	RSE: { lat: -33.869, lon: 151.262 },
	RSI: { lat: 25.627975, lon: 37.088914 },
	TKM: { lat: 56.361668, lon: 114.93 },
	NOI: { lat: 44.962905, lon: 37.999071 },
	MJY: { lat: 58.180921, lon: 94.745272 },
	UHS: { lat: 50.877144, lon: 142.17561 },
	KVK: { lat: 67.462851, lon: 33.585294 },
	TYA: { lat: 54.239, lon: 37.6 },
	LNX: { lat: 54.824, lon: 32.025 },
	EIK: { lat: 46.68, lon: 38.21 },
	RUU: { lat: -5.334444, lon: 144.256667 },
	RVC: { lat: 5.472469, lon: -9.58546 },
	LPS: { lat: 48.483898, lon: -122.938004 },
	KEH: { lat: 47.754799, lon: -122.259003 },
	MJR: { lat: -38.2271, lon: -57.8697 },
	COC: { lat: -31.2969, lon: -57.9966 },
	GHU: { lat: -33.005567, lon: -58.612833 },
	PRA: { lat: -31.7948, lon: -60.4804 },
	ROS: { lat: -32.9036, lon: -60.785 },
	SFN: { lat: -31.7117, lon: -60.8117 },
	AEP: { lat: -34.5592, lon: -58.4156 },
	LCM: { lat: -31.0058, lon: -64.531898 },
	COR: { lat: -31.323601, lon: -64.208 },
	LPG: { lat: -34.9722, lon: -57.8947 },
	EPA: { lat: -34.6099, lon: -58.6126 },
	EZE: { lat: -34.8222, lon: -58.5358 },
	RAF: { lat: -31.2825, lon: -61.5017 },
	NCJ: { lat: -30.9575, lon: -61.5283 },
	HOS: { lat: -37.444698, lon: -70.222504 },
	CVH: { lat: -37.851398, lon: -71.009201 },
	GNR: { lat: -39.000702, lon: -67.620499 },
	RDS: { lat: -37.390598, lon: -68.904198 },
	APZ: { lat: -38.975498, lon: -70.113602 },
	SAM: { lat: -9.6701, lon: 150.7903 },
	MDZ: { lat: -32.831699, lon: -68.7929 },
	LGS: { lat: -35.493599, lon: -69.574303 },
	AFA: { lat: -34.588299, lon: -68.4039 },
	CTC: { lat: -28.593117, lon: -65.7512 },
	SDE: { lat: -27.765556, lon: -64.309998 },
	IRJ: { lat: -29.381599, lon: -66.795799 },
	RHD: { lat: -27.4966, lon: -64.93595 },
	TUC: { lat: -26.8409, lon: -65.104897 },
	UAQ: { lat: -31.571501, lon: -68.418198 },
	CRR: { lat: -29.872292, lon: -61.927925 },
	RCU: { lat: -33.085098, lon: -64.261299 },
	VDR: { lat: -31.9452, lon: -65.146301 },
	VME: { lat: -33.7299, lon: -65.387398 },
	RLO: { lat: -32.384701, lon: -65.186501 },
	LUQ: { lat: -33.273201, lon: -66.3564 },
	CNQ: { lat: -27.4455, lon: -58.7619 },
	RES: { lat: -27.45, lon: -59.0561 },
	FMA: { lat: -26.2127, lon: -58.2281 },
	IGR: { lat: -25.737301, lon: -54.4734 },
	AOL: { lat: -29.6894, lon: -57.1521 },
	MCS: { lat: -30.2719, lon: -57.6402 },
	PSS: { lat: -27.3858, lon: -55.9707 },
	PRQ: { lat: -26.753611, lon: -60.492222 },
	SLA: { lat: -24.856001, lon: -65.486198 },
	JUJ: { lat: -24.392799, lon: -65.097801 },
	ORA: { lat: -23.1528, lon: -64.329201 },
	TTG: { lat: -22.616877, lon: -63.793015 },
	CLX: { lat: -25.3036, lon: -57.7344 },
	ELO: { lat: -26.397499, lon: -54.574699 },
	OYA: { lat: -29.1058, lon: -59.2189 },
	LLS: { lat: -24.721399, lon: -60.548801 },
	MDX: { lat: -29.221399, lon: -58.087799 },
	RCQ: { lat: -29.210278, lon: -59.683333 },
	UZU: { lat: -29.7706, lon: -57.9789 },
	EHL: { lat: -41.943199, lon: -71.532303 },
	CRD: { lat: -45.7853, lon: -67.4655 },
	EMX: { lat: -42.029202, lon: -71.172501 },
	EQS: { lat: -42.908001, lon: -71.139503 },
	LHS: { lat: -46.538517, lon: -68.965323 },
	IGB: { lat: -41.3209, lon: -69.574898 },
	OLN: { lat: -45.5752, lon: -69.077 },
	OES: { lat: -40.7512, lon: -65.0343 },
	MQD: { lat: -41.243099, lon: -68.707802 },
	ARR: { lat: -45.013599, lon: -70.812202 },
	SGV: { lat: -41.591702, lon: -65.339401 },
	REL: { lat: -43.2105, lon: -65.2703 },
	VDM: { lat: -40.8692, lon: -63.0004 },
	PMY: { lat: -42.7592, lon: -65.1027 },
	FTE: { lat: -50.2803, lon: -72.053101 },
	PUD: { lat: -47.7353, lon: -65.9041 },
	RGA: { lat: -53.7777, lon: -67.7494 },
	RGL: { lat: -51.6089, lon: -69.3126 },
	USH: { lat: -54.8433, lon: -68.2958 },
	ULA: { lat: -49.306816, lon: -67.802596 },
	ROY: { lat: -45.703899, lon: -70.245598 },
	PMQ: { lat: -46.537899, lon: -70.978699 },
	GGS: { lat: -48.7831, lon: -70.150002 },
	JSM: { lat: -44.048599, lon: -70.4589 },
	RYO: { lat: -51.605, lon: -72.2203 },
	RZA: { lat: -50.0165, lon: -68.5792 },
	BHI: { lat: -38.725, lon: -62.1693 },
	CSZ: { lat: -37.446098, lon: -61.889301 },
	OVR: { lat: -36.889999, lon: -60.216599 },
	GPO: { lat: -35.696201, lon: -63.758301 },
	OYO: { lat: -38.3869, lon: -60.3297 },
	SST: { lat: -36.5423, lon: -56.7218 },
	MDQ: { lat: -37.9342, lon: -57.5733 },
	NQN: { lat: -38.949001, lon: -68.155701 },
	NEC: { lat: -38.490746, lon: -58.816337 },
	PEH: { lat: -35.8446, lon: -61.8576 },
	RSA: { lat: -36.588299, lon: -64.275703 },
	BRC: { lat: -41.151199, lon: -71.157501 },
	TDL: { lat: -37.234634, lon: -59.228647 },
	VLG: { lat: -37.2354, lon: -57.0292 },
	CUT: { lat: -38.939701, lon: -69.264603 },
	CPC: { lat: -40.075401, lon: -71.137299 },
	VIU: { lat: -8.508457, lon: 157.689986 },
	CDJ: { lat: -8.34835, lon: -49.301498 },
	ARX: { lat: -4.568896, lon: -37.805135 },
	JTC: { lat: -22.160755, lon: -49.070325 },
	AQA: { lat: -21.812, lon: -48.132999 },
	AJU: { lat: -10.984, lon: -37.070301 },
	AFL: { lat: -9.866389, lon: -56.106298 },
	ARU: { lat: -21.141479, lon: -50.424575 },
	AAX: { lat: -19.5632, lon: -46.9604 },
	BEL: { lat: -1.379279, lon: -48.476207 },
	BGX: { lat: -31.390499, lon: -54.112202 },
	PLU: { lat: -19.85074, lon: -43.950316 },
	BFH: { lat: -25.4051, lon: -49.231998 },
	BJP: { lat: -22.978822, lon: -46.537131 },
	BSB: { lat: -15.869167, lon: -47.920834 },
	BAT: { lat: -20.584631, lon: -48.594125 },
	BVB: { lat: 2.845855, lon: -60.690944 },
	BPG: { lat: -15.861417, lon: -52.389008 },
	BZC: { lat: -22.770881, lon: -41.96308 },
	CAC: { lat: -25.000323, lon: -53.501208 },
	CFB: { lat: -22.921485, lon: -42.071874 },
	CFC: { lat: -26.787423, lon: -50.939942 },
	CNF: { lat: -19.63571, lon: -43.966928 },
	CGR: { lat: -20.469998, lon: -54.673988 },
	XAP: { lat: -27.134199, lon: -52.656601 },
	CLN: { lat: -7.32044, lon: -47.458698 },
	CKS: { lat: -6.117841, lon: -50.003372 },
	CCM: { lat: -28.725743, lon: -49.424475 },
	CLV: { lat: -17.725096, lon: -48.606324 },
	QNS: { lat: -29.945928, lon: -51.144413 },
	CAW: { lat: -21.698299, lon: -41.301701 },
	CMG: { lat: -19.01193, lon: -57.672772 },
	CWB: { lat: -25.5285, lon: -49.1758 },
	CRQ: { lat: -17.6523, lon: -39.253101 },
	CXJ: { lat: -29.197183, lon: -51.187647 },
	CGB: { lat: -15.6529, lon: -56.116699 },
	CZS: { lat: -7.59991, lon: -72.769501 },
	BYO: { lat: -21.2473, lon: -56.452399 },
	PPB: { lat: -22.1751, lon: -51.424599 },
	DOU: { lat: -22.2019, lon: -54.926601 },
	MAO: { lat: -3.03861, lon: -60.049702 },
	JCR: { lat: -6.23316, lon: -57.776901 },
	IGU: { lat: -25.594167, lon: -54.489444 },
	FLN: { lat: -27.670279, lon: -48.552502 },
	FEN: { lat: -3.854471, lon: -32.423302 },
	FOR: { lat: -3.775833, lon: -38.532222 },
	GIG: { lat: -22.809999, lon: -43.250557 },
	GJM: { lat: -10.78641, lon: -65.28486 },
	GYN: { lat: -16.632, lon: -49.220699 },
	GRU: { lat: -23.431944, lon: -46.467778 },
	GPB: { lat: -25.388327, lon: -51.52349 },
	GVR: { lat: -18.895882, lon: -41.982869 },
	GUJ: { lat: -22.791599, lon: -45.2048 },
	ATM: { lat: -3.253144, lon: -52.253938 },
	ITA: { lat: -3.126539, lon: -58.481668 },
	ITB: { lat: -4.242131, lon: -56.000651 },
	IOS: { lat: -14.815929, lon: -39.033458 },
	IPN: { lat: -19.470699, lon: -42.487598 },
	ITR: { lat: -18.4447, lon: -49.213402 },
	IMP: { lat: -5.53129, lon: -47.459999 },
	JJG: { lat: -28.6753, lon: -49.0596 },
	QDV: { lat: -23.180861, lon: -46.943921 },
	JJD: { lat: -2.906425, lon: -40.357338 },
	JDF: { lat: -21.791482, lon: -43.386072 },
	JHF: { lat: -23.426886, lon: -47.165658 },
	JPR: { lat: -10.870743, lon: -61.846675 },
	JPA: { lat: -7.148691, lon: -34.950554 },
	RRJ: { lat: -22.986773, lon: -43.372194 },
	JDO: { lat: -7.21932, lon: -39.269096 },
	JOI: { lat: -26.224501, lon: -48.797401 },
	CPV: { lat: -7.269662, lon: -35.896057 },
	VCP: { lat: -23.007404, lon: -47.134502 },
	LEC: { lat: -12.4823, lon: -41.277 },
	LAJ: { lat: -27.782101, lon: -50.281502 },
	LIP: { lat: -21.663491, lon: -49.729954 },
	LDB: { lat: -23.334375, lon: -51.128365 },
	LAZ: { lat: -13.2621, lon: -43.4081 },
	MAB: { lat: -5.36859, lon: -49.138 },
	MQH: { lat: -13.5491, lon: -48.195301 },
	MEU: { lat: -0.889839, lon: -52.6022 },
	MEA: { lat: -22.343, lon: -41.765999 },
	MGF: { lat: -23.47606, lon: -52.016187 },
	MOC: { lat: -16.706919, lon: -43.818901 },
	MII: { lat: -22.196899, lon: -49.926485 },
	PLL: { lat: -3.14604, lon: -59.986301 },
	MCZ: { lat: -9.51081, lon: -35.791698 },
	MCP: { lat: 0.050664, lon: -51.072201 },
	MVF: { lat: -5.20192, lon: -37.3643 },
	RTE: { lat: -23.5091, lon: -46.637798 },
	MNX: { lat: -5.81138, lon: -61.278301 },
	NVT: { lat: -26.879431, lon: -48.650979 },
	GEL: { lat: -28.282503, lon: -54.169623 },
	OYK: { lat: 3.85412, lon: -51.797056 },
	POA: { lat: -29.994712, lon: -51.166592 },
	PHB: { lat: -2.89375, lon: -41.731998 },
	POO: { lat: -21.842529, lon: -46.569768 },
	PFB: { lat: -28.243976, lon: -52.32777 },
	PGZ: { lat: -25.184476, lon: -50.143822 },
	PMW: { lat: -10.2915, lon: -48.356998 },
	PET: { lat: -31.717253, lon: -52.327952 },
	PNZ: { lat: -9.362422, lon: -40.569098 },
	PNB: { lat: -10.719402, lon: -48.3997 },
	PTO: { lat: -26.217184, lon: -52.694463 },
	PMG: { lat: -22.549601, lon: -55.702599 },
	BPS: { lat: -16.438426, lon: -39.080584 },
	PVH: { lat: -8.707854, lon: -63.90242 },
	RBR: { lat: -9.869031, lon: -67.893984 },
	ROO: { lat: -16.584292, lon: -54.724803 },
	REC: { lat: -8.125984, lon: -34.923316 },
	SDU: { lat: -22.9105, lon: -43.163101 },
	RAO: { lat: -21.134314, lon: -47.774053 },
	BRB: { lat: -2.756644, lon: -42.803187 },
	SNZ: { lat: -22.9324, lon: -43.719101 },
	NAT: { lat: -5.769804, lon: -35.366578 },
	OPS: { lat: -11.885001, lon: -55.586109 },
	SJK: { lat: -23.2292, lon: -45.8615 },
	SLZ: { lat: -2.58536, lon: -44.2341 },
	RIA: { lat: -29.711399, lon: -53.688202 },
	STM: { lat: -2.422423, lon: -54.79306 },
	SMT: { lat: -12.479177, lon: -55.672341 },
	CGH: { lat: -23.627657, lon: -46.654601 },
	SJP: { lat: -20.817113, lon: -49.406963 },
	SSZ: { lat: -23.928192, lon: -46.300195 },
	SSA: { lat: -12.908611, lon: -38.322498 },
	TMT: { lat: -1.4896, lon: -56.396801 },
	UNA: { lat: -15.354358, lon: -38.998729 },
	TOW: { lat: -24.6863, lon: -53.697498 },
	THE: { lat: -5.06025, lon: -42.823712 },
	TFF: { lat: -3.38294, lon: -64.724098 },
	TJL: { lat: -20.752643, lon: -51.682026 },
	TRQ: { lat: -8.155534, lon: -70.782985 },
	TEC: { lat: -24.317801, lon: -50.6516 },
	TSQ: { lat: -29.4149, lon: -49.810001 },
	TBT: { lat: -4.25567, lon: -69.935799 },
	TUR: { lat: -3.78601, lon: -49.720299 },
	SJL: { lat: -0.14835, lon: -66.9855 },
	PAV: { lat: -9.40088, lon: -38.250599 },
	URG: { lat: -29.7822, lon: -57.0382 },
	UDI: { lat: -18.883579, lon: -48.225936 },
	UBA: { lat: -19.765036, lon: -47.964805 },
	RPU: { lat: -4.884263, lon: -65.355421 },
	VAG: { lat: -21.591375, lon: -45.474116 },
	BVH: { lat: -12.6944, lon: -60.098301 },
	VIX: { lat: -20.258, lon: -40.285 },
	QPS: { lat: -21.984692, lon: -47.341207 },
	IZA: { lat: -21.513086, lon: -43.173069 },
	ZUD: { lat: -41.904251, lon: -73.796571 },
	LOB: { lat: -32.814201, lon: -70.646698 },
	WAP: { lat: -43.611492, lon: -71.805452 },
	ARI: { lat: -18.348499, lon: -70.338699 },
	WPA: { lat: -45.3992, lon: -72.670303 },
	CPO: { lat: -27.2612, lon: -70.779198 },
	BBA: { lat: -45.915968, lon: -71.689499 },
	TOQ: { lat: -22.1411, lon: -70.062897 },
	DPB: { lat: -54.049977, lon: -68.809193 },
	CCH: { lat: -46.5831, lon: -71.686323 },
	CJC: { lat: -22.498199, lon: -68.903603 },
	YAI: { lat: -36.5825, lon: -72.031403 },
	PUQ: { lat: -53.002602, lon: -70.854599 },
	COW: { lat: -30.198889, lon: -71.246944 },
	GXQ: { lat: -45.5942, lon: -72.106102 },
	IQQ: { lat: -20.5352, lon: -70.181297 },
	SCL: { lat: -33.393002, lon: -70.785797 },
	ESR: { lat: -26.3111, lon: -69.765198 },
	FRT: { lat: -41.051666, lon: -73.35111 },
	ANF: { lat: -23.444501, lon: -70.445099 },
	WPR: { lat: -53.2537, lon: -70.319199 },
	FFU: { lat: -43.189201, lon: -71.851097 },
	UGL: { lat: -79.777778, lon: -83.320833 },
	LSQ: { lat: -37.401699, lon: -72.4254 },
	WPU: { lat: -54.931099, lon: -67.626297 },
	LGR: { lat: -47.243591, lon: -72.58815 },
	CCP: { lat: -36.772701, lon: -73.063103 },
	IPC: { lat: -27.164801, lon: -109.421997 },
	ZOS: { lat: -40.611198, lon: -73.060997 },
	CPP: { lat: -20.7505, lon: -68.683502 },
	VLR: { lat: -28.596399, lon: -70.755997 },
	ZLR: { lat: -35.861698, lon: -71.548599 },
	PNT: { lat: -51.67067, lon: -72.529078 },
	OVL: { lat: -30.5592, lon: -71.175598 },
	ZPC: { lat: -39.292801, lon: -71.915901 },
	MHC: { lat: -42.340388, lon: -73.715693 },
	PUX: { lat: -41.3494, lon: -72.946701 },
	ZCO: { lat: -38.9259, lon: -72.6515 },
	CNR: { lat: -26.3325, lon: -70.6073 },
	VAP: { lat: -33.0681, lon: -71.557503 },
	TNM: { lat: -62.191026, lon: -58.98669 },
	SMB: { lat: -52.736698, lon: -69.333603 },
	LSC: { lat: -29.916201, lon: -71.199501 },
	SSD: { lat: -32.7458, lon: -70.705002 },
	WCA: { lat: -42.490299, lon: -73.772797 },
	PZS: { lat: -38.7668, lon: -72.6371 },
	PMC: { lat: -41.4389, lon: -73.094002 },
	TLX: { lat: -35.3778, lon: -71.6017 },
	WCH: { lat: -42.781943, lon: -72.834999 },
	ZIC: { lat: -38.245602, lon: -72.348602 },
	TTC: { lat: -25.564301, lon: -70.3759 },
	ZAL: { lat: -39.650002, lon: -73.086098 },
	KNA: { lat: -32.9496, lon: -71.4786 },
	BVM: { lat: -15.8717, lon: -38.871899 },
	GDR: { lat: -22.9753, lon: -44.307098 },
	OLC: { lat: -3.46907, lon: -68.921056 },
	SOD: { lat: -23.478001, lon: -47.490002 },
	JTN: { lat: -24.159729, lon: -46.790604 },
	FEC: { lat: -12.200694, lon: -38.906164 },
	JLS: { lat: -20.292296, lon: -50.545546 },
	PBA: { lat: -13.5648, lon: -38.939999 },
	JMR: { lat: -22.9195, lon: -42.830898 },
	NVM: { lat: -13.821021, lon: -56.038591 },
	OUS: { lat: -22.966598, lon: -49.912049 },
	OIA: { lat: -6.762992, lon: -51.04993 },
	REZ: { lat: -22.4785, lon: -44.480301 },
	QSC: { lat: -21.875032, lon: -47.903851 },
	JPY: { lat: -23.224044, lon: -44.7234 },
	UBT: { lat: -23.441122, lon: -45.075814 },
	ITP: { lat: -21.219299, lon: -41.8759 },
	VOT: { lat: -20.458426, lon: -50.003134 },
	JTA: { lat: -5.9334, lon: -40.2975 },
	HUV: { lat: 61.768087, lon: 17.080715 },
	ATF: { lat: -1.21207, lon: -78.5746 },
	OCC: { lat: -0.462886, lon: -76.986801 },
	CUE: { lat: -2.88947, lon: -78.984398 },
	GPS: { lat: -0.453758, lon: -90.2659 },
	GYE: { lat: -2.15742, lon: -79.883598 },
	IBB: { lat: -0.942628, lon: -90.953003 },
	TNW: { lat: -1.060185, lon: -77.580525 },
	JIP: { lat: -1.0, lon: -80.666664 },
	LTX: { lat: -0.906833, lon: -78.615799 },
	MRR: { lat: -4.37823, lon: -79.941002 },
	XMS: { lat: -2.29917, lon: -78.120796 },
	MEC: { lat: -0.946078, lon: -80.678802 },
	LGQ: { lat: 0.093056, lon: -76.8675 },
	PYO: { lat: 0.115949, lon: -75.85022 },
	PVO: { lat: -1.04165, lon: -80.472198 },
	UIO: { lat: -0.125399, lon: -78.354306 },
	ETR: { lat: -3.441986, lon: -79.996957 },
	SNC: { lat: -2.210057, lon: -80.985067 },
	SUQ: { lat: -2.474201, lon: -78.169041 },
	PTZ: { lat: -1.50524, lon: -78.062698 },
	SCY: { lat: -0.910206, lon: -89.617401 },
	BHA: { lat: -0.608111, lon: -80.402702 },
	TSC: { lat: -2.38167, lon: -77.5028 },
	TPN: { lat: -0.776111, lon: -75.526398 },
	LOH: { lat: -3.995606, lon: -79.371902 },
	ESM: { lat: 0.978519, lon: -79.626602 },
	TPC: { lat: -0.122956, lon: -76.337799 },
	TUA: { lat: 0.809506, lon: -77.708099 },
	PSY: { lat: -51.685699, lon: -57.777599 },
	ASU: { lat: -25.240156, lon: -57.519227 },
	AYO: { lat: -27.378379, lon: -56.856791 },
	BFA: { lat: -20.230777, lon: -58.170455 },
	CIO: { lat: -23.440334, lon: -57.429206 },
	ENO: { lat: -27.227537, lon: -55.837584 },
	AGT: { lat: -25.457186, lon: -54.839544 },
	FLM: { lat: -22.354611, lon: -60.053211 },
	ESG: { lat: -22.046499, lon: -60.6217 },
	OLK: { lat: -21.045724, lon: -57.882935 },
	PIL: { lat: -26.881981, lon: -58.319067 },
	PJC: { lat: -22.641427, lon: -55.829993 },
	SIC: { lat: 8.2622, lon: -79.078 },
	ITJ: { lat: -26.983055, lon: -48.816387 },
	LVR: { lat: -13.037861, lon: -55.95025 },
	SFV: { lat: -20.228473, lon: -50.968943 },
	FRC: { lat: -20.592199, lon: -47.3829 },
	MUU: { lat: -13.906082, lon: -38.940804 },
	JUA: { lat: -11.2966, lon: -57.5495 },
	SJF: { lat: 18.3315, lon: -64.796 },
	CFO: { lat: -10.633296, lon: -51.565836 },
	NPR: { lat: -7.125833, lon: -55.400833 },
	AQM: { lat: -9.880436, lon: -63.047115 },
	JRT: { lat: -2.186667, lon: -56.090279 },
	RIG: { lat: -32.083065, lon: -52.167184 },
	ARS: { lat: -15.8994, lon: -52.2411 },
	ECO: { lat: -1.753333, lon: -73.204722 },
	MIX: { lat: -0.886017, lon: -70.983446 },
	ARO: { lat: 8.855118, lon: -76.422676 },
	ULS: { lat: 8.64019, lon: -76.71884 },
	SJR: { lat: 8.766667, lon: -76.533333 },
	NPU: { lat: 8.289325, lon: -76.375006 },
	PCC: { lat: 1.916667, lon: -75.166667 },
	SQF: { lat: 0.702022, lon: -75.2505 },
	AYI: { lat: -0.383333, lon: -72.266667 },
	CUI: { lat: 4.666667, lon: -72.0 },
	MOY: { lat: 4.906926, lon: -72.894809 },
	NUH: { lat: 5.65, lon: -72.2 },
	EUO: { lat: 4.401295, lon: -73.188381 },
	PRE: { lat: 5.733333, lon: -71.983333 },
	SQE: { lat: 5.400181, lon: -71.7001 },
	TTM: { lat: 5.726667, lon: -72.100556 },
	LMX: { lat: 2.841177, lon: -77.237214 },
	AYC: { lat: 8.602149, lon: -73.612866 },
	GRA: { lat: 8.20199, lon: -73.7653 },
	DZI: { lat: 10.096608, lon: -73.2337 },
	SJH: { lat: 10.766667, lon: -73.016667 },
	PZR: { lat: 4.961621, lon: -77.363913 },
	UNC: { lat: 8.032714, lon: -77.091751 },
	AYA: { lat: 8.3, lon: -75.15 },
	SCA: { lat: 8.5, lon: -76.175 },
	MND: { lat: 4.483687, lon: -73.344739 },
	NAD: { lat: 2.808967, lon: -67.621683 },
	GCA: { lat: 2.283333, lon: -74.95 },
	SRO: { lat: 2.216667, lon: -75.25 },
	IVO: { lat: 10.016667, lon: -74.683333 },
	GAA: { lat: 9.15, lon: -74.233333 },
	BAC: { lat: 4.583333, lon: -72.966667 },
	CJD: { lat: 2.066667, lon: -74.583333 },
	CQT: { lat: 2.033333, lon: -74.216667 },
	ELJ: { lat: 2.0, lon: -74.133333 },
	MSK: { lat: 3.750453, lon: -71.456137 },
	SOH: { lat: 3.016667, lon: -71.75 },
	MQR: { lat: 2.64955, lon: -78.3361 },
	PYN: { lat: 1.8, lon: -78.166667 },
	ISD: { lat: 2.445825, lon: -77.981753 },
	AZT: { lat: 6.767262, lon: -73.284775 },
	HRR: { lat: 3.216667, lon: -75.85 },
	PLA: { lat: 3.197051, lon: -75.642042 },
	SQB: { lat: 4.408333, lon: -75.021667 },
	ARF: { lat: 0.533333, lon: -70.133333 },
	MFB: { lat: 0.633333, lon: -69.75 },
	MHF: { lat: 1.75, lon: -69.916667 },
	VAB: { lat: 0.611772, lon: -69.207369 },
	CSR: { lat: 5.833333, lon: -68.133333 },
	GMC: { lat: 3.629996, lon: -70.323028 },
	ACR: { lat: -0.600854, lon: -72.398011 },
	ACD: { lat: 8.497847, lon: -77.274106 },
	HAY: { lat: 8.247, lon: -73.5814 },
	AFI: { lat: 6.895033, lon: -75.047334 },
	API: { lat: 4.07607, lon: -73.5627 },
	AXM: { lat: 4.45278, lon: -75.7664 },
	PUU: { lat: 0.505228, lon: -76.5008 },
	ARQ: { lat: 7.02106, lon: -71.388901 },
	ELB: { lat: 9.04554, lon: -73.9749 },
	BGA: { lat: 7.1265, lon: -73.1848 },
	NBB: { lat: 3.490691, lon: -69.808151 },
	BOG: { lat: 4.70159, lon: -74.1469 },
	BAQ: { lat: 10.8896, lon: -74.7808 },
	BSC: { lat: 6.20292, lon: -77.3947 },
	BUN: { lat: 3.81963, lon: -76.9898 },
	CPB: { lat: 8.632169, lon: -77.350262 },
	CUC: { lat: 7.92757, lon: -72.5115 },
	COG: { lat: 5.072007, lon: -76.676373 },
	CTG: { lat: 10.4424, lon: -75.513 },
	CCO: { lat: 4.56417, lon: -71.3364 },
	CLO: { lat: 3.54322, lon: -76.3816 },
	CIM: { lat: 6.367484, lon: -73.970658 },
	RAV: { lat: 6.316404, lon: -70.21137 },
	TCO: { lat: 1.81442, lon: -78.7492 },
	BHF: { lat: 6.694817, lon: -77.493643 },
	CUO: { lat: 1.013822, lon: -71.297343 },
	CAQ: { lat: 7.96847, lon: -75.1985 },
	CVE: { lat: 9.40092, lon: -75.6913 },
	CZU: { lat: 9.33274, lon: -75.2856 },
	EBG: { lat: 7.59647, lon: -74.8089 },
	ECR: { lat: 2.449444, lon: -78.094167 },
	EJA: { lat: 7.02433, lon: -73.8068 },
	FLA: { lat: 1.58919, lon: -75.5644 },
	FDA: { lat: 10.5333, lon: -74.2 },
	LGT: { lat: 4.550543, lon: -70.925353 },
	GIR: { lat: 4.27624, lon: -74.7967 },
	CRC: { lat: 4.75818, lon: -75.9557 },
	GPI: { lat: 2.57013, lon: -77.897969 },
	CPL: { lat: 3.724293, lon: -75.465785 },
	HTZ: { lat: 6.153311, lon: -71.761969 },
	IBE: { lat: 4.42161, lon: -75.1333 },
	IGO: { lat: 7.677606, lon: -76.683165 },
	LPE: { lat: 5.4776, lon: -70.4212 },
	IPI: { lat: 0.861946, lon: -77.671783 },
	JUO: { lat: 7.07181, lon: -77.727117 },
	APO: { lat: 7.81196, lon: -76.7164 },
	LQM: { lat: -0.182278, lon: -74.7708 },
	MCJ: { lat: 11.2325, lon: -72.4901 },
	LPD: { lat: -1.324882, lon: -69.581294 },
	LET: { lat: -4.19355, lon: -69.9432 },
	TBD: { lat: 2.778569, lon: -77.668045 },
	EOH: { lat: 6.219686, lon: -75.590597 },
	MFS: { lat: 1.35, lon: -71.9444 },
	MGN: { lat: 9.28474, lon: -74.8461 },
	MTB: { lat: 7.97174, lon: -75.4325 },
	MMP: { lat: 9.258348, lon: -74.438393 },
	MTR: { lat: 8.82374, lon: -75.8258 },
	MVP: { lat: 1.25366, lon: -70.2339 },
	MZL: { lat: 5.0296, lon: -75.4647 },
	LMC: { lat: 2.17565, lon: -73.78674 },
	NCI: { lat: 8.454429, lon: -76.779326 },
	NQU: { lat: 5.710348, lon: -77.261868 },
	NVA: { lat: 2.95015, lon: -75.294 },
	OCV: { lat: 8.31506, lon: -73.3583 },
	ORC: { lat: 4.79222, lon: -71.3564 },
	OTU: { lat: 7.010532, lon: -74.715398 },
	RON: { lat: 5.76454, lon: -73.1054 },
	PCR: { lat: 6.18472, lon: -67.4932 },
	PDA: { lat: 3.85353, lon: -67.9062 },
	PEI: { lat: 4.81267, lon: -75.7395 },
	PTX: { lat: 1.85777, lon: -76.0857 },
	PLT: { lat: 9.8, lon: -74.7833 },
	NAR: { lat: 6.21002, lon: -74.5906 },
	PPN: { lat: 2.4544, lon: -76.6093 },
	PAL: { lat: 5.48361, lon: -74.6574 },
	PBE: { lat: 6.46034, lon: -74.4105 },
	PSO: { lat: 1.39625, lon: -77.2915 },
	PVA: { lat: 13.357461, lon: -81.357977 },
	PZA: { lat: 5.87615, lon: -71.8866 },
	MQU: { lat: 5.21256, lon: -74.8836 },
	TCD: { lat: -2.895802, lon: -69.749762 },
	MDE: { lat: 6.16454, lon: -75.4231 },
	RCH: { lat: 11.5262, lon: -72.926 },
	SNT: { lat: 7.38322, lon: -73.505402 },
	RVE: { lat: 6.951868, lon: -71.857179 },
	SJE: { lat: 2.57969, lon: -72.6394 },
	SSL: { lat: 5.1309, lon: -70.8682 },
	SMR: { lat: 11.1196, lon: -74.2306 },
	SOX: { lat: 5.67732, lon: -72.9703 },
	ADZ: { lat: 12.5836, lon: -81.7112 },
	SRS: { lat: 8.69, lon: -75.156 },
	SVI: { lat: 2.15217, lon: -74.7663 },
	TAU: { lat: 5.01281, lon: -72.7424 },
	TIB: { lat: 8.63152, lon: -72.7304 },
	TDA: { lat: 5.43278, lon: -71.6625 },
	TLU: { lat: 9.50945, lon: -75.5854 },
	TME: { lat: 6.45108, lon: -71.7603 },
	TQS: { lat: 0.7459, lon: -75.234 },
	TRB: { lat: 8.071878, lon: -76.740124 },
	URI: { lat: 3.2375, lon: -74.347222 },
	AUC: { lat: 7.06888, lon: -70.7369 },
	UIB: { lat: 5.69076, lon: -76.6412 },
	ULQ: { lat: 4.08836, lon: -76.2351 },
	URR: { lat: 6.32883, lon: -76.1425 },
	VGZ: { lat: 0.978767, lon: -76.6056 },
	PYA: { lat: 5.93904, lon: -74.457 },
	VUP: { lat: 10.435, lon: -73.2495 },
	VVC: { lat: 4.16787, lon: -73.6138 },
	AYG: { lat: 1.54417, lon: -73.9333 },
	EYP: { lat: 5.31911, lon: -72.384 },
	MHW: { lat: -19.827, lon: -63.960999 },
	SRE: { lat: -19.246835, lon: -65.149611 },
	APB: { lat: -14.7356, lon: -68.411903 },
	ASC: { lat: -15.933365, lon: -63.155575 },
	BJO: { lat: -22.7733, lon: -64.312897 },
	CAM: { lat: -20.00656, lon: -63.527827 },
	CBB: { lat: -17.421101, lon: -66.177101 },
	CIJ: { lat: -11.0404, lon: -68.782997 },
	CEP: { lat: -16.142688, lon: -62.026595 },
	SRZ: { lat: -17.8116, lon: -63.171501 },
	GYA: { lat: -10.88856, lon: -65.380955 },
	CCA: { lat: -16.976834, lon: -65.145568 },
	BVK: { lat: -13.605556, lon: -63.879444 },
	SJS: { lat: -17.830799, lon: -60.743099 },
	SJB: { lat: -13.0528, lon: -64.661697 },
	SJV: { lat: -16.2708, lon: -62.470299 },
	LPB: { lat: -16.5133, lon: -68.192299 },
	MGD: { lat: -13.260748, lon: -64.060764 },
	ORU: { lat: -17.962601, lon: -67.076202 },
	POI: { lat: -19.543331, lon: -65.723734 },
	PUR: { lat: -11.107663, lon: -67.551155 },
	PSZ: { lat: -18.975301, lon: -57.820599 },
	SRD: { lat: -13.2639, lon: -64.603897 },
	RBO: { lat: -18.328224, lon: -59.765339 },
	RIB: { lat: -11.009355, lon: -66.075468 },
	RBQ: { lat: -14.4279, lon: -67.496803 },
	REY: { lat: -14.3044, lon: -67.353401 },
	SBL: { lat: -13.7622, lon: -65.435204 },
	SRJ: { lat: -14.8592, lon: -66.737503 },
	SNG: { lat: -16.38719, lon: -60.962318 },
	SNM: { lat: -14.9658, lon: -65.6338 },
	SRB: { lat: -14.073072, lon: -66.787391 },
	MQK: { lat: -16.339199, lon: -58.401901 },
	TJA: { lat: -21.5557, lon: -64.701302 },
	TDD: { lat: -14.8187, lon: -64.917999 },
	UYU: { lat: -20.441304, lon: -66.857553 },
	VAH: { lat: -18.4825, lon: -64.099403 },
	VLM: { lat: -21.255199, lon: -63.405602 },
	VVI: { lat: -17.6448, lon: -63.135399 },
	BYC: { lat: -21.960899, lon: -63.651699 },
	ABN: { lat: 5.51272, lon: -54.050098 },
	AAJ: { lat: 3.898681, lon: -55.577907 },
	TOT: { lat: 5.86583, lon: -56.327499 },
	DRJ: { lat: 4.111359, lon: -54.672766 },
	LDO: { lat: 4.376108, lon: -55.407057 },
	PBM: { lat: 5.45283, lon: -55.187801 },
	MOJ: { lat: 5.6076, lon: -54.4003 },
	ICK: { lat: 5.955435, lon: -57.040617 },
	OEM: { lat: 3.346051, lon: -55.443707 },
	SMZ: { lat: 4.351389, lon: -54.418056 },
	KCB: { lat: 3.15, lon: -55.716999 },
	AGI: { lat: 5.841252, lon: -56.673247 },
	WSO: { lat: 5.215277, lon: -57.185302 },
	ORG: { lat: 5.811131, lon: -55.1913 },
	JSO: { lat: -3.614488, lon: -40.231426 },
	JAW: { lat: -7.586417, lon: -40.535431 },
	APQ: { lat: -9.776589, lon: -36.628983 },
	AMJ: { lat: -16.165579, lon: -40.684024 },
	AIF: { lat: -22.638601, lon: -50.455983 },
	BDC: { lat: -5.5025, lon: -45.215833 },
	BRA: { lat: -12.0789, lon: -45.008999 },
	BSS: { lat: -7.525305, lon: -46.053364 },
	BQQ: { lat: -11.0808, lon: -43.147499 },
	MXQ: { lat: -13.389444, lon: -38.91 },
	EEA: { lat: -27.634128, lon: -50.358253 },
	QCH: { lat: -19.487476, lon: -40.579362 },
	RDC: { lat: -8.031188, lon: -49.979687 },
	DTI: { lat: -18.232, lon: -43.650398 },
	DIQ: { lat: -20.1807, lon: -44.870899 },
	JPE: { lat: -3.019798, lon: -47.316474 },
	CNV: { lat: -15.667, lon: -38.9547 },
	VCC: { lat: -28.43248, lon: -51.023322 },
	SXX: { lat: -6.6413, lon: -51.9523 },
	GUZ: { lat: -20.6465, lon: -40.491901 },
	GDP: { lat: -6.78222, lon: -43.582199 },
	GNM: { lat: -14.2082, lon: -42.746101 },
	QGP: { lat: -8.83428, lon: -36.4716 },
	SET: { lat: -8.061433, lon: -38.328888 },
	IRE: { lat: -11.3399, lon: -41.847 },
	QIG: { lat: -6.346319, lon: -39.294448 },
	QIT: { lat: -15.2445, lon: -40.277199 },
	IPU: { lat: -14.173538, lon: -39.68399 },
	JCM: { lat: -11.1632, lon: -40.553101 },
	JEQ: { lat: -13.8777, lon: -40.071602 },
	JMA: { lat: -20.259722, lon: -42.183887 },
	JNA: { lat: -15.4738, lon: -44.385502 },
	JDR: { lat: -21.085638, lon: -44.225299 },
	CDI: { lat: -20.834299, lon: -41.1856 },
	QCP: { lat: -6.280833, lon: -36.540279 },
	LHN: { lat: -19.355202, lon: -40.07128 },
	SSO: { lat: -22.0909, lon: -45.044498 },
	MTE: { lat: -1.9958, lon: -54.0742 },
	MVS: { lat: -18.048901, lon: -39.864321 },
	SBJ: { lat: -18.7213, lon: -39.833698 },
	PTQ: { lat: -1.741307, lon: -52.236026 },
	NNU: { lat: -17.823158, lon: -40.329662 },
	PSW: { lat: -20.731838, lon: -46.662011 },
	FEJ: { lat: -8.141213, lon: -70.340821 },
	ORX: { lat: -1.71408, lon: -55.836201 },
	PCS: { lat: -7.061385, lon: -41.525871 },
	POJ: { lat: -18.672673, lon: -46.491292 },
	PIV: { lat: -17.3169, lon: -44.860298 },
	SNQ: { lat: 30.5288, lon: -115.9462 },
	FLB: { lat: -6.84639, lon: -43.077301 },
	CHD: { lat: -13.0312, lon: -41.444099 },
	PDF: { lat: -17.296976, lon: -39.271131 },
	CAU: { lat: -8.28239, lon: -36.0135 },
	OPP: { lat: -0.696111, lon: -47.336111 },
	SFK: { lat: -0.697844, lon: -48.519759 },
	TXF: { lat: -17.524392, lon: -39.668499 },
	OBI: { lat: -1.867981, lon: -55.514596 },
	TFL: { lat: -17.8923, lon: -41.513599 },
	JPO: { lat: -7.03899, lon: -37.251598 },
	AIY: { lat: -16.851571, lon: -42.045633 },
	VAL: { lat: -13.2965, lon: -38.992401 },
	BVS: { lat: -1.63653, lon: -50.4436 },
	CMC: { lat: -2.895596, lon: -40.859299 },
	JCS: { lat: -5.21135, lon: -40.704201 },
	GGF: { lat: -1.479524, lon: -52.578214 },
	PHI: { lat: -2.477426, lon: -45.105003 },
	GMS: { lat: -2.109444, lon: -44.651114 },
	PPY: { lat: -22.2892, lon: -45.919102 },
	PYT: { lat: -17.242599, lon: -46.883099 },
	ITE: { lat: -13.731571, lon: -39.140377 },
	LKR: { lat: 11.17348, lon: 48.21426 },
	GUO: { lat: 5.317412, lon: 45.985308 },
	BXX: { lat: 9.9463, lon: 43.1495 },
	SOA: { lat: 9.5814, lon: 105.9602 },
	CAY: { lat: 4.819964, lon: -52.361326 },
	GSI: { lat: 4.285833, lon: -54.373056 },
	MPY: { lat: 3.655907, lon: -54.039431 },
	OYP: { lat: 3.8976, lon: -51.8041 },
	LDX: { lat: 5.48306, lon: -54.034401 },
	REI: { lat: 4.31339, lon: -52.132745 },
	XAU: { lat: 3.61361, lon: -53.204201 },
	SOR: { lat: 34.390394, lon: 40.15256 },
	ALD: { lat: -11.65018, lon: -69.229614 },
	AOP: { lat: -2.79613, lon: -76.466599 },
	AYX: { lat: -10.7291, lon: -73.766502 },
	MBP: { lat: -6.018889, lon: -76.988327 },
	IBP: { lat: -11.4116, lon: -69.488701 },
	PCL: { lat: -8.37794, lon: -74.574303 },
	TDP: { lat: -3.80601, lon: -75.039299 },
	CHM: { lat: -9.14961, lon: -78.523804 },
	CGL: { lat: -7.797624, lon: -77.651249 },
	TGI: { lat: -9.289667, lon: -76.005058 },
	CIX: { lat: -6.78748, lon: -79.828102 },
	AYP: { lat: -13.1548, lon: -74.204399 },
	ANS: { lat: -13.7064, lon: -73.350403 },
	ATA: { lat: -9.34744, lon: -77.598396 },
	UMI: { lat: -13.231357, lon: -70.75145 },
	LIM: { lat: -12.0219, lon: -77.114305 },
	UCZ: { lat: -8.467, lon: -76.349998 },
	RIJ: { lat: -6.06786, lon: -77.160004 },
	JAE: { lat: -5.59248, lon: -78.774002 },
	JJI: { lat: -7.1691, lon: -76.7286 },
	JAU: { lat: -11.7831, lon: -75.473396 },
	JUL: { lat: -15.4671, lon: -70.158203 },
	SJA: { lat: -15.357508, lon: -75.135005 },
	CJA: { lat: -7.13918, lon: -78.489403 },
	RIM: { lat: -6.39231, lon: -77.501198 },
	ILQ: { lat: -17.695, lon: -71.344002 },
	TBP: { lat: -3.552074, lon: -80.381086 },
	MZA: { lat: -11.3254, lon: -74.535598 },
	YMS: { lat: -5.89377, lon: -76.118202 },
	HUU: { lat: -9.87881, lon: -76.204803 },
	SQU: { lat: -6.96003, lon: -76.768402 },
	CHH: { lat: -6.201911, lon: -77.856195 },
	IQT: { lat: -3.78474, lon: -73.3088 },
	AQP: { lat: -16.341101, lon: -71.583099 },
	TRU: { lat: -8.08141, lon: -79.108803 },
	PIO: { lat: -13.7449, lon: -76.220299 },
	TPP: { lat: -6.50874, lon: -76.373199 },
	SYC: { lat: -11.898, lon: -69.0625 },
	TCQ: { lat: -18.053301, lon: -70.275803 },
	PEM: { lat: -12.6136, lon: -69.2286 },
	PIU: { lat: -5.20575, lon: -80.616402 },
	TYL: { lat: -4.57664, lon: -81.254097 },
	NZC: { lat: -14.854, lon: -74.961502 },
	CUZ: { lat: -13.5357, lon: -71.938797 },
	EAX: { lat: 5.8604, lon: -55.192 },
	SRL: { lat: 27.0927, lon: -112.0985 },
	SRM: { lat: -24.0568, lon: 139.0821 },
	SRV: { lat: 61.7897, lon: -156.589005 },
	CZB: { lat: -28.657934, lon: -53.610095 },
	APU: { lat: -23.609099, lon: -51.384301 },
	BGV: { lat: -29.147424, lon: -51.540791 },
	BNU: { lat: -26.831661, lon: -49.093569 },
	CCI: { lat: -27.180511, lon: -52.051755 },
	CSS: { lat: -19.146861, lon: -51.676941 },
	CEL: { lat: -29.370091, lon: -50.831729 },
	CKO: { lat: -23.152711, lon: -50.602868 },
	GGH: { lat: -23.69157, lon: -52.642091 },
	ERM: { lat: -27.663614, lon: -52.271489 },
	FBE: { lat: -26.05938, lon: -53.063827 },
	GGJ: { lat: -24.0811, lon: -54.1917 },
	HRZ: { lat: -27.6383, lon: -54.3391 },
	IJU: { lat: -28.368711, lon: -53.846568 },
	ITQ: { lat: -29.171981, lon: -56.538343 },
	JCB: { lat: -27.171514, lon: -51.553327 },
	CBW: { lat: -24.009199, lon: -52.3568 },
	QDB: { lat: -30.0019, lon: -52.9408 },
	OAL: { lat: -11.496, lon: -61.4508 },
	LOI: { lat: -27.16, lon: -49.5425 },
	ALQ: { lat: -29.811595, lon: -55.894707 },
	QGF: { lat: -29.7194, lon: -51.489399 },
	QHV: { lat: -29.6961, lon: -51.081699 },
	SQX: { lat: -26.781601, lon: -53.503502 },
	APX: { lat: -23.352636, lon: -51.491967 },
	VRZ: { lat: -21.240601, lon: -44.963902 },
	AIR: { lat: -10.187375, lon: -59.457469 },
	PNG: { lat: -25.5401, lon: -48.5312 },
	PVI: { lat: -23.089899, lon: -52.488499 },
	PBB: { lat: -19.651199, lon: -51.199402 },
	SQY: { lat: -31.383301, lon: -52.032799 },
	SSS: { lat: -5.5965, lon: 147.8106 },
	JBS: { lat: -28.6549, lon: -56.034599 },
	CSU: { lat: -29.684099, lon: -52.412201 },
	UMU: { lat: -23.7987, lon: -53.313801 },
	ZFU: { lat: -23.408611, lon: -46.330555 },
	UVI: { lat: -26.233224, lon: -51.066754 },
	VIA: { lat: -26.999701, lon: -51.141899 },
	BMS: { lat: -14.2554, lon: -41.817501 },
	AXE: { lat: -26.875067, lon: -52.372862 },
	SRA: { lat: -27.90658, lon: -54.520628 },
	ATI: { lat: -30.4007, lon: -56.5079 },
	BUV: { lat: -30.319807, lon: -57.558823 },
	CYR: { lat: -34.456402, lon: -57.770599 },
	DZO: { lat: -33.358898, lon: -56.499199 },
	PDP: { lat: -34.855099, lon: -55.094299 },
	MLZ: { lat: -32.337898, lon: -54.216702 },
	MVD: { lat: -34.835647, lon: -56.026497 },
	PDU: { lat: -32.3633, lon: -58.061901 },
	RVY: { lat: -30.9746, lon: -55.4762 },
	STY: { lat: -31.438499, lon: -57.985298 },
	TAW: { lat: -31.749001, lon: -55.925801 },
	TYT: { lat: -33.195714, lon: -54.347246 },
	VCH: { lat: -31.739166, lon: -54.587776 },
	AGV: { lat: 9.553375, lon: -69.237869 },
	AAO: { lat: 9.430225, lon: -64.470726 },
	LPJ: { lat: 6.577504, lon: -66.816564 },
	BLA: { lat: 10.111111, lon: -64.692222 },
	BNS: { lat: 8.615, lon: -70.214167 },
	BRM: { lat: 10.042747, lon: -69.35862 },
	MYC: { lat: 10.249978, lon: -67.649422 },
	CBL: { lat: 8.122161, lon: -63.536957 },
	CXA: { lat: 7.62551, lon: -66.162804 },
	CUV: { lat: 8.75814, lon: -72.536301 },
	CLZ: { lat: 8.924656, lon: -67.417091 },
	CAJ: { lat: 6.231989, lon: -62.85485 },
	CUP: { lat: 10.660014, lon: -63.261681 },
	CZE: { lat: 11.414944, lon: -69.680901 },
	CUM: { lat: 10.450333, lon: -64.13047 },
	PPZ: { lat: 6.220095, lon: -67.447508 },
	EOR: { lat: 6.71573, lon: -61.638786 },
	EOZ: { lat: 7.059677, lon: -69.4967 },
	GDO: { lat: 7.210834, lon: -70.756386 },
	GUI: { lat: 10.574078, lon: -62.312668 },
	GUQ: { lat: 9.026944, lon: -69.75515 },
	HGE: { lat: 10.462474, lon: -66.092779 },
	ICA: { lat: 4.338137, lon: -61.738661 },
	ICC: { lat: 10.794432, lon: -63.98159 },
	LSP: { lat: 11.780775, lon: -70.151497 },
	KAV: { lat: 5.593056, lon: -61.763333 },
	KTV: { lat: 5.7171, lon: -62.33727 },
	LFR: { lat: 8.239167, lon: -72.271027 },
	MAR: { lat: 10.558208, lon: -71.727859 },
	MRD: { lat: 8.582078, lon: -71.161041 },
	PMV: { lat: 10.912603, lon: -63.966599 },
	CCS: { lat: 10.601194, lon: -66.991222 },
	MUN: { lat: 9.749023, lon: -63.153348 },
	CBS: { lat: 10.3307, lon: -71.322502 },
	PYH: { lat: 5.61999, lon: -67.606102 },
	PBL: { lat: 10.4805, lon: -68.072998 },
	PDZ: { lat: 9.978672, lon: -62.231318 },
	PPH: { lat: 4.600362, lon: -61.49816 },
	SCI: { lat: 7.80132, lon: -72.202904 },
	PZO: { lat: 8.28853, lon: -62.760399 },
	PTM: { lat: 7.575479, lon: -70.174435 },
	LRV: { lat: 11.946935, lon: -66.668333 },
	SVS: { lat: 66.016727, lon: -149.056835 },
	SVZ: { lat: 7.840809, lon: -72.439878 },
	SBB: { lat: 7.803514, lon: -71.165718 },
	SNV: { lat: 4.554699, lon: -61.145234 },
	STD: { lat: 7.56538, lon: -72.035103 },
	SNF: { lat: 10.2787, lon: -68.755203 },
	SFD: { lat: 7.88332, lon: -67.444 },
	SOM: { lat: 8.945147, lon: -64.151085 },
	STB: { lat: 8.97455, lon: -71.943253 },
	TUV: { lat: 9.088994, lon: -62.094173 },
	TMO: { lat: 7.24938, lon: -61.52893 },
	URM: { lat: 5.358118, lon: -62.671625 },
	WOK: { lat: 4.984002, lon: -61.730102 },
	VLN: { lat: 10.149733, lon: -67.928398 },
	VIG: { lat: 8.624139, lon: -71.672668 },
	VLV: { lat: 9.340478, lon: -70.584061 },
	VDP: { lat: 9.222028, lon: -65.993584 },
	BAZ: { lat: -0.981191, lon: -62.918603 },
	JSB: { lat: -4.042841, lon: -40.893813 },
	LCB: { lat: -15.1934, lon: -59.3848 },
	RBB: { lat: -4.40634, lon: -59.602402 },
	CAF: { lat: -4.871473, lon: -66.897552 },
	CQS: { lat: -12.4211, lon: -64.251602 },
	DMT: { lat: -14.3769, lon: -56.400398 },
	DNO: { lat: -11.5954, lon: -46.846699 },
	ERN: { lat: -6.639533, lon: -69.879709 },
	CQA: { lat: -13.574444, lon: -52.270557 },
	SXO: { lat: -11.6324, lon: -50.689602 },
	GRP: { lat: -11.7396, lon: -49.132198 },
	AUX: { lat: -7.22787, lon: -48.240501 },
	GGB: { lat: -14.019959, lon: -52.152003 },
	HUW: { lat: -7.53212, lon: -63.072102 },
	IPG: { lat: -2.940141, lon: -69.694264 },
	IDO: { lat: -11.5723, lon: -50.666199 },
	JIA: { lat: -11.419444, lon: -58.701668 },
	JTI: { lat: -17.829901, lon: -51.772999 },
	CCX: { lat: -16.0436, lon: -57.629902 },
	CIZ: { lat: -4.13406, lon: -63.132599 },
	NSR: { lat: -9.083392, lon: -42.644656 },
	TLZ: { lat: -18.216801, lon: -47.8997 },
	LBR: { lat: -7.27897, lon: -64.769501 },
	RVD: { lat: -17.834723, lon: -50.956112 },
	MBZ: { lat: -3.37217, lon: -57.7248 },
	NVP: { lat: -5.11803, lon: -60.364899 },
	BCR: { lat: -8.83456, lon: -67.312401 },
	NQL: { lat: -14.434869, lon: -48.491615 },
	APS: { lat: -16.363575, lon: -48.9288 },
	FBA: { lat: -2.53261, lon: -66.083199 },
	PIN: { lat: -2.673521, lon: -56.777625 },
	PBQ: { lat: -11.6416, lon: -61.1791 },
	PBX: { lat: -10.85935, lon: -51.688152 },
	IRZ: { lat: -0.378604, lon: -64.992558 },
	TGQ: { lat: -14.662, lon: -57.443744 },
	AZL: { lat: -13.465528, lon: -58.866935 },
	SQM: { lat: -13.3313, lon: -50.197601 },
	VLP: { lat: -9.981057, lon: -51.140358 },
	MBK: { lat: -10.170368, lon: -54.953964 },
	NOK: { lat: -14.697778, lon: -52.347246 },
	IUP: { lat: -7.172773, lon: -59.8396 },
	ITI: { lat: -18.147591, lon: -41.715044 },
	SXP: { lat: 62.520599, lon: -164.848006 },
	AHL: { lat: 2.47403, lon: -59.320786 },
	NAI: { lat: 3.95944, lon: -59.124199 },
	SYB: { lat: 58.373291, lon: -152.201797 },
	BMJ: { lat: 7.37012, lon: -60.487999 },
	GFO: { lat: 6.358864, lon: -58.655207 },
	GEO: { lat: 6.49855, lon: -58.254101 },
	SYF: { lat: 49.151, lon: -123.698 },
	OGL: { lat: 6.80628, lon: -58.1059 },
	IMB: { lat: 5.70811, lon: -60.294201 },
	KAI: { lat: 5.177349, lon: -59.48898 },
	KAR: { lat: 5.86534, lon: -60.614201 },
	KRM: { lat: 3.752572, lon: -59.30902 },
	KRG: { lat: 4.03005, lon: -59.54749 },
	KTO: { lat: 4.64916, lon: -59.832199 },
	KKG: { lat: 5.2684, lon: -58.995 },
	SYL: { lat: 35.814999, lon: -120.744003 },
	LUB: { lat: 2.39393, lon: -59.441002 },
	LTM: { lat: 3.37276, lon: -59.789398 },
	USI: { lat: 8.20017, lon: -59.777965 },
	MHA: { lat: 5.272845, lon: -59.149296 },
	VEG: { lat: 4.898172, lon: -59.817027 },
	MYM: { lat: 4.452267, lon: -59.603126 },
	MWJ: { lat: 7.487736, lon: -60.185237 },
	QSX: { lat: 6.244324, lon: -57.474172 },
	ORJ: { lat: 4.72527, lon: -60.035 },
	PKM: { lat: 7.7424, lon: -59.8819 },
	PIQ: { lat: 5.356667, lon: -60.381 },
	PMT: { lat: 4.699587, lon: -59.713841 },
	PRR: { lat: 5.81724, lon: -61.055489 },
	SDC: { lat: 2.9913, lon: -59.51 },
	SKM: { lat: 5.8599, lon: -57.14894 },
	ANU: { lat: 17.1367, lon: -61.792702 },
	BBQ: { lat: 17.635799, lon: -61.828602 },
	BGI: { lat: 13.0746, lon: -59.4925 },
	TBV: { lat: 8.3027, lon: 171.1615 },
	TCT: { lat: 62.993206, lon: -156.029026 },
	DCF: { lat: 15.336693, lon: -61.392108 },
	DOM: { lat: 15.547, lon: -61.299999 },
	DSD: { lat: 16.296902, lon: -61.0844 },
	BBR: { lat: 16.013648, lon: -61.742928 },
	SFC: { lat: 16.257799, lon: -61.262501 },
	FDF: { lat: 14.591, lon: -61.003201 },
	SFG: { lat: 18.100057, lon: -63.047444 },
	SBH: { lat: 17.9044, lon: -62.843601 },
	GBJ: { lat: 15.868925, lon: -61.270087 },
	PTP: { lat: 16.265301, lon: -61.531799 },
	LSS: { lat: 15.8644, lon: -61.580601 },
	GND: { lat: 12.0042, lon: -61.786201 },
	CRU: { lat: 12.4761, lon: -61.472801 },
	THW: { lat: 8.56, lon: 81.22 },
	STT: { lat: 18.337091, lon: -64.977251 },
	STX: { lat: 17.701413, lon: -64.802608 },
	ARE: { lat: 18.45085, lon: -66.675768 },
	BQN: { lat: 18.4949, lon: -67.129402 },
	TJC: { lat: 9.4185, lon: -78.4896 },
	CPX: { lat: 18.312954, lon: -65.303893 },
	SIG: { lat: 18.4568, lon: -66.098099 },
	MAZ: { lat: 18.255699, lon: -67.148499 },
	PSE: { lat: 18.008301, lon: -66.563004 },
	NRR: { lat: 18.2453, lon: -65.643402 },
	SJU: { lat: 18.4394, lon: -66.001801 },
	VQS: { lat: 18.1348, lon: -65.493599 },
	TKE: { lat: 57.779701, lon: -135.218002 },
	TKL: { lat: 58.4897, lon: -133.942993 },
	SKB: { lat: 17.311199, lon: -62.7187 },
	NEV: { lat: 17.2057, lon: -62.589901 },
	SLU: { lat: 14.0202, lon: -60.992901 },
	UVF: { lat: 13.7332, lon: -60.952599 },
	TLT: { lat: 61.086973, lon: -160.922842 },
	AUA: { lat: 12.5014, lon: -70.015198 },
	BON: { lat: 12.131, lon: -68.268501 },
	CUR: { lat: 12.1889, lon: -68.959801 },
	EUX: { lat: 17.4965, lon: -62.979401 },
	SXM: { lat: 18.041, lon: -63.108898 },
	SAB: { lat: 17.645351, lon: -63.220571 },
	TOK: { lat: -6.2015, lon: 155.063 },
	TOV: { lat: 18.45, lon: -64.583333 },
	TPT: { lat: 6.4948, lon: -8.873 },
	AXA: { lat: 18.204773, lon: -63.05383 },
	XXX: { lat: 36.913289, lon: 31.083723 },
	MNI: { lat: 16.791401, lon: -62.193298 },
	TSG: { lat: 63.374401, lon: -143.335999 },
	TSI: { lat: -6.8498, lon: 146.3554 },
	TAB: { lat: 11.1497, lon: -60.832199 },
	POS: { lat: 10.5954, lon: -61.3372 },
	TTW: { lat: 6.2876, lon: 81.2906 },
	TUJ: { lat: 6.26, lon: 35.5184 },
	NGD: { lat: 18.727734, lon: -64.32852 },
	EIS: { lat: 18.445492, lon: -64.541707 },
	VIJ: { lat: 18.446634, lon: -64.427932 },
	SVD: { lat: 13.156695, lon: -61.149945 },
	BQU: { lat: 12.9884, lon: -61.262001 },
	CIW: { lat: 12.699, lon: -61.3424 },
	MQS: { lat: 12.8879, lon: -61.180199 },
	UNI: { lat: 12.600135, lon: -61.411945 },
	TWC: { lat: 39.886663, lon: 79.233408 },
	TWH: { lat: 33.432222, lon: -118.508611 },
	BDA: { lat: 32.363998, lon: -64.678703 },
	TYE: { lat: 61.076556, lon: -151.131363 },
	GIT: { lat: -2.813667, lon: 32.172472 },
	TZO: { lat: -18.345064, lon: 45.015643 },
	DBS: { lat: 44.162057, lon: -112.220581 },
	MXR: { lat: 49.932, lon: 33.641 },
	KHU: { lat: 49.136799, lon: 33.477893 },
	KCP: { lat: 48.695631, lon: 26.609471 },
	ALA: { lat: 43.354267, lon: 77.042828 },
	BXH: { lat: 46.894246, lon: 75.004533 },
	USJ: { lat: 46.190767, lon: 80.830922 },
	BXJ: { lat: 43.352052, lon: 76.883039 },
	TDK: { lat: 45.12255, lon: 78.442758 },
	NQZ: { lat: 51.027035, lon: 71.467094 },
	KOV: { lat: 53.329102, lon: 69.594597 },
	PPK: { lat: 54.774702, lon: 69.183273 },
	DMB: { lat: 42.8536, lon: 71.303596 },
	BSZ: { lat: 43.061298, lon: 74.4776 },
	OSS: { lat: 40.609001, lon: 72.793297 },
	IKG: { lat: 42.508099, lon: 78.407799 },
	CIT: { lat: 42.364201, lon: 69.478897 },
	HSA: { lat: 43.313126, lon: 68.549881 },
	DZN: { lat: 47.708953, lon: 67.738094 },
	KGF: { lat: 49.670799, lon: 73.334396 },
	BXY: { lat: 45.621994, lon: 63.210773 },
	KZO: { lat: 44.706902, lon: 65.592499 },
	URA: { lat: 51.150799, lon: 51.543098 },
	EKB: { lat: 51.591, lon: 75.214996 },
	UKK: { lat: 50.036571, lon: 82.493477 },
	PWQ: { lat: 52.195, lon: 77.073898 },
	PLX: { lat: 50.351295, lon: 80.234398 },
	SZI: { lat: 47.487491, lon: 84.887675 },
	SCO: { lat: 43.860093, lon: 51.09086 },
	GUW: { lat: 47.122559, lon: 51.819321 },
	AKX: { lat: 50.2458, lon: 57.206699 },
	AYK: { lat: 50.3186, lon: 66.952797 },
	KSN: { lat: 53.206902, lon: 63.550301 },
	GYD: { lat: 40.467499, lon: 50.0467 },
	FZL: { lat: 39.594578, lon: 47.196128 },
	GNJ: { lat: 40.738935, lon: 46.320067 },
	LLK: { lat: 38.757919, lon: 48.807042 },
	NAJ: { lat: 39.188801, lon: 45.458401 },
	GBB: { lat: 40.808617, lon: 47.725389 },
	ZTU: { lat: 41.557823, lon: 46.669464 },
	ZZE: { lat: 39.11443, lon: 46.74392 },
	YLV: { lat: 40.631901, lon: 47.141899 },
	IKU: { lat: 42.585584, lon: 76.701181 },
	LWN: { lat: 40.750401, lon: 43.859299 },
	EVN: { lat: 40.147301, lon: 44.395901 },
	BQJ: { lat: 67.648003, lon: 134.695007 },
	SUK: { lat: 67.792, lon: 130.394 },
	UKG: { lat: 70.011002, lon: 135.645004 },
	TLK: { lat: 59.876389, lon: 111.044444 },
	ADH: { lat: 58.602798, lon: 125.408997 },
	YKS: { lat: 62.0933, lon: 129.770996 },
	NER: { lat: 56.913898, lon: 124.914001 },
	MQJ: { lat: 66.450861, lon: 143.261551 },
	KDY: { lat: 62.789001, lon: 136.854996 },
	GYG: { lat: 62.103484, lon: 129.545288 },
	OLZ: { lat: 60.401833, lon: 120.476094 },
	USR: { lat: 64.550003, lon: 143.115005 },
	UMS: { lat: 60.356998, lon: 134.434998 },
	VHV: { lat: 63.458057, lon: 120.269165 },
	NYR: { lat: 63.296703, lon: 118.341953 },
	SUY: { lat: 62.185001, lon: 117.635002 },
	VYI: { lat: 63.756668, lon: 121.693336 },
	ULK: { lat: 60.7206, lon: 114.825996 },
	ONK: { lat: 68.514999, lon: 112.480003 },
	PYJ: { lat: 66.400398, lon: 112.029999 },
	MJZ: { lat: 62.534698, lon: 114.039001 },
	SYS: { lat: 71.927902, lon: 114.080002 },
	BGN: { lat: 68.556227, lon: 146.22784 },
	SEK: { lat: 67.4805, lon: 153.7364 },
	CKH: { lat: 70.6231, lon: 147.901993 },
	CYX: { lat: 68.740601, lon: 161.337997 },
	IKS: { lat: 71.697701, lon: 128.903 },
	ZKP: { lat: 65.7485, lon: 150.8889 },
	ZIX: { lat: 66.796501, lon: 123.361 },
	KXO: { lat: -1.2837, lon: 29.7197 },
	KHX: { lat: -0.7165, lon: 29.6997 },
	OYG: { lat: 3.6444, lon: 31.762762 },
	UGB: { lat: 57.424052, lon: -157.74479 },
	KUT: { lat: 42.176768, lon: 42.482393 },
	BUS: { lat: 41.610298, lon: 41.599701 },
	SUI: { lat: 42.8582, lon: 41.128101 },
	TBS: { lat: 41.669201, lon: 44.9547 },
	BQS: { lat: 50.4254, lon: 127.412003 },
	EYA: { lat: 53.687023, lon: 127.090972 },
	TYD: { lat: 55.284936, lon: 124.77901 },
	KHV: { lat: 48.528338, lon: 135.188588 },
	KXK: { lat: 50.409, lon: 136.934006 },
	GVN: { lat: 48.925067, lon: 140.035348 },
	DYR: { lat: 64.734902, lon: 177.740997 },
	PVS: { lat: 64.378098, lon: -173.242996 },
	KPW: { lat: 67.845001, lon: 166.139999 },
	GDX: { lat: 59.910999, lon: 150.720001 },
	KVM: { lat: 64.665446, lon: 170.417626 },
	PWE: { lat: 69.783302, lon: 170.597 },
	SWV: { lat: 61.921786, lon: 159.229059 },
	BQG: { lat: 52.381041, lon: 140.449378 },
	NLI: { lat: 53.154999, lon: 140.649994 },
	OHO: { lat: 59.410065, lon: 143.056503 },
	PKC: { lat: 53.168716, lon: 158.451068 },
	BVV: { lat: 44.919998, lon: 147.621994 },
	OHH: { lat: 53.516446, lon: 142.881426 },
	ITU: { lat: 45.256389, lon: 147.95549 },
	EKS: { lat: 49.1903, lon: 142.082993 },
	DEE: { lat: 43.961066, lon: 145.684977 },
	NGK: { lat: 51.783955, lon: 143.141785 },
	ZZO: { lat: 50.669929, lon: 142.760082 },
	UUS: { lat: 46.885461, lon: 142.717466 },
	AEM: { lat: 45.84126, lon: 137.673568 },
	ETL: { lat: 46.541704, lon: 138.321703 },
	EDN: { lat: 47.178201, lon: 138.657357 },
	KVR: { lat: 44.2726, lon: 135.029 },
	TLY: { lat: 44.814999, lon: 136.292007 },
	NEI: { lat: 45.0825, lon: 136.5912 },
	VVO: { lat: 43.396256, lon: 132.148155 },
	HTA: { lat: 52.026299, lon: 113.306 },
	CZR: { lat: 56.913334, lon: 118.269997 },
	BTK: { lat: 56.370602, lon: 101.697998 },
	UIK: { lat: 58.136101, lon: 102.565002 },
	IKT: { lat: 52.268002, lon: 104.389 },
	ODO: { lat: 57.8661, lon: 114.242996 },
	ERG: { lat: 61.275002, lon: 108.029999 },
	KCK: { lat: 57.773, lon: 108.064 },
	RZH: { lat: 42.921698, lon: 133.904438 },
	UKX: { lat: 56.856701, lon: 105.730003 },
	NZG: { lat: 55.8008, lon: 109.595001 },
	UUD: { lat: 51.808614, lon: 107.439652 },
	KBP: { lat: 50.345001, lon: 30.894699 },
	KRQ: { lat: 48.706799, lon: 37.630922 },
	MPW: { lat: 47.076099, lon: 37.4496 },
	ERD: { lat: 46.814999, lon: 36.758099 },
	DNK: { lat: 48.357201, lon: 35.100601 },
	OZH: { lat: 47.867001, lon: 35.315701 },
	KWG: { lat: 48.043301, lon: 33.209999 },
	UKS: { lat: 44.691822, lon: 33.57462 },
	SIP: { lat: 45.0522, lon: 33.975101 },
	KHC: { lat: 45.372501, lon: 36.401402 },
	UKH: { lat: 19.386389, lon: 56.401389 },
	HRK: { lat: 49.926943, lon: 36.290814 },
	PLV: { lat: 49.5686, lon: 34.397202 },
	UMY: { lat: 50.858299, lon: 34.762501 },
	CKC: { lat: 49.4156, lon: 31.9953 },
	KGO: { lat: 48.542801, lon: 32.285 },
	IEV: { lat: 50.40194, lon: 30.45194 },
	ZTR: { lat: 50.270556, lon: 28.738611 },
	UCK: { lat: 50.678404, lon: 25.487165 },
	HMJ: { lat: 49.359699, lon: 26.933399 },
	IFO: { lat: 48.884201, lon: 24.6861 },
	LWO: { lat: 49.8125, lon: 23.9561 },
	CWC: { lat: 48.2593, lon: 25.980801 },
	RWN: { lat: 50.607101, lon: 26.1416 },
	TNL: { lat: 49.5242, lon: 25.7001 },
	UDJ: { lat: 48.6343, lon: 22.263399 },
	KHE: { lat: 46.6758, lon: 32.506401 },
	NLV: { lat: 47.057899, lon: 31.9198 },
	ODS: { lat: 46.4268, lon: 30.6765 },
	VIN: { lat: 49.242531, lon: 28.613778 },
	ARH: { lat: 64.600304, lon: 40.716702 },
	VKV: { lat: 64.441704, lon: 40.4217 },
	LDG: { lat: 64.896004, lon: 45.723 },
	NNM: { lat: 67.639999, lon: 53.121899 },
	CSH: { lat: 65.029999, lon: 35.733334 },
	AMV: { lat: 69.763298, lon: 61.5564 },
	VRI: { lat: 68.848503, lon: 58.201401 },
	KSZ: { lat: 61.235802, lon: 46.697498 },
	LED: { lat: 59.800301, lon: 30.262501 },
	MMK: { lat: 68.7817, lon: 32.750801 },
	PKV: { lat: 57.783901, lon: 28.395599 },
	PES: { lat: 61.885201, lon: 34.154701 },
	CEE: { lat: 59.273602, lon: 38.0158 },
	VUS: { lat: 60.7883, lon: 46.259998 },
	VGD: { lat: 59.282501, lon: 39.944401 },
	BQT: { lat: 52.108299, lon: 23.8981 },
	GME: { lat: 52.527, lon: 31.016701 },
	VTB: { lat: 55.126499, lon: 30.3496 },
	KGD: { lat: 54.891616, lon: 20.598607 },
	GNA: { lat: 53.602001, lon: 24.053801 },
	MSQ: { lat: 53.888071, lon: 28.039964 },
	MVQ: { lat: 53.954899, lon: 30.0951 },
	ABA: { lat: 53.740002, lon: 91.385002 },
	BAX: { lat: 53.3638, lon: 83.538498 },
	RGK: { lat: 51.969204, lon: 85.836539 },
	KEJ: { lat: 55.2701, lon: 86.107201 },
	BKA: { lat: 61.676701, lon: 96.355003 },
	EIE: { lat: 58.474201, lon: 92.112503 },
	YAE: { lat: 60.255001, lon: 90.195 },
	TGP: { lat: 61.589699, lon: 89.994003 },
	VEO: { lat: 60.373299, lon: 93.011703 },
	GOY: { lat: 64.333511, lon: 100.432892 },
	VAQ: { lat: 60.356229, lon: 102.309641 },
	BGS: { lat: 58.380615, lon: 97.472336 },
	KNY: { lat: 58.479401, lon: 99.093903 },
	KJA: { lat: 56.173077, lon: 92.492437 },
	KCY: { lat: 56.177584, lon: 92.545881 },
	ACS: { lat: 56.269185, lon: 90.57511 },
	KYZ: { lat: 51.669399, lon: 94.400597 },
	OVB: { lat: 55.019756, lon: 82.618675 },
	OMS: { lat: 54.966999, lon: 73.310501 },
	SWT: { lat: 60.7094, lon: 77.660004 },
	TOF: { lat: 56.380299, lon: 85.208298 },
	NOZ: { lat: 53.811401, lon: 86.877197 },
	DKS: { lat: 73.517807, lon: 80.379669 },
	HTG: { lat: 71.978104, lon: 102.490997 },
	SES: { lat: 66.839996, lon: 88.403336 },
	IAA: { lat: 67.437202, lon: 86.621902 },
	NSK: { lat: 69.311096, lon: 87.332199 },
	THX: { lat: 65.797203, lon: 87.935303 },
	AAQ: { lat: 45.002102, lon: 37.347301 },
	GDZ: { lat: 44.582093, lon: 38.012481 },
	KRR: { lat: 45.034698, lon: 39.170502 },
	GRV: { lat: 43.388106, lon: 45.699772 },
	MCX: { lat: 42.816799, lon: 47.652302 },
	MRV: { lat: 44.225101, lon: 43.081902 },
	NAL: { lat: 43.512901, lon: 43.6366 },
	OGZ: { lat: 43.205101, lon: 44.606602 },
	IGT: { lat: 43.323268, lon: 45.012568 },
	STW: { lat: 45.1092, lon: 42.112801 },
	ROV: { lat: 47.493888, lon: 39.924722 },
	TGK: { lat: 47.198333, lon: 38.849167 },
	AER: { lat: 43.449902, lon: 39.9566 },
	ASF: { lat: 46.282843, lon: 48.010511 },
	ESL: { lat: 46.373901, lon: 44.330898 },
	VOG: { lat: 48.782501, lon: 44.345501 },
	BNH: { lat: 42.352502, lon: -71.025832 },
	RTL: { lat: 43.387501, lon: -95.139198 },
	FWL: { lat: 62.509327, lon: -153.892279 },
	CRO: { lat: 36.102661, lon: -119.594815 },
	HLM: { lat: 42.795898, lon: -86.162003 },
	XFT: { lat: 24.723717, lon: -81.387856 },
	PQS: { lat: 61.96169, lon: -162.941944 },
	CEK: { lat: 55.305801, lon: 61.5033 },
	MQF: { lat: 53.393101, lon: 58.755699 },
	SBT: { lat: 71.219167, lon: 72.052222 },
	BVJ: { lat: 70.315278, lon: 68.333611 },
	SLY: { lat: 66.590797, lon: 66.611 },
	YMK: { lat: 68.467676, lon: 73.596733 },
	KKQ: { lat: 65.717, lon: 82.455 },
	TQL: { lat: 64.930485, lon: 77.811295 },
	UEN: { lat: 65.959999, lon: 78.436996 },
	EZV: { lat: 63.921001, lon: 65.030502 },
	HMA: { lat: 61.0285, lon: 69.086098 },
	IRM: { lat: 63.200391, lon: 64.440136 },
	KXD: { lat: 59.655083, lon: 67.430046 },
	NYA: { lat: 62.110001, lon: 65.614998 },
	EYK: { lat: 63.686901, lon: 66.698601 },
	OVS: { lat: 61.326622, lon: 63.601913 },
	URJ: { lat: 60.103298, lon: 64.826698 },
	IJK: { lat: 56.828098, lon: 53.4575 },
	KVX: { lat: 58.503883, lon: 49.347831 },
	NYM: { lat: 65.480904, lon: 72.698898 },
	NUX: { lat: 66.069397, lon: 76.520302 },
	NJC: { lat: 60.949299, lon: 76.483597 },
	PEE: { lat: 57.914501, lon: 56.021198 },
	KGP: { lat: 62.190399, lon: 74.533798 },
	NFG: { lat: 61.108299, lon: 72.650002 },
	NOJ: { lat: 63.1833, lon: 75.269997 },
	SGC: { lat: 61.3437, lon: 73.401802 },
	SVX: { lat: 56.743099, lon: 60.8027 },
	RMZ: { lat: 58.058427, lon: 68.348801 },
	TOX: { lat: 58.135799, lon: 68.231903 },
	TJM: { lat: 57.178984, lon: 65.327696 },
	KRO: { lat: 55.4753, lon: 65.415604 },
	BKN: { lat: 39.480598, lon: 54.366001 },
	GMV: { lat: 37.015868, lon: -110.202031 },
	ASB: { lat: 37.986801, lon: 58.361 },
	KEA: { lat: 37.822051, lon: 65.135279 },
	KRW: { lat: 40.063301, lon: 53.007198 },
	MYP: { lat: 37.62353, lon: 61.895668 },
	TAZ: { lat: 41.759853, lon: 59.836149 },
	CRZ: { lat: 38.930662, lon: 63.563982 },
	DYU: { lat: 38.543746, lon: 68.822977 },
	TJU: { lat: 37.988098, lon: 69.805 },
	LBD: { lat: 40.215401, lon: 69.694702 },
	KQT: { lat: 37.866402, lon: 68.8647 },
	NMA: { lat: 40.9846, lon: 71.556702 },
	AZN: { lat: 40.727699, lon: 72.293999 },
	FEG: { lat: 40.358799, lon: 71.745003 },
	OQN: { lat: 40.447183, lon: 70.989144 },
	MOK: { lat: 43.753636, lon: 59.029884 },
	NCU: { lat: 42.4884, lon: 59.623299 },
	UGC: { lat: 41.584301, lon: 60.641701 },
	NVI: { lat: 40.117199, lon: 65.170799 },
	BHK: { lat: 39.775002, lon: 64.483299 },
	KSQ: { lat: 38.802246, lon: 65.773068 },
	AFS: { lat: 41.613899, lon: 64.2332 },
	SKD: { lat: 39.7005, lon: 66.983803 },
	TMJ: { lat: 37.287261, lon: 67.311869 },
	TAS: { lat: 41.2579, lon: 69.281197 },
	OMN: { lat: 40.01402, lon: 68.41103 },
	UTU: { lat: 9.1283, lon: -77.9337 },
	KMW: { lat: 57.796902, lon: 41.019402 },
	KLF: { lat: 54.549999, lon: 36.366669 },
	IWA: { lat: 56.9394, lon: 40.9408 },
	RYB: { lat: 58.104198, lon: 38.929401 },
	BZK: { lat: 53.214199, lon: 34.176399 },
	ZIA: { lat: 55.553299, lon: 38.150002 },
	DME: { lat: 55.408798, lon: 37.9063 },
	IAR: { lat: 57.560699, lon: 40.157398 },
	SVO: { lat: 55.972599, lon: 37.4146 },
	KLD: { lat: 56.824699, lon: 35.757702 },
	OSF: { lat: 55.511667, lon: 37.507222 },
	CKL: { lat: 55.8783, lon: 38.061699 },
	EGO: { lat: 50.643799, lon: 36.590099 },
	URS: { lat: 51.750599, lon: 36.295601 },
	LPK: { lat: 52.702801, lon: 39.5378 },
	VOZ: { lat: 51.814201, lon: 39.229599 },
	TBW: { lat: 52.806099, lon: 41.4828 },
	UUU: { lat: -9.0746, lon: 147.5735 },
	VKO: { lat: 55.591499, lon: 37.261501 },
	UCT: { lat: 63.566898, lon: 53.804699 },
	INA: { lat: 66.053372, lon: 60.105786 },
	PEX: { lat: 65.121101, lon: 57.130798 },
	USK: { lat: 66.0047, lon: 57.367199 },
	VKT: { lat: 67.488602, lon: 63.993099 },
	UTS: { lat: 65.437294, lon: 52.200336 },
	SCW: { lat: 61.646999, lon: 50.8451 },
	GOJ: { lat: 56.228254, lon: 43.785197 },
	UUA: { lat: 54.641184, lon: 52.800229 },
	KZN: { lat: 55.606201, lon: 49.278702 },
	NBC: { lat: 55.564701, lon: 52.092499 },
	JOK: { lat: 56.7006, lon: 47.904701 },
	CSY: { lat: 56.090302, lon: 47.347301 },
	ULV: { lat: 54.268299, lon: 48.2267 },
	ULY: { lat: 54.401001, lon: 48.8027 },
	REN: { lat: 51.795799, lon: 55.456699 },
	OSW: { lat: 51.072498, lon: 58.5956 },
	PEZ: { lat: 53.1106, lon: 45.021099 },
	SKX: { lat: 54.12513, lon: 45.212257 },
	BWO: { lat: 51.858299, lon: 47.745602 },
	GSV: { lat: 51.712778, lon: 46.171111 },
	BCX: { lat: 53.938389, lon: 58.340113 },
	OKT: { lat: 54.439999, lon: 53.388302 },
	UFA: { lat: 54.557499, lon: 55.874401 },
	KUF: { lat: 53.504902, lon: 50.164299 },
	RBZ: { lat: 39.030067, lon: 66.775825 },
	UZM: { lat: 68.156, lon: -106.618 },
	UZR: { lat: 47.09115, lon: 81.66521 },
	REW: { lat: 24.503401, lon: 81.220299 },
	DIU: { lat: 20.714185, lon: 70.921855 },
	GDB: { lat: 21.526817, lon: 80.290347 },
	AMD: { lat: 23.0772, lon: 72.634697 },
	AKD: { lat: 20.698931, lon: 77.056883 },
	IXU: { lat: 19.8627, lon: 75.398102 },
	BOM: { lat: 19.088699, lon: 72.867897 },
	BHJ: { lat: 23.2878, lon: 69.670197 },
	IXG: { lat: 15.8593, lon: 74.618301 },
	BDQ: { lat: 22.336201, lon: 73.226303 },
	BHO: { lat: 23.2875, lon: 77.337402 },
	BHU: { lat: 21.752199, lon: 72.185204 },
	NMB: { lat: 20.434401, lon: 72.843201 },
	GUX: { lat: 24.654699, lon: 77.347298 },
	HBX: { lat: 15.3617, lon: 75.0849 },
	HSR: { lat: 22.378824, lon: 71.039391 },
	IDR: { lat: 22.7218, lon: 75.801102 },
	JLR: { lat: 23.177799, lon: 80.052002 },
	JLG: { lat: 20.962678, lon: 75.627492 },
	JGA: { lat: 22.4655, lon: 70.012604 },
	IXY: { lat: 23.1127, lon: 70.100304 },
	HJR: { lat: 24.8172, lon: 79.918602 },
	KLH: { lat: 16.6647, lon: 74.289398 },
	IXK: { lat: 21.317101, lon: 70.270401 },
	LTU: { lat: 18.411501, lon: 76.464699 },
	NDC: { lat: 19.1833, lon: 77.316704 },
	NAG: { lat: 21.092199, lon: 79.047203 },
	ISK: { lat: 20.119101, lon: 73.912903 },
	PNQ: { lat: 18.5821, lon: 73.919701 },
	PBD: { lat: 21.649524, lon: 69.656405 },
	RTC: { lat: 17.013599, lon: 73.327797 },
	RAJ: { lat: 22.3092, lon: 70.779503 },
	RPR: { lat: 21.180401, lon: 81.7388 },
	SAG: { lat: 19.688752, lon: 74.377354 },
	SSE: { lat: 17.628, lon: 75.934799 },
	STV: { lat: 21.1141, lon: 72.741798 },
	UDR: { lat: 24.617701, lon: 73.896103 },
	CMB: { lat: 7.18076, lon: 79.884102 },
	ACJ: { lat: 8.301542, lon: 80.42848 },
	BTC: { lat: 7.70576, lon: 81.678802 },
	RML: { lat: 6.82199, lon: 79.8862 },
	ADP: { lat: 7.336745, lon: 81.623869 },
	HIM: { lat: 8.04981, lon: 80.9814 },
	JAF: { lat: 9.79233, lon: 80.070099 },
	KCT: { lat: 5.99368, lon: 80.320297 },
	KTY: { lat: 6.55212, lon: 79.977501 },
	GIU: { lat: 7.95667, lon: 80.7285 },
	TRR: { lat: 8.539159, lon: 81.18128 },
	WRZ: { lat: 6.25449, lon: 81.235199 },
	HRI: { lat: 6.284467, lon: 81.124128 },
	BBM: { lat: 13.0956, lon: 103.223999 },
	KKZ: { lat: 11.613397, lon: 102.997084 },
	MWV: { lat: 12.464562, lon: 107.188039 },
	PNH: { lat: 11.5466, lon: 104.844002 },
	RBE: { lat: 13.73, lon: 106.987 },
	SAI: { lat: 13.369167, lon: 104.223056 },
	KOS: { lat: 10.571969, lon: 103.632689 },
	KZD: { lat: 12.5385, lon: 104.1486 },
	SFX: { lat: 8.2788, lon: -62.6652 },
	SVV: { lat: 7.0, lon: -62.0 },
	ELX: { lat: 8.833546, lon: -64.20828 },
	AZH: { lat: 26.153333, lon: 83.118333 },
	IXV: { lat: 28.175301, lon: 94.802002 },
	IXA: { lat: 23.886999, lon: 91.240402 },
	IXB: { lat: 26.6812, lon: 88.328598 },
	RGH: { lat: 25.2617, lon: 88.795601 },
	SHL: { lat: 25.7036, lon: 91.978699 },
	VNS: { lat: 25.452129, lon: 82.861805 },
	BBI: { lat: 20.2444, lon: 85.817802 },
	PAB: { lat: 21.9884, lon: 82.111 },
	CCU: { lat: 22.654699, lon: 88.446701 },
	COH: { lat: 26.3305, lon: 89.467201 },
	CWK: { lat: 25.167694, lon: 80.9358 },
	DBD: { lat: 23.834, lon: 86.425301 },
	RDP: { lat: 23.6225, lon: 87.243 },
	DBR: { lat: 26.192801, lon: 85.916901 },
	DGH: { lat: 24.446842, lon: 86.704955 },
	DEP: { lat: 27.9855, lon: 94.222801 },
	GOP: { lat: 26.7397, lon: 83.449699 },
	GAU: { lat: 26.1061, lon: 91.585899 },
	GAY: { lat: 24.744301, lon: 84.951202 },
	IMF: { lat: 24.76, lon: 93.896698 },
	JRG: { lat: 21.9135, lon: 84.0504 },
	PYB: { lat: 18.879549, lon: 82.552478 },
	IXW: { lat: 22.813706, lon: 86.168981 },
	JRH: { lat: 26.730456, lon: 94.175416 },
	KBK: { lat: 26.776534, lon: 83.889214 },
	IXQ: { lat: 24.134325, lon: 91.810769 },
	IXH: { lat: 24.308657, lon: 92.00768 },
	IXS: { lat: 24.912901, lon: 92.978699 },
	IXN: { lat: 24.061899, lon: 91.603897 },
	AJL: { lat: 23.840599, lon: 92.619698 },
	IXI: { lat: 27.295682, lon: 94.097266 },
	LDA: { lat: 25.01018, lon: 88.126917 },
	DIB: { lat: 27.4839, lon: 95.016899 },
	DMU: { lat: 25.8839, lon: 93.771103 },
	MZU: { lat: 26.119101, lon: 85.313698 },
	IXT: { lat: 28.064786, lon: 95.336952 },
	PAT: { lat: 25.591299, lon: 85.087997 },
	IXR: { lat: 23.314301, lon: 85.321701 },
	RRK: { lat: 22.256571, lon: 84.815193 },
	RUP: { lat: 26.141867, lon: 89.907892 },
	TEI: { lat: 27.9412, lon: 96.134399 },
	TEZ: { lat: 26.709101, lon: 92.784698 },
	VTZ: { lat: 17.723506, lon: 83.227729 },
	ZER: { lat: 27.588301, lon: 93.828102 },
	RAD: { lat: 18.418273, lon: -64.617369 },
	BZL: { lat: 22.801001, lon: 90.301201 },
	CXB: { lat: 21.457517, lon: 91.963263 },
	CLA: { lat: 23.440133, lon: 91.188685 },
	CGP: { lat: 22.249599, lon: 91.813301 },
	DAC: { lat: 23.843347, lon: 90.397783 },
	IRD: { lat: 24.1525, lon: 89.0494 },
	JSR: { lat: 23.1838, lon: 89.160797 },
	RJH: { lat: 24.437201, lon: 88.616501 },
	SPD: { lat: 25.759199, lon: 88.908897 },
	TKR: { lat: 26.016378, lon: 88.402092 },
	ZHM: { lat: 24.398333, lon: 91.916944 },
	ZYL: { lat: 24.963832, lon: 91.864843 },
	HKG: { lat: 22.308901, lon: 113.915001 },
	HHP: { lat: 22.288868, lon: 114.152369 },
	SPB: { lat: 18.338204, lon: -64.939675 },
	SSB: { lat: 17.7472, lon: -64.704903 },
	AGR: { lat: 27.157683, lon: 77.960942 },
	HRH: { lat: 27.861437, lon: 78.145404 },
	IXD: { lat: 25.4401, lon: 81.733902 },
	ATQ: { lat: 31.7096, lon: 74.797302 },
	AIP: { lat: 31.4338, lon: 75.758797 },
	BKB: { lat: 28.070601, lon: 73.207199 },
	KUU: { lat: 31.876699, lon: 77.154404 },
	BUP: { lat: 30.2701, lon: 74.755798 },
	BEK: { lat: 28.4221, lon: 79.450798 },
	IXC: { lat: 30.6735, lon: 76.788498 },
	KNU: { lat: 26.404301, lon: 80.410103 },
	DED: { lat: 30.189243, lon: 78.176651 },
	DEL: { lat: 28.55563, lon: 77.09519 },
	HDO: { lat: 28.707701, lon: 77.358902 },
	DHM: { lat: 32.164902, lon: 76.263018 },
	GWL: { lat: 26.293301, lon: 78.227798 },
	HSS: { lat: 29.179399, lon: 75.755302 },
	JDH: { lat: 26.251101, lon: 73.048897 },
	JAI: { lat: 26.8242, lon: 75.812202 },
	JSA: { lat: 26.8887, lon: 70.864998 },
	IXJ: { lat: 32.688849, lon: 74.838152 },
	KQH: { lat: 26.591007, lon: 74.812956 },
	KTU: { lat: 25.1602, lon: 75.845596 },
	LUH: { lat: 30.8547, lon: 75.952599 },
	IXL: { lat: 34.135899, lon: 77.546501 },
	LKO: { lat: 26.760599, lon: 80.889297 },
	MZS: { lat: 28.81746, lon: 78.92187 },
	IXP: { lat: 32.233611, lon: 75.634444 },
	PGH: { lat: 29.0334, lon: 79.473701 },
	SLV: { lat: 31.0818, lon: 77.068001 },
	SWN: { lat: 29.994303, lon: 77.42456 },
	SXR: { lat: 33.987099, lon: 74.7742 },
	TNI: { lat: 24.56262, lon: 80.852927 },
	VSV: { lat: 27.499732, lon: 82.032927 },
	VIV: { lat: -9.303333, lon: 150.318889 },
	VJQ: { lat: -15.5062, lon: 36.9904 },
	AOU: { lat: 14.793056, lon: 107.045278 },
	HOE: { lat: 20.257299, lon: 100.436996 },
	LPQ: { lat: 19.897301, lon: 102.161003 },
	LXG: { lat: 20.966999, lon: 101.400002 },
	ODY: { lat: 20.682699, lon: 101.994003 },
	PKZ: { lat: 15.1321, lon: 105.780998 },
	ZBY: { lat: 19.2436, lon: 101.7093 },
	ZVK: { lat: 16.556601, lon: 104.760002 },
	NEU: { lat: 20.4184, lon: 104.067001 },
	VNA: { lat: 15.709026, lon: 106.410937 },
	THK: { lat: 17.377917, lon: 104.857378 },
	VTE: { lat: 17.9883, lon: 102.563004 },
	XKH: { lat: 19.450001, lon: 103.157997 },
	XIE: { lat: 19.6203, lon: 100.815332 },
	VMI: { lat: -22.159371, lon: -57.942395 },
	MFM: { lat: 22.149599, lon: 113.592003 },
	BJH: { lat: 29.539, lon: 81.185402 },
	BHP: { lat: 27.1474, lon: 87.050797 },
	BGL: { lat: 28.212799, lon: 83.666298 },
	BHR: { lat: 27.678101, lon: 84.429398 },
	BJU: { lat: 29.502001, lon: 81.668999 },
	BIT: { lat: 29.463421, lon: 80.548968 },
	BWA: { lat: 27.505328, lon: 83.412594 },
	BDP: { lat: 26.570801, lon: 88.079597 },
	DNP: { lat: 28.111099, lon: 82.294197 },
	DHI: { lat: 28.755283, lon: 80.583398 },
	DAP: { lat: 29.668571, lon: 80.548199 },
	DOP: { lat: 28.985659, lon: 82.818703 },
	SIH: { lat: 29.262226, lon: 80.935968 },
	GKH: { lat: 28.0385, lon: 84.4664 },
	JIR: { lat: 27.626313, lon: 86.230581 },
	JUM: { lat: 29.2742, lon: 82.193298 },
	JKR: { lat: 26.708799, lon: 85.922401 },
	JMO: { lat: 28.780426, lon: 83.723 },
	KTM: { lat: 27.6966, lon: 85.3591 },
	LDN: { lat: 27.253099, lon: 86.669998 },
	LUA: { lat: 27.686768, lon: 86.729479 },
	LTG: { lat: 28.200001, lon: 85.583 },
	NGX: { lat: 28.641399, lon: 84.089203 },
	MEY: { lat: 27.5774, lon: 84.22875 },
	XMG: { lat: 28.9632, lon: 80.147903 },
	KEP: { lat: 28.1036, lon: 81.667 },
	PKR: { lat: 28.200621, lon: 83.981203 },
	PPL: { lat: 27.517752, lon: 86.585019 },
	RJB: { lat: 26.510066, lon: 86.733902 },
	RHP: { lat: 27.393999, lon: 86.061401 },
	RUK: { lat: 28.627001, lon: 82.194021 },
	RPA: { lat: 28.267292, lon: 82.756496 },
	RUM: { lat: 27.303499, lon: 86.5504 },
	SYH: { lat: 27.8112, lon: 86.7124 },
	SIF: { lat: 27.159803, lon: 84.980021 },
	SKH: { lat: 28.586, lon: 81.636002 },
	FEB: { lat: 29.236629, lon: 81.215317 },
	IMK: { lat: 29.9711, lon: 81.818901 },
	TPJ: { lat: 27.3509, lon: 87.69525 },
	TPU: { lat: 28.5219, lon: 81.123 },
	TMI: { lat: 27.315001, lon: 87.193298 },
	BIR: { lat: 26.481501, lon: 87.264 },
	AGX: { lat: 10.8237, lon: 72.176003 },
	BEP: { lat: 15.1628, lon: 76.882797 },
	BLR: { lat: 13.1979, lon: 77.706299 },
	IXX: { lat: 17.9081, lon: 77.487099 },
	VGA: { lat: 16.530399, lon: 80.796799 },
	CJB: { lat: 11.03, lon: 77.043404 },
	COK: { lat: 10.151047, lon: 76.400838 },
	CCJ: { lat: 11.1368, lon: 75.955299 },
	CDP: { lat: 14.513154, lon: 78.769183 },
	CBD: { lat: 9.153056, lon: 92.819273 },
	GOX: { lat: 15.744257, lon: 73.860625 },
	GBI: { lat: 17.308154, lon: 76.965246 },
	GOI: { lat: 15.3808, lon: 73.831398 },
	HYD: { lat: 17.231318, lon: 78.429855 },
	BPM: { lat: 17.4531, lon: 78.467598 },
	VDY: { lat: 15.175921, lon: 76.63303 },
	CNN: { lat: 11.918614, lon: 75.547211 },
	KJB: { lat: 15.716288, lon: 78.16923 },
	IXM: { lat: 9.83451, lon: 78.093399 },
	IXE: { lat: 12.9613, lon: 74.890099 },
	MAA: { lat: 12.990005, lon: 80.169296 },
	MYQ: { lat: 12.23, lon: 76.655833 },
	NVY: { lat: 11.612956, lon: 79.527382 },
	IXZ: { lat: 11.641208, lon: 92.729643 },
	PNY: { lat: 11.968, lon: 79.812 },
	PUT: { lat: 14.1493, lon: 77.7911 },
	RMD: { lat: 18.701, lon: 79.3923 },
	RJA: { lat: 17.105799, lon: 81.813204 },
	SXV: { lat: 11.7833, lon: 78.065598 },
	TJV: { lat: 10.723835, lon: 79.109457 },
	TCR: { lat: 8.724241, lon: 78.025803 },
	TIR: { lat: 13.6325, lon: 79.543297 },
	TRZ: { lat: 10.766223, lon: 78.71774 },
	TRV: { lat: 8.48212, lon: 76.920097 },
	WGC: { lat: 17.9144, lon: 79.602203 },
	BUT: { lat: 27.5622, lon: 90.7471 },
	GLU: { lat: 26.88456, lon: 90.46412 },
	PBH: { lat: 27.4032, lon: 89.424599 },
	YON: { lat: 27.25627, lon: 91.514633 },
	HRF: { lat: 6.96967, lon: 72.896287 },
	HDK: { lat: 6.630762, lon: 73.067815 },
	NMF: { lat: 5.818394, lon: 73.469181 },
	IFU: { lat: 5.7083, lon: 73.025 },
	DRV: { lat: 5.1561, lon: 73.1302 },
	FVM: { lat: -0.309722, lon: 73.435 },
	GAN: { lat: -0.692694, lon: 73.151557 },
	HAQ: { lat: 6.74423, lon: 73.170502 },
	KDO: { lat: 1.85917, lon: 73.521896 },
	MLE: { lat: 4.19183, lon: 73.529099 },
	GKK: { lat: 0.7324, lon: 73.4336 },
	KDM: { lat: 0.488131, lon: 72.996902 },
	DDD: { lat: 2.666075, lon: 72.887118 },
	VAM: { lat: 3.470556, lon: 72.835833 },
	TMF: { lat: 2.211, lon: 73.1533 },
	RUL: { lat: 0.338085, lon: 73.512869 },
	DMK: { lat: 13.9126, lon: 100.607002 },
	KDT: { lat: 14.102, lon: 99.917198 },
	KKM: { lat: 14.87462, lon: 100.663397 },
	TDX: { lat: 12.2746, lon: 102.319 },
	BKK: { lat: 13.6811, lon: 100.747002 },
	UTP: { lat: 12.6799, lon: 101.004997 },
	CNX: { lat: 18.7668, lon: 98.962601 },
	HGN: { lat: 19.3013, lon: 97.9758 },
	PYY: { lat: 19.372054, lon: 98.435904 },
	LPT: { lat: 18.270901, lon: 99.504204 },
	NNT: { lat: 18.807899, lon: 100.782997 },
	PRH: { lat: 18.1322, lon: 100.165001 },
	CEI: { lat: 19.952299, lon: 99.882896 },
	PHY: { lat: 16.676001, lon: 101.195 },
	HHQ: { lat: 12.6362, lon: 99.9515 },
	TKH: { lat: 15.2773, lon: 100.295998 },
	MAQ: { lat: 16.6999, lon: 98.545097 },
	THS: { lat: 17.238001, lon: 99.818199 },
	PHS: { lat: 16.7829, lon: 100.278999 },
	TKT: { lat: 16.896, lon: 99.253304 },
	URT: { lat: 9.1326, lon: 99.135597 },
	NAW: { lat: 6.51992, lon: 101.742996 },
	CJM: { lat: 10.7112, lon: 99.361702 },
	NST: { lat: 8.53962, lon: 99.944702 },
	KBV: { lat: 8.09912, lon: 98.986198 },
	SGZ: { lat: 7.18656, lon: 100.608002 },
	PAN: { lat: 6.78546, lon: 101.153999 },
	USM: { lat: 9.54779, lon: 100.061996 },
	HKT: { lat: 8.1132, lon: 98.316902 },
	UNN: { lat: 9.77762, lon: 98.585503 },
	HDY: { lat: 6.93321, lon: 100.392998 },
	TST: { lat: 7.50874, lon: 99.6166 },
	UTH: { lat: 17.3864, lon: 102.788002 },
	SNO: { lat: 17.195101, lon: 104.119003 },
	PXR: { lat: 14.8683, lon: 103.498001 },
	KKC: { lat: 16.4666, lon: 102.783997 },
	LOE: { lat: 17.4391, lon: 101.722 },
	BFV: { lat: 15.2295, lon: 103.252998 },
	NAK: { lat: 14.9495, lon: 102.313004 },
	UBP: { lat: 15.2513, lon: 104.870003 },
	ROI: { lat: 16.1168, lon: 103.774002 },
	KOP: { lat: 17.383801, lon: 104.642998 },
	VUU: { lat: -14.838611, lon: 35.301389 },
	BMV: { lat: 12.6683, lon: 108.120003 },
	VCL: { lat: 15.4033, lon: 108.706001 },
	HPH: { lat: 20.81686, lon: 106.722994 },
	CAH: { lat: 9.177667, lon: 105.177778 },
	CXR: { lat: 11.9982, lon: 109.219002 },
	VCS: { lat: 8.73183, lon: 106.633003 },
	VCA: { lat: 10.0851, lon: 105.711998 },
	DIN: { lat: 21.397499, lon: 103.008003 },
	VDH: { lat: 17.515, lon: 106.590556 },
	DLI: { lat: 11.750556, lon: 108.366997 },
	DAD: { lat: 16.0439, lon: 108.198997 },
	VVN: { lat: -11.854861, lon: -72.939332 },
	HAN: { lat: 21.221201, lon: 105.806999 },
	SQH: { lat: 21.215301, lon: 104.032803 },
	HUI: { lat: 16.400628, lon: 107.703094 },
	UIH: { lat: 13.955, lon: 109.042 },
	PXU: { lat: 14.0045, lon: 108.016998 },
	PQC: { lat: 10.1698, lon: 103.9931 },
	PHA: { lat: 11.6335, lon: 108.952003 },
	VKG: { lat: 9.95803, lon: 105.13238 },
	TBB: { lat: 13.0496, lon: 109.334 },
	SGN: { lat: 10.8188, lon: 106.652 },
	THD: { lat: 19.901667, lon: 105.467778 },
	VDO: { lat: 21.120693, lon: 107.41539 },
	VII: { lat: 18.7376, lon: 105.670998 },
	VTG: { lat: 10.375093, lon: 107.096185 },
	VBA: { lat: 19.769199, lon: 94.0261 },
	NYU: { lat: 21.178801, lon: 94.930199 },
	BMO: { lat: 24.27044, lon: 97.2476 },
	VBP: { lat: 11.1494, lon: 98.735901 },
	VBC: { lat: 21.9405, lon: 96.0896 },
	TVY: { lat: 14.1039, lon: 98.203598 },
	SRU: { lat: 22.939167, lon: 93.615333 },
	GAW: { lat: 22.1747, lon: 94.134399 },
	GWA: { lat: 17.6, lon: 94.583298 },
	HEH: { lat: 20.74714, lon: 96.792029 },
	HOX: { lat: 24.899599, lon: 94.914001 },
	TIO: { lat: 21.700001, lon: 94.099998 },
	KET: { lat: 21.3016, lon: 99.636002 },
	KHM: { lat: 25.9883, lon: 95.6744 },
	KMV: { lat: 23.188801, lon: 94.051102 },
	KYP: { lat: 19.426399, lon: 93.534798 },
	KAW: { lat: 10.0493, lon: 98.538002 },
	KYT: { lat: 21.4, lon: 94.133301 },
	LIW: { lat: 19.6915, lon: 97.214798 },
	LSH: { lat: 22.9779, lon: 97.752197 },
	MDL: { lat: 21.7022, lon: 95.977898 },
	MGZ: { lat: 12.4398, lon: 98.621498 },
	MYT: { lat: 25.3836, lon: 97.351898 },
	MNU: { lat: 16.4447, lon: 97.660698 },
	MGU: { lat: 18.8458, lon: 93.688904 },
	MOE: { lat: 23.092501, lon: 96.645302 },
	MOG: { lat: 20.5168, lon: 99.256798 },
	MGK: { lat: 20.2967, lon: 98.898903 },
	MWQ: { lat: 20.1656, lon: 94.941399 },
	NYW: { lat: 22.221638, lon: 95.093479 },
	NMS: { lat: 20.890499, lon: 97.735901 },
	NYT: { lat: 19.623501, lon: 96.200996 },
	NMT: { lat: 23.083, lon: 97.383003 },
	PAA: { lat: 16.8937, lon: 97.674599 },
	PAU: { lat: 21.4492, lon: 94.4869 },
	BSX: { lat: 16.815201, lon: 94.7799 },
	PPU: { lat: 18.0667, lon: 97.449799 },
	PBU: { lat: 27.329901, lon: 97.4263 },
	PKK: { lat: 21.4043, lon: 95.11125 },
	PRU: { lat: 18.824499, lon: 95.265999 },
	AKY: { lat: 20.133165, lon: 92.870693 },
	SNW: { lat: 18.460699, lon: 94.300102 },
	THL: { lat: 20.483801, lon: 99.935402 },
	XYE: { lat: 15.301361, lon: 97.864288 },
	RGN: { lat: 16.907301, lon: 96.133202 },
	FBS: { lat: 48.5373, lon: -123.010002 },
	RSJ: { lat: 48.645699, lon: -122.867996 },
	LKE: { lat: 47.629002, lon: -122.338997 },
	RCE: { lat: 48.612301, lon: -123.139 },
	TQQ: { lat: -5.76457, lon: 123.917 },
	WSX: { lat: 48.617901, lon: -122.956903 },
	UPG: { lat: -5.06163, lon: 119.554001 },
	BIK: { lat: -1.19002, lon: 136.108002 },
	ONI: { lat: -4.00659, lon: 136.037704 },
	FOO: { lat: -0.935745, lon: 134.872292 },
	WET: { lat: -4.05916, lon: 136.281715 },
	NBX: { lat: -3.397973, lon: 135.393071 },
	KBF: { lat: -3.684615, lon: 138.479018 },
	ILA: { lat: -3.97648, lon: 137.6225 },
	KOX: { lat: -4.71075, lon: 136.43515 },
	ZRI: { lat: -1.82842, lon: 136.062402 },
	TIM: { lat: -4.52978, lon: 136.887388 },
	EWI: { lat: -3.925739, lon: 136.378634 },
	WAD: { lat: -17.631, lon: 47.7233 },
	BMU: { lat: -8.537184, lon: 118.685002 },
	DPS: { lat: -8.748409, lon: 115.167123 },
	LOP: { lat: -8.759962, lon: 116.278169 },
	SWQ: { lat: -8.48904, lon: 117.412003 },
	TMC: { lat: -9.409224, lon: 119.242558 },
	LYK: { lat: -8.989931, lon: 117.216018 },
	WGP: { lat: -9.66922, lon: 120.302002 },
	BWX: { lat: -8.31015, lon: 114.3401 },
	TTE: { lat: 0.831012, lon: 127.381611 },
	SQN: { lat: -2.100424, lon: 125.965838 },
	OTI: { lat: 2.04599, lon: 128.324997 },
	TRT: { lat: -3.185833, lon: 119.91775 },
	LLO: { lat: -3.082997, lon: 120.245018 },
	PLW: { lat: -0.916462, lon: 119.908647 },
	MJU: { lat: -2.590017, lon: 119.025051 },
	TLI: { lat: 1.123428, lon: 120.793658 },
	MXB: { lat: -2.558031, lon: 120.324342 },
	PSJ: { lat: -1.414121, lon: 120.659241 },
	OJU: { lat: -0.865437, lon: 121.628625 },
	LUW: { lat: -1.035893, lon: 122.773934 },
	HMS: { lat: -1.02581, lon: 114.92881 },
	KLP: { lat: -3.376062, lon: 112.536521 },
	PKY: { lat: -2.227146, lon: 113.943388 },
	YIA: { lat: -7.905338, lon: 110.057264 },
	CXP: { lat: -7.64506, lon: 109.033997 },
	PWL: { lat: -7.461342, lon: 109.414612 },
	KWB: { lat: -5.80091, lon: 110.47838 },
	BUI: { lat: -3.68455, lon: 138.677437 },
	DRH: { lat: -3.27061, lon: 138.613433 },
	BXM: { lat: -4.442687, lon: 140.883565 },
	ZRM: { lat: -1.873077, lon: 138.753275 },
	DJJ: { lat: -2.579627, lon: 140.519857 },
	LHI: { lat: -3.080046, lon: 139.952817 },
	LII: { lat: -3.701938, lon: 137.957 },
	OKL: { lat: -4.9071, lon: 140.6277 },
	SEH: { lat: -3.442448, lon: 140.778079 },
	MDP: { lat: -5.876929, lon: 140.70946 },
	BXD: { lat: -7.175902, lon: 139.58333 },
	MKQ: { lat: -8.523898, lon: 140.419693 },
	KCD: { lat: -6.1851, lon: 138.6372 },
	OKQ: { lat: -8.0946, lon: 139.7233 },
	KEI: { lat: -6.54297, lon: 139.332401 },
	ZEG: { lat: -5.690668, lon: 139.350414 },
	TMH: { lat: -6.09669, lon: 140.303521 },
	GHS: { lat: -0.203611, lon: 115.760002 },
	TJS: { lat: 2.835833, lon: 117.373611 },
	DTD: { lat: 0.807028, lon: 114.529052 },
	BPN: { lat: -1.268342, lon: 116.89452 },
	TRK: { lat: 3.325145, lon: 117.564169 },
	AAP: { lat: -0.374478, lon: 117.250128 },
	BYQ: { lat: 3.45572, lon: 117.866997 },
	GLX: { lat: 1.838134, lon: 127.786191 },
	PGQ: { lat: 0.917144, lon: 128.382116 },
	GTO: { lat: 0.637119, lon: 122.849998 },
	NAH: { lat: 3.68478, lon: 125.527162 },
	LKM: { lat: 0.88855, lon: 124.033634 },
	GEB: { lat: -0.078889, lon: 129.457993 },
	KAZ: { lat: 1.188608, lon: 127.896036 },
	MDC: { lat: 1.549266, lon: 124.926319 },
	MNA: { lat: 4.010334, lon: 126.673192 },
	BRG: { lat: 2.648591, lon: 125.423301 },
	MWS: { lat: -2.799322, lon: 122.141385 },
	IAX: { lat: 5.560419, lon: 126.580095 },
	UOL: { lat: 1.102318, lon: 121.413358 },
	BTW: { lat: -3.41241, lon: 115.995003 },
	PKN: { lat: -2.7052, lon: 111.672997 },
	KBU: { lat: -3.294796, lon: 116.163815 },
	TJG: { lat: -2.21656, lon: 115.435997 },
	BDJ: { lat: -3.44236, lon: 114.763 },
	SMQ: { lat: -2.499198, lon: 112.974987 },
	TBM: { lat: -1.469024, lon: 113.080984 },
	AHI: { lat: -3.347851, lon: 128.927093 },
	NDA: { lat: -4.5214, lon: 129.9054 },
	DOB: { lat: -5.773724, lon: 134.209245 },
	MAL: { lat: -1.782255, lon: 125.482246 },
	LUV: { lat: -5.760278, lon: 132.759444 },
	NRE: { lat: -3.85522, lon: 126.700902 },
	LAH: { lat: -0.633764, lon: 127.505394 },
	BJK: { lat: -6.06613, lon: 134.273971 },
	NAM: { lat: -3.143159, lon: 126.976469 },
	AMQ: { lat: -3.71026, lon: 128.089005 },
	TAX: { lat: -1.64263, lon: 124.558998 },
	WBA: { lat: -2.8114, lon: 129.484 },
	RTU: { lat: 2.19759, lon: 118.599361 },
	LNU: { lat: 3.575256, lon: 116.619769 },
	BEJ: { lat: 2.14776, lon: 117.430705 },
	MLG: { lat: -7.929099, lon: 112.714233 },
	CPF: { lat: -7.195522, lon: 111.545287 },
	JBB: { lat: -8.242494, lon: 113.693476 },
	JOG: { lat: -7.78818, lon: 110.431999 },
	SOC: { lat: -7.516044, lon: 110.757492 },
	SUB: { lat: -7.37983, lon: 112.787003 },
	SRG: { lat: -6.970732, lon: 110.373244 },
	SUP: { lat: -7.022391, lon: 113.887699 },
	BXW: { lat: -5.723628, lon: 112.678889 },
	AYW: { lat: -1.159779, lon: 132.464082 },
	NTI: { lat: -2.102572, lon: 133.515981 },
	RSK: { lat: -1.496667, lon: 134.1925 },
	KEQ: { lat: -0.810418, lon: 133.054937 },
	FKQ: { lat: -2.920508, lon: 132.267011 },
	INX: { lat: -2.127447, lon: 132.160056 },
	KNG: { lat: -3.6446, lon: 133.695116 },
	RDE: { lat: -1.591154, lon: 133.295867 },
	RJM: { lat: -0.423056, lon: 130.773333 },
	BXB: { lat: -2.53224, lon: 133.438995 },
	MKW: { lat: -0.891833, lon: 134.048996 },
	SOQ: { lat: -0.894, lon: 131.287 },
	TXM: { lat: -1.44545, lon: 132.021139 },
	KBX: { lat: -1.316815, lon: 132.286987 },
	WSR: { lat: -2.720434, lon: 134.505902 },
	ABU: { lat: -9.074841, lon: 124.903285 },
	BJW: { lat: -8.70777, lon: 121.058243 },
	MOF: { lat: -8.639514, lon: 122.238135 },
	ENE: { lat: -8.849114, lon: 121.66101 },
	RTG: { lat: -8.596171, lon: 120.478177 },
	LKA: { lat: -8.274424, lon: 123.002 },
	ARD: { lat: -8.13234, lon: 124.597 },
	LBJ: { lat: -8.480694, lon: 119.888306 },
	RTI: { lat: -10.7673, lon: 123.0747 },
	SAU: { lat: -10.4924, lon: 121.8482 },
	KOE: { lat: -10.1716, lon: 123.670998 },
	LWE: { lat: -8.361805, lon: 123.438554 },
	WMX: { lat: -4.097324, lon: 138.952417 },
	BUW: { lat: -5.486037, lon: 122.569823 },
	WNI: { lat: -5.293996, lon: 123.634 },
	KSR: { lat: -6.17921, lon: 120.437479 },
	APD: { lat: -4.459582, lon: 120.310436 },
	KXB: { lat: -4.338158, lon: 121.524047 },
	RAQ: { lat: -4.763298, lon: 122.566352 },
	SQR: { lat: -2.530582, lon: 121.356096 },
	TTR: { lat: -3.04474, lon: 119.821999 },
	KDI: { lat: -4.08161, lon: 122.417999 },
	WBB: { lat: 63.515999, lon: -162.278 },
	BTU: { lat: 3.12385, lon: 113.019997 },
	BLG: { lat: 2.652143, lon: 113.767043 },
	LSM: { lat: 4.217, lon: 115.599998 },
	LGL: { lat: 3.421, lon: 115.153999 },
	KCH: { lat: 1.487364, lon: 110.352859 },
	ODN: { lat: 3.976087, lon: 115.067303 },
	LMN: { lat: 4.8083, lon: 115.010002 },
	MKM: { lat: 2.881944, lon: 112.043333 },
	LKH: { lat: 3.310909, lon: 114.785553 },
	MUR: { lat: 4.178734, lon: 114.330318 },
	BSE: { lat: 1.812678, lon: 109.765391 },
	KPI: { lat: 2.010524, lon: 112.931468 },
	BKM: { lat: 3.974, lon: 115.617996 },
	MYY: { lat: 4.32201, lon: 113.987 },
	SBW: { lat: 2.2616, lon: 111.985001 },
	LSU: { lat: 4.55222, lon: 115.494003 },
	LWY: { lat: 4.84917, lon: 115.407997 },
	BBN: { lat: 3.734648, lon: 115.478548 },
	SMM: { lat: 4.454596, lon: 118.595023 },
	LDU: { lat: 5.03241, lon: 118.32376 },
	TEL: { lat: 5.62861, lon: 117.125999 },
	KGU: { lat: 5.355487, lon: 116.164884 },
	SXS: { lat: 5.08778, lon: 119.094002 },
	BKI: { lat: 5.932743, lon: 116.049324 },
	LBU: { lat: 5.301667, lon: 115.248333 },
	TMG: { lat: 5.40257, lon: 118.65763 },
	GSA: { lat: 4.409756, lon: 115.724473 },
	SPE: { lat: 4.733, lon: 116.467003 },
	PAY: { lat: 5.996571, lon: 117.404795 },
	RNU: { lat: 5.957793, lon: 116.680191 },
	SDK: { lat: 5.9009, lon: 118.058998 },
	KUD: { lat: 6.924111, lon: 116.837068 },
	TWU: { lat: 4.31338, lon: 118.12152 },
	MZV: { lat: 4.04833, lon: 114.805 },
	BWN: { lat: 4.9442, lon: 114.928001 },
	TGC: { lat: 2.17784, lon: 111.202003 },
	WDA: { lat: 14.859579, lon: 45.545705 },
	WED: { lat: -10.0954, lon: 150.0826 },
	WHL: { lat: -38.682382, lon: 146.445331 },
	PKU: { lat: 0.458647, lon: 101.444321 },
	DUM: { lat: 1.609114, lon: 101.433492 },
	RGT: { lat: -0.352808, lon: 102.334999 },
	SEQ: { lat: 1.37, lon: 102.139999 },
	TJB: { lat: 1.05287, lon: 103.391517 },
	KJT: { lat: -6.647384, lon: 108.165561 },
	RTO: { lat: -6.293171, lon: 106.57 },
	BDO: { lat: -6.90063, lon: 107.575996 },
	CBN: { lat: -6.757, lon: 108.538849 },
	TSY: { lat: -7.3466, lon: 108.246002 },
	CJN: { lat: -7.719895, lon: 108.488995 },
	TBX: { lat: 0.979922, lon: 107.564658 },
	BTH: { lat: 1.12103, lon: 104.119003 },
	PPR: { lat: 0.845431, lon: 100.370154 },
	LMU: { lat: 2.96447, lon: 105.75484 },
	MWK: { lat: 3.34812, lon: 106.258003 },
	TNJ: { lat: 0.92397, lon: 104.53341 },
	SIQ: { lat: -0.479611, lon: 104.579498 },
	MPC: { lat: -2.541058, lon: 101.087651 },
	HLP: { lat: -6.26661, lon: 106.890999 },
	PCB: { lat: -6.33696, lon: 106.764999 },
	CGK: { lat: -6.12557, lon: 106.655998 },
	TKG: { lat: -5.246803, lon: 105.182531 },
	TFY: { lat: -5.211562, lon: 103.936501 },
	LSW: { lat: 5.22668, lon: 96.950302 },
	GNS: { lat: 1.16628, lon: 97.704327 },
	AEG: { lat: 1.4001, lon: 99.430496 },
	JHN: { lat: 0.943995, lon: 99.534093 },
	MES: { lat: 3.558425, lon: 98.672275 },
	KNO: { lat: 3.637847, lon: 98.870566 },
	DTB: { lat: 2.25973, lon: 98.991898 },
	SIW: { lat: 2.601967, lon: 98.962381 },
	FLZ: { lat: 1.557127, lon: 98.887145 },
	LSR: { lat: 3.391456, lon: 97.863726 },
	TJQ: { lat: -2.744109, lon: 107.754535 },
	NPO: { lat: -0.34864, lon: 111.746155 },
	KTG: { lat: -1.817165, lon: 109.963469 },
	NTX: { lat: 3.90871, lon: 108.388 },
	PNK: { lat: -0.150711, lon: 109.403999 },
	PSU: { lat: 0.834579, lon: 112.940217 },
	SQG: { lat: -0.045214, lon: 111.458049 },
	DJB: { lat: -1.638685, lon: 103.645063 },
	LLJ: { lat: -3.288165, lon: 102.91449 },
	BUU: { lat: -1.541635, lon: 102.181613 },
	PGK: { lat: -2.1622, lon: 106.139 },
	BKS: { lat: -3.8637, lon: 102.338997 },
	PLM: { lat: -2.897653, lon: 104.698147 },
	PDO: { lat: -3.28607, lon: 103.879997 },
	PDG: { lat: -0.786917, lon: 100.280998 },
	PXA: { lat: -4.0225, lon: 103.379167 },
	TPK: { lat: 3.16904, lon: 97.288299 },
	MEQ: { lat: 4.040998, lon: 96.253312 },
	LKI: { lat: 2.411328, lon: 96.327722 },
	TXE: { lat: 4.72113, lon: 96.851943 },
	LSX: { lat: 5.06951, lon: 97.259201 },
	SBG: { lat: 5.874668, lon: 95.33967 },
	BTJ: { lat: 5.525087, lon: 95.41997 },
	SXT: { lat: 4.330278, lon: 102.394997 },
	MEP: { lat: 2.389148, lon: 103.874183 },
	SWY: { lat: 4.2222, lon: 100.6993 },
	TPG: { lat: 4.866432, lon: 100.715381 },
	TOD: { lat: 2.81818, lon: 104.160004 },
	AOR: { lat: 6.18967, lon: 100.398003 },
	BWH: { lat: 5.46592, lon: 100.390999 },
	KBR: { lat: 6.16685, lon: 102.292999 },
	KUA: { lat: 3.77539, lon: 103.209 },
	KTE: { lat: 4.53722, lon: 103.427002 },
	IPH: { lat: 4.56797, lon: 101.092003 },
	JHB: { lat: 1.64131, lon: 103.669998 },
	KUL: { lat: 2.74558, lon: 101.709999 },
	LGK: { lat: 6.32973, lon: 99.728699 },
	MKZ: { lat: 2.265613, lon: 102.252778 },
	TGG: { lat: 5.38264, lon: 103.102997 },
	PEN: { lat: 5.29714, lon: 100.277 },
	PKG: { lat: 4.24472, lon: 100.553001 },
	RDN: { lat: 5.764804, lon: 103.004942 },
	SZB: { lat: 3.13058, lon: 101.549004 },
	DTR: { lat: 48.500171, lon: -122.813973 },
	SXK: { lat: -7.848354, lon: 131.337068 },
	AUT: { lat: -8.243133, lon: 125.606378 },
	UAI: { lat: -9.30331, lon: 125.287003 },
	DIL: { lat: -8.546562, lon: 125.524507 },
	BCH: { lat: -8.486479, lon: 126.399981 },
	MPT: { lat: -8.97224, lon: 125.214996 },
	OEC: { lat: -9.19806, lon: 124.343002 },
	VIQ: { lat: -8.8838, lon: 126.373001 },
	SGQ: { lat: 0.3847, lon: 117.543 },
	LBW: { lat: 3.900495, lon: 115.690089 },
	BXT: { lat: 0.121656, lon: 117.476558 },
	NNX: { lat: 4.134001, lon: 117.669546 },
	TNB: { lat: -1.885541, lon: 116.256809 },
	LPU: { lat: 1.706932, lon: 114.969934 },
	QPG: { lat: 1.36042, lon: 103.910004 },
	TGA: { lat: 1.387561, lon: 103.708291 },
	WSB: { lat: 55.532662, lon: -133.638167 },
	UGI: { lat: 57.7304, lon: -153.320999 },
	WSM: { lat: 67.404602, lon: -150.123001 },
	XSP: { lat: 1.41555, lon: 103.86673 },
	SIN: { lat: 1.35019, lon: 103.994003 },
	GWV: { lat: 39.9487, lon: -80.759499 },
	WZQ: { lat: 41.460289, lon: 108.539085 },
	MPB: { lat: 25.783075, lon: -80.177545 },
	XBB: { lat: 49.793958, lon: -124.621064 },
	XIG: { lat: -7.0906, lon: -49.9765 },
	XMA: { lat: 7.7538, lon: 125.0333 },
	XRQ: { lat: 48.575585, lon: 116.939382 },
	XZM: { lat: 22.196242, lon: 113.55936 },
	UKN: { lat: 43.280499, lon: -91.469498 },
	ALH: { lat: -34.943333, lon: 117.808889 },
	ABG: { lat: -17.608814, lon: 143.183531 },
	AWN: { lat: -26.488959, lon: 139.259906 },
	AUD: { lat: -18.5087, lon: 139.882084 },
	YAJ: { lat: 48.795274, lon: -123.181801 },
	MRP: { lat: -27.334298, lon: 133.627696 },
	AXL: { lat: -19.0602, lon: 136.710007 },
	AXC: { lat: -22.95788, lon: 145.249504 },
	ADO: { lat: -30.438299, lon: 137.136993 },
	AMX: { lat: -21.7383, lon: 135.242004 },
	AMT: { lat: -26.097363, lon: 131.202732 },
	WLP: { lat: -23.135556, lon: 118.707222 },
	AYL: { lat: -18.018079, lon: 135.535069 },
	ABH: { lat: -23.652849, lon: 146.582668 },
	YAQ: { lat: 48.8167, lon: -123.6084 },
	ARY: { lat: -37.309978, lon: 142.988688 },
	GYL: { lat: -16.636944, lon: 128.451389 },
	ARM: { lat: -30.528099, lon: 151.617004 },
	AAB: { lat: -26.69639, lon: 141.048718 },
	AUU: { lat: -13.354019, lon: 141.720028 },
	AWP: { lat: -20.5, lon: 137.75 },
	AVG: { lat: -15.690555, lon: 130.008818 },
	AYQ: { lat: -25.185913, lon: 130.97703 },
	AYR: { lat: -19.595832, lon: 147.324495 },
	MBN: { lat: -16.741453, lon: 125.905608 },
	BCI: { lat: -23.566268, lon: 145.302086 },
	ASP: { lat: -23.806588, lon: 133.903427 },
	BDD: { lat: -10.14955, lon: 142.173665 },
	BKP: { lat: -20.495833, lon: 138.474722 },
	BNE: { lat: -27.384199, lon: 153.117004 },
	OOL: { lat: -28.165962, lon: 153.506641 },
	BKQ: { lat: -24.431678, lon: 145.429716 },
	CNS: { lat: -16.878921, lon: 145.74948 },
	CTL: { lat: -26.4133, lon: 146.261993 },
	BDW: { lat: -17.286699, lon: 127.462997 },
	BXG: { lat: -36.739399, lon: 144.330002 },
	BVI: { lat: -25.897499, lon: 139.348007 },
	BXF: { lat: -17.545, lon: 128.305 },
	BTX: { lat: -25.694791, lon: 140.738339 },
	BEE: { lat: -17.0165, lon: 122.6464 },
	OCM: { lat: -22.541111, lon: 117.269444 },
	BQW: { lat: -20.148333, lon: 127.973889 },
	YBH: { lat: 50.9179, lon: -127.9372 },
	BHQ: { lat: -32.0014, lon: 141.472 },
	HTI: { lat: -20.358101, lon: 148.951996 },
	BEU: { lat: -24.3461, lon: 139.460007 },
	BIW: { lat: -19.5667, lon: 127.667 },
	BZP: { lat: -14.740278, lon: 144.119444 },
	YBJ: { lat: 50.283745, lon: -62.81004 },
	BRK: { lat: -30.0392, lon: 145.951996 },
	BUC: { lat: -17.7486, lon: 139.533997 },
	BLN: { lat: -36.551899, lon: 146.007004 },
	LCN: { lat: -30.535, lon: 139.337006 },
	ZBL: { lat: -24.320816, lon: 150.509627 },
	BLS: { lat: -28.051247, lon: 147.481799 },
	BQB: { lat: -33.687222, lon: 115.400278 },
	ISA: { lat: -20.66638, lon: 139.488468 },
	BFC: { lat: -15.8736, lon: 145.330002 },
	MKY: { lat: -21.170816, lon: 149.182588 },
	BNK: { lat: -28.833236, lon: 153.561471 },
	BSJ: { lat: -37.887539, lon: 147.569379 },
	GIC: { lat: -9.23278, lon: 142.218002 },
	OKY: { lat: -27.409262, lon: 151.736727 },
	BQL: { lat: -22.9133, lon: 139.899994 },
	BMP: { lat: -20.804633, lon: 149.279931 },
	KAH: { lat: -37.822272, lon: 144.956789 },
	PPP: { lat: -20.494416, lon: 148.553583 },
	YBQ: { lat: 48.97, lon: -123.664 },
	ROK: { lat: -23.380019, lon: 150.475359 },
	BOX: { lat: -16.0753, lon: 136.302002 },
	BME: { lat: -17.949444, lon: 122.227778 },
	BZD: { lat: -34.624834, lon: 143.577114 },
	BTD: { lat: -18.637472, lon: 135.938355 },
	BWQ: { lat: -29.975792, lon: 146.81438 },
	BYP: { lat: -22.673889, lon: 119.166111 },
	MCY: { lat: -26.593324, lon: 153.08319 },
	BHS: { lat: -33.406817, lon: 149.651161 },
	BRT: { lat: -11.764966, lon: 130.615774 },
	TSV: { lat: -19.252904, lon: 146.766512 },
	BLT: { lat: -23.6031, lon: 148.807007 },
	BVW: { lat: -12.6592, lon: 142.675003 },
	BDB: { lat: -24.905039, lon: 152.322612 },
	BUY: { lat: -33.378056, lon: 115.676944 },
	BIP: { lat: -16.8808, lon: 143.479004 },
	ZBO: { lat: -20.017999, lon: 148.215245 },
	WEI: { lat: -12.677493, lon: 141.922618 },
	BCK: { lat: -17.3883, lon: 144.169006 },
	WTB: { lat: -27.558332, lon: 151.793335 },
	BWB: { lat: -20.864444, lon: 115.406111 },
	BVZ: { lat: -16.732756, lon: 125.439105 },
	CTR: { lat: -17.607, lon: 131.548996 },
	CGV: { lat: -32.280457, lon: 125.477943 },
	CLH: { lat: -31.773864, lon: 149.615322 },
	CVQ: { lat: -24.884337, lon: 113.666393 },
	CSI: { lat: -28.881304, lon: 153.060724 },
	CAZ: { lat: -31.5383, lon: 145.794006 },
	COJ: { lat: -31.3325, lon: 149.266998 },
	CBY: { lat: -19.479401, lon: 140.927002 },
	CBI: { lat: -40.390537, lon: 148.016933 },
	CPD: { lat: -29.038312, lon: 134.722166 },
	CRB: { lat: -29.523239, lon: 148.578243 },
	CCL: { lat: -26.771947, lon: 150.617571 },
	CNC: { lat: -10.050139, lon: 143.070007 },
	CNJ: { lat: -20.6686, lon: 140.503998 },
	CBX: { lat: -33.06565, lon: 147.21316 },
	CUD: { lat: -26.80336, lon: 153.104975 },
	CED: { lat: -32.1306, lon: 133.710007 },
	CVC: { lat: -33.709702, lon: 136.505005 },
	YCF: { lat: 50.063, lon: -124.930002 },
	CFI: { lat: -17.0217, lon: 131.326996 },
	CFH: { lat: -27.018299, lon: 138.891998 },
	CQP: { lat: -14.970832, lon: 145.311667 },
	CFS: { lat: -30.320601, lon: 153.115997 },
	LLG: { lat: -17.138386, lon: 144.528494 },
	CRH: { lat: -28.4301, lon: 152.08895 },
	CKW: { lat: -22.354302, lon: 119.642603 },
	CXT: { lat: -20.0431, lon: 146.272995 },
	DCN: { lat: -17.581389, lon: 123.828333 },
	CKI: { lat: -11.165, lon: 132.483002 },
	CTN: { lat: -15.443649, lon: 145.183221 },
	CMQ: { lat: -22.7731, lon: 147.621002 },
	CMA: { lat: -28.030001, lon: 145.621994 },
	CML: { lat: -19.911699, lon: 138.125 },
	NIF: { lat: -21.6717, lon: 121.586998 },
	CES: { lat: -32.787498, lon: 151.341995 },
	CNB: { lat: -30.980946, lon: 148.377833 },
	ODL: { lat: -26.7453, lon: 140.638 },
	CUQ: { lat: -13.761133, lon: 143.113311 },
	CIE: { lat: -33.366699, lon: 116.217003 },
	OOM: { lat: -36.300445, lon: 148.972408 },
	CDA: { lat: -12.9033, lon: 132.531998 },
	CWW: { lat: -35.994701, lon: 146.356995 },
	CFP: { lat: -18.718481, lon: 144.313028 },
	CYG: { lat: -36.1828, lon: 147.888 },
	CXQ: { lat: -18.8728, lon: 125.934 },
	CDQ: { lat: -18.225, lon: 142.257996 },
	KCE: { lat: -20.596701, lon: 147.860001 },
	CMD: { lat: -34.624283, lon: 148.036641 },
	CUG: { lat: -33.278026, lon: 148.768708 },
	CUY: { lat: -27.450663, lon: 117.917703 },
	CJF: { lat: -22.966667, lon: 118.813333 },
	CWR: { lat: -27.7117, lon: 138.328003 },
	CCW: { lat: -33.666698, lon: 136.891998 },
	CWT: { lat: -33.846894, lon: 148.648007 },
	COY: { lat: -21.7946, lon: 117.755 },
	DJR: { lat: -21.7083, lon: 139.533005 },
	DBY: { lat: -27.158476, lon: 151.263428 },
	DRN: { lat: -28.587912, lon: 148.217161 },
	DNB: { lat: -16.047394, lon: 142.394415 },
	DRB: { lat: -17.37193, lon: 123.66221 },
	DFP: { lat: -16.052124, lon: 143.013339 },
	DDI: { lat: -20.2603, lon: 148.8136 },
	DGD: { lat: -27.829722, lon: 117.316389 },
	DNG: { lat: -15.386429, lon: 126.302235 },
	DXD: { lat: -15.117494, lon: 143.31605 },
	DKI: { lat: -17.93913, lon: 146.141447 },
	DLK: { lat: -29.0133, lon: 138.481003 },
	DNQ: { lat: -35.559399, lon: 144.945999 },
	DDN: { lat: -16.991699, lon: 141.317001 },
	DLV: { lat: -12.55, lon: 130.684998 },
	DYW: { lat: -16.264695, lon: 133.383379 },
	DMD: { lat: -17.9403, lon: 138.822006 },
	DVR: { lat: -13.749806, lon: 130.693878 },
	NLF: { lat: -9.579176, lon: 143.780276 },
	DRD: { lat: -16.5537, lon: 141.8238 },
	DVP: { lat: -24.15, lon: 141.108002 },
	DPO: { lat: -41.169701, lon: 146.429993 },
	DOX: { lat: -29.298128, lon: 114.927334 },
	DRY: { lat: -15.71357, lon: 126.381097 },
	DHD: { lat: -27.075001, lon: 141.899994 },
	DRR: { lat: -25.684999, lon: 140.227997 },
	SRR: { lat: -27.519005, lon: 153.427618 },
	DKV: { lat: -24.859533, lon: 129.122209 },
	DYA: { lat: -22.6222, lon: 148.363998 },
	RXA: { lat: 14.44872, lon: 47.27955 },
	ECH: { lat: -36.1572, lon: 144.761993 },
	EUC: { lat: -31.707084, lon: 128.877243 },
	ETD: { lat: -28.740801, lon: 138.589005 },
	ENB: { lat: -29.8325, lon: 115.246002 },
	EIH: { lat: -18.5033, lon: 144.093994 },
	ELC: { lat: -12.0194, lon: 135.570999 },
	EKD: { lat: -21.172501, lon: 135.444 },
	EMD: { lat: -23.567499, lon: 148.179001 },
	EDD: { lat: -25.206106, lon: 133.254161 },
	ERB: { lat: -26.2633, lon: 132.182007 },
	ERQ: { lat: -20.9764, lon: 141.0066 },
	EPR: { lat: -33.684399, lon: 121.822998 },
	EVD: { lat: -18.000999, lon: 134.863007 },
	EVH: { lat: -29.101786, lon: 153.419255 },
	WHB: { lat: -22.428395, lon: 116.887879 },
	EXM: { lat: -22.040677, lon: 114.102663 },
	FRB: { lat: -33.363602, lon: 147.934998 },
	KFE: { lat: -22.290754, lon: 119.437143 },
	FLY: { lat: -35.658918, lon: 145.561214 },
	FLS: { lat: -40.091702, lon: 147.992996 },
	FVL: { lat: -18.297844, lon: 128.455897 },
	FIK: { lat: -25.5947, lon: 134.582993 },
	FOS: { lat: -30.83662, lon: 128.112811 },
	FVR: { lat: -15.1647, lon: 127.8401 },
	FOT: { lat: -32.202489, lon: 152.481136 },
	JFM: { lat: -32.045149, lon: 115.733022 },
	FIZ: { lat: -18.183596, lon: 125.559783 },
	YGA: { lat: 29.356667, lon: 106.010441 },
	GBP: { lat: -16.54412, lon: 143.668155 },
	GAH: { lat: -25.615939, lon: 151.62055 },
	GBL: { lat: -11.65, lon: 133.382004 },
	GUH: { lat: -30.957511, lon: 150.248981 },
	GOO: { lat: -28.5214, lon: 150.320007 },
	GDD: { lat: -18.678101, lon: 128.591995 },
	GGD: { lat: -18.625, lon: 139.233002 },
	YGE: { lat: 50.0994, lon: -125.0235 },
	GET: { lat: -28.796101, lon: 114.707001 },
	GFN: { lat: -29.754795, lon: 153.031234 },
	GBW: { lat: -22.5812, lon: 120.03553 },
	GBV: { lat: -16.418661, lon: 126.445685 },
	GKL: { lat: -23.184575, lon: 150.94164 },
	GLT: { lat: -23.869763, lon: 151.225439 },
	GUL: { lat: -34.810299, lon: 149.725998 },
	GLG: { lat: -24.8083, lon: 139.600006 },
	GLI: { lat: -29.676029, lon: 151.691156 },
	GLM: { lat: -22.8883, lon: 138.824997 },
	YGN: { lat: 50.839, lon: -126.775 },
	GFE: { lat: -34.0, lon: 148.132996 },
	GVP: { lat: -18.9966, lon: 145.0136 },
	GPD: { lat: -19.77265, lon: 139.40425 },
	GPN: { lat: -11.399686, lon: 130.425568 },
	GSC: { lat: -25.0546, lon: 115.2026 },
	GTE: { lat: -13.972405, lon: 136.458553 },
	GFF: { lat: -34.250801, lon: 146.067001 },
	GTT: { lat: -18.302676, lon: 143.530925 },
	GEE: { lat: -41.079491, lon: 146.839061 },
	GYP: { lat: -26.290149, lon: 152.702998 },
	HWK: { lat: -31.855907, lon: 138.468079 },
	HXX: { lat: -34.531399, lon: 144.830002 },
	HVB: { lat: -25.320127, lon: 152.880662 },
	HUB: { lat: -16.48967, lon: 130.63028 },
	HRY: { lat: -24.584, lon: 133.236 },
	HIP: { lat: -21.3333, lon: 138.283005 },
	HIG: { lat: -16.424148, lon: 143.14534 },
	HID: { lat: -10.585628, lon: 142.292653 },
	HLL: { lat: -21.718283, lon: 119.440334 },
	HCQ: { lat: -18.2339, lon: 127.669998 },
	HMG: { lat: -23.926485, lon: 132.807798 },
	HLT: { lat: -37.648899, lon: 142.065002 },
	HOK: { lat: -18.3367, lon: 130.638 },
	MHU: { lat: -37.047501, lon: 147.334 },
	HAP: { lat: -20.3358, lon: 148.8525 },
	HTU: { lat: -35.715302, lon: 142.360001 },
	HPE: { lat: -15.2923, lon: 145.1035 },
	HSM: { lat: -36.669701, lon: 142.173004 },
	HAT: { lat: -11.7369, lon: 142.576996 },
	HGD: { lat: -20.815001, lon: 144.225006 },
	IBM: { lat: -21.287575, lon: 118.88252 },
	IDK: { lat: -26.965435, lon: 133.321989 },
	IFL: { lat: -17.559401, lon: 146.011993 },
	IFF: { lat: -18.9, lon: 141.216995 },
	IGH: { lat: -18.664149, lon: 146.145804 },
	IKP: { lat: -16.229225, lon: 141.434607 },
	INJ: { lat: -25.851, lon: 148.5497 },
	INM: { lat: -27.697589, lon: 140.739498 },
	IVW: { lat: -17.841101, lon: 129.643005 },
	ISI: { lat: -24.258301, lon: 144.425003 },
	IVR: { lat: -29.8883, lon: 151.143997 },
	JAB: { lat: -12.658056, lon: 132.894638 },
	JUN: { lat: -24.838045, lon: 143.061962 },
	JCK: { lat: -20.668301, lon: 141.723007 },
	JUR: { lat: -30.302699, lon: 115.055551 },
	UBU: { lat: -14.28784, lon: 126.633182 },
	KQR: { lat: -29.217223, lon: 116.687154 },
	KYB: { lat: -22.15722, lon: 116.156223 },
	KDB: { lat: -31.1907, lon: 121.5978 },
	KAX: { lat: -27.692813, lon: 114.259169 },
	KBY: { lat: -32.836621, lon: 134.292991 },
	KBJ: { lat: -24.260229, lon: 131.488924 },
	KCS: { lat: -24.421285, lon: 131.819458 },
	OOD: { lat: -22.504291, lon: 119.07683 },
	KRA: { lat: -35.7514, lon: 143.938995 },
	KNS: { lat: -39.877499, lon: 143.878006 },
	KBB: { lat: -17.7792, lon: 129.210007 },
	KFG: { lat: -17.4319, lon: 130.807999 },
	KOH: { lat: -15.888484, lon: 142.439461 },
	KKP: { lat: -15.3189, lon: 143.955002 },
	KCI: { lat: -16.125, lon: 123.735 },
	KRB: { lat: -17.456699, lon: 140.830002 },
	KML: { lat: -19.375, lon: 140.057007 },
	KPS: { lat: -31.07232, lon: 152.765313 },
	KNI: { lat: -33.699423, lon: 117.65703 },
	KWM: { lat: -15.485369, lon: 141.752572 },
	KPP: { lat: -14.89, lon: 144.22 },
	KGY: { lat: -26.581077, lon: 151.839927 },
	KGC: { lat: -35.713902, lon: 137.520996 },
	YKT: { lat: 52.607635, lon: -128.521757 },
	KUG: { lat: -10.22648, lon: 142.219619 },
	KRD: { lat: -20.51, lon: 134.6706 },
	LWH: { lat: -18.57453, lon: 138.586106 },
	LGH: { lat: -30.598301, lon: 138.425995 },
	LNO: { lat: -28.878099, lon: 121.315002 },
	LEL: { lat: -12.4989, lon: 135.806 },
	LFP: { lat: -14.9207, lon: 144.203 },
	LDH: { lat: -31.538204, lon: 159.07546 },
	IRG: { lat: -12.7869, lon: 143.304993 },
	LTP: { lat: -19.195801, lon: 144.371002 },
	LIB: { lat: -17.2356, lon: 129.882004 },
	LDC: { lat: -20.4536, lon: 149.039993 },
	LSY: { lat: -28.830689, lon: 153.258419 },
	LNH: { lat: -20.9807, lon: 137.9178 },
	BBL: { lat: -27.405633, lon: 141.809458 },
	BEO: { lat: -33.065975, lon: 151.646283 },
	LKD: { lat: -15.841213, lon: 144.849118 },
	LOC: { lat: -33.544201, lon: 135.692993 },
	LOA: { lat: -18.993299, lon: 139.906998 },
	LTV: { lat: -17.0483, lon: 141.376007 },
	YLP: { lat: 50.2869, lon: -64.1528 },
	LUU: { lat: -15.560495, lon: 144.451418 },
	LHG: { lat: -29.452857, lon: 147.977146 },
	LRE: { lat: -23.4342, lon: 144.279999 },
	LUT: { lat: -15.182758, lon: 144.345535 },
	LER: { lat: -27.8433, lon: 120.703003 },
	LVO: { lat: -28.614267, lon: 122.428673 },
	TGN: { lat: -38.211004, lon: 146.470817 },
	LZR: { lat: -14.673273, lon: 145.454571 },
	UBB: { lat: -9.950168, lon: 142.19523 },
	MYI: { lat: -9.915105, lon: 144.054644 },
	AVV: { lat: -38.040269, lon: 144.467196 },
	ABX: { lat: -36.066758, lon: 146.959148 },
	MRG: { lat: -17.070277, lon: 145.424228 },
	MBB: { lat: -21.1633, lon: 119.833 },
	XMC: { lat: -37.598301, lon: 149.720001 },
	MFP: { lat: -22.1, lon: 137.983002 },
	MLR: { lat: -37.583599, lon: 140.365997 },
	DGE: { lat: -32.564794, lon: 149.609452 },
	MQA: { lat: -19.73799, lon: 120.83818 },
	MNW: { lat: -22.444, lon: 135.199005 },
	MKR: { lat: -26.6117, lon: 118.547997 },
	MEB: { lat: -37.7281, lon: 144.901993 },
	MIM: { lat: -36.9086, lon: 149.901001 },
	MLV: { lat: -13.0649, lon: 142.4536 },
	MGT: { lat: -12.0944, lon: 134.893997 },
	MNG: { lat: -12.0561, lon: 134.233994 },
	GSN: { lat: -31.4597, lon: 137.174443 },
	MGV: { lat: -18.6217, lon: 126.883003 },
	MQZ: { lat: -33.930599, lon: 115.099998 },
	MVU: { lat: -14.7757, lon: 143.5047 },
	HBA: { lat: -42.8371, lon: 147.51295 },
	MHO: { lat: -17.051917, lon: 125.712491 },
	MCV: { lat: -16.442499, lon: 136.084 },
	MQL: { lat: -34.229198, lon: 142.085999 },
	XML: { lat: -34.743801, lon: 137.529087 },
	MIH: { lat: -14.790817, lon: 125.825729 },
	MWY: { lat: -17.328899, lon: 141.886002 },
	MTQ: { lat: -26.483299, lon: 147.936996 },
	MJP: { lat: -34.265301, lon: 116.139999 },
	WLE: { lat: -26.806447, lon: 150.168953 },
	LST: { lat: -41.544935, lon: 147.210785 },
	MBW: { lat: -37.9758, lon: 145.102005 },
	WUI: { lat: -28.705299, lon: 121.89099 },
	MEL: { lat: -37.661548, lon: 144.836432 },
	MMM: { lat: -22.801444, lon: 148.706796 },
	MTL: { lat: -32.701265, lon: 151.492912 },
	WME: { lat: -27.28733, lon: 120.554937 },
	ONR: { lat: -24.8167, lon: 140.533005 },
	MSF: { lat: -22.624696, lon: 135.034512 },
	OXY: { lat: -25.358299, lon: 141.432999 },
	MMG: { lat: -28.1161, lon: 117.842003 },
	OOR: { lat: -25.25, lon: 140.983002 },
	MRZ: { lat: -29.498899, lon: 149.845001 },
	MET: { lat: -12.4442, lon: 142.638 },
	MIN: { lat: -32.8433, lon: 135.145004 },
	MQE: { lat: -22.805799, lon: 137.251007 },
	MOV: { lat: -22.0578, lon: 148.076996 },
	RRE: { lat: -29.6633, lon: 138.065002 },
	MWB: { lat: -29.2017, lon: 116.022003 },
	MYA: { lat: -35.8978, lon: 150.143997 },
	MTD: { lat: -16.9783, lon: 130.554993 },
	MIY: { lat: -18.8093, lon: 137.0815 },
	UTB: { lat: -22.5833, lon: 144.533005 },
	MGB: { lat: -37.744382, lon: 140.780561 },
	ONG: { lat: -16.6625, lon: 139.177994 },
	MNQ: { lat: -24.892267, lon: 151.101787 },
	MUQ: { lat: -20.658899, lon: 120.067001 },
	MNE: { lat: -28.009199, lon: 138.656998 },
	MVK: { lat: -28.347799, lon: 138.649994 },
	MUP: { lat: -25.860001, lon: 131.649994 },
	MNV: { lat: -14.0833, lon: 133.817001 },
	MXU: { lat: -28.475, lon: 115.516998 },
	MWT: { lat: -29.9069, lon: 139.765 },
	MXD: { lat: -23.363702, lon: 139.649663 },
	MBH: { lat: -25.513528, lon: 152.713603 },
	MYO: { lat: -18.123996, lon: 124.270261 },
	RTY: { lat: -28.582713, lon: 140.303264 },
	NMR: { lat: -27.549201, lon: 141.158416 },
	NRA: { lat: -34.702202, lon: 146.511993 },
	NAA: { lat: -30.319201, lon: 149.826996 },
	RPM: { lat: -14.7228, lon: 134.746994 },
	NBH: { lat: -30.673058, lon: 152.984233 },
	NLS: { lat: -18.049999, lon: 128.899994 },
	NKB: { lat: -18.494699, lon: 124.851997 },
	NMP: { lat: -19.2, lon: 145.773 },
	NPP: { lat: -22.5312, lon: 132.7632 },
	ABM: { lat: -10.946194, lon: 142.455081 },
	NAC: { lat: -36.985298, lon: 140.725006 },
	NRG: { lat: -32.93, lon: 117.080002 },
	QRM: { lat: -32.214699, lon: 148.225006 },
	RVT: { lat: -33.797199, lon: 120.208 },
	NSV: { lat: -26.423177, lon: 153.064935 },
	NSM: { lat: -32.203, lon: 121.758127 },
	NTN: { lat: -17.68409, lon: 141.069664 },
	NUR: { lat: -31.4417, lon: 130.901993 },
	NLL: { lat: -21.9133, lon: 120.197998 },
	NUB: { lat: -14.2717, lon: 135.716995 },
	UTD: { lat: -15.8074, lon: 134.1459 },
	ZNE: { lat: -23.417801, lon: 119.803001 },
	NYN: { lat: -31.550645, lon: 147.202973 },
	OPI: { lat: -12.325, lon: 133.005997 },
	YOI: { lat: 52.221944, lon: -76.611944 },
	XCO: { lat: -38.286701, lon: 143.679993 },
	OLP: { lat: -30.483861, lon: 136.876699 },
	ONS: { lat: -21.670161, lon: 115.114902 },
	ODD: { lat: -27.562473, lon: 135.442946 },
	MOO: { lat: -28.0994, lon: 140.197006 },
	RBS: { lat: -37.790001, lon: 148.610001 },
	OKB: { lat: -24.9594, lon: 153.315002 },
	OAG: { lat: -33.382014, lon: 149.131262 },
	ODR: { lat: -17.340799, lon: 128.912003 },
	OSO: { lat: -22.081699, lon: 140.554993 },
	OYN: { lat: -35.088819, lon: 142.354778 },
	ADL: { lat: -34.947512, lon: 138.533393 },
	PUG: { lat: -32.506901, lon: 137.716995 },
	PMK: { lat: -18.755301, lon: 146.580994 },
	PBO: { lat: -23.171101, lon: 117.745003 },
	CCK: { lat: -12.19134, lon: 96.833696 },
	PDN: { lat: -35.807, lon: 137.264 },
	PDE: { lat: -26.122248, lon: 139.403501 },
	DRW: { lat: -12.41497, lon: 130.88185 },
	PRD: { lat: -20.119428, lon: 119.571945 },
	GOV: { lat: -12.2694, lon: 136.817993 },
	PPI: { lat: -33.238899, lon: 137.994995 },
	JAD: { lat: -32.0975, lon: 115.880997 },
	KTA: { lat: -20.7122, lon: 116.773003 },
	KGI: { lat: -30.791543, lon: 121.464586 },
	PKE: { lat: -33.131401, lon: 148.238998 },
	PKT: { lat: -14.249701, lon: 129.529538 },
	KNX: { lat: -15.7781, lon: 128.707993 },
	PLO: { lat: -34.605301, lon: 135.880005 },
	LEA: { lat: -22.235201, lon: 114.090024 },
	PXH: { lat: -29.716, lon: 135.5244 },
	EDR: { lat: -14.896451, lon: 141.60908 },
	PQQ: { lat: -31.435801, lon: 152.863007 },
	PEY: { lat: -31.9167, lon: 133.0 },
	PTJ: { lat: -38.3181, lon: 141.470993 },
	MBF: { lat: -36.717731, lon: 146.890039 },
	PHE: { lat: -20.3778, lon: 118.625999 },
	PER: { lat: -31.9403, lon: 115.967003 },
	PEA: { lat: -35.755846, lon: 137.962875 },
	KTR: { lat: -14.5211, lon: 132.378006 },
	UMR: { lat: -31.144199, lon: 136.817001 },
	XCH: { lat: -10.449382, lon: 105.690931 },
	UIR: { lat: -31.498177, lon: 150.521708 },
	YQJ: { lat: 50.065, lon: -125.235 },
	ULP: { lat: -26.609176, lon: 144.253746 },
	UEE: { lat: -42.075731, lon: 145.530088 },
	RRV: { lat: -16.7183, lon: 136.945007 },
	YRC: { lat: 50.1234, lon: -124.843 },
	YRD: { lat: 52.82371, lon: -126.964957 },
	RMK: { lat: -34.1964, lon: 140.673996 },
	RCM: { lat: -20.7019, lon: 143.115005 },
	RAM: { lat: -12.3564, lon: 134.897995 },
	ROH: { lat: -18.844999, lon: 143.710007 },
	RBU: { lat: -20.763898, lon: 117.155199 },
	RBC: { lat: -34.642887, lon: 142.773042 },
	RMA: { lat: -26.545, lon: 148.774994 },
	RPB: { lat: -14.734814, lon: 134.525485 },
	RSB: { lat: -25.825737, lon: 139.627476 },
	RTS: { lat: -32.006699, lon: 115.540001 },
	RTP: { lat: -15.644963, lon: 141.844373 },
	RHL: { lat: -22.625816, lon: 119.95903 },
	NDS: { lat: -27.98, lon: 119.296997 },
	BWU: { lat: -33.923618, lon: 150.990792 },
	CBR: { lat: -35.3069, lon: 149.195007 },
	WCD: { lat: -30.173611, lon: 122.322222 },
	CDU: { lat: -34.038338, lon: 150.686406 },
	NSO: { lat: -32.038012, lon: 150.831966 },
	SQC: { lat: -31.24, lon: 119.360001 },
	DBO: { lat: -32.216702, lon: 148.574997 },
	SGO: { lat: -28.0497, lon: 148.595001 },
	SIX: { lat: -32.600832, lon: 151.193056 },
	ZGL: { lat: -25.67464, lon: 142.089171 },
	SGP: { lat: -20.4247, lon: 120.140999 },
	MJK: { lat: -25.897294, lon: 113.575802 },
	WOL: { lat: -34.5611, lon: 150.789001 },
	WSY: { lat: -20.276127, lon: 148.754979 },
	SHT: { lat: -36.428341, lon: 145.391473 },
	SBR: { lat: -9.37833, lon: 142.625 },
	GOS: { lat: -33.367681, lon: 151.299806 },
	SIO: { lat: -40.834999, lon: 145.084 },
	SOI: { lat: -20.2622, lon: 148.8399 },
	SHU: { lat: -11.133566, lon: 132.15957 },
	STH: { lat: -17.862709, lon: 142.557788 },
	SNB: { lat: -11.417674, lon: 130.648481 },
	NLK: { lat: -29.041887, lon: 167.939616 },
	NOA: { lat: -34.9466, lon: 150.542451 },
	SLJ: { lat: -22.25677, lon: 117.850454 },
	SNH: { lat: -28.620113, lon: 151.983281 },
	SCG: { lat: -18.637704, lon: 144.545672 },
	SHQ: { lat: -27.921848, lon: 153.371469 },
	KSV: { lat: -23.549999, lon: 140.699997 },
	XRH: { lat: -33.604652, lon: 150.783051 },
	SRN: { lat: -42.154999, lon: 145.292007 },
	SYD: { lat: -33.946098, lon: 151.177002 },
	HLS: { lat: -41.3367, lon: 148.281998 },
	STF: { lat: -9.51, lon: 143.55 },
	TMW: { lat: -31.077898, lon: 150.845484 },
	SSP: { lat: -13.9754, lon: 143.5537 },
	WGA: { lat: -35.163484, lon: 147.46832 },
	SWH: { lat: -35.375801, lon: 143.533005 },
	SWC: { lat: -37.071701, lon: 142.740997 },
	XTR: { lat: -27.163054, lon: 150.476423 },
	TBL: { lat: -17.2833, lon: 126.900002 },
	XTO: { lat: -25.801701, lon: 149.899994 },
	TAQ: { lat: -30.702871, lon: 134.58282 },
	TBK: { lat: -15.62, lon: 130.445007 },
	TDR: { lat: -24.986796, lon: 150.093076 },
	TQP: { lat: -21.834999, lon: 140.888 },
	TEF: { lat: -21.715, lon: 122.228996 },
	TEM: { lat: -34.421398, lon: 147.511993 },
	TAN: { lat: -27.137693, lon: 153.364141 },
	XTG: { lat: -27.986368, lon: 143.812065 },
	GTS: { lat: -20.5483, lon: 130.347 },
	TDN: { lat: -14.790567, lon: 126.498041 },
	TYG: { lat: -26.093047, lon: 143.45136 },
	TYB: { lat: -29.451099, lon: 142.057999 },
	TKY: { lat: -17.0408, lon: 128.205994 },
	PHQ: { lat: -21.8111, lon: 139.923996 },
	TPR: { lat: -22.746, lon: 117.869003 },
	TUM: { lat: -35.26832, lon: 148.240526 },
	TYP: { lat: -22.2558, lon: 137.953003 },
	TXR: { lat: -25.847799, lon: 141.927994 },
	THG: { lat: -24.494863, lon: 150.577967 },
	TCA: { lat: -19.634399, lon: 134.182999 },
	TCW: { lat: -35.811699, lon: 145.608002 },
	TRO: { lat: -31.888599, lon: 152.514008 },
	TTX: { lat: -14.0897, lon: 126.380997 },
	TWB: { lat: -27.543365, lon: 151.919112 },
	UDA: { lat: -18.19134, lon: 144.61224 },
	CZY: { lat: -24.516701, lon: 139.617004 },
	USL: { lat: -26.157923, lon: 113.394817 },
	VCD: { lat: -16.402124, lon: 131.004974 },
	VNR: { lat: -16.961532, lon: 141.95227 },
	WAU: { lat: -20.640614, lon: 134.215276 },
	WLA: { lat: -19.7736, lon: 120.649002 },
	WAV: { lat: -17.393299, lon: 131.117996 },
	WMB: { lat: -38.2953, lon: 142.447006 },
	SYU: { lat: -10.2083, lon: 142.824997 },
	WIO: { lat: -31.522082, lon: 143.378358 },
	WLC: { lat: -31.009492, lon: 151.547442 },
	WAZ: { lat: -28.149401, lon: 151.942993 },
	WND: { lat: -28.48061, lon: 122.244415 },
	WRN: { lat: -30.032277, lon: 119.386489 },
	WNR: { lat: -25.410641, lon: 142.668428 },
	WON: { lat: -18.575001, lon: 140.891998 },
	MFL: { lat: -19.67, lon: 144.8852 },
	GYB: { lat: -21.036568, lon: 118.642936 },
	WGT: { lat: -36.417914, lon: 146.306896 },
	WYA: { lat: -33.058899, lon: 137.514008 },
	WIT: { lat: -22.224992, lon: 118.353739 },
	WKB: { lat: -36.321098, lon: 142.419006 },
	WGE: { lat: -30.032801, lon: 148.126007 },
	NTL: { lat: -32.794998, lon: 151.834 },
	WUN: { lat: -26.6292, lon: 120.221001 },
	WPK: { lat: -16.658915, lon: 143.999263 },
	WDI: { lat: -26.277392, lon: 151.861673 },
	WLL: { lat: -17.2199, lon: 137.93453 },
	SXE: { lat: -38.090827, lon: 146.965335 },
	WLO: { lat: -16.629999, lon: 129.320007 },
	WIN: { lat: -22.3636, lon: 143.085999 },
	WUD: { lat: -33.043301, lon: 135.447006 },
	WEW: { lat: -30.258301, lon: 149.408005 },
	WRW: { lat: -20.8442, lon: 120.702003 },
	WWI: { lat: -21.64551, lon: 121.191184 },
	WWY: { lat: -33.937199, lon: 147.190994 },
	WYN: { lat: -15.5114, lon: 128.153 },
	BWT: { lat: -40.997039, lon: 145.726 },
	YLG: { lat: -28.355301, lon: 116.683998 },
	OKR: { lat: -9.752801, lon: 143.405673 },
	KYF: { lat: -27.27706, lon: 120.095673 },
	XMY: { lat: -9.899187, lon: 142.774265 },
	YUE: { lat: -22.2542, lon: 131.781998 },
	NGA: { lat: -34.255576, lon: 148.247118 },
	ORR: { lat: -35.003564, lon: 137.619295 },
	KYI: { lat: -31.4706, lon: 131.824997 },
	KKI: { lat: 60.913809, lon: -161.493329 },
	BCC: { lat: 63.573316, lon: -156.149454 },
	JBT: { lat: 60.782001, lon: -161.742996 },
	CZP: { lat: 55.966301, lon: -133.796997 },
	KBW: { lat: 56.295601, lon: -158.401001 },
	KBC: { lat: 66.274002, lon: -145.824005 },
	CZC: { lat: 61.943713, lon: -145.299398 },
	HPR: { lat: -25.655701, lon: 28.2206 },
	TDT: { lat: -24.525533, lon: 31.289748 },
	HZV: { lat: -25.0501, lon: 31.131901 },
	KHO: { lat: -24.593, lon: 31.4151 },
	MBM: { lat: -31.2849, lon: 29.9884 },
	INY: { lat: -24.7777, lon: 31.3855 },
	TSD: { lat: -22.619301, lon: 30.1756 },
	SSX: { lat: -24.801985, lon: 31.42194 },
	KIG: { lat: -30.187136, lon: 17.282706 },
	PEK: { lat: 40.080101, lon: 116.584999 },
	PKX: { lat: 39.509945, lon: 116.41092 },
	CDE: { lat: 41.1225, lon: 118.073889 },
	CIF: { lat: 42.159723, lon: 118.840971 },
	CIH: { lat: 36.247501, lon: 113.125999 },
	BPE: { lat: 39.666384, lon: 119.061384 },
	DSN: { lat: 39.493514, lon: 109.8599 },
	DAT: { lat: 40.061614, lon: 113.480032 },
	ERL: { lat: 43.4225, lon: 112.096667 },
	YIE: { lat: 47.3106, lon: 119.9117 },
	HDG: { lat: 36.525833, lon: 114.425556 },
	HET: { lat: 40.849658, lon: 111.824598 },
	HUO: { lat: 45.487222, lon: 119.407222 },
	HLD: { lat: 49.205002, lon: 119.824997 },
	LFQ: { lat: 36.132629, lon: 111.641236 },
	LLV: { lat: 37.683333, lon: 111.142778 },
	NZH: { lat: 49.566667, lon: 117.33 },
	BAV: { lat: 40.560001, lon: 109.997002 },
	SZH: { lat: 39.273241, lon: 112.691552 },
	SJW: { lat: 38.280701, lon: 114.696999 },
	TVS: { lat: 39.7178, lon: 118.002625 },
	TSN: { lat: 39.124401, lon: 117.346001 },
	TGO: { lat: 43.556702, lon: 122.199997 },
	UCB: { lat: 41.130266, lon: 113.107274 },
	WUA: { lat: 39.7934, lon: 106.7993 },
	HLH: { lat: 46.195333, lon: 122.008333 },
	XIL: { lat: 43.9156, lon: 115.963997 },
	XNT: { lat: 36.8831, lon: 114.4293 },
	WUT: { lat: 38.597456, lon: 112.969173 },
	YCU: { lat: 35.116391, lon: 111.031389 },
	TYN: { lat: 37.746899, lon: 112.627998 },
	RLK: { lat: 40.926, lon: 107.7428 },
	ZQZ: { lat: 40.738602, lon: 114.930278 },
	NZL: { lat: 47.865942, lon: 122.768662 },
	ZDM: { lat: 31.91123, lon: 35.20756 },
	BHY: { lat: 21.5394, lon: 109.293999 },
	AEB: { lat: 23.7206, lon: 106.959999 },
	CGD: { lat: 28.9189, lon: 111.639999 },
	HJJ: { lat: 27.443087, lon: 109.704666 },
	HCZ: { lat: 25.753419, lon: 112.845404 },
	DYG: { lat: 29.1028, lon: 110.443001 },
	FUO: { lat: 23.0825, lon: 113.070833 },
	CAN: { lat: 23.392401, lon: 113.299004 },
	CSX: { lat: 28.189199, lon: 113.220001 },
	HCJ: { lat: 24.804344, lon: 107.710819 },
	HNY: { lat: 26.72208, lon: 112.617958 },
	HUZ: { lat: 23.049999, lon: 114.599998 },
	KWL: { lat: 25.219828, lon: 110.039553 },
	LLF: { lat: 26.338661, lon: 111.610043 },
	MXZ: { lat: 24.263425, lon: 116.097857 },
	NNG: { lat: 22.608544, lon: 108.175335 },
	SWA: { lat: 23.552, lon: 116.5033 },
	ZUH: { lat: 22.006399, lon: 113.375999 },
	WGN: { lat: 26.806123, lon: 110.641042 },
	SZX: { lat: 22.639299, lon: 113.810997 },
	WUZ: { lat: 23.40316, lon: 111.09331 },
	XIN: { lat: 24.1492, lon: 115.758003 },
	DXJ: { lat: 28.4972, lon: 109.5218 },
	YLX: { lat: 22.438056, lon: 110.120833 },
	YYA: { lat: 29.311699, lon: 113.281574 },
	LZH: { lat: 24.2075, lon: 109.390999 },
	ZHA: { lat: 21.481667, lon: 110.590278 },
	AYN: { lat: 36.1339, lon: 114.344002 },
	CGO: { lat: 34.526497, lon: 113.849165 },
	EHU: { lat: 30.341178, lon: 115.03926 },
	ENH: { lat: 30.320299, lon: 109.485001 },
	LHK: { lat: 32.38866, lon: 111.69425 },
	WUH: { lat: 30.774798, lon: 114.213723 },
	SHS: { lat: 30.29281, lon: 112.44854 },
	LYA: { lat: 34.7411, lon: 112.388 },
	NNY: { lat: 32.982696, lon: 112.617467 },
	HQQ: { lat: 35.870833, lon: 114.461944 },
	HPG: { lat: 31.626, lon: 110.34 },
	WDS: { lat: 32.592889, lon: 110.906296 },
	XFN: { lat: 32.152222, lon: 112.291666 },
	XAI: { lat: 32.540819, lon: 114.079141 },
	YIH: { lat: 30.554132, lon: 111.482563 },
	ZIZ: { lat: 26.710944, lon: 67.66725 },
	HAK: { lat: 19.9349, lon: 110.459 },
	BAR: { lat: 19.140951, lon: 110.452766 },
	SYX: { lat: 18.3029, lon: 109.412003 },
	RGO: { lat: 41.428538, lon: 129.647555 },
	FNJ: { lat: 39.224098, lon: 125.669998 },
	DSO: { lat: 39.745201, lon: 127.473999 },
	YJS: { lat: 41.907132, lon: 128.409834 },
	UJU: { lat: 40.150013, lon: 124.501104 },
	WOS: { lat: 39.166801, lon: 127.486 },
	AKA: { lat: 32.75696, lon: 108.87338 },
	DNH: { lat: 40.161098, lon: 94.809196 },
	HXD: { lat: 37.125286, lon: 97.268658 },
	GMQ: { lat: 34.418066, lon: 100.301144 },
	GOQ: { lat: 36.4006, lon: 94.786102 },
	GYU: { lat: 36.078889, lon: 106.216944 },
	HBQ: { lat: 38.008068, lon: 100.645065 },
	HTT: { lat: 38.201645, lon: 90.837843 },
	HZG: { lat: 33.133527, lon: 107.203817 },
	INC: { lat: 38.322758, lon: 106.393214 },
	JIC: { lat: 38.542222, lon: 102.348333 },
	JGN: { lat: 39.856899, lon: 98.3414 },
	LHW: { lat: 36.515202, lon: 103.620003 },
	LNL: { lat: 33.789918, lon: 105.790014 },
	IQN: { lat: 35.802638, lon: 107.598896 },
	SIA: { lat: 34.376701, lon: 109.120003 },
	THQ: { lat: 34.5601, lon: 105.860343 },
	GXH: { lat: 34.819014, lon: 102.622261 },
	XNN: { lat: 36.530093, lon: 102.040062 },
	XIY: { lat: 34.447102, lon: 108.751999 },
	ENY: { lat: 36.479413, lon: 109.464083 },
	UYN: { lat: 38.35971, lon: 109.590927 },
	YUS: { lat: 32.836389, lon: 97.036389 },
	ZHY: { lat: 37.573125, lon: 105.154454 },
	YZY: { lat: 38.801899, lon: 100.675003 },
	UMB: { lat: -12.25358, lon: 25.44432 },
	AVK: { lat: 46.250301, lon: 102.802002 },
	LTI: { lat: 46.3764, lon: 96.2211 },
	BYN: { lat: 46.1633, lon: 100.704002 },
	UGA: { lat: 48.855, lon: 103.475998 },
	UGT: { lat: 43.749304, lon: 104.114985 },
	HBU: { lat: 46.100601, lon: 91.584198 },
	UUN: { lat: 46.660301, lon: 113.285004 },
	COQ: { lat: 48.1357, lon: 114.646004 },
	UBN: { lat: 47.646916, lon: 106.819833 },
	ZMD: { lat: -9.116, lon: -68.6108 },
	ULZ: { lat: 47.7093, lon: 96.5258 },
	DLZ: { lat: 43.608628, lon: 104.367734 },
	HTM: { lat: 50.435988, lon: 100.139532 },
	KHR: { lat: 47.246667, lon: 102.826111 },
	HJT: { lat: 46.9258, lon: 102.773003 },
	HVD: { lat: 47.954102, lon: 91.628197 },
	MXW: { lat: 45.738098, lon: 106.268997 },
	MXV: { lat: 49.6633, lon: 100.098999 },
	TSZ: { lat: 47.461476, lon: 101.483804 },
	TNZ: { lat: 48.73887, lon: 98.2941 },
	ULN: { lat: 47.843102, lon: 106.766998 },
	ULO: { lat: 50.066588, lon: 91.938273 },
	UNR: { lat: 47.30486, lon: 110.6092 },
	ULG: { lat: 48.993301, lon: 89.922501 },
	ZNC: { lat: 60.980701, lon: -159.994003 },
	ZNU: { lat: 51.862825, lon: -127.869357 },
	BSD: { lat: 25.053301, lon: 99.168297 },
	CWJ: { lat: 23.276331, lon: 99.373169 },
	DLU: { lat: 25.649401, lon: 100.319 },
	DIG: { lat: 27.7936, lon: 99.6772 },
	JHG: { lat: 21.974648, lon: 100.762224 },
	JMJ: { lat: 22.417733, lon: 99.784012 },
	LNJ: { lat: 23.7381, lon: 100.025002 },
	LJG: { lat: 26.68, lon: 100.246002 },
	LUM: { lat: 24.4011, lon: 98.5317 },
	KMG: { lat: 25.110313, lon: 102.936743 },
	SYM: { lat: 22.793301, lon: 100.959 },
	WNH: { lat: 23.5583, lon: 104.3255 },
	YUA: { lat: 25.737499, lon: 101.882004 },
	ZAT: { lat: 27.327549, lon: 103.75617 },
	XMN: { lat: 24.544001, lon: 118.127998 },
	AQG: { lat: 30.582199, lon: 117.050003 },
	BFU: { lat: 32.847733, lon: 117.320244 },
	CZX: { lat: 31.920485, lon: 119.77546 },
	KHN: { lat: 28.864815, lon: 115.90271 },
	AZJ: { lat: 32.23649, lon: 119.718683 },
	DOY: { lat: 37.50137, lon: 118.789863 },
	FUG: { lat: 32.882157, lon: 115.734364 },
	FOC: { lat: 25.934669, lon: 119.66318 },
	KOW: { lat: 25.853333, lon: 114.778889 },
	HGH: { lat: 30.23609, lon: 120.428865 },
	HZA: { lat: 35.212972, lon: 115.736748 },
	JDZ: { lat: 29.3386, lon: 117.176003 },
	JNG: { lat: 35.647358, lon: 116.743269 },
	JIU: { lat: 29.476944, lon: 115.801111 },
	TNA: { lat: 36.857201, lon: 117.216003 },
	JUZ: { lat: 28.96613, lon: 118.898793 },
	LYG: { lat: 34.41406, lon: 119.17899 },
	LCX: { lat: 25.67592, lon: 116.745907 },
	HYN: { lat: 28.562201, lon: 121.429001 },
	LYI: { lat: 35.052918, lon: 118.411828 },
	NGB: { lat: 29.8267, lon: 121.461998 },
	NKG: { lat: 31.735032, lon: 118.865949 },
	NTG: { lat: 32.073566, lon: 120.980076 },
	HFE: { lat: 31.98779, lon: 116.9769 },
	PVG: { lat: 31.1434, lon: 121.805 },
	TAO: { lat: 36.361953, lon: 120.088171 },
	JJN: { lat: 24.796587, lon: 118.588883 },
	RUG: { lat: 32.258341, lon: 120.501131 },
	RIZ: { lat: 35.405033, lon: 119.324403 },
	HIA: { lat: 33.790833, lon: 119.125 },
	SQJ: { lat: 26.4263, lon: 117.8336 },
	SQD: { lat: 28.3797, lon: 117.9643 },
	SHA: { lat: 31.198104, lon: 121.33426 },
	SZV: { lat: 31.2631, lon: 120.401001 },
	TXN: { lat: 29.733299, lon: 118.255997 },
	WHA: { lat: 31.1045, lon: 118.66687 },
	WEF: { lat: 36.646702, lon: 119.119003 },
	WEH: { lat: 37.187099, lon: 122.228996 },
	WHU: { lat: 31.3906, lon: 118.408997 },
	WUX: { lat: 31.4944, lon: 120.429001 },
	WUS: { lat: 27.7019, lon: 118.000999 },
	WNZ: { lat: 27.910572, lon: 120.853465 },
	XUZ: { lat: 34.059056, lon: 117.555278 },
	YTY: { lat: 32.5634, lon: 119.7198 },
	YIC: { lat: 27.8025, lon: 114.3062 },
	YNZ: { lat: 33.425833, lon: 120.203056 },
	YNT: { lat: 37.659724, lon: 120.978124 },
	YIW: { lat: 29.342095, lon: 120.03116 },
	HSN: { lat: 29.9342, lon: 122.362 },
	NGQ: { lat: 32.09794, lon: 80.053971 },
	AVA: { lat: 26.260556, lon: 105.873333 },
	BCJ: { lat: 31.581474, lon: 104.459701 },
	BPX: { lat: 30.5536, lon: 97.108299 },
	BFJ: { lat: 27.267066, lon: 105.472097 },
	CKG: { lat: 29.712254, lon: 106.651895 },
	DZH: { lat: 31.048815, lon: 107.435646 },
	DCY: { lat: 29.31632, lon: 100.060317 },
	DEJ: { lat: 28.121, lon: 108.1631 },
	DAX: { lat: 31.1302, lon: 107.4295 },
	DZU: { lat: 29.636227, lon: 105.773621 },
	GHN: { lat: 30.9485, lon: 104.3296 },
	GYS: { lat: 32.390254, lon: 105.694571 },
	KWE: { lat: 26.541466, lon: 106.803331 },
	GZG: { lat: 31.7575, lon: 99.554167 },
	AHJ: { lat: 32.53154, lon: 102.35224 },
	JZH: { lat: 32.853333, lon: 103.682222 },
	KGT: { lat: 30.142464, lon: 101.73872 },
	KJH: { lat: 26.972, lon: 107.988 },
	LLB: { lat: 25.4525, lon: 107.961667 },
	LIA: { lat: 30.679399, lon: 107.786003 },
	LXA: { lat: 29.298001, lon: 90.911951 },
	LZO: { lat: 29.030357, lon: 105.468407 },
	WMT: { lat: 27.961837, lon: 106.435416 },
	MIG: { lat: 31.428101, lon: 104.740997 },
	NAO: { lat: 30.798104, lon: 106.16415 },
	HZH: { lat: 26.32217, lon: 109.1499 },
	LZY: { lat: 29.303301, lon: 94.335297 },
	LPF: { lat: 26.609417, lon: 104.979 },
	JIQ: { lat: 29.513333, lon: 108.831111 },
	RKZ: { lat: 29.3519, lon: 89.311401 },
	LGZ: { lat: 28.422422, lon: 92.348082 },
	TCZ: { lat: 24.938056, lon: 98.485833 },
	TFU: { lat: 30.31252, lon: 104.441284 },
	TEN: { lat: 27.883333, lon: 109.308889 },
	CTU: { lat: 30.558257, lon: 103.945966 },
	CQW: { lat: 29.465658, lon: 107.693664 },
	WSK: { lat: 31.06896, lon: 109.708958 },
	WXN: { lat: 30.8017, lon: 108.433 },
	XIC: { lat: 27.9891, lon: 102.183998 },
	YBP: { lat: 28.858431, lon: 104.526157 },
	ACX: { lat: 25.083423, lon: 104.960804 },
	PZI: { lat: 26.54, lon: 101.79852 },
	ZYI: { lat: 27.810723, lon: 107.247189 },
	AKU: { lat: 41.262501, lon: 80.291702 },
	ACF: { lat: 40.434748, lon: 81.26206 },
	AAT: { lat: 47.749886, lon: 88.085808 },
	BPL: { lat: 44.895461, lon: 82.30007 },
	IQM: { lat: 38.234516, lon: 85.465462 },
	FYN: { lat: 46.804169, lon: 89.512006 },
	HMI: { lat: 42.8414, lon: 93.669197 },
	SHF: { lat: 44.2421, lon: 85.8905 },
	KCA: { lat: 41.677856, lon: 82.872917 },
	KRL: { lat: 41.614979, lon: 86.140817 },
	KRY: { lat: 45.46655, lon: 84.9527 },
	KJI: { lat: 48.2223, lon: 86.9959 },
	NLT: { lat: 43.4318, lon: 83.3786 },
	RQA: { lat: 38.974722, lon: 88.008333 },
	QSZ: { lat: 38.24542, lon: 77.056149 },
	KHG: { lat: 39.5429, lon: 76.019997 },
	SXJ: { lat: 42.911701, lon: 90.247498 },
	TCG: { lat: 46.672501, lon: 83.340797 },
	TLQ: { lat: 43.0308, lon: 89.0987 },
	HTN: { lat: 37.038502, lon: 79.864899 },
	URC: { lat: 43.907101, lon: 87.474197 },
	YIN: { lat: 43.955799, lon: 81.330299 },
	YTW: { lat: 36.8085, lon: 81.7827 },
	AOG: { lat: 41.105301, lon: 122.853996 },
	DBC: { lat: 45.505278, lon: 123.019722 },
	NBS: { lat: 42.066944, lon: 127.602222 },
	CGQ: { lat: 43.996201, lon: 125.684998 },
	CNI: { lat: 39.266667, lon: 122.666944 },
	CHG: { lat: 41.538101, lon: 120.434998 },
	DDG: { lat: 40.025453, lon: 124.28669 },
	DQA: { lat: 46.750883, lon: 125.138642 },
	DTU: { lat: 48.441037, lon: 126.128374 },
	FYJ: { lat: 48.197219, lon: 134.36298 },
	HRB: { lat: 45.623402, lon: 126.25 },
	HEK: { lat: 50.171621, lon: 127.308884 },
	JGD: { lat: 50.371389, lon: 124.1175 },
	JIL: { lat: 44.002652, lon: 126.395244 },
	JMU: { lat: 46.843399, lon: 130.464996 },
	JSJ: { lat: 47.108248, lon: 132.65792 },
	JXA: { lat: 45.293, lon: 131.193 },
	JNZ: { lat: 40.936032, lon: 121.277114 },
	LDS: { lat: 47.752056, lon: 129.019125 },
	MDG: { lat: 44.524101, lon: 129.569 },
	OHE: { lat: 52.916871, lon: 122.422759 },
	NDG: { lat: 47.239601, lon: 123.917999 },
	HSF: { lat: 44.453889, lon: 130.843889 },
	YSQ: { lat: 44.931143, lon: 124.552121 },
	DLC: { lat: 38.965719, lon: 121.538477 },
	TNH: { lat: 42.048435, lon: 125.733963 },
	SHE: { lat: 41.639801, lon: 123.483002 },
	XEN: { lat: 40.580328, lon: 120.700374 },
	YNJ: { lat: 42.882801, lon: 129.451004 },
	YKH: { lat: 40.542524, lon: 122.3586 },
};
